
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("l1WtJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");

/**
 * @generated SignedSource<<b79e5bd56d584876e3084d10ea24c8b8>>
 * @relayHash 949ec93e2e750573480678a72afd0b2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9abcf8b8bdce61a01169ab458d5e031dab509316cdf48a38da7f2646c97dea15
const $364cc8302a9c5705$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "allFirst"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "favouritesFirst"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "verifiedFirst"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceId"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
    }, v8 = {
        "kind": "Variable",
        "name": "workspaceId",
        "variableName": "workspaceId"
    }, v9 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "favouritesFirst"
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyFavouriteAgents": true
            }
        },
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "description"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v15 = {
        "kind": "ScalarField",
        "name": "creatorType"
    }, v16 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v17 = {
        "concreteType": "AgentStudioAgentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineDataFragmentSpread",
                        "name": "mapEdgeToAgent",
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v10 /*: any*/ ,
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            v14 /*: any*/ ,
                                            v15 /*: any*/ ,
                                            {
                                                "kind": "LinkedField",
                                                "name": "identityAccount",
                                                "plural": false,
                                                "selections": [
                                                    v10 /*: any*/ ,
                                                    v16 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "AgentStudioAssistant"
                                    }
                                ],
                                "type": "AgentStudioAgent",
                                "abstractKey": "__isAgentStudioAgent"
                            }
                        ],
                        "argumentDefinitions": []
                    }
                ]
            }
        ]
    }, v18 = [
        v17 /*: any*/ 
    ], v19 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "verifiedFirst"
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyVerifiedAgents": true
            }
        },
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v20 = [
        v6 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "allFirst"
        },
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v21 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v22 = {
        "concreteType": "AgentStudioAgentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
            {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v11 /*: any*/ ,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v12 /*: any*/ ,
                                    v13 /*: any*/ ,
                                    v14 /*: any*/ ,
                                    v15 /*: any*/ ,
                                    {
                                        "kind": "LinkedField",
                                        "name": "identityAccount",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            v10 /*: any*/ ,
                                            v16 /*: any*/ 
                                        ]
                                    }
                                ],
                                "type": "AgentStudioAssistant"
                            }
                        ],
                        "type": "AgentStudioAgent",
                        "abstractKey": "__isAgentStudioAgent"
                    }
                ]
            }
        ]
    }, v23 = [
        v22 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "initialMentionAgentsQuery",
            "selections": [
                {
                    "alias": "favourites",
                    "args": v9 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v18 /*: any*/ 
                },
                {
                    "alias": "verified",
                    "args": v19 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v18 /*: any*/ 
                },
                {
                    "alias": "all",
                    "args": v20 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        v21 /*: any*/ ,
                        v17 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "initialMentionAgentsQuery",
            "selections": [
                {
                    "alias": "favourites",
                    "args": v9 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v23 /*: any*/ 
                },
                {
                    "alias": "verified",
                    "args": v19 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v23 /*: any*/ 
                },
                {
                    "alias": "all",
                    "args": v20 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        v21 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "9abcf8b8bdce61a01169ab458d5e031dab509316cdf48a38da7f2646c97dea15",
            "metadata": {},
            "name": "initialMentionAgentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$364cc8302a9c5705$var$node.hash = "6d7fccabc8a52038fa7c5d9dd5cbf22e";
var $364cc8302a9c5705$export$2e2bcd8739ae039 = $364cc8302a9c5705$var$node;



var $cbY7C = parcelRequire("cbY7C");


var $iKWdo = parcelRequire("iKWdo");




/**
 * @generated SignedSource<<f35e8f3239937f13dfedc067b866c427>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342f13b682637c61$var$node = {
    "kind": "InlineDataFragment",
    "name": "mapEdgeToAgent"
};
$342f13b682637c61$var$node.hash = "874147c17269a920001abdbc5847f9d5";
var $342f13b682637c61$export$2e2bcd8739ae039 = $342f13b682637c61$var$node;






var $9JsfF = parcelRequire("9JsfF");

const $9f7dc2a7a15fe802$export$d7d185046b48dbb6 = (ref)=>{
    if (!ref) return null;
    const node = (0, $6SsN4.readInlineData)((0, $342f13b682637c61$export$2e2bcd8739ae039), ref);
    if (typeof node.name !== 'string') return null;
    let agentId;
    try {
        agentId = (0, $9JsfF.RovoAgentAri).parse(node.id).agentId;
    } catch  {
        return null;
    }
    return {
        id: agentId,
        name: node.name,
        description: node.description ?? '',
        avatarUrl: node.identityAccount?.picture ?? null,
        identityAccountId: node.identityAccount?.id ?? undefined,
        isFavourite: node.isFavourite ?? false,
        isVerified: node.isVerified ?? false,
        creatorType: node.creatorType ?? undefined
    };
};


const $85488a9a1612b8a9$var$PREFETCH_FAVOURITES_COUNT = 5;
const $85488a9a1612b8a9$var$PREFETCH_VERIFIED_COUNT = 5;
const $85488a9a1612b8a9$var$PREFETCH_ALL_COUNT = 30;
const $85488a9a1612b8a9$export$7d9661023338b817 = async (params)=>{
    if (params.signal?.aborted) return {
        mergedAgents: [],
        canFilterClientSide: false
    };
    const data = await new Promise((resolve, reject)=>{
        let unbindAbortListener = null;
        const settle = (value)=>{
            unbindAbortListener?.();
            resolve(value);
        };
        const fail = (error)=>{
            unbindAbortListener?.();
            reject(error);
        };
        const subscription = (0, $6SsN4.fetchQuery)(params.environment, (0, $364cc8302a9c5705$export$2e2bcd8739ae039), {
            cloudId: params.cloudId,
            product: params.product,
            workspaceId: params.workspaceId,
            favouritesFirst: $85488a9a1612b8a9$var$PREFETCH_FAVOURITES_COUNT,
            verifiedFirst: $85488a9a1612b8a9$var$PREFETCH_VERIFIED_COUNT,
            allFirst: $85488a9a1612b8a9$var$PREFETCH_ALL_COUNT
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: settle,
            error: fail
        });
        if (params.signal) unbindAbortListener = (0, $cbY7C.bind)(params.signal, {
            type: 'abort',
            listener: ()=>{
                subscription.unsubscribe();
                settle(null);
            },
            options: {
                once: true
            }
        });
    });
    const collect = (bucket)=>{
        if (!bucket) return [];
        const result = [];
        for (const edge of bucket.edges){
            const mapped = (0, $9f7dc2a7a15fe802$export$d7d185046b48dbb6)(edge?.node);
            if (mapped) result.push(mapped);
        }
        return result;
    };
    const favourites = collect(data?.favourites);
    const verified = collect(data?.verified);
    const all = collect(data?.all);
    const mergedAgents = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))([
        ...favourites,
        ...verified,
        ...all
    ], 'id');
    const canFilterClientSide = data?.all != null && !data.all.pageInfo?.hasNextPage;
    return {
        mergedAgents: mergedAgents,
        canFilterClientSide: canFilterClientSide
    };
};


/**
 * @generated SignedSource<<0b7e745e1653f09af82d136a4de538b6>>
 * @relayHash 718c1447cbd5d9ff48bc9c15a440b8d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cb9a8bb731d1c02be09cd33be5a679de5a24add31ea47ebd820e40664a4f18d0
const $9061918ecbff5d6c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "name"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "name",
                    "variableName": "name"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
        },
        {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "workspaceId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    }, v8 = {
        "kind": "ScalarField",
        "name": "description"
    }, v9 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchMentionAgentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineDataFragmentSpread",
                                            "name": "mapEdgeToAgent",
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "identityAccount",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "AgentStudioAssistant"
                                                        }
                                                    ],
                                                    "type": "AgentStudioAgent",
                                                    "abstractKey": "__isAgentStudioAgent"
                                                }
                                            ],
                                            "argumentDefinitions": []
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchMentionAgentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "identityAccount",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                v6 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "AgentStudioAssistant"
                                                }
                                            ],
                                            "type": "AgentStudioAgent",
                                            "abstractKey": "__isAgentStudioAgent"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cb9a8bb731d1c02be09cd33be5a679de5a24add31ea47ebd820e40664a4f18d0",
            "metadata": {},
            "name": "searchMentionAgentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9061918ecbff5d6c$var$node.hash = "1409ce63630ddff8c8668acf84d719dd";
var $9061918ecbff5d6c$export$2e2bcd8739ae039 = $9061918ecbff5d6c$var$node;









const $36d71b45f145d06f$var$TYPED_SEARCH_RESULT_LIMIT = 10;
const $36d71b45f145d06f$export$1cd836fb56127c7c = (params)=>new Promise((resolve, reject)=>{
        if (params.signal?.aborted) {
            resolve([]);
            return;
        }
        let unbindAbortListener = null;
        const settle = (result)=>{
            unbindAbortListener?.();
            resolve(result);
        };
        const fail = (error)=>{
            unbindAbortListener?.();
            reject(error);
        };
        const subscription = (0, $6SsN4.fetchQuery)(params.environment, (0, $9061918ecbff5d6c$export$2e2bcd8739ae039), {
            cloudId: params.cloudId,
            product: params.product,
            workspaceId: params.workspaceId,
            name: params.name,
            first: params.count ?? $36d71b45f145d06f$var$TYPED_SEARCH_RESULT_LIMIT
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (response)=>{
                const data = response;
                const edges = data?.agentStudio_getAgents?.edges ?? [];
                const result = [];
                for (const edge of edges){
                    const mapped = (0, $9f7dc2a7a15fe802$export$d7d185046b48dbb6)(edge?.node);
                    if (mapped) result.push(mapped);
                }
                settle(result);
            },
            error: fail
        });
        if (params.signal) unbindAbortListener = (0, $cbY7C.bind)(params.signal, {
            type: 'abort',
            listener: ()=>{
                subscription.unsubscribe();
                settle([]);
            },
            options: {
                once: true
            }
        });
    });


const $95ba3f6dba5dbd17$var$inertSource = {
    getAllAgents: async ()=>[],
    searchByName: async ()=>[],
    canFilterClientSide: ()=>false
};
const $95ba3f6dba5dbd17$export$8b57d6e194b98b62 = (params)=>{
    const { environment: environment, cloudId: cloudId, product: product, workspaceId: workspaceId } = params;
    if (!cloudId) return $95ba3f6dba5dbd17$var$inertSource;
    let lastCanFilterClientSide = false;
    return {
        getAllAgents: async (signal)=>{
            try {
                const result = await (0, $85488a9a1612b8a9$export$7d9661023338b817)({
                    environment: environment,
                    cloudId: cloudId,
                    product: product,
                    workspaceId: workspaceId,
                    signal: signal
                });
                lastCanFilterClientSide = result.canFilterClientSide;
                return result.mergedAgents;
            } catch  {
                return [];
            }
        },
        searchByName: (name, signal)=>(0, $36d71b45f145d06f$export$1cd836fb56127c7c)({
                environment: environment,
                cloudId: cloudId,
                product: product,
                workspaceId: workspaceId,
                name: name,
                signal: signal
            }).catch(()=>[]),
        canFilterClientSide: ()=>lastCanFilterClientSide
    };
};


const $098784ee9fcacf79$export$9556bd500f74be35 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (options)=>{
    const $ = (0, $bDgLe.c)(11);
    const environment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment ?? null;
    const [hasAvailableAgents, setHasAvailableAgents] = (0, $cozmU.useState)(false);
    let t0;
    bb0: {
        if (!options.enabled || !environment) {
            t0 = null;
            break bb0;
        }
        let t1;
        if ($[0] !== environment || $[1] !== options.cloudId || $[2] !== options.product || $[3] !== options.workspaceId) {
            t1 = (0, $95ba3f6dba5dbd17$export$8b57d6e194b98b62)({
                environment: environment,
                cloudId: options.cloudId,
                product: options.product,
                workspaceId: options.workspaceId
            });
            $[0] = environment;
            $[1] = options.cloudId;
            $[2] = options.product;
            $[3] = options.workspaceId;
            $[4] = t1;
        } else t1 = $[4];
        t0 = t1;
    }
    const source = t0;
    let t1;
    let t2;
    if ($[5] !== source) {
        t1 = ()=>{
            if (!source) {
                setHasAvailableAgents(false);
                return;
            }
            const abortController = new AbortController();
            source.getAllAgents(abortController.signal).then((agents)=>{
                if (!abortController.signal.aborted) setHasAvailableAgents(agents.length > 0);
            }).catch(()=>{
                if (!abortController.signal.aborted) setHasAvailableAgents(false);
            });
            return ()=>abortController.abort();
        };
        t2 = [
            source
        ];
        $[5] = source;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[8] !== hasAvailableAgents || $[9] !== source) {
        t3 = {
            agentSource: source,
            hasAvailableAgents: hasAvailableAgents
        };
        $[8] = hasAvailableAgents;
        $[9] = source;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (options)=>{
    const environment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment ?? null;
    const [hasAvailableAgents, setHasAvailableAgents] = (0, $cozmU.useState)(false);
    const source = (0, $cozmU.useMemo)(()=>{
        if (!options.enabled || !environment) return null;
        return (0, $95ba3f6dba5dbd17$export$8b57d6e194b98b62)({
            environment: environment,
            cloudId: options.cloudId,
            product: options.product,
            workspaceId: options.workspaceId
        });
    }, [
        environment,
        options.enabled,
        options.cloudId,
        options.product,
        options.workspaceId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!source) {
            setHasAvailableAgents(false);
            return;
        }
        const abortController = new AbortController();
        source.getAllAgents(abortController.signal).then((agents)=>{
            if (!abortController.signal.aborted) setHasAvailableAgents(agents.length > 0);
        }).catch(()=>{
            if (!abortController.signal.aborted) setHasAvailableAgents(false);
        });
        return ()=>abortController.abort();
    }, [
        source
    ]);
    return {
        agentSource: source,
        hasAvailableAgents: hasAvailableAgents
    };
};
module.exports["useMentionAgentSource"] = $098784ee9fcacf79$export$9556bd500f74be35;

});

parcelRegister("2NrpD", function(module, exports) {
/**
 * BrowserContextSanitizer type definition.
 */ /**
 * Context override provided by an entity-driven chat launch (e.g. clicking "Chat" on a project card).
 * When present, the banner displays this entity's context instead of the current page context.
 *
 * Extensible — to support new entity types, add a new optional field here and a corresponding
 * extractor + priority branch in the `currentContext` memo inside `ContextBanner`.
 */ const $e498d2d47e74c5e8$export$ecf15bf5825c60bb = 'entity_context';
module.exports["ENTITY_CONTEXT_TYPE"] = $e498d2d47e74c5e8$export$ecf15bf5825c60bb;

});

parcelRegister("jOKtZ", function(module, exports) {
const $242e18f876e1e645$export$a252afe315e12711 = ({ useCurrentPageContext: useCurrentPageContext = true, isSpaceScopedConversation: isSpaceScopedConversation = false, hasActiveEditorContext: hasActiveEditorContext, isBrowserContextBlocklisted: isBrowserContextBlocklisted = false, isBrowserContextLoading: isBrowserContextLoading = false })=>{
    return useCurrentPageContext && !isSpaceScopedConversation && hasActiveEditorContext && !isBrowserContextBlocklisted && !isBrowserContextLoading;
};
module.exports["shouldRenderContextBannerSmartCard"] = $242e18f876e1e645$export$a252afe315e12711;

});

parcelRegister("76AAr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");








var $9Yqfz = parcelRequire("9Yqfz");

const $14295ecc3dc2e111$export$4b208edda918084f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToTitle), (0, $9Yqfz.getTitleSnapshot), (0, $9Yqfz.getTitleServerSnapshot));
} : ()=>(0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToTitle), (0, $9Yqfz.getTitleSnapshot), (0, $9Yqfz.getTitleServerSnapshot));



var $hywIT = parcelRequire("hywIT");


var $iDrrr = parcelRequire("iDrrr");


var $2NrpD = parcelRequire("2NrpD");

// Transient query params that the Confluence/Jira SPA shell appends mid-navigation
// (e.g. `?atl_f=PAGETREE` when navigating via the page tree). They change the URL
// for a single intermediate render before settling on the clean URL, which would
// otherwise cause the smart card (keyed/resolved by URL) to churn on a junk URL.
const $3823a126d9b81be9$var$TRANSIENT_URL_PARAMS = [
    'atl_f'
];
/**
 * Strips transient navigation params so the derived URL is stable across a single
 * SPA navigation. Returns the input unchanged if it cannot be parsed.
 */ const $3823a126d9b81be9$var$normalizeContextUrl = (rawUrl)=>{
    if (!rawUrl) return rawUrl;
    try {
        const url = new URL(rawUrl);
        let mutated = false;
        for (const param of $3823a126d9b81be9$var$TRANSIENT_URL_PARAMS)if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            mutated = true;
        }
        return mutated ? url.toString() : rawUrl;
    } catch  {
        return rawUrl;
    }
};
const $3823a126d9b81be9$export$ff2c64d3f2c9ce84 = ({ currentContext: currentContext, hasBrowserContext: hasBrowserContext, browserContextUrl: browserContextUrl, windowHref: windowHref, documentTitle: documentTitle })=>{
    if (currentContext.type === (0, $2NrpD.ENTITY_CONTEXT_TYPE)) return {
        displayUrl: currentContext.url,
        displayTitle: currentContext.name,
        source: 'entity'
    };
    if (currentContext.type === 'trello_view_context' && (0, $iDrrr.fg)('trello_enterprise_rovo_trello_context')) return {
        displayUrl: currentContext.payload.url,
        displayTitle: currentContext.payload.name ?? currentContext.payload.url,
        source: 'entity'
    };
    if (hasBrowserContext && browserContextUrl) return {
        displayUrl: browserContextUrl,
        displayTitle: browserContextUrl,
        source: 'browser-context'
    };
    return {
        displayUrl: $3823a126d9b81be9$var$normalizeContextUrl(windowHref),
        displayTitle: documentTitle,
        source: 'current-page'
    };
};


const $e8bc14143868a298$export$147bebfd1c81350a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { currentContext: currentContext, hasBrowserContext: hasBrowserContext, browserContextUrl: browserContextUrl } = t0;
    const windowHref = (0, $hywIT.useWindowLocation)();
    const documentTitle = (0, $14295ecc3dc2e111$export$4b208edda918084f)();
    let t1;
    if ($[0] !== browserContextUrl || $[1] !== currentContext || $[2] !== documentTitle || $[3] !== hasBrowserContext || $[4] !== windowHref) {
        t1 = (0, $3823a126d9b81be9$export$ff2c64d3f2c9ce84)({
            currentContext: currentContext,
            hasBrowserContext: hasBrowserContext,
            browserContextUrl: browserContextUrl,
            windowHref: windowHref,
            documentTitle: documentTitle
        });
        $[0] = browserContextUrl;
        $[1] = currentContext;
        $[2] = documentTitle;
        $[3] = hasBrowserContext;
        $[4] = windowHref;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ currentContext: currentContext, hasBrowserContext: hasBrowserContext, browserContextUrl: browserContextUrl })=>{
    // Subscribe to location changes so the banner re-derives its URL on SPA
    // navigation even when the parent does not re-render (e.g. when this
    // component is memoized). A raw `window.location.href` read here would be
    // a render-time global read with no subscription, so under React.memo it
    // could go stale on pushState/replaceState/popstate navigations.
    const windowHref = (0, $hywIT.useWindowLocation)();
    // `document.title` is updated by the shell *after* the navigation that changes
    // the location, so reading it reactively (rather than at render time) is what
    // keeps the smart-link placeholder from lagging one navigation behind.
    const documentTitle = (0, $14295ecc3dc2e111$export$4b208edda918084f)();
    return (0, $cozmU.useMemo)(()=>(0, $3823a126d9b81be9$export$ff2c64d3f2c9ce84)({
            currentContext: currentContext,
            hasBrowserContext: hasBrowserContext,
            browserContextUrl: browserContextUrl,
            windowHref: windowHref,
            documentTitle: documentTitle
        }), [
        currentContext,
        hasBrowserContext,
        browserContextUrl,
        windowHref,
        documentTitle
    ]);
};
module.exports["useContextBannerSmartLinkInfo"] = $e8bc14143868a298$export$147bebfd1c81350a;

});

parcelRegister("bkEQw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $9OWHk = parcelRequire("9OWHk");


var $5aQkY = parcelRequire("5aQkY");

const $03095ef2b4e313b0$var$useConversationSelectedAgentDraftState = (0, $kBr4q.createStateHook)((0, $5aQkY.selectedAgentDraftControllerStore), {
    selector: (state, conversationId)=>{
        const selectedAgentIds = state.selectedAgentIds[conversationId] ?? (0, $9OWHk.EMPTY_SELECTED_AGENT_IDS);
        const activeSelectedAgentId = selectedAgentIds.at(-1);
        return {
            selectedAgentIds: selectedAgentIds,
            activeSelectedAgentId: activeSelectedAgentId,
            activeSelectedAgentMetadata: activeSelectedAgentId ? state.selectedAgentMetadata[conversationId]?.[activeSelectedAgentId] : undefined
        };
    }
});
const $03095ef2b4e313b0$var$useSelectedAgentDraftActions = (0, $kBr4q.createActionsHook)((0, $5aQkY.selectedAgentDraftControllerStore));
const $03095ef2b4e313b0$export$cf0f6472d8ae68d1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId)=>{
    const $ = (0, $bDgLe.c)(16);
    const { selectedAgentIds: selectedAgentIds, activeSelectedAgentId: activeSelectedAgentId, activeSelectedAgentMetadata: activeSelectedAgentMetadata } = $03095ef2b4e313b0$var$useConversationSelectedAgentDraftState(conversationId);
    const { setSelectedAgentIds: storeSetSelectedAgentIds, addSelectedAgentId: storeAddSelectedAgentId, removeSelectedAgentId: storeRemoveSelectedAgentId } = $03095ef2b4e313b0$var$useSelectedAgentDraftActions();
    let t0;
    if ($[0] !== conversationId || $[1] !== storeSetSelectedAgentIds) {
        t0 = (agentIds)=>{
            storeSetSelectedAgentIds(conversationId, agentIds);
        };
        $[0] = conversationId;
        $[1] = storeSetSelectedAgentIds;
        $[2] = t0;
    } else t0 = $[2];
    const setSelectedAgentIds = t0;
    let t1;
    if ($[3] !== conversationId || $[4] !== storeAddSelectedAgentId) {
        t1 = (agentId, metadata)=>{
            storeAddSelectedAgentId(conversationId, agentId, metadata);
        };
        $[3] = conversationId;
        $[4] = storeAddSelectedAgentId;
        $[5] = t1;
    } else t1 = $[5];
    const addSelectedAgentId = t1;
    let t2;
    if ($[6] !== conversationId || $[7] !== storeRemoveSelectedAgentId) {
        t2 = (agentId_0)=>{
            storeRemoveSelectedAgentId(conversationId, agentId_0);
        };
        $[6] = conversationId;
        $[7] = storeRemoveSelectedAgentId;
        $[8] = t2;
    } else t2 = $[8];
    const removeSelectedAgentId = t2;
    let t3;
    if ($[9] !== activeSelectedAgentId || $[10] !== activeSelectedAgentMetadata || $[11] !== addSelectedAgentId || $[12] !== removeSelectedAgentId || $[13] !== selectedAgentIds || $[14] !== setSelectedAgentIds) {
        t3 = {
            selectedAgentIds: selectedAgentIds,
            activeSelectedAgentId: activeSelectedAgentId,
            activeSelectedAgentMetadata: activeSelectedAgentMetadata,
            setSelectedAgentIds: setSelectedAgentIds,
            addSelectedAgentId: addSelectedAgentId,
            removeSelectedAgentId: removeSelectedAgentId
        };
        $[9] = activeSelectedAgentId;
        $[10] = activeSelectedAgentMetadata;
        $[11] = addSelectedAgentId;
        $[12] = removeSelectedAgentId;
        $[13] = selectedAgentIds;
        $[14] = setSelectedAgentIds;
        $[15] = t3;
    } else t3 = $[15];
    return t3;
} : (conversationId)=>{
    const { selectedAgentIds: selectedAgentIds, activeSelectedAgentId: activeSelectedAgentId, activeSelectedAgentMetadata: activeSelectedAgentMetadata } = $03095ef2b4e313b0$var$useConversationSelectedAgentDraftState(conversationId);
    const { setSelectedAgentIds: storeSetSelectedAgentIds, addSelectedAgentId: storeAddSelectedAgentId, removeSelectedAgentId: storeRemoveSelectedAgentId } = $03095ef2b4e313b0$var$useSelectedAgentDraftActions();
    const setSelectedAgentIds = (0, $cozmU.useCallback)((agentIds)=>{
        storeSetSelectedAgentIds(conversationId, agentIds);
    }, [
        conversationId,
        storeSetSelectedAgentIds
    ]);
    const addSelectedAgentId = (0, $cozmU.useCallback)((agentId, metadata)=>{
        storeAddSelectedAgentId(conversationId, agentId, metadata);
    }, [
        conversationId,
        storeAddSelectedAgentId
    ]);
    const removeSelectedAgentId = (0, $cozmU.useCallback)((agentId_0)=>{
        storeRemoveSelectedAgentId(conversationId, agentId_0);
    }, [
        conversationId,
        storeRemoveSelectedAgentId
    ]);
    return {
        selectedAgentIds: selectedAgentIds,
        activeSelectedAgentId: activeSelectedAgentId,
        activeSelectedAgentMetadata: activeSelectedAgentMetadata,
        setSelectedAgentIds: setSelectedAgentIds,
        addSelectedAgentId: addSelectedAgentId,
        removeSelectedAgentId: removeSelectedAgentId
    };
};
module.exports["useSelectedAgentDraftController"] = $03095ef2b4e313b0$export$cf0f6472d8ae68d1;

});

parcelRegister("g3RoK", function(module, exports) {
const $086fd1797ae125c3$var$agentCreatorTypes = [
    'SYSTEM',
    'CUSTOMER',
    'THIRD_PARTY',
    'FORGE',
    'OOTB',
    'REMOTE_A2A'
];
const $086fd1797ae125c3$export$49428e407f5ce21e = (creatorType)=>$086fd1797ae125c3$var$agentCreatorTypes.includes(creatorType);
module.exports["isAgentCreatorType"] = $086fd1797ae125c3$export$49428e407f5ce21e;

});

parcelRegister("fIbhb", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $g9Q3L = parcelRequire("g9Q3L");

const $9aa8701dbb8f1b88$export$102435cf7eabb2a2 = (0, $kBr4q.createActionsHook)((0, $g9Q3L.store));
module.exports["useAppConnectionBannerActions"] = $9aa8701dbb8f1b88$export$102435cf7eabb2a2;

});

parcelRegister("gj7Xh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $eh6Ml = parcelRequire("eh6Ml");


var $l3wuH = parcelRequire("l3wuH");


var $cJ0FD = parcelRequire("cJ0FD");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $7pCWA = parcelRequire("7pCWA");


var $its7R = parcelRequire("its7R");


var $4M6Ac = parcelRequire("4M6Ac");




const $b07e91c8046e7502$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    resultsAreFromApps: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.results-are-from-apps",
        defaultMessage: "Results are from {appList}."
    },
    connectPromptIntro: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connect-prompt-intro",
        defaultMessage: "Connect {appList} below and real context will start flowing into drafts like this, usually within a few hours. Need something specific now? Paste a link and I\u2019ll use it right away."
    },
    connectAppName: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connect-app-name",
        defaultMessage: "Connect {appName}"
    },
    connect: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connect",
        defaultMessage: "Connect"
    },
    connected: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.connected",
        defaultMessage: "Connected"
    },
    dismissBannerLabel: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-connection-banner.dismiss-label",
        defaultMessage: "Dismiss app connection banner"
    }
});


const $cfbcd8eb9fcb0f15$var$styles = {
    bannerWrapper: "_0bjKvDyzSk _2Y7lL48HPE _4c065U8HPE _0KLXrunmFW _0rIjyk8HPE _4kiQYAUF4f",
    bannerWrapperMultiline: "_0bjKvDyzSk _2mHwu82ADO _2Y7lL48HPE _4c065U8HPE _0KLXrunmFW _0rIjyk8HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    contentContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn",
    topRow: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLchRC _37wbyuI7V3",
    buttonsRow: "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT",
    buttonContent: "_2mHwu8gVvo _3iDTPbQ4SZ _0hPCNLDIqT _1kk5Tku7m9",
    buttonsContainer: "_3YEZNOdnbC",
    rowLabel: "_4ouGXIdnbC",
    rowsCard: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc",
    row: "_2Y7lL48HPE _4c065U2ADO",
    rowDivider: "_4auqkJNvrM _2yjt2x6wH8 _3mHaMX9r67",
    connectedChip: "_2mHwu81Y8M _0bjKvDKxmn _2Y7lL42ADO _4c065UFQfX _2V7sgONvrM _3hxITi6wH8 _3vBAKHgYjz _3iDTPbccYA _0hPCNLDIqT _0KLXruzaZe _1UtDYzGL5O"
};
/** Intl.ListFormat is ES2020; type assertion for TS libs that don't declare it. */ const $cfbcd8eb9fcb0f15$var$ListFormatConstructor = Intl.ListFormat; /**
                * Formats app names for display using proper i18n list formatting.
                * e.g. conjunction → "A and B", disjunction → "A or B" (varies by locale)
                */ 
function $cfbcd8eb9fcb0f15$var$formatAppList(names, locale, type) {
    if (names.length === 1) return names[0];
    const formatter = new $cfbcd8eb9fcb0f15$var$ListFormatConstructor(locale, {
        style: 'long',
        type: type
    });
    return formatter.format(names);
} /**
   * Like {@link formatAppList} but renders each app name in bold, preserving the
   * locale-correct separators (", ", " or ", …) between them.
   */ 
function $cfbcd8eb9fcb0f15$var$formatAppListNodes(names, locale, type) {
    if (names.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, names[0]);
    const formatter = new $cfbcd8eb9fcb0f15$var$ListFormatConstructor(locale, {
        style: 'long',
        type: type
    });
    return formatter.formatToParts(names).map((part, index)=>part.type === 'element' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: index,
            as: "strong"
        }, part.value) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: index
        }, part.value));
}
const $cfbcd8eb9fcb0f15$var$ConnectAppButton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { app: app, connectLabel: connectLabel, onConnectSuccess: onConnectSuccess } = t0;
    let t1;
    if ($[0] !== app.source || $[1] !== onConnectSuccess) {
        t1 = ()=>{
            onConnectSuccess(app.source);
        };
        $[0] = app.source;
        $[1] = onConnectSuccess;
        $[2] = t1;
    } else t1 = $[2];
    const handleConnectSuccess = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "connectionBanner"
        };
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== app.friendlyName || $[5] !== app.outboundAuthUrl || $[6] !== app.source || $[7] !== handleConnectSuccess) {
        t3 = {
            friendlyName: app.friendlyName,
            appSource: app.source,
            outboundAuthUrl: app.outboundAuthUrl,
            onCompletedAction: handleConnectSuccess,
            analyticsAttributes: t2
        };
        $[4] = app.friendlyName;
        $[5] = app.outboundAuthUrl;
        $[6] = app.source;
        $[7] = handleConnectSuccess;
        $[8] = t3;
    } else t3 = $[8];
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)(t3);
    let t4;
    if ($[9] !== app.friendlyName || $[10] !== app.iconUrl || $[11] !== app.source) {
        t4 = (0, $iDrrr.fg)("rovo_chat_use_be_knowledge_icons") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: app.iconUrl,
            alt: app.friendlyName,
            width: 20,
            height: 20
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
            appSource: app.source,
            rovoLogoProps: {
                size: "xsmall"
            }
        });
        $[9] = app.friendlyName;
        $[10] = app.iconUrl;
        $[11] = app.source;
        $[12] = t4;
    } else t4 = $[12];
    const icon = t4;
    let t5;
    if ($[13] !== connectLabel || $[14] !== icon) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cfbcd8eb9fcb0f15$var$styles.buttonContent
        }, icon, connectLabel);
        $[13] = connectLabel;
        $[14] = icon;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== onAuthorize || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onAuthorize
        }, t5);
        $[16] = onAuthorize;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ app: app, connectLabel: connectLabel, onConnectSuccess: onConnectSuccess })=>{
    const handleConnectSuccess = (0, $cozmU.useCallback)(()=>{
        onConnectSuccess(app.source);
    }, [
        app.source,
        onConnectSuccess
    ]);
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)({
        friendlyName: app.friendlyName,
        appSource: app.source,
        outboundAuthUrl: app.outboundAuthUrl,
        onCompletedAction: handleConnectSuccess,
        analyticsAttributes: {
            source: 'connectionBanner'
        }
    });
    const icon = (0, $iDrrr.fg)('rovo_chat_use_be_knowledge_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: app.iconUrl,
        alt: app.friendlyName,
        width: 20,
        height: 20
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
        appSource: app.source,
        rovoLogoProps: {
            size: 'xsmall'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onAuthorize
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.buttonContent
    }, icon, connectLabel));
};
const $cfbcd8eb9fcb0f15$var$ConnectRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { app: app, connectLabel: connectLabel, connectAccessibleLabel: connectAccessibleLabel, connectedLabel: connectedLabel, onConnectSuccess: onConnectSuccess } = t0;
    const [connectors] = (0, $7pCWA.useConnectors)();
    let t1;
    if ($[0] !== app.source || $[1] !== onConnectSuccess) {
        t1 = ()=>{
            onConnectSuccess(app.source);
        };
        $[0] = app.source;
        $[1] = onConnectSuccess;
        $[2] = t1;
    } else t1 = $[2];
    const handleConnectSuccess = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "connectionBanner"
        };
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== app.friendlyName || $[5] !== app.outboundAuthUrl || $[6] !== app.source || $[7] !== handleConnectSuccess) {
        t3 = {
            friendlyName: app.friendlyName,
            appSource: app.source,
            outboundAuthUrl: app.outboundAuthUrl,
            onCompletedAction: handleConnectSuccess,
            analyticsAttributes: t2
        };
        $[4] = app.friendlyName;
        $[5] = app.outboundAuthUrl;
        $[6] = app.source;
        $[7] = handleConnectSuccess;
        $[8] = t3;
    } else t3 = $[8];
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)(t3);
    let t4;
    if ($[9] !== app.iconUrl || $[10] !== app.source) {
        t4 = (0, $iDrrr.fg)("rovo_chat_use_be_knowledge_icons") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: app.iconUrl,
            alt: "",
            width: 24,
            height: 24
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
            appSource: app.source,
            rovoLogoProps: {
                size: "small"
            }
        });
        $[9] = app.iconUrl;
        $[10] = app.source;
        $[11] = t4;
    } else t4 = $[11];
    const icon = t4;
    let t5;
    if ($[12] !== app.friendlyName) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, app.friendlyName);
        $[12] = app.friendlyName;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== icon || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $cfbcd8eb9fcb0f15$var$styles.rowLabel
        }, icon, t5);
        $[14] = icon;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== app.source || $[18] !== connectAccessibleLabel || $[19] !== connectLabel || $[20] !== connectedLabel || $[21] !== connectors || $[22] !== onAuthorize) {
        t7 = connectors[app.source]?.isUserOAuthed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cfbcd8eb9fcb0f15$var$styles.connectedChip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            size: "small",
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "inherit"
        }, connectedLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: onAuthorize,
            "aria-label": connectAccessibleLabel
        }, connectLabel);
        $[17] = app.source;
        $[18] = connectAccessibleLabel;
        $[19] = connectLabel;
        $[20] = connectedLabel;
        $[21] = connectors;
        $[22] = onAuthorize;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== t6 || $[25] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, t6, t7);
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
} : ({ app: app, connectLabel: connectLabel, connectAccessibleLabel: connectAccessibleLabel, connectedLabel: connectedLabel, onConnectSuccess: onConnectSuccess })=>{
    const [connectors] = (0, $7pCWA.useConnectors)();
    const handleConnectSuccess = (0, $cozmU.useCallback)(()=>{
        onConnectSuccess(app.source);
    }, [
        app.source,
        onConnectSuccess
    ]);
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)({
        friendlyName: app.friendlyName,
        appSource: app.source,
        outboundAuthUrl: app.outboundAuthUrl,
        onCompletedAction: handleConnectSuccess,
        analyticsAttributes: {
            source: 'connectionBanner'
        }
    });
    const icon = (0, $iDrrr.fg)('rovo_chat_use_be_knowledge_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: app.iconUrl,
        alt: "",
        width: 24,
        height: 24
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
        appSource: app.source,
        rovoLogoProps: {
            size: 'small'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $cfbcd8eb9fcb0f15$var$styles.rowLabel
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, app.friendlyName)), connectors[app.source]?.isUserOAuthed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.connectedChip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        size: "small",
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "inherit"
    }, connectedLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onAuthorize,
        "aria-label": connectAccessibleLabel
    }, connectLabel));
};
const $cfbcd8eb9fcb0f15$export$c2ec720f39265ac3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(50);
    const { unconnectedApps: unconnectedApps, onDismiss: onDismiss, onConnect: onConnect, forceMultiline: t1, showConnectedState: t2 } = t0;
    const forceMultiline = t1 === undefined ? false : t1;
    const showConnectedState = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    if (unconnectedApps.length === 0) return null;
    let t3;
    if ($[0] !== formatMessage || $[1] !== locale || $[2] !== showConnectedState || $[3] !== unconnectedApps) {
        const appNames = unconnectedApps.map($cfbcd8eb9fcb0f15$var$_temp);
        t3 = showConnectedState ? formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connectPromptIntro, {
            appList: $cfbcd8eb9fcb0f15$var$formatAppListNodes(appNames, locale, "disjunction")
        }) : formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).resultsAreFromApps, {
            appList: $cfbcd8eb9fcb0f15$var$formatAppList(appNames, locale, "conjunction")
        });
        $[0] = formatMessage;
        $[1] = locale;
        $[2] = showConnectedState;
        $[3] = unconnectedApps;
        $[4] = t3;
    } else t3 = $[4];
    const bannerMessage = t3;
    if (showConnectedState) {
        let t4;
        if ($[5] !== bannerMessage) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium"
            }, bannerMessage);
            $[5] = bannerMessage;
            $[6] = t4;
        } else t4 = $[6];
        let t5;
        if ($[7] !== formatMessage || $[8] !== onConnect || $[9] !== unconnectedApps) {
            let t6;
            if ($[11] !== formatMessage || $[12] !== onConnect || $[13] !== unconnectedApps.length) {
                t6 = (app_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        key: app_0.source,
                        xcss: (0, $w6R6I.cx)($cfbcd8eb9fcb0f15$var$styles.row, index < unconnectedApps.length - 1 && $cfbcd8eb9fcb0f15$var$styles.rowDivider)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cfbcd8eb9fcb0f15$var$ConnectRow, {
                        app: app_0,
                        connectLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connect),
                        connectAccessibleLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connectAppName, {
                            appName: app_0.friendlyName
                        }),
                        connectedLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connected),
                        onConnectSuccess: onConnect
                    }));
                $[11] = formatMessage;
                $[12] = onConnect;
                $[13] = unconnectedApps.length;
                $[14] = t6;
            } else t6 = $[14];
            t5 = unconnectedApps.map(t6);
            $[7] = formatMessage;
            $[8] = onConnect;
            $[9] = unconnectedApps;
            $[10] = t5;
        } else t5 = $[10];
        let t6;
        if ($[15] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $cfbcd8eb9fcb0f15$var$styles.rowsCard
            }, t5);
            $[15] = t5;
            $[16] = t6;
        } else t6 = $[16];
        let t7;
        if ($[17] !== t4 || $[18] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.150"
            }, t4, t6);
            $[17] = t4;
            $[18] = t6;
            $[19] = t7;
        } else t7 = $[19];
        return t7;
    }
    const isMultiline = forceMultiline || unconnectedApps.length > 2;
    let t4;
    if ($[20] !== formatMessage) {
        t4 = formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).dismissBannerLabel);
        $[20] = formatMessage;
        $[21] = t4;
    } else t4 = $[21];
    let t5;
    if ($[22] !== onDismiss || $[23] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            spacing: "compact",
            appearance: "subtle",
            shape: "circle",
            label: t4,
            icon: $cfbcd8eb9fcb0f15$var$_temp2,
            onClick: onDismiss
        });
        $[22] = onDismiss;
        $[23] = t4;
        $[24] = t5;
    } else t5 = $[24];
    const closeButton = t5;
    let t6;
    if ($[25] !== formatMessage || $[26] !== onConnect || $[27] !== unconnectedApps) {
        let t7;
        if ($[29] !== formatMessage || $[30] !== onConnect) {
            t7 = (app_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cfbcd8eb9fcb0f15$var$ConnectAppButton, {
                    key: app_1.source,
                    app: app_1,
                    connectLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connectAppName, {
                        appName: app_1.friendlyName
                    }),
                    onConnectSuccess: onConnect
                });
            $[29] = formatMessage;
            $[30] = onConnect;
            $[31] = t7;
        } else t7 = $[31];
        t6 = unconnectedApps.map(t7);
        $[25] = formatMessage;
        $[26] = onConnect;
        $[27] = unconnectedApps;
        $[28] = t6;
    } else t6 = $[28];
    const connectButtons = t6;
    if (isMultiline) {
        let t7;
        if ($[32] !== bannerMessage) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $cfbcd8eb9fcb0f15$var$styles.contentContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "medium"
            }, bannerMessage));
            $[32] = bannerMessage;
            $[33] = t7;
        } else t7 = $[33];
        let t8;
        if ($[34] !== closeButton || $[35] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $cfbcd8eb9fcb0f15$var$styles.topRow
            }, t7, closeButton);
            $[34] = closeButton;
            $[35] = t7;
            $[36] = t8;
        } else t8 = $[36];
        let t9;
        if ($[37] !== connectButtons) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $cfbcd8eb9fcb0f15$var$styles.buttonsRow
            }, connectButtons);
            $[37] = connectButtons;
            $[38] = t9;
        } else t9 = $[38];
        let t10;
        if ($[39] !== t8 || $[40] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $cfbcd8eb9fcb0f15$var$styles.bannerWrapperMultiline
            }, t8, t9);
            $[39] = t8;
            $[40] = t9;
            $[41] = t10;
        } else t10 = $[41];
        return t10;
    }
    let t7;
    if ($[42] !== bannerMessage) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cfbcd8eb9fcb0f15$var$styles.contentContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium"
        }, bannerMessage));
        $[42] = bannerMessage;
        $[43] = t7;
    } else t7 = $[43];
    let t8;
    if ($[44] !== closeButton || $[45] !== connectButtons) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $cfbcd8eb9fcb0f15$var$styles.buttonsContainer
        }, connectButtons, closeButton);
        $[44] = closeButton;
        $[45] = connectButtons;
        $[46] = t8;
    } else t8 = $[46];
    let t9;
    if ($[47] !== t7 || $[48] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cfbcd8eb9fcb0f15$var$styles.bannerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.150",
            alignBlock: "center",
            spread: "space-between"
        }, t7, t8));
        $[47] = t7;
        $[48] = t8;
        $[49] = t9;
    } else t9 = $[49];
    return t9;
} : ({ unconnectedApps: unconnectedApps, onDismiss: onDismiss, onConnect: onConnect, forceMultiline: forceMultiline = false, showConnectedState: showConnectedState = false })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    if (unconnectedApps.length === 0) return null;
    const appNames = unconnectedApps.map((app)=>app.friendlyName); // The 3P connected-state variant uses an invitational intro ("Connect X or Y…"),
    // so the app names read as alternatives (disjunction) rather than a result set.
    const bannerMessage = showConnectedState ? formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connectPromptIntro, {
        appList: $cfbcd8eb9fcb0f15$var$formatAppListNodes(appNames, locale, 'disjunction')
    }) : formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).resultsAreFromApps, {
        appList: $cfbcd8eb9fcb0f15$var$formatAppList(appNames, locale, 'conjunction')
    }); // 3P suggested-prompts variant: rendered inline in the chat thread
    // (InThreadAppConnectionPrompt), so it reads as assistant message content — an
    // invitational intro followed by per-connector rows, with no banner surface or
    // dismiss chrome.
    if (showConnectedState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, bannerMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.rowsCard
    }, unconnectedApps.map((app_0, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: app_0.source,
            xcss: (0, $w6R6I.cx)($cfbcd8eb9fcb0f15$var$styles.row, index < unconnectedApps.length - 1 && $cfbcd8eb9fcb0f15$var$styles.rowDivider)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cfbcd8eb9fcb0f15$var$ConnectRow, {
            app: app_0,
            connectLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connect),
            connectAccessibleLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connectAppName, {
                appName: app_0.friendlyName
            }),
            connectedLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connected),
            onConnectSuccess: onConnect
        })))));
    const isMultiline = forceMultiline || unconnectedApps.length > 2;
    const closeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        spacing: "compact",
        appearance: "subtle",
        shape: "circle",
        label: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).dismissBannerLabel),
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                size: "small",
                label: "",
                color: "var(--ds-text-subtlest, #6B6E76)"
            }),
        onClick: onDismiss
    });
    const connectButtons = unconnectedApps.map((app_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cfbcd8eb9fcb0f15$var$ConnectAppButton, {
            key: app_1.source,
            app: app_1,
            connectLabel: formatMessage((0, $b07e91c8046e7502$export$defe85febe8b728c).connectAppName, {
                appName: app_1.friendlyName
            }),
            onConnectSuccess: onConnect
        }));
    if (isMultiline) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.bannerWrapperMultiline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.topRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, bannerMessage)), closeButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.buttonsRow
    }, connectButtons));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.bannerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cfbcd8eb9fcb0f15$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium"
    }, bannerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $cfbcd8eb9fcb0f15$var$styles.buttonsContainer
    }, connectButtons, closeButton)));
};
function $cfbcd8eb9fcb0f15$var$_temp(app) {
    return app.friendlyName;
}
function $cfbcd8eb9fcb0f15$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        size: "small",
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    });
}
module.exports["AppConnectionBanner"] = $cfbcd8eb9fcb0f15$export$c2ec720f39265ac3;

});

parcelRegister("its7R", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bltJZ = parcelRequire("bltJZ");


var $91ZZN = parcelRequire("91ZZN");


var $ak8CL = parcelRequire("ak8CL");


const $29e2588a6989af85$var$Lazy3PLogoWrapper = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUIvd")).then((module)=>({
            default: module.Lazy3PLogoWrapper
        })));
const $29e2588a6989af85$var$ProductKeysToLogoMap = new Map([
    [
        'jira',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.JiraIcon))
    ],
    [
        'confluence',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.ConfluenceIcon))
    ],
    [
        'bamboo',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.BambooIcon))
    ],
    [
        'focus',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.FocusIcon))
    ],
    [
        'compass',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.CompassIcon))
    ],
    [
        'jsm',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.JiraServiceManagementIcon))
    ],
    [
        'admin',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.AdminIcon))
    ],
    [
        'align',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.AlignIcon))
    ],
    [
        'bitbucket',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.BitbucketIcon))
    ],
    [
        'jira_dc',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.JiraDataCenterIcon))
    ],
    [
        'confluence_dc',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.ConfluenceDataCenterIcon))
    ],
    [
        'trello',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.TrelloIcon))
    ],
    [
        'atlas',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.HomeIcon))
    ],
    [
        'help_aggregator',
        (0, $ak8CL.RovoLogoFromLogo)((0, $bltJZ.CustomerServiceManagementIcon))
    ]
]);
const $29e2588a6989af85$export$88e12026a61a33a9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoLogoForAppSource(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { appSource: appSource, rovoLogoProps: rovoLogoProps, fallback: fallback } = t0;
    let t1;
    if ($[0] !== appSource) {
        t1 = $29e2588a6989af85$var$ProductKeysToLogoMap.get(appSource);
        $[0] = appSource;
        $[1] = t1;
    } else t1 = $[1];
    const productLogo = t1;
    if (productLogo) {
        const Logo = productLogo;
        let t2;
        if ($[2] !== Logo || $[3] !== rovoLogoProps) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, rovoLogoProps);
            $[2] = Logo;
            $[3] = rovoLogoProps;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t2;
    if ($[5] !== appSource || $[6] !== fallback || $[7] !== rovoLogoProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($29e2588a6989af85$var$Lazy3PLogoWrapper, {
            appSource: appSource,
            rovoLogoProps: rovoLogoProps,
            fallback: fallback
        });
        $[5] = appSource;
        $[6] = fallback;
        $[7] = rovoLogoProps;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== fallback || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-rovo-logo-for-app-source",
            fallback: fallback
        }, t2);
        $[9] = fallback;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : function RovoLogoForAppSource({ appSource: appSource, rovoLogoProps: rovoLogoProps, fallback: fallback }) {
    const productLogo = $29e2588a6989af85$var$ProductKeysToLogoMap.get(appSource);
    if (productLogo) {
        const Logo = productLogo;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Logo, rovoLogoProps);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-rovo-logo-for-app-source",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($29e2588a6989af85$var$Lazy3PLogoWrapper, {
        appSource: appSource,
        rovoLogoProps: rovoLogoProps,
        fallback: fallback
    }));
};
module.exports["RovoLogoForAppSource"] = $29e2588a6989af85$export$88e12026a61a33a9;

});

parcelRegister("ak8CL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bb66c4985ea9ad7a$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
};
module.exports["RovoLogoFromLogo"] = $bb66c4985ea9ad7a$export$32db889b380fa03c;

});

parcelRegister("hUIvd", function(module, exports) {

let $d0aa2fe39b26f686$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d0aa2fe39b26f686$var$load("eS1b9"),
    $d0aa2fe39b26f686$var$load("d1mSF")
]).then(()=>parcelRequire('duTH0'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("4M6Ac", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7ieQR = parcelRequire("7ieQR");

const $4c53bcf4cb37778f$export$683e74383c07ce41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction, onFailAction: onFailAction, analyticsAttributes: t1 } = t0;
    const { source: source, isNewlyEnabled: isNewlyEnabled, surface: surface } = t1;
    const createHandler = (0, $7ieQR.useOAuthHandlerFactory)();
    let t2;
    if ($[0] !== appSource || $[1] !== createHandler || $[2] !== friendlyName || $[3] !== isNewlyEnabled || $[4] !== onCompletedAction || $[5] !== onFailAction || $[6] !== outboundAuthUrl || $[7] !== source || $[8] !== surface) {
        t2 = createHandler({
            friendlyName: friendlyName,
            appSource: appSource,
            outboundAuthUrl: outboundAuthUrl,
            onCompletedAction: onCompletedAction,
            onFailAction: onFailAction,
            analyticsAttributes: {
                source: source,
                isNewlyEnabled: isNewlyEnabled,
                surface: surface
            }
        });
        $[0] = appSource;
        $[1] = createHandler;
        $[2] = friendlyName;
        $[3] = isNewlyEnabled;
        $[4] = onCompletedAction;
        $[5] = onFailAction;
        $[6] = outboundAuthUrl;
        $[7] = source;
        $[8] = surface;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction, onFailAction: onFailAction, analyticsAttributes: { source: source, isNewlyEnabled: isNewlyEnabled, surface: surface } })=>{
    const createHandler = (0, $7ieQR.useOAuthHandlerFactory)();
    return (0, $cozmU.useMemo)(()=>createHandler({
            friendlyName: friendlyName,
            appSource: appSource,
            outboundAuthUrl: outboundAuthUrl,
            onCompletedAction: onCompletedAction,
            onFailAction: onFailAction,
            analyticsAttributes: {
                source: source,
                isNewlyEnabled: isNewlyEnabled,
                surface: surface
            }
        }), [
        createHandler,
        friendlyName,
        appSource,
        outboundAuthUrl,
        onCompletedAction,
        onFailAction,
        source,
        isNewlyEnabled,
        surface
    ]);
};
module.exports["useAppOAuth"] = $4c53bcf4cb37778f$export$683e74383c07ce41;

});

parcelRegister("lTaB7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gzMZq = parcelRequire("gzMZq");


var $7pCWA = parcelRequire("7pCWA");

/**
 * Extracts the `serviceKey` query parameter from an outbound auth URL.
 * Handles two URL shapes:
 * - Direct: `outboundAuth/start?serviceKey=slack&...`
 * - Wrapped: `login?continue=...%2FoutboundAuth%2Fstart%3FserviceKey%3Dslack...`
 *
 * Both the ORS `meta.auth[0].url` and the connector `outboundAuthUrl` use the same
 * `serviceKey` value, making it the reliable key for cross-environment matching.
 */ function $33022145a6a650e1$var$extractServiceKey(url) {
    try {
        const parsed = new URL(url);
        const direct = parsed.searchParams.get('serviceKey');
        if (direct) return direct;
        const continueParam = parsed.searchParams.get('continue');
        if (continueParam) {
            const inner = new URL(decodeURIComponent(continueParam));
            return inner.searchParams.get('serviceKey') ?? undefined;
        }
    } catch  {
    // malformed URL
    }
    return undefined;
}
const $33022145a6a650e1$export$7d18d4a799cee79f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [pageSmartLinks] = (0, $gzMZq.useChatContextPageSmartLinks)();
    const [allKnowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    let t0;
    if ($[0] !== allKnowledgeSources || $[1] !== pageSmartLinks) {
        bb0: {
            if (!pageSmartLinks?.length || !allKnowledgeSources.length) {
                t0 = null;
                break bb0;
            }
            let unconnectedByName;
            let unconnectedByServiceKey;
            if ($[3] !== allKnowledgeSources) {
                unconnectedByName = new Map();
                unconnectedByServiceKey = new Map();
                for (const connector of allKnowledgeSources)if (!connector.isUserOAuthed) {
                    if (connector.friendlyName) unconnectedByName.set(connector.friendlyName.toLowerCase(), connector);
                    const serviceKey = $33022145a6a650e1$var$extractServiceKey(connector.outboundAuthUrl) ?? connector.source;
                    unconnectedByServiceKey.set(serviceKey, connector);
                }
                $[3] = allKnowledgeSources;
                $[4] = unconnectedByName;
                $[5] = unconnectedByServiceKey;
            } else {
                unconnectedByName = $[4];
                unconnectedByServiceKey = $[5];
            }
            if (unconnectedByName.size === 0 && unconnectedByServiceKey.size === 0) {
                t0 = null;
                break bb0;
            }
            for (const smartLink of pageSmartLinks){
                if (smartLink.generatorName) {
                    const connector_0 = unconnectedByName.get(smartLink.generatorName.toLowerCase());
                    if (connector_0) {
                        t0 = connector_0;
                        break bb0;
                    }
                }
                if (smartLink.orsAuthKey) {
                    const connector_1 = unconnectedByServiceKey.get(smartLink.orsAuthKey);
                    if (connector_1) {
                        t0 = connector_1;
                        break bb0;
                    }
                }
            }
            t0 = null;
        }
        $[0] = allKnowledgeSources;
        $[1] = pageSmartLinks;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const [pageSmartLinks] = (0, $gzMZq.useChatContextPageSmartLinks)();
    const [allKnowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    return (0, $cozmU.useMemo)(()=>{
        if (!pageSmartLinks?.length || !allKnowledgeSources.length) return null;
        // Primary: match by friendlyName (case-insensitive) — works regardless of auth state
        const unconnectedByName = new Map();
        // Fallback: match by serviceKey extracted from outboundAuthUrl
        const unconnectedByServiceKey = new Map();
        for (const connector of allKnowledgeSources)if (!connector.isUserOAuthed) {
            if (connector.friendlyName) unconnectedByName.set(connector.friendlyName.toLowerCase(), connector);
            const serviceKey = $33022145a6a650e1$var$extractServiceKey(connector.outboundAuthUrl) ?? connector.source;
            unconnectedByServiceKey.set(serviceKey, connector);
        }
        if (unconnectedByName.size === 0 && unconnectedByServiceKey.size === 0) return null;
        // pageSmartLinks is sorted by count desc — first match wins
        for (const smartLink of pageSmartLinks){
            // Primary: match generatorName against connector friendlyName
            if (smartLink.generatorName) {
                const connector_0 = unconnectedByName.get(smartLink.generatorName.toLowerCase());
                if (connector_0) return connector_0;
            }
            // Fallback: match orsAuthKey against connector serviceKey
            if (smartLink.orsAuthKey) {
                const connector_1 = unconnectedByServiceKey.get(smartLink.orsAuthKey);
                if (connector_1) return connector_1;
            }
        }
        return null;
    }, [
        pageSmartLinks,
        allKnowledgeSources
    ]);
};
module.exports["useSmartLinkConnector"] = $33022145a6a650e1$export$7d18d4a799cee79f;

});

parcelRegister("kyTdj", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $g9Q3L = parcelRequire("g9Q3L");

const $559c90cffc307c82$export$fbe84495e0bec3b0 = (0, $kBr4q.createHook)((0, $g9Q3L.store));
module.exports["useAppConnectionBannerStore"] = $559c90cffc307c82$export$fbe84495e0bec3b0;

});

parcelRegister("8hYSP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $71003fe44ebb6f95$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury'
};
const $71003fe44ebb6f95$export$e42943029b7e264a = [
    $71003fe44ebb6f95$var$ProductKeys1P.Confluence,
    $71003fe44ebb6f95$var$ProductKeys1P.Jira,
    $71003fe44ebb6f95$var$ProductKeys1P.JiraProductDiscovery,
    $71003fe44ebb6f95$var$ProductKeys1P.JiraServiceManagement,
    $71003fe44ebb6f95$var$ProductKeys1P.Atlas,
    $71003fe44ebb6f95$var$ProductKeys1P.Trello,
    $71003fe44ebb6f95$var$ProductKeys1P.Bitbucket,
    $71003fe44ebb6f95$var$ProductKeys1P.Compass,
    $71003fe44ebb6f95$var$ProductKeys1P.Focus
];



async function $3944aef95aa38413$export$c04f0237bea14274() {
    const { ProductsOrder3P: ProductsOrder3P } = await (parcelRequire("hUIvd"));
    return [
        ...(0, $71003fe44ebb6f95$export$e42943029b7e264a),
        ...ProductsOrder3P
    ];
}


const $b23a9a999e50db5b$export$5529283e19f23755 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductSortOrder() {
    const $ = (0, $bDgLe.c)(1);
    const productsOrderRef = (0, $cozmU.useRef)(undefined);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = async ()=>{
            let productsOrder = productsOrderRef.current;
            if (productsOrder === undefined) {
                productsOrder = await (0, $3944aef95aa38413$export$c04f0237bea14274)();
                productsOrderRef.current = productsOrder;
            }
            return (a, b)=>{
                const indexA = productsOrder.indexOf(a);
                const indexB = productsOrder.indexOf(b);
                if (indexA === -1 || indexB === -1) return 0;
                else return indexA - indexB;
            };
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function useProductSortOrder() {
    const productsOrderRef = (0, $cozmU.useRef)(undefined);
    return (0, $cozmU.useCallback)(async ()=>{
        let productsOrder = productsOrderRef.current;
        if (productsOrder === undefined) {
            productsOrder = await (0, $3944aef95aa38413$export$c04f0237bea14274)();
            productsOrderRef.current = productsOrder;
        }
        return (a, b)=>{
            const indexA = productsOrder.indexOf(a);
            const indexB = productsOrder.indexOf(b);
            if (indexA === -1 || indexB === -1) return 0;
            else return indexA - indexB;
        };
    }, [
        productsOrderRef
    ]);
};
module.exports["useProductSortOrder"] = $b23a9a999e50db5b$export$5529283e19f23755;

});

parcelRegister("j3dQ1", function(module, exports) {
/**
 * Display name used in the UI for the atlassian-web-crawler knowledge source.
 * Kept in one place so all app-filter call sites stay in sync (see search-page mapping).
 */ const $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_SOURCE = 'atlassian-web-crawler';
const $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_DISPLAY_NAME = 'Web pages';
function $26393ac590b6b6bd$export$ecbd54e9e35a1b36(source, friendlyName) {
    return source === $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_SOURCE ? $26393ac590b6b6bd$var$ATLASSIAN_WEB_CRAWLER_DISPLAY_NAME : friendlyName;
}
module.exports["getKnowledgeSourceDisplayName"] = $26393ac590b6b6bd$export$ecbd54e9e35a1b36;

});

parcelRegister("9Bssi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7db0d4a226b50604360a5bd86296f974>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fdda46a58d223dd$var$_react = $6fdda46a58d223dd$var$_interopRequireDefault((parcelRequire("cozmU")));

var $6fdda46a58d223dd$var$_baseNew = $6fdda46a58d223dd$var$_interopRequireDefault((parcelRequire("gElAV")));
function $6fdda46a58d223dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PowerCable".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/power-cable
 * Usage guidance:
 * Suggested uses: Data connectivity, Connection, Plugins, Extensions, Extensibility
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fdda46a58d223dd$var$PowerCableIcon = (props)=>/*#__PURE__*/ $6fdda46a58d223dd$var$_react.default.createElement($6fdda46a58d223dd$var$_baseNew.default, Object.assign({
        name: "PowerCableIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.5 3h-3v1.5A.5.5 0 0 0 2 5h2a.5.5 0 0 0 .5-.5zM6 4.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2.25a.75.75 0 0 1 .75-.75H1V0h1.5v1.5h1V0H5v1.5h.33a.75.75 0 0 1 .67.75zm8.5 8.5h-3v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5zm1.5-1.5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2.25c0 .41.34.75.75.75H11V16h1.5v-1.5h1V16H15v-1.5h.33a.75.75 0 0 0 .67-.75z"/><path fill="currentcolor" d="M12.25 6.25a1.75 1.75 0 1 0-3.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-4h1.5v4a1.75 1.75 0 1 0 3.5 0v-3.5a3.25 3.25 0 1 1 6.5 0v4h-1.5z"/>`
    }, props));
$6fdda46a58d223dd$var$PowerCableIcon.displayName = 'PowerCableIcon';
var $6fdda46a58d223dd$var$_default = module.exports.default = $6fdda46a58d223dd$var$PowerCableIcon;

});

parcelRegister("3eqaf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $w6R6I = parcelRequire("w6R6I");


var $krYZG = parcelRequire("krYZG");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $faAj4 = parcelRequire("faAj4");


var $kCECX = parcelRequire("kCECX");


var $cXtTj = parcelRequire("cXtTj");


var $4MnFz = parcelRequire("4MnFz");


var $gC2EJ = parcelRequire("gC2EJ");


var $24dy7 = parcelRequire("24dy7");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $a1L5E = parcelRequire("a1L5E");


var $hdBxM = parcelRequire("hdBxM");


var $l1WtJ = parcelRequire("l1WtJ");


var $lxLAg = parcelRequire("lxLAg");

/**
 * Calculates the Levenshtein distance between two strings.
 * The Levenshtein distance is the minimum number of single-character edits
 * (insertions, deletions or substitutions) required to change one string into the other.
 *
 * @param str1 - The first string
 * @param str2 - The second string
 * @returns The Levenshtein distance between the two strings
 *
 * @example
 * calculateLevenshteinDistance('kitten', 'sitting') // returns 3
 * calculateLevenshteinDistance('hello', 'hello') // returns 0
 */ const $24affa2b8a50a9e7$export$7436934dc23a518f = (str1, str2)=>{
    const len1 = str1.length;
    const len2 = str2.length;
    // Create a 2D array for dynamic programming
    const dp = Array(len1 + 1).fill(null).map(()=>Array(len2 + 1).fill(0));
    // Initialize base cases
    for(let i = 0; i <= len1; i++)dp[i][0] = i;
    for(let j = 0; j <= len2; j++)dp[0][j] = j;
    // Fill in the rest of the matrix
    for(let i = 1; i <= len1; i++)for(let j = 1; j <= len2; j++){
        const cost = str1[i - 1] === str2[j - 1] ? 0 : 1;
        dp[i][j] = Math.min(dp[i - 1][j] + 1, // deletion
        dp[i][j - 1] + 1, // insertion
        dp[i - 1][j - 1] + cost // substitution
        );
    }
    return dp[len1][len2];
};
const $24affa2b8a50a9e7$export$40ed3fc5181805d9 = (originalText, editedText)=>{
    const distance = $24affa2b8a50a9e7$export$7436934dc23a518f(originalText, editedText);
    const maxLength = Math.max(originalText.length, editedText.length);
    // Avoid division by zero
    if (maxLength === 0) return {
        distance: 0,
        editRate: 0,
        maxLength: 0
    };
    // Calculate edit rate as a percentage
    const editRate = distance / maxLength * 100;
    return {
        distance: distance,
        editRate: Math.round(editRate * 100) / 100,
        maxLength: // Round to 2 decimal places
        maxLength
    };
};
const $24affa2b8a50a9e7$export$5305c36dce8387e9 = (selectedTexts, submittedQuery)=>{
    return selectedTexts.map((selectedText)=>{
        const { distance: distance, editRate: editRate } = $24affa2b8a50a9e7$export$40ed3fc5181805d9(selectedText, submittedQuery);
        return {
            editDistance: distance,
            maxNormalizedEditRate: editRate
        };
    });
};



var $kvaCg = parcelRequire("kvaCg");


var $ljEF1 = parcelRequire("ljEF1");


var $e4kXe = parcelRequire("e4kXe");


var $fJ1pJ = parcelRequire("fJ1pJ");


var $6rwn6 = parcelRequire("6rwn6");


var $8lhhf = parcelRequire("8lhhf");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $89QZA = parcelRequire("89QZA");


var $7pCWA = parcelRequire("7pCWA");


var $j4TFB = parcelRequire("j4TFB");


var $isp1U = parcelRequire("isp1U");


var $vQngM = parcelRequire("vQngM");


var $iDlFY = parcelRequire("iDlFY");


var $8VrqA = parcelRequire("8VrqA");

/**
 * Converts a glob-like pattern to a regular expression.
 * Supports * (single segment wildcard) and ** (multi-segment wildcard).
 *
 * @param pattern - A glob-like pattern (e.g., 'trello.com/c/**', 'atlassian.net/browse/*')
 * @returns RegExp - Regular expression that matches the pattern
 *
 * @example
 * patternToRegex('trello.com/c/**') // Matches trello.com/c/abc/id
 * patternToRegex('jira.com/browse/*') // Matches jira.com/browse/ABC-123 but not jira.com/browse/a/b
 */ const $eaf631758c84dc43$var$patternToRegex = (pattern)=>{
    const escaped = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&') // Escape special chars
    .replace(/\*\*/g, '__MULTI__') // Placeholder for **
    .replace(/\*/g, '[^/]*') // Single * → match non-slash
    .replace(/__MULTI__/g, '.*'); // ** → match anything
    return new RegExp(`^${escaped}$`);
};
const $eaf631758c84dc43$export$b7f660c5f13ab6cb = (url, allowedUrlPatterns)=>{
    if (!allowedUrlPatterns || allowedUrlPatterns.length === 0) return false;
    const normalizedUrl = url.replace(/^https?:\/\//, '');
    return allowedUrlPatterns.some((pattern)=>{
        const normalizedPattern = pattern.replace(/^https?:\/\//, '');
        const regex = $eaf631758c84dc43$var$patternToRegex(normalizedPattern);
        return regex.test(normalizedUrl);
    });
};
const $eaf631758c84dc43$export$20d841f6cb4f3b8 = (urls, config)=>{
    if (!config) return [];
    if (config.allowAnyUrl) return urls;
    return urls.filter((url)=>$eaf631758c84dc43$export$b7f660c5f13ab6cb(url, config.allowedUrlPatterns));
};



var $2yWJZ = parcelRequire("2yWJZ");


var $eSr5w = parcelRequire("eSr5w");













const $a5d73b339c9022b5$export$8d23ed261940919e = ({ sessionData: sessionData, contentContext: contentContext, useCurrentPageContext: useCurrentPageContext, isConversationAgentic: isConversationAgentic, productKey: productKey, renderToggleItem: renderToggleItem, renderIcon: renderIcon, title: customTitle, subtitle: customSubtitle, onToggleChange: onToggleChange, onError: onError })=>{
    // ALL HOOKS MUST BE CALLED BEFORE ANY CONDITIONAL RETURNS
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    // Check availability first
    const { autoApplyAvailability: autoApplyAvailability } = (0, $eSr5w.useAutoApplyAvailability)(contentContext, useCurrentPageContext, isConversationAgentic, productKey);
    // Check if feature is enabled and available
    const isAvailable = (0, $iDrrr.fg)('enable_auto_apply_toggling') && autoApplyAvailability.type === 'available';
    // Only fetch state if available (pass undefined sessionData to prevent backend calls)
    const { enabled: enabled, loading: loading, setEnabled: setEnabled } = (0, $eSr5w.useAutoApplyState)(isAvailable ? sessionData : undefined, contentContext, useCurrentPageContext, isConversationAgentic);
    // Create ref for icon animation
    const iconContainerRef = (0, $cozmU.useRef)(null);
    // Track the visual state locally to prevent optimistic UI updates
    const [visualState, setVisualState] = (0, $cozmU.useState)(enabled);
    // Sync visual state with actual enabled state
    (0, $cozmU.useEffect)(()=>{
        setVisualState(enabled);
    }, [
        enabled
    ]);
    const handleToggle = (0, $cozmU.useCallback)(async (newEnabled)=>{
        // Don't allow toggling if already in progress
        if (loading) return;
        // Capture current state before attempting update
        const previousState = enabled;
        // Trigger icon animation when enabling
        if (newEnabled) iconContainerRef.current?.runAnimation();
        try {
            // Use the hook's setEnabled method which handles backend + localStorage
            await setEnabled(newEnabled);
            // Send analytics event
            sendAnalyticsEvent({
                action: 'change',
                actionSubject: 'toggle',
                actionSubjectId: 'autoApplyToggle',
                attributes: {
                    isSelected: newEnabled
                }
            });
            // Call custom callback if provided
            onToggleChange?.(newEnabled);
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Unknown error');
            // Send analytics event for error
            sendAnalyticsEvent({
                action: 'failed',
                actionSubject: 'toggle',
                actionSubjectId: 'autoApplyToggle',
                attributes: {
                    isSelected: newEnabled,
                    errorMessage: error.message
                }
            });
            // Ensure visual state reverts to previous state on error
            setVisualState(previousState);
            // Call error callback so parent can handle UI
            onError?.(error);
        }
    }, [
        setEnabled,
        sendAnalyticsEvent,
        onToggleChange,
        onError,
        enabled,
        loading
    ]);
    // Don't render if feature gate is disabled
    if (!(0, $iDrrr.fg)('enable_auto_apply_toggling')) return null;
    // Don't render if auto-apply is not available
    if (autoApplyAvailability.type === 'unavailable') return null;
    // Prepare title and subtitle (use custom or default to empty)
    const title = customTitle ?? 'Auto-apply AI changes';
    const subtitle = customSubtitle;
    // Prepare icon (use custom renderer or no icon)
    const icon = renderIcon ? renderIcon({
        selected: visualState,
        ref: iconContainerRef
    }) : null;
    // Render using custom renderer
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderToggleItem({
        toggleId: 'auto_apply_toggle',
        icon: icon,
        title: title,
        subtitle: subtitle,
        onToggle: handleToggle,
        isActive: visualState,
        isDisabled: loading
    }));
};





const $16d3157d3312c2b3$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "ai-mate.creation-settings.auto-apply-toggle.error-flag-title",
        defaultMessage: "Failed to update auto-apply setting"
    },
    errorFlagDescription: {
        id: "ai-mate.creation-settings.auto-apply-toggle.error-flag-description",
        defaultMessage: "There was a problem saving your auto-apply preference. Please try again."
    }
});



var $d5gEx = parcelRequire("d5gEx");


var $2n773 = parcelRequire("2n773");


var $YooNh = parcelRequire("YooNh");


var $8ICFm = parcelRequire("8ICFm");






















const $e171eabc12b9546a$var$useIsomorphicLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $e171eabc12b9546a$export$32dd15a79fe30a30 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (callback)=>{
    const $ = (0, $bDgLe.c)(4);
    const callbackRef = (0, $cozmU.useRef)(callback);
    let t0;
    let t1;
    if ($[0] !== callback) {
        t0 = ()=>{
            callbackRef.current = callback;
        };
        t1 = [
            callback
        ];
        $[0] = callback;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    $e171eabc12b9546a$var$useIsomorphicLayoutEffect(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (...t3)=>{
            const args = t3;
            return callbackRef.current(...args);
        };
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (callback)=>{
    const callbackRef = (0, $cozmU.useRef)(callback);
    $e171eabc12b9546a$var$useIsomorphicLayoutEffect(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $cozmU.useCallback)((...args)=>callbackRef.current(...args), []);
};


const $e83b8df11f75afe4$export$1f3f2bce478b5a53 = (callback, deps, isRenderStabilizationEnabled)=>{
    // The disabled path still updates the stable-event ref each render; that tiny cost keeps this
    // hook type-honest and avoids branching around hook calls.
    const stableCallback = (0, $e171eabc12b9546a$export$32dd15a79fe30a30)(callback);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- preserve the caller's existing useCallback dependency contract while the experiment is disabled.
    const controlCallback = (0, $cozmU.useCallback)(callback, deps);
    return isRenderStabilizationEnabled ? stableCallback : controlCallback;
};


const $604bd22cb82e5411$export$b4e4aedf2922193b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { editorApi: editorApi, closeTypeAhead: closeTypeAhead, isRenderStabilizationEnabled: isRenderStabilizationEnabled } = t0;
    let t1;
    if ($[0] !== closeTypeAhead || $[1] !== editorApi?.core.actions || $[2] !== editorApi?.hyperlink?.commands) {
        t1 = ()=>{
            closeTypeAhead();
            const command = editorApi?.hyperlink?.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
            editorApi?.core.actions.execute(command);
        };
        $[0] = closeTypeAhead;
        $[1] = editorApi?.core.actions;
        $[2] = editorApi?.hyperlink?.commands;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== closeTypeAhead || $[5] !== editorApi) {
        t2 = [
            closeTypeAhead,
            editorApi
        ];
        $[4] = closeTypeAhead;
        $[5] = editorApi;
        $[6] = t2;
    } else t2 = $[6];
    const openLinkTypeAheadFromMenu = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(t1, t2, isRenderStabilizationEnabled);
    let t3;
    if ($[7] !== closeTypeAhead || $[8] !== editorApi?.core.actions || $[9] !== editorApi?.hyperlink?.commands || $[10] !== editorApi?.hyperlink?.sharedState) {
        t3 = ()=>{
            closeTypeAhead();
            let selectionRange = {
                from: 0,
                to: 0
            };
            let placeholderMark = null;
            editorApi?.core.actions.execute((t4)=>{
                const { tr: tr } = t4;
                const { from: from, to: to } = tr.selection;
                selectionRange = {
                    from: from,
                    to: to
                };
                placeholderMark = tr.doc.type.schema.marks.code;
                tr.removeMark(from, to, placeholderMark);
                return tr;
            });
            const command_0 = editorApi?.hyperlink?.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
            editorApi?.core.actions.execute(command_0);
            const unsubscribe = editorApi?.hyperlink?.sharedState.onChange((t5)=>{
                const { nextSharedState: nextSharedState } = t5;
                if (!nextSharedState?.activeLinkMark) {
                    editorApi?.core.actions.execute((t6)=>{
                        const { tr: tr_0 } = t6;
                        const { from: from_0, to: to_0 } = tr_0.selection;
                        const linkMark = tr_0.doc.type.schema.marks.link;
                        const hasLinkInOriginalRange = tr_0.doc.rangeHasMark(selectionRange.from, selectionRange.to, linkMark);
                        const hasLinkInCurrentSelection = tr_0.doc.rangeHasMark(from_0, to_0, linkMark);
                        if (placeholderMark && !hasLinkInOriginalRange && !hasLinkInCurrentSelection) tr_0.addMark(selectionRange.from, selectionRange.to, placeholderMark.create());
                        return tr_0;
                    });
                    unsubscribe?.();
                }
            });
        };
        $[7] = closeTypeAhead;
        $[8] = editorApi?.core.actions;
        $[9] = editorApi?.hyperlink?.commands;
        $[10] = editorApi?.hyperlink?.sharedState;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== closeTypeAhead || $[13] !== editorApi) {
        t4 = [
            closeTypeAhead,
            editorApi
        ];
        $[12] = closeTypeAhead;
        $[13] = editorApi;
        $[14] = t4;
    } else t4 = $[14];
    const openLinkTypeAheadFromPlaceholder = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(t3, t4, isRenderStabilizationEnabled);
    let t5;
    if ($[15] !== openLinkTypeAheadFromMenu || $[16] !== openLinkTypeAheadFromPlaceholder) {
        t5 = {
            openLinkTypeAheadFromMenu: openLinkTypeAheadFromMenu,
            openLinkTypeAheadFromPlaceholder: openLinkTypeAheadFromPlaceholder
        };
        $[15] = openLinkTypeAheadFromMenu;
        $[16] = openLinkTypeAheadFromPlaceholder;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ editorApi: editorApi, closeTypeAhead: closeTypeAhead, isRenderStabilizationEnabled: isRenderStabilizationEnabled })=>{
    const openLinkTypeAheadFromMenu = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(()=>{
        closeTypeAhead();
        const command = editorApi?.hyperlink?.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        editorApi?.core.actions.execute(command);
    }, [
        closeTypeAhead,
        editorApi
    ], isRenderStabilizationEnabled);
    const openLinkTypeAheadFromPlaceholder = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(()=>{
        closeTypeAhead();
        let selectionRange = {
            from: 0,
            to: 0
        };
        let placeholderMark = null;
        // removes placeholder marks so that toolbar can be created
        editorApi?.core.actions.execute(({ tr: tr })=>{
            const { from: from, to: to } = tr.selection;
            selectionRange = {
                from: from,
                to: to
            };
            placeholderMark = tr.doc.type.schema.marks.code;
            tr.removeMark(from, to, placeholderMark);
            return tr;
        });
        // open link toolbar
        const command_0 = editorApi?.hyperlink?.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        editorApi?.core.actions.execute(command_0);
        // track toolbar state to restore placeholder marks when toolbar closes
        const unsubscribe = editorApi?.hyperlink?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (!nextSharedState?.activeLinkMark) {
                editorApi?.core.actions.execute(({ tr: tr_0 })=>{
                    const { from: from_0, to: to_0 } = tr_0.selection;
                    const linkMark = tr_0.doc.type.schema.marks.link;
                    const hasLinkInOriginalRange = tr_0.doc.rangeHasMark(selectionRange.from, selectionRange.to, linkMark);
                    const hasLinkInCurrentSelection = tr_0.doc.rangeHasMark(from_0, to_0, linkMark);
                    // restore placeholder marks if no link was created
                    if (placeholderMark && !hasLinkInOriginalRange && !hasLinkInCurrentSelection) tr_0.addMark(selectionRange.from, selectionRange.to, placeholderMark.create());
                    return tr_0;
                });
                unsubscribe?.();
            }
        });
    }, [
        closeTypeAhead,
        editorApi
    ], isRenderStabilizationEnabled);
    return {
        openLinkTypeAheadFromMenu: openLinkTypeAheadFromMenu,
        openLinkTypeAheadFromPlaceholder: openLinkTypeAheadFromPlaceholder
    };
};












const $b1b9267ba57605ff$export$973f54181831614 = ()=>(0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true;


const $d5c467d18ae6b9d0$export$9499fc18c2c213f4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const [isEnabled] = (0, $cozmU.useState)((0, $b1b9267ba57605ff$export$973f54181831614));
    return isEnabled;
} : ()=>{
    const [isEnabled] = (0, $cozmU.useState)((0, $b1b9267ba57605ff$export$973f54181831614));
    return isEnabled;
};












var $5Sv3D = parcelRequire("5Sv3D");




const $d05067ada95c5706$export$65511cb417df6a49 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [unconnectedSourceTip, setUnconnectedSourceTip] = (0, $cozmU.useState)(null);
    const [allKnowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    let t0;
    if ($[0] !== allKnowledgeSources) {
        t0 = allKnowledgeSources.filter($d05067ada95c5706$var$_temp).map($d05067ada95c5706$var$_temp2);
        $[0] = allKnowledgeSources;
        $[1] = t0;
    } else t0 = $[1];
    const unconnectedSources = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setUnconnectedSourceTip(null);
        };
        $[2] = t1;
    } else t1 = $[2];
    const dismissTip = t1;
    let t2;
    if ($[3] !== unconnectedSources) {
        t2 = (textContent)=>{
            if (unconnectedSources.length === 0) {
                setUnconnectedSourceTip(null);
                return;
            }
            const lowerText = textContent.toLowerCase();
            let bestConnector = null;
            let bestIdx = -1;
            for (const { connector: connector, lowerName: lowerName } of unconnectedSources){
                const idx = lowerText.lastIndexOf(lowerName);
                if (idx <= bestIdx) continue;
                const charBefore = lowerText[idx - 1];
                const charAfter = lowerText[idx + lowerName.length];
                const atStart = idx === 0 || /\W/.test(charBefore);
                const atEnd = charAfter === undefined || /\W/.test(charAfter);
                if (atStart && atEnd) {
                    bestConnector = connector;
                    bestIdx = idx;
                }
            }
            setUnconnectedSourceTip(bestConnector);
        };
        $[3] = unconnectedSources;
        $[4] = t2;
    } else t2 = $[4];
    const detectUnconnectedSource = t2;
    const [debouncedDetectUnconnectedSource] = (0, $5Sv3D.default)(detectUnconnectedSource, 200);
    let t3;
    if ($[5] !== debouncedDetectUnconnectedSource || $[6] !== unconnectedSourceTip) {
        t3 = {
            unconnectedSourceTip: unconnectedSourceTip,
            dismissTip: dismissTip,
            detectUnconnectedSource: debouncedDetectUnconnectedSource
        };
        $[5] = debouncedDetectUnconnectedSource;
        $[6] = unconnectedSourceTip;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const [unconnectedSourceTip, setUnconnectedSourceTip] = (0, $cozmU.useState)(null);
    const [allKnowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    // Pre-process once per store update — not on every keystroke:
    // filter to unconnected and lowercase the names.
    const unconnectedSources = (0, $cozmU.useMemo)(()=>allKnowledgeSources.filter((s)=>!s.isUserOAuthed).map((s_0)=>({
                connector: s_0,
                lowerName: s_0.friendlyName.toLowerCase()
            })), [
        allKnowledgeSources
    ]);
    const dismissTip = (0, $cozmU.useCallback)(()=>{
        setUnconnectedSourceTip(null);
    }, []);
    const detectUnconnectedSource = (0, $cozmU.useCallback)((textContent)=>{
        if (unconnectedSources.length === 0) {
            setUnconnectedSourceTip(null);
            return;
        }
        const lowerText = textContent.toLowerCase();
        // Find the rightmost valid match — whichever app name appears latest
        // in the text is the one the user most recently typed.
        let bestConnector = null;
        let bestIdx = -1;
        for (const { connector: connector, lowerName: lowerName } of unconnectedSources){
            const idx = lowerText.lastIndexOf(lowerName);
            if (idx <= bestIdx) continue;
            // Ensure the match sits on word boundaries — the surrounding
            // character must be absent (start/end of string) or a non-word
            // character (whitespace, punctuation, brackets, etc.) so that
            // "slack" doesn't match inside "slackbot" or "reslack", but
            // "Google Drive," and "(Google Drive)" still match.
            const charBefore = lowerText[idx - 1];
            const charAfter = lowerText[idx + lowerName.length];
            const atStart = idx === 0 || /\W/.test(charBefore);
            const atEnd = charAfter === undefined || /\W/.test(charAfter);
            if (atStart && atEnd) {
                bestConnector = connector;
                bestIdx = idx;
            }
        }
        setUnconnectedSourceTip(bestConnector);
    }, [
        unconnectedSources
    ]);
    const [debouncedDetectUnconnectedSource] = (0, $5Sv3D.default)(detectUnconnectedSource, 200);
    return {
        unconnectedSourceTip: unconnectedSourceTip,
        dismissTip: dismissTip,
        detectUnconnectedSource: debouncedDetectUnconnectedSource
    };
};
function $d05067ada95c5706$var$_temp(s) {
    return !s.isUserOAuthed;
}
function $d05067ada95c5706$var$_temp2(s_0) {
    return {
        connector: s_0,
        lowerName: s_0.friendlyName.toLowerCase()
    };
}








const $86ac1f3c27b15a40$export$87847a6e73952730 = (urls)=>{
    const nodes = [];
    urls.forEach((url, index)=>{
        // Add the URL node
        nodes.push({
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
        // Add a space between URLs (but not after the last one)
        if (index < urls.length - 1) nodes.push({
            type: 'text',
            text: ' '
        });
    });
    return nodes;
};


const $1268783c1a2a09ca$export$9e64b96eea1f7537 = (doc)=>{
    const existingUrls = new Set();
    const traverseNode = (node)=>{
        if (!node || typeof node !== 'object') return;
        // Check if this node contains a URL
        if (node.type === 'inlineCard' && node.attrs && typeof node.attrs === 'object') {
            const url = node.attrs.url;
            if (url) existingUrls.add(url);
        }
        // Recursively traverse child nodes
        if (node.content && Array.isArray(node.content)) node.content.forEach((childNode)=>{
            if (childNode) traverseNode(childNode);
        });
    };
    if (doc.content && Array.isArray(doc.content)) doc.content.forEach((node)=>traverseNode(node));
    return existingUrls;
};


const $93b01236840b5c5f$export$e684a60d984ce421 = (existingContent, newInlineContent)=>{
    // Case 1: Empty document - create the first paragraph
    if (existingContent.length === 0) return [
        {
            type: 'paragraph',
            content: newInlineContent
        }
    ];
    // Case 2: Document has content - check the last node
    const lastNode = existingContent[existingContent.length - 1];
    if (lastNode.type === 'paragraph') {
        // Append to existing paragraph with a space separator if needed
        const existingParagraphContent = lastNode.content || [];
        const separator = existingParagraphContent.length > 0 ? [
            {
                type: 'text',
                text: ' '
            }
        ] : [];
        return [
            ...existingContent.slice(0, -1),
            {
                ...lastNode,
                content: [
                    ...existingParagraphContent,
                    ...separator,
                    ...newInlineContent
                ]
            }
        ];
    }
    // Case 3: Last node is not a paragraph - create a new paragraph
    return [
        ...existingContent,
        {
            type: 'paragraph',
            content: newInlineContent
        }
    ];
};


const $5be41c6880979bfe$export$a3e933699338c61d = (editorApi)=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    /**
   * Inserts URLs into the document.
   * @param urls - The URLs to insert.
   */ const insertUrls = (0, $cozmU.useCallback)((urls, source)=>{
        if (!urls || !Array.isArray(urls)) return;
        try {
            editorApi?.core?.actions?.requestDocument((currentDoc)=>{
                if (!currentDoc) throw new Error('Current document is not found');
                const existingUrls = (0, $1268783c1a2a09ca$export$9e64b96eea1f7537)(currentDoc);
                const newUrls = urls.filter((url)=>!existingUrls.has(url));
                if (newUrls.length === 0) {
                    editorApi?.core?.actions?.focus();
                    return;
                }
                const urlNodes = (0, $86ac1f3c27b15a40$export$87847a6e73952730)(newUrls);
                const updatedContent = (0, $93b01236840b5c5f$export$e684a60d984ce421)(currentDoc.content || [], urlNodes);
                const updatedDoc = {
                    type: 'doc',
                    version: 1,
                    content: updatedContent
                };
                const success = editorApi?.core?.actions?.replaceDocument(updatedDoc);
                if (!success) throw new Error('Failed to insert URLs into document');
                editorApi?.core?.actions?.focus();
                sendAnalyticsEvent({
                    eventType: 'track',
                    action: 'inserted',
                    actionSubject: 'link',
                    actionSubjectId: 'insertLinksIntoPromptInput',
                    attributes: {
                        urlCount: newUrls.length,
                        source: source
                    }
                });
            });
        } catch (error) {
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'failed',
                actionSubject: 'link',
                attributes: {
                    source: source,
                    error: error instanceof Error ? error.message : String(error)
                }
            });
        }
    }, [
        editorApi,
        sendAnalyticsEvent
    ]);
    return {
        insertUrls: insertUrls
    };
};



var $lN13T = parcelRequire("lN13T");


var $d9k9Z = parcelRequire("d9k9Z");


var $aW7DE = parcelRequire("aW7DE");

const $a5ebe6e16ec109bd$export$5008f08b2ad8f7df = (doc)=>{
    const actualTextContent = (0, $aW7DE.getActualTextContent)(doc);
    return actualTextContent.trim().length;
};



var $fIbhb = parcelRequire("fIbhb");


var $kyTdj = parcelRequire("kyTdj");


var $7685l = parcelRequire("7685l");


var $aJU2k = parcelRequire("aJU2k");





var $kBr4q = parcelRequire("kBr4q");


var $9OWHk = parcelRequire("9OWHk");


var $5aQkY = parcelRequire("5aQkY");

const $a500ad076315612c$var$useConversationDeactivatedSelectedAgentIds = (0, $kBr4q.createStateHook)((0, $5aQkY.selectedAgentDraftControllerStore), {
    selector: (state, conversationId)=>state.deactivatedAgentIds[conversationId] ?? (0, $9OWHk.EMPTY_SELECTED_AGENT_IDS)
});
const $a500ad076315612c$export$ce4317e58f8f464 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId)=>{
    return $a500ad076315612c$var$useConversationDeactivatedSelectedAgentIds(conversationId);
} : (conversationId)=>$a500ad076315612c$var$useConversationDeactivatedSelectedAgentIds(conversationId);






var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");

const $b74a7acd29563287$export$5a87ff428a5fd37b = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService } })=>{
    // Check feature flag first - if disabled, don't make the API request
    const isFeatureFlagEnabled = (0, $iDrrr.fg)('rovo_chat_web_search_enabled');
    const { data: data, error: error, isFetching: isFetching } = (0, $5SS4O.useQuery)({
        queryKey: [
            'webSearchConfiguration'
        ],
        queryFn: async ()=>{
            return await assistanceService.getWebSearchConfiguration();
        },
        // Only fetch if the feature flag is enabled
        enabled: isFeatureFlagEnabled
    });
    return {
        webSearchEnabled: isFeatureFlagEnabled && (data?.enabled ?? false),
        isLoading: isFetching,
        error: error instanceof Error ? error.message : error ? 'Failed to fetch web search configuration' : undefined
    };
});


const $e4a3cb164641be9e$export$fc8af3d94a34aff7 = ({ agentId: agentId, selectedAgentCountBeforeDismiss: selectedAgentCountBeforeDismiss, conversationAgentId: conversationAgentId, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    sendAnalyticsEvent({
        action: 'dismissed',
        actionSubject: 'mentionAgent',
        eventType: 'ui',
        attributes: {
            agentId: agentId,
            source: 'inputHat',
            selectedAgentCountBeforeDismiss: selectedAgentCountBeforeDismiss,
            remainingSelectedAgentCount: Math.max(selectedAgentCountBeforeDismiss - 1, 0),
            ...conversationAgentId ? {
                conversationAgentId: conversationAgentId
            } : {}
        }
    });
};


const $40c556120769ec97$export$a8de503786bd6bf4 = (chatSessionId, chatTurnNumber)=>{
    const turnContext = {};
    if (chatTurnNumber !== undefined) {
        turnContext.chatTurnNumber = chatTurnNumber;
        if (chatSessionId !== undefined) turnContext.conversationChannelId = chatSessionId;
    }
    return turnContext;
};


const $c7b1d7580c9f820b$export$beda2291995e7723 = ({ agentId: agentId, selectedAgentCount: selectedAgentCount, conversationAgentId: conversationAgentId, chatSessionId: chatSessionId, chatTurnNumber: chatTurnNumber, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    const turnContext = (0, $40c556120769ec97$export$a8de503786bd6bf4)(chatSessionId, chatTurnNumber);
    sendAnalyticsEvent({
        action: 'submitted',
        actionSubject: 'mentionAgent',
        eventType: 'track',
        attributes: {
            agentId: agentId,
            source: 'chatInputSubmit',
            selectedAgentCount: selectedAgentCount,
            ...turnContext,
            ...conversationAgentId ? {
                conversationAgentId: conversationAgentId
            } : {}
        }
    });
};



const $37219049bd2e8e2a$export$ba17c24faf9c6458 = ({ event: event, previousAgentId: previousAgentId, previousAgentName: previousAgentName, previousAgentCreatorType: previousAgentCreatorType, conversationAgentId: conversationAgentId, chatSessionId: chatSessionId, chatTurnNumber: chatTurnNumber, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    const conversationContext = conversationAgentId ? {
        conversationAgentId: conversationAgentId
    } : {};
    const resultCountContext = {
        agentResultCount: event.agentResultCount,
        peopleResultCount: event.peopleResultCount,
        teamResultCount: event.teamResultCount
    };
    const turnContext = (0, $40c556120769ec97$export$a8de503786bd6bf4)(chatSessionId, chatTurnNumber);
    if (event.action === 'selected') {
        if (event.resultType === 'person' || event.resultType === 'team') {
            sendAnalyticsEvent({
                action: 'selected',
                actionSubject: 'mentionResult',
                eventType: 'ui',
                attributes: {
                    resultType: event.resultType,
                    position: event.position,
                    queryLength: event.queryLength,
                    ...resultCountContext,
                    ...turnContext,
                    ...conversationContext
                }
            });
            return;
        }
        // Names of private (customer-authored) agents may carry sensitive text, so
        // only include the name for non-private agents. An unknown creator type is
        // treated as private (name omitted) to stay on the safe side.
        const includeAgentName = event.agentCreatorType !== undefined && event.agentCreatorType !== 'CUSTOMER';
        sendAnalyticsEvent({
            action: 'selected',
            actionSubject: 'mentionResult',
            eventType: 'ui',
            attributes: {
                resultType: event.resultType,
                agentId: event.agentId,
                agentCreatorType: event.agentCreatorType,
                agentIsVerified: event.agentIsVerified,
                position: event.position,
                queryLength: event.queryLength,
                ...resultCountContext,
                ...turnContext,
                ...includeAgentName && event.agentName ? {
                    agentName: event.agentName
                } : {},
                ...conversationContext
            }
        });
        if (event.resultType === 'agent' && event.agentId !== undefined && previousAgentId !== undefined && previousAgentId !== event.agentId) {
            // Same privacy gate as the new agent's name, applied to the agent
            // being switched away from.
            const includePreviousAgentName = previousAgentCreatorType !== undefined && previousAgentCreatorType !== 'CUSTOMER';
            sendAnalyticsEvent({
                action: 'switched',
                actionSubject: 'mentionAgent',
                eventType: 'ui',
                attributes: {
                    previousAgentId: previousAgentId,
                    previousAgentCreatorType: previousAgentCreatorType,
                    ...includePreviousAgentName && previousAgentName ? {
                        previousAgentName: previousAgentName
                    } : {},
                    newAgentId: event.agentId,
                    newAgentCreatorType: event.agentCreatorType,
                    ...resultCountContext,
                    ...turnContext,
                    ...includeAgentName && event.agentName ? {
                        newAgentName: event.agentName
                    } : {},
                    ...conversationContext
                }
            });
        }
        return;
    }
    sendAnalyticsEvent({
        action: event.action,
        actionSubject: 'mentionAgentMenu',
        eventType: 'ui',
        attributes: {
            queryLength: event.queryLength,
            agentResultCount: event.agentResultCount,
            peopleResultCount: event.peopleResultCount,
            teamResultCount: event.teamResultCount,
            ...turnContext,
            ...conversationContext
        }
    });
};



var $gj7Xh = parcelRequire("gj7Xh");

const $e8dbbe344c450ab9$export$338c380e79652155 = ({ isAgentMentionActive: isAgentMentionActive, isSpecialistPromptInput: isSpecialistPromptInput })=>isAgentMentionActive || isSpecialistPromptInput;












var $aZANo = parcelRequire("aZANo");

const $ea65d716a8ff208f$export$18cf5c7f34a381c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (chatModeKey, assistanceServiceParams)=>{
    const $ = (0, $bDgLe.c)(5);
    const setParams = (0, $aZANo.useSetViewMoreModalParams)();
    let t0;
    let t1;
    if ($[0] !== assistanceServiceParams || $[1] !== chatModeKey || $[2] !== setParams) {
        t0 = ()=>{
            if (assistanceServiceParams) {
                setParams({
                    chatModeKey: chatModeKey,
                    assistanceServiceParams: assistanceServiceParams
                });
                return ()=>setParams(null);
            }
        };
        t1 = [
            chatModeKey,
            assistanceServiceParams,
            setParams
        ];
        $[0] = assistanceServiceParams;
        $[1] = chatModeKey;
        $[2] = setParams;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
} : (chatModeKey, assistanceServiceParams)=>{
    const setParams = (0, $aZANo.useSetViewMoreModalParams)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (assistanceServiceParams) {
            setParams({
                chatModeKey: chatModeKey,
                assistanceServiceParams: assistanceServiceParams
            });
            return ()=>setParams(null);
        }
    }, [
        chatModeKey,
        assistanceServiceParams,
        setParams
    ]);
};












var $hekY6 = parcelRequire("hekY6");


var $kB5K2 = parcelRequire("kB5K2");


var $eh6Ml = parcelRequire("eh6Ml");


var $9d7Pd = parcelRequire("9d7Pd");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $c0A7H = parcelRequire("c0A7H");

const $b22d6a7777fc40da$var$styles = {
    toggleContainer: "_3YEZNOdnbC",
    contentContainer: "_1ANEUSzUZr _1pp6NdYbGa",
    alphaChip: "_0bjKvDKxmn _2Y7lL41Y8M _0KLXruqjHC"
}; /* eslint-disable  @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */ 
const $b22d6a7777fc40da$var$compiledStyles = {
    roundedItem: "_0bjKvDJg58 _4bt5LAnQyn _2WAcuGnQyn",
    forcePointer: "_0wOv4Q7zJH _4udvkF7zJH",
    forceNotAllowed: "_0wOv4Qsyl5 _4udvkFsyl5"
}; /* eslint-enable  @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */ 
const $b22d6a7777fc40da$export$d1e3ff30e3cec4a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { toggleId: toggleId, icon: icon, isCheckmark: t1, title: title, lozengeLabel: lozengeLabel, subtitle: subtitle, onToggle: onToggle, isActive: isActive, isDisabled: isDisabled } = t0;
    const isCheckmark = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isActive || $[1] !== onToggle) {
        t2 = ()=>onToggle(!isActive);
        $[0] = isActive;
        $[1] = onToggle;
        $[2] = t2;
    } else t2 = $[2];
    const t3 = isDisabled ? $b22d6a7777fc40da$var$compiledStyles.forceNotAllowed : $b22d6a7777fc40da$var$compiledStyles.forcePointer;
    let t4;
    if ($[3] !== t3) {
        t4 = (0, $hekY6.default)([
            $b22d6a7777fc40da$var$compiledStyles.roundedItem,
            t3
        ]);
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== title) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, title);
        $[5] = title;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== lozengeLabel) {
        t6 = lozengeLabel ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            xcss: $b22d6a7777fc40da$var$styles.alphaChip
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            weight: "bold",
            color: "color.text.inverse"
        }, lozengeLabel)) : undefined;
        $[7] = lozengeLabel;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t5, t6);
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== subtitle) {
        t8 = subtitle ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            weight: "regular",
            color: "color.text.subtle"
        }, subtitle) : undefined;
        $[12] = subtitle;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t7 || $[15] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t7, t8);
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t9 || $[18] !== toggleId) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
            htmlFor: toggleId
        }, t9);
        $[17] = t9;
        $[18] = toggleId;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            $b22d6a7777fc40da$var$styles.toggleContainer
        ]);
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== isActive || $[22] !== isCheckmark || $[23] !== toggleId) {
        t12 = isCheckmark ? isActive ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: ""
        }) : undefined : /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
            id: toggleId,
            defaultChecked: isActive,
            isChecked: isActive
        });
        $[21] = isActive;
        $[22] = isCheckmark;
        $[23] = toggleId;
        $[24] = t12;
    } else t12 = $[24];
    let t13;
    if ($[25] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t11
        }, t12);
        $[25] = t12;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== t10 || $[28] !== t13) {
        t14 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.200",
            xcss: $b22d6a7777fc40da$var$styles.contentContainer
        }, t10, t13);
        $[27] = t10;
        $[28] = t13;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== icon || $[31] !== isDisabled || $[32] !== t14 || $[33] !== t2 || $[34] !== t4) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
            role: "menuitem",
            isDisabled: isDisabled,
            onClick: t2,
            iconBefore: icon,
            className: t4
        }, t14);
        $[30] = icon;
        $[31] = isDisabled;
        $[32] = t14;
        $[33] = t2;
        $[34] = t4;
        $[35] = t15;
    } else t15 = $[35];
    return t15;
} : ({ toggleId: toggleId, icon: icon, isCheckmark: isCheckmark = false, title: title, lozengeLabel: lozengeLabel, subtitle: subtitle, onToggle: onToggle, isActive: isActive, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        role: "menuitem",
        isDisabled: isDisabled,
        onClick: ()=>onToggle(!isActive),
        iconBefore: icon,
        className: (0, $hekY6.default)([
            $b22d6a7777fc40da$var$compiledStyles.roundedItem,
            isDisabled ? $b22d6a7777fc40da$var$compiledStyles.forceNotAllowed : $b22d6a7777fc40da$var$compiledStyles.forcePointer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $b22d6a7777fc40da$var$styles.contentContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $kB5K2.Label), {
        htmlFor: toggleId
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, title), lozengeLabel ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $b22d6a7777fc40da$var$styles.alphaChip
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        weight: "bold",
        color: "color.text.inverse"
    }, lozengeLabel)) : undefined), subtitle ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        color: "color.text.subtle"
    }, subtitle) : undefined)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $b22d6a7777fc40da$var$styles.toggleContainer
        ])
    }, isCheckmark ? isActive ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: ""
    }) : undefined : /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        id: toggleId,
        defaultChecked: isActive,
        isChecked: isActive
    }))));
};














const $31f9dba6bd17fa76$var$styles = {
    iconContainerStyles: "_0bjKvDS5Zs _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $31f9dba6bd17fa76$var$spinGradientBurst = null; /* eslint-disable  @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */ 
const $31f9dba6bd17fa76$var$compiledStyles = {
    defaultStyle: "_0bjKvDS5Zs _1UtDYz4YkS _0KLXrushJp",
    bgGradientAngularContent: "_0bjKvDS5Zs _1mT5xdRAKS _42Yu6B7dHp _0KLXru52mJ _49h7cij02L",
    bgGradientAngularAnimated: "_0KLXrujOvk _1mT5xdRAKS _1UtDYzt28M _4eDJc6QBP4 _1OimfuS5Zs _2OUbymeKR3 _3Ku51Iogpp _3dCYwDWVPG _35I30BdnbC _1L3m71dnbC _1D2b5MdnbC _31ReDydnbC _3qT6l0dnbC _2oFdXcRAKS _25QAss7dHp",
    bgGradientAngularStatic: "_2uo31fJUxq _0bjKvDS5Zs _1UtDYzt28M"
}; /* eslint-enable  @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */ 
const $31f9dba6bd17fa76$export$8f314e512d92575f = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    const { children: children, selected: selected } = t0;
    const [runninAnimation, setRunningAnimation] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRunningAnimation(true);
            setTimeout(()=>{
                setRunningAnimation(false);
            }, 400);
        };
        $[0] = t1;
    } else t1 = $[0];
    const runAnimation = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>({
                runAnimation: runAnimation
            });
        $[1] = t2;
    } else t2 = $[1];
    (0, $cozmU.useImperativeHandle)(ref, t2);
    if (!selected) {
        let t3;
        let t4;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $hekY6.default)([
                $31f9dba6bd17fa76$var$compiledStyles.defaultStyle
            ]);
            t4 = (0, $hekY6.default)([
                $31f9dba6bd17fa76$var$styles.iconContainerStyles
            ]);
            $[2] = t3;
            $[3] = t4;
        } else {
            t3 = $[2];
            t4 = $[3];
        }
        let t5;
        if ($[4] !== children || $[5] !== t4) {
            t5 = /*#__PURE__*/ $cozmU.createElement("div", {
                className: t4
            }, children);
            $[4] = children;
            $[5] = t4;
            $[6] = t5;
        } else t5 = $[6];
        let t6;
        if ($[7] !== t3 || $[8] !== t5) {
            t6 = /*#__PURE__*/ $cozmU.createElement("div", {
                className: t3
            }, t5);
            $[7] = t3;
            $[8] = t5;
            $[9] = t6;
        } else t6 = $[9];
        return t6;
    }
    let t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$compiledStyles.bgGradientAngularContent
        ]);
        t4 = (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$styles.iconContainerStyles
        ]);
        $[10] = t3;
        $[11] = t4;
    } else {
        t3 = $[10];
        t4 = $[11];
    }
    let t5;
    if ($[12] !== children || $[13] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t4
        }, children);
        $[12] = children;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t3 || $[16] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, t5);
        $[15] = t3;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    const content = t6;
    let t7;
    if ($[18] !== content || $[19] !== runninAnimation) {
        t7 = runninAnimation ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $31f9dba6bd17fa76$var$compiledStyles.bgGradientAngularAnimated
            ])
        }, content) : /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $31f9dba6bd17fa76$var$compiledStyles.bgGradientAngularStatic
            ])
        }, content);
        $[18] = content;
        $[19] = runninAnimation;
        $[20] = t7;
    } else t7 = $[20];
    return t7;
} : ({ children: children, selected: selected }, ref)=>{
    const [runninAnimation, setRunningAnimation] = (0, $cozmU.useState)(false);
    const runAnimation = (0, $cozmU.useCallback)(()=>{
        setRunningAnimation(true);
        setTimeout(()=>{
            setRunningAnimation(false);
        }, 400);
    }, []);
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            runAnimation: runAnimation
        }));
    if (!selected) return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$compiledStyles.defaultStyle
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$styles.iconContainerStyles
        ])
    }, children));
    const content = /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$compiledStyles.bgGradientAngularContent
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$styles.iconContainerStyles
        ])
    }, children));
    return runninAnimation ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$compiledStyles.bgGradientAngularAnimated
        ])
    }, content) : /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $31f9dba6bd17fa76$var$compiledStyles.bgGradientAngularStatic
        ])
    }, content);
});





const $e50ecf229d50e279$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    filterByAppsButtonLabel: {
        id: "ai-mate.chat-input.mode.menu.filter-by-apps.label",
        defaultMessage: "Filter by apps"
    },
    chatModeMenuTooltip: {
        id: "ai-mate.chat-input.mode.menu.tooltip",
        defaultMessage: "Customize"
    },
    webSearchToggleTitle: {
        id: "ai-mate.chat-input.mode.menu.web-search.title",
        defaultMessage: "Include web results"
    },
    orgKnowledgeToggleTitle: {
        id: "ai-mate.chat-input.mode.menu.org-knowledge.title",
        defaultMessage: "Search company knowledge"
    },
    reasoningSectionTitle: {
        id: "ai-mate.chat-input.mode.menu.reasoning.section.title",
        defaultMessage: "Reasoning"
    },
    sourcesSectionTitle: {
        id: "ai-mate.chat-input.mode.menu.sources.section.title",
        defaultMessage: "Sources"
    },
    rovoAutoReasoningToggleTitle: {
        id: "ai-mate.chat-input.mode.menu.rovo-auto-reasoning.title",
        defaultMessage: "Let Rovo decide"
    },
    rovoAutoReasoningToggleDescription: {
        id: "ai-mate.chat-input.mode.menu.rovo-auto-reasoning.description",
        defaultMessage: "Rovo picks the best reasoning"
    },
    thinkDeeperToggleTitle: {
        id: "ai-mate.chat-input.mode.menu.think-deeper.title",
        defaultMessage: "Think deeper"
    },
    thinkDeeperToggleDescription: {
        id: "ai-mate.chat-input.mode.menu.think-deeper.description",
        defaultMessage: "Longer thinking for robust responses"
    },
    thinkDeeperDisabledDueToAgentsTooltip: {
        id: "ai-mate.chat-input.mode.menu.think-deeper.disabled.tooltip",
        defaultMessage: "For now, agents can't use think deeper."
    },
    deepResearchToggleTitle: {
        id: "ai-mate.chat-input.mode.menu.deep-research.title",
        defaultMessage: "Deep research"
    },
    deepResearchToggleDescription: {
        id: "ai-mate.chat-input.mode.menu.deep-research.description",
        defaultMessage: "Synthesize insights and create reports"
    },
    autoApplyToggleTitle: {
        id: "ai-mate.chat-input.mode.menu.auto-apply.title",
        defaultMessage: "Auto-apply AI writing changes"
    },
    autoApplyDisabledTooltip: {
        id: "ai-mate.chat-input.mode.menu.auto-apply.disabled.tooltip",
        defaultMessage: "Auto-apply is not available in this context"
    },
    searchAppsPlaceholder: {
        id: "ai-mate.chat-input.mode.menu.search-apps.placeholder",
        defaultMessage: "Search apps"
    },
    searchDisabledDueToAgentsTooltip: {
        id: "ai-mate.chat-input.mode.menu.search.disabled.tooltip",
        defaultMessage: "For now, agents can't use web search."
    },
    drDisabledDueToAgentsTooltip: {
        id: "ai-mate.chat-input.mode.menu.dr.disabled.tooltip",
        defaultMessage: "For now, agents can't use deep research."
    }
});












var $9EOlJ = parcelRequire("9EOlJ");





var $dqxOF = parcelRequire("dqxOF");





















var $91ZZN = parcelRequire("91ZZN");

// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("91BX8"));
}



var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $iuCeV = parcelRequire("iuCeV");

/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $iSrRp = parcelRequire("iSrRp");


var $6Bv0m = parcelRequire("6Bv0m");










const $788a6bfcc271d405$var$message = (0, $kSwu1.defineMessages)({
    dragDropMessage: {
        id: "rovo-chat.file-upload-dropzone.drag-drop-message",
        defaultMessage: "Drag and drop to add context"
    }
});
var $788a6bfcc271d405$export$2e2bcd8739ae039 = $788a6bfcc271d405$var$message;


/**
 * Add files up to the maximum number of files allowed.
 * @param addedFiles - The files to add.
 * @param currentFiles - The current files.
 * @returns The files to add.
 */ const $a2fd2a625e2bb941$export$c71ec59453b6867a = ({ addedFiles: addedFiles, currentFileCount: currentFileCount, maxFileCount: maxFileCount })=>{
    const remainingSlots = maxFileCount - currentFileCount;
    const limitedFiles = addedFiles.slice(0, remainingSlots > 0 ? remainingSlots : 0);
    return limitedFiles;
};


const $215735e71f9a3265$var$styles = {
    wrapper: "_1mT5xdRAKS",
    fileDropzoneContentWrapper: "_0bjKvD8fU6 _3hxITisurO _3vBAKHnXvL _1mT5xdWVPG _2IhTonPgdg _3OE6xYPgdg _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _42Yu6B7dHp"
};
const $215735e71f9a3265$export$e182130f07919e28 = ({ children: children, maxFiles: maxFiles, currentFileCount: currentFileCount, onFilesSelected: onFilesSelected, onUrlsSelected: onUrlsSelected, disabled: disabled, urlValidationConfig: urlValidationConfig })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isDraggedOver, setIsDraggedOver] = (0, $cozmU.useState)(false);
    const isDragAndDropEnabled = (0, $iDrrr.fg)('phx_drag_and_drop_trello_cards_to_rovo_chat');
    const ref = (0, $cozmU.useRef)(null);
    const onFileSelectedRef = (0, $cozmU.useRef)(onFilesSelected);
    const onUrlsSelectedRef = (0, $cozmU.useRef)(onUrlsSelected);
    const validatedUrlsRef = (0, $cozmU.useRef)([]);
    onFileSelectedRef.current = onFilesSelected;
    onUrlsSelectedRef.current = onUrlsSelected;
    (0, $cozmU.useEffect)(()=>{
        const element = ref.current;
        if (!element) return;
        const cleanupElements = isDragAndDropEnabled ? (0, $iSrRp.dropTargetForElements)({
            element: element,
            canDrop: ()=>!disabled,
            onDragEnter: ({ source: { data: data } })=>{
                const urls = data?.urls;
                if (Array.isArray(urls)) {
                    const filteredUrls = (0, $eaf631758c84dc43$export$20d841f6cb4f3b8)(urls, urlValidationConfig);
                    validatedUrlsRef.current = filteredUrls;
                    if (filteredUrls.length > 0) setIsDraggedOver(true);
                }
            },
            onDragLeave: ()=>{
                validatedUrlsRef.current = [];
                setIsDraggedOver(false);
            },
            onDrop: ()=>{
                if (validatedUrlsRef.current.length > 0) onUrlsSelectedRef.current?.(validatedUrlsRef.current);
                validatedUrlsRef.current = [];
                setIsDraggedOver(false);
            }
        }) : undefined;
        const cleanupExternal = (0, $6Bv0m.dropTargetForExternal)({
            element: element,
            canDrop: ()=>!disabled,
            onDragEnter: ()=>setIsDraggedOver(true),
            onDragLeave: ()=>setIsDraggedOver(false),
            onDrop: async ({ source: { items: items } })=>{
                setIsDraggedOver(false);
                const filePromises = await Promise.all(items.map((item)=>item.getAsFile()));
                const rawFiles = filePromises.filter((file)=>file !== null);
                const filesToAdd = (0, $a2fd2a625e2bb941$export$c71ec59453b6867a)({
                    addedFiles: rawFiles,
                    currentFileCount: currentFileCount,
                    maxFileCount: maxFiles
                });
                if (filesToAdd.length === 0) return;
                onFileSelectedRef.current(filesToAdd);
            }
        });
        return ()=>{
            cleanupElements?.();
            cleanupExternal();
        };
    }, [
        ref,
        currentFileCount,
        maxFiles,
        disabled,
        isDragAndDropEnabled,
        urlValidationConfig
    ]);
    const onPaste = (0, $cozmU.useCallback)((event)=>{
        const files = Array.from(event.clipboardData.files); // Rename pasted image files with incremental names (image1.png, image2.png, etc.)
        // instead of the browser-generated "image.png" to avoid missing files due to editor deduping by file name
        const processedFiles = files.map((file_0, index)=>{
            // Only rename generic browser-generated image names like "image.png"
            const genericImagePattern = /^image\.\w+$/i;
            if (genericImagePattern.test(file_0.name)) {
                const extension = file_0.name.split('.').pop() || 'png';
                const newName = `image${currentFileCount + index + 1}.${extension}`;
                return new File([
                    file_0
                ], newName, {
                    type: file_0.type
                });
            }
            return file_0;
        });
        const filesToAdd_0 = (0, $a2fd2a625e2bb941$export$c71ec59453b6867a)({
            addedFiles: processedFiles,
            currentFileCount: currentFileCount,
            maxFileCount: maxFiles
        });
        if (filesToAdd_0.length === 0) return;
        onFileSelectedRef.current(filesToAdd_0);
    }, [
        currentFileCount,
        maxFiles
    ]);
    return children({
        isDraggedOver: isDraggedOver,
        innerProps: {
            ref: ref,
            onPaste: onPaste
        },
        dropzoneContent: isDraggedOver ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $215735e71f9a3265$var$styles.fileDropzoneContentWrapper,
            backgroundColor: "color.background.accent.blue.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.brand"
        }, formatMessage((0, $788a6bfcc271d405$export$2e2bcd8739ae039).dragDropMessage))) : null
    });
};






var $1SiET = parcelRequire("1SiET");


var $cH7ad = parcelRequire("cH7ad");


var $4y2BX = parcelRequire("4y2BX");


var $b8kYV = parcelRequire("b8kYV");















const $0c6cfd9419ae9608$var$styles = {
    wrapper: "_0bjKvDzXzM _3vBAKHnod9 _2V7sgONvrM _3hxITi6wH8 _0KLXruig7D _0Of8r2FQfX _1ZnuxbgVvo _1wydGWFQfX _2Zuz6QgVvo _3iDTPbvbI6 _39xV02E6Kk"
};
const $0c6cfd9419ae9608$export$4f20080e67eaaf20 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { count: count } = t0;
    const exceedsLimit = count < 0;
    if (exceedsLimit) {
        let t1;
        if ($[0] !== count) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $0c6cfd9419ae9608$var$styles.wrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text",
                size: "small",
                weight: "medium",
                testId: "conversation-assistant-chat-prompt-input.text.negative-counter"
            }, count));
            $[0] = count;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return null;
} : ({ count: count })=>{
    const exceedsLimit = count < 0;
    if (exceedsLimit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0c6cfd9419ae9608$var$styles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text",
        size: "small",
        weight: "medium",
        testId: "conversation-assistant-chat-prompt-input.text.negative-counter"
    }, count));
    return null;
};














const $c6718c697198a5dc$var$DisabledVoiceFooterRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { promptControlsSlot: promptControlsSlot, actionsBeforeSubmitSlot: actionsBeforeSubmitSlot, submitButtonSlot: submitButtonSlot } = t0;
    let t1;
    if ($[0] !== actionsBeforeSubmitSlot || $[1] !== submitButtonSlot) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, actionsBeforeSubmitSlot, submitButtonSlot);
        $[0] = actionsBeforeSubmitSlot;
        $[1] = submitButtonSlot;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== promptControlsSlot || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, promptControlsSlot, t1);
        $[3] = promptControlsSlot;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ promptControlsSlot: promptControlsSlot, actionsBeforeSubmitSlot: actionsBeforeSubmitSlot, submitButtonSlot: submitButtonSlot })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, promptControlsSlot, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, actionsBeforeSubmitSlot, submitButtonSlot));
var $c6718c697198a5dc$export$2e2bcd8739ae039 = $c6718c697198a5dc$var$DisabledVoiceFooterRow;



var $a6scT = parcelRequire("a6scT");







/**
 * @generated SignedSource<<2db79beb4274348ea0a98a5c4d89f23c>>
 * @relayHash 10bf00e2633700922be941f41fd6e77b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d29a48e361894ee5d130acd90c4a409e70cffa756c275f588d2562e5ce74f5a
const $d612aafebcc69f6d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "identityAccountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "identityAccountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgentInputHatIdentityAccountQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgentInputHatIdentityAccountQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d29a48e361894ee5d130acd90c4a409e70cffa756c275f588d2562e5ce74f5a",
            "metadata": {},
            "name": "AgentInputHatIdentityAccountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d612aafebcc69f6d$var$node.hash = "cb707bfab5c3edd50e616c2a61a82765";
var $d612aafebcc69f6d$export$2e2bcd8739ae039 = $d612aafebcc69f6d$var$node;












var $6SsN4 = parcelRequire("6SsN4");


var $eFbDl = parcelRequire("eFbDl");


var $1sCHt = parcelRequire("1sCHt");





var $l3wuH = parcelRequire("l3wuH");


var $bltJZ = parcelRequire("bltJZ");








/**
 * Shared identity-derivation helper used by AgentInputHat (above the prompt
 * input) and AgentResponseHat (above an assistant message). Both components
 * need to translate raw agent identity props into the inputs that AgentAvatar
 * expects, plus an accessible/visible name pair, with the same fallback
 * semantics. Centralising the logic here avoids drift between the two hats —
 * historically every change to one needed a paired change to the other.
 */ 



var $g3RoK = parcelRequire("g3RoK");


var $hq9Cp = parcelRequire("hq9Cp");

function $7fde21960088fe3e$export$b0b6be9085e9ca13({ agentId: agentId, agentName: agentName, agentNamedId: agentNamedId, agentIdentityAccountId: agentIdentityAccountId, imageUrl: imageUrl, creatorType: creatorType, isForgeAgent: isForgeAgentOverride, forgeAgentIconUrl: forgeAgentIconUrl, defaultName: defaultName }) {
    const trimmedAgentId = typeof agentId === 'string' ? agentId.trim() : undefined;
    const specialistAgentId = trimmedAgentId && trimmedAgentId.length > 0 ? trimmedAgentId : undefined;
    const trimmedAgentNamedId = typeof agentNamedId === 'string' ? agentNamedId.trim() : undefined;
    const specialistAgentNamedId = trimmedAgentNamedId && trimmedAgentNamedId.length > 0 ? trimmedAgentNamedId : undefined;
    const specialistIdentity = specialistAgentId ?? specialistAgentNamedId;
    const trimmedAgentName = agentName?.trim();
    const visibleName = specialistIdentity ? trimmedAgentName || undefined : defaultName;
    const accessibleName = specialistIdentity ? trimmedAgentName || specialistIdentity : defaultName;
    const a2aGateOn = (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar');
    // Prefer the explicit override; otherwise validate creatorType via the
    // type guard so the call site doesn't need an unsafe cast.
    const isForgeAgent = isForgeAgentOverride !== undefined ? isForgeAgentOverride : creatorType && (0, $g3RoK.isAgentCreatorType)(creatorType) ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : undefined;
    return {
        hasSpecialistIdentity: Boolean(specialistIdentity),
        specialistAgentId: specialistAgentId,
        visibleName: visibleName,
        accessibleName: accessibleName,
        avatarProps: {
            agentId: specialistAgentId,
            agentNamedId: specialistAgentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            imageUrl: imageUrl,
            isForgeAgent: a2aGateOn ? isForgeAgent : undefined,
            forgeAgentIconUrl: a2aGateOn ? forgeAgentIconUrl : undefined
        }
    };
}



var $6gGPb = parcelRequire("6gGPb");


var $a9aSv = parcelRequire("a9aSv");







const $73f55fa38e4c5892$var$messages = (0, $kSwu1.defineMessages)({
    defaultAgentName: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.agent-input-hat-messages.defaultAgentName",
        defaultMessage: "Rovo"
    },
    closeLabel: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.agent-input-hat-messages.closeLabel",
        defaultMessage: "Dismiss active agent"
    }
});
var $73f55fa38e4c5892$export$2e2bcd8739ae039 = $73f55fa38e4c5892$var$messages;



const $60b389bd4ceedccc$var$AgentProfileCardWrapper = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cyU0n")).then((mod)=>({
            default: mod.AgentProfileCardWrapper
        })));
const $60b389bd4ceedccc$var$styles = {
    container: "_4c065U2ADO _2Y7lL48HPE",
    agentTriggerBase: "_0bjKvDKTcp _4c065U1Y8M _2Y7lL42ADO _3iDTPbccYA _0hPCNLDIqT",
    agentTriggerInteractive: "_0wOv4Q7zJH _1eOmH6d1Zr _3gzVzLJNoT"
};
const $60b389bd4ceedccc$var$getAccountIdFromIdentityAccountId = (value)=>{
    const trimmedValue = value?.trim();
    if (!trimmedValue) return undefined;
    const identityUserAriPrefix = 'ari:cloud:identity::user/';
    if (trimmedValue.startsWith(identityUserAriPrefix)) return trimmedValue.slice(identityUserAriPrefix.length);
    return trimmedValue.startsWith('ari:') ? undefined : trimmedValue;
};
const $60b389bd4ceedccc$var$AgentInputHatIdentityAccount = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { identityAccountId: identityAccountId, fallback: fallback } = t0;
    let t1;
    if ($[0] !== identityAccountId) {
        t1 = {
            identityAccountId: identityAccountId
        };
        $[0] = identityAccountId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $d612aafebcc69f6d$export$2e2bcd8739ae039), t1, t2);
    let t3;
    if ($[3] !== data.user?.name) {
        t3 = data.user?.name?.trim();
        $[3] = data.user?.name;
        $[4] = t3;
    } else t3 = $[4];
    const name = t3;
    let t4;
    if ($[5] !== data.user?.picture) {
        t4 = data.user?.picture?.trim();
        $[5] = data.user?.picture;
        $[6] = t4;
    } else t4 = $[6];
    const picture = t4;
    if (!name || !picture) return fallback;
    let t5;
    if ($[7] !== name || $[8] !== picture) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $6gGPb.AgentAvatar), {
            imageUrl: picture,
            size: "small",
            name: name,
            label: name,
            showBorder: false
        });
        $[7] = name;
        $[8] = picture;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== name) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text",
            weight: "regular"
        }, name);
        $[10] = name;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, t5, t6);
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ({ identityAccountId: identityAccountId, fallback: fallback })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $d612aafebcc69f6d$export$2e2bcd8739ae039), {
        identityAccountId: identityAccountId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const name = data.user?.name?.trim();
    const picture = data.user?.picture?.trim();
    if (!name || !picture) return fallback;
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, $6gGPb.AgentAvatar), {
        imageUrl: picture,
        size: "small",
        name: name,
        label: name,
        showBorder: false
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text",
        weight: "regular"
    }, name));
};
const $60b389bd4ceedccc$export$9c8d9142406f756c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { agentName: agentName, agentId: agentId, agentNamedId: agentNamedId, agentIdentityAccountId: agentIdentityAccountId, imageUrl: imageUrl, creatorType: creatorType, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl, cloudId: cloudId, onDismiss: onDismiss, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== agentId || $[1] !== agentNamedId) {
        t1 = (0, $2yWJZ.isDefaultRovoChat)({
            agentId: agentId,
            agentNamedId: agentNamedId
        });
        $[0] = agentId;
        $[1] = agentNamedId;
        $[2] = t1;
    } else t1 = $[2];
    const isDefaultRovo = t1;
    let t2;
    if ($[3] !== agentIdentityAccountId || $[4] !== isDefaultRovo) {
        t2 = isDefaultRovo ? undefined : $60b389bd4ceedccc$var$getAccountIdFromIdentityAccountId(agentIdentityAccountId);
        $[3] = agentIdentityAccountId;
        $[4] = isDefaultRovo;
        $[5] = t2;
    } else t2 = $[5];
    const identityAccountId = t2;
    const hasSpecialistIdentity = Boolean(identityAccountId);
    let t3;
    if ($[6] !== agentId || $[7] !== agentIdentityAccountId || $[8] !== agentName || $[9] !== agentNamedId || $[10] !== creatorType || $[11] !== forgeAgentIconUrl || $[12] !== formatMessage || $[13] !== hasSpecialistIdentity || $[14] !== imageUrl || $[15] !== isDefaultRovo || $[16] !== isForgeAgent) {
        t3 = hasSpecialistIdentity ? {
            visibleName: undefined
        } : (0, $7fde21960088fe3e$export$b0b6be9085e9ca13)({
            agentId: isDefaultRovo ? undefined : agentId,
            agentName: agentName,
            agentNamedId: isDefaultRovo ? undefined : agentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            imageUrl: imageUrl,
            creatorType: creatorType,
            isForgeAgent: isForgeAgent,
            forgeAgentIconUrl: forgeAgentIconUrl,
            defaultName: formatMessage((0, $73f55fa38e4c5892$export$2e2bcd8739ae039).defaultAgentName)
        });
        $[6] = agentId;
        $[7] = agentIdentityAccountId;
        $[8] = agentName;
        $[9] = agentNamedId;
        $[10] = creatorType;
        $[11] = forgeAgentIconUrl;
        $[12] = formatMessage;
        $[13] = hasSpecialistIdentity;
        $[14] = imageUrl;
        $[15] = isDefaultRovo;
        $[16] = isForgeAgent;
        $[17] = t3;
    } else t3 = $[17];
    const { visibleName: visibleName } = t3;
    const hasProfileCard = Boolean(identityAccountId && cloudId);
    let t4;
    if ($[18] !== hasSpecialistIdentity || $[19] !== visibleName) {
        t4 = hasSpecialistIdentity ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, /*#__PURE__*/ $cozmU.createElement((0, $eFbDl.default), {
            appearance: "circle",
            size: "small"
        }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "80px",
            height: "12px"
        })) : /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
            label: "",
            shouldUseHexLogo: true,
            size: "xsmall"
        }), visibleName ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "medium",
            color: "color.text",
            weight: "regular"
        }, visibleName) : null);
        $[18] = hasSpecialistIdentity;
        $[19] = visibleName;
        $[20] = t4;
    } else t4 = $[20];
    const fallback = t4;
    const t5 = hasProfileCard ? $60b389bd4ceedccc$var$styles.agentTriggerInteractive : undefined;
    let t6;
    if ($[21] !== t5) {
        t6 = (0, $w6R6I.cx)($60b389bd4ceedccc$var$styles.agentTriggerBase, t5);
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== fallback || $[24] !== identityAccountId) {
        t7 = identityAccountId ? /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: fallback
        }, /*#__PURE__*/ $cozmU.createElement($60b389bd4ceedccc$var$AgentInputHatIdentityAccount, {
            identityAccountId: identityAccountId,
            fallback: fallback
        }))) : fallback;
        $[23] = fallback;
        $[24] = identityAccountId;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t6
        }, t7);
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    const agentTriggerBox = t8;
    let t9;
    if ($[29] !== agentTriggerBox || $[30] !== cloudId || $[31] !== hasProfileCard || $[32] !== identityAccountId) {
        t9 = hasProfileCard ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: agentTriggerBox
        }, /*#__PURE__*/ $cozmU.createElement($60b389bd4ceedccc$var$AgentProfileCardWrapper, {
            identityAccountId: identityAccountId,
            cloudId: cloudId
        }, agentTriggerBox)) : agentTriggerBox;
        $[29] = agentTriggerBox;
        $[30] = cloudId;
        $[31] = hasProfileCard;
        $[32] = identityAccountId;
        $[33] = t9;
    } else t9 = $[33];
    const wrappedAgentTriggerBox = t9;
    let t10;
    if ($[34] !== formatMessage || $[35] !== onDismiss) {
        t10 = typeof onDismiss === "function" ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage((0, $73f55fa38e4c5892$export$2e2bcd8739ae039).closeLabel),
            onClick: onDismiss
        }) : null;
        $[34] = formatMessage;
        $[35] = onDismiss;
        $[36] = t10;
    } else t10 = $[36];
    let t11;
    if ($[37] !== t10 || $[38] !== wrappedAgentTriggerBox) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.075"
        }, wrappedAgentTriggerBox, t10);
        $[37] = t10;
        $[38] = wrappedAgentTriggerBox;
        $[39] = t11;
    } else t11 = $[39];
    let t12;
    if ($[40] !== t11 || $[41] !== testId) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $60b389bd4ceedccc$var$styles.container,
            testId: testId
        }, t11);
        $[40] = t11;
        $[41] = testId;
        $[42] = t12;
    } else t12 = $[42];
    return t12;
} : ({ agentName: agentName, agentId: agentId, agentNamedId: agentNamedId, agentIdentityAccountId: agentIdentityAccountId, imageUrl: imageUrl, creatorType: creatorType, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl, cloudId: cloudId, onDismiss: onDismiss, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isDefaultRovo = (0, $2yWJZ.isDefaultRovoChat)({
        agentId: agentId,
        agentNamedId: agentNamedId
    });
    const identityAccountId = isDefaultRovo ? undefined : $60b389bd4ceedccc$var$getAccountIdFromIdentityAccountId(agentIdentityAccountId);
    const hasSpecialistIdentity = Boolean(identityAccountId);
    const { visibleName: visibleName } = hasSpecialistIdentity ? {
        visibleName: undefined
    } : (0, $7fde21960088fe3e$export$b0b6be9085e9ca13)({
        agentId: isDefaultRovo ? undefined : agentId,
        agentName: agentName,
        agentNamedId: isDefaultRovo ? undefined : agentNamedId,
        agentIdentityAccountId: agentIdentityAccountId,
        imageUrl: imageUrl,
        creatorType: creatorType,
        isForgeAgent: isForgeAgent,
        forgeAgentIconUrl: forgeAgentIconUrl,
        defaultName: formatMessage((0, $73f55fa38e4c5892$export$2e2bcd8739ae039).defaultAgentName)
    });
    const hasProfileCard = Boolean(identityAccountId && cloudId);
    const fallback = hasSpecialistIdentity ? /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, $eFbDl.default), {
        appearance: "circle",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "80px",
        height: "12px"
    })) : /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
        label: "",
        shouldUseHexLogo: true,
        size: "xsmall"
    }), visibleName ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text",
        weight: "regular"
    }, visibleName) : null);
    const agentTriggerBox = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($60b389bd4ceedccc$var$styles.agentTriggerBase, hasProfileCard ? $60b389bd4ceedccc$var$styles.agentTriggerInteractive : undefined)
    }, identityAccountId ? /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: fallback
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, /*#__PURE__*/ $cozmU.createElement($60b389bd4ceedccc$var$AgentInputHatIdentityAccount, {
        identityAccountId: identityAccountId,
        fallback: fallback
    }))) : fallback);
    const wrappedAgentTriggerBox = hasProfileCard ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: agentTriggerBox
    }, /*#__PURE__*/ $cozmU.createElement($60b389bd4ceedccc$var$AgentProfileCardWrapper, {
        identityAccountId: identityAccountId,
        cloudId: cloudId
    }, agentTriggerBox)) : agentTriggerBox;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $60b389bd4ceedccc$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.075"
    }, wrappedAgentTriggerBox, typeof onDismiss === 'function' ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $73f55fa38e4c5892$export$2e2bcd8739ae039).closeLabel),
        onClick: onDismiss
    }) : null));
};












var $cbY7C = parcelRequire("cbY7C");





var $3vgx3 = parcelRequire("3vgx3");





var $9Bssi = parcelRequire("9Bssi");


var $2hJf7 = parcelRequire("2hJf7");


var $krxYo = parcelRequire("krxYo");


var $cJ0FD = parcelRequire("cJ0FD");


var $9KSWX = parcelRequire("9KSWX");


var $6IL1T = parcelRequire("6IL1T");









var $hBYtq = parcelRequire("hBYtq");




var $lpNn5 = parcelRequire("lpNn5");








var $ekfm7 = parcelRequire("ekfm7");













const $2ba5a522f3921255$var$DEFAULT_MAX_VISIBLE = 2;
const $2ba5a522f3921255$var$DEFAULT_AMPLITUDE = 4;
const $2ba5a522f3921255$var$DEFAULT_BOB_DURATION = 620;
const $2ba5a522f3921255$var$DEFAULT_STAGGER = 180;
const $2ba5a522f3921255$var$DEFAULT_WAVE_COUNT = 3;
const $2ba5a522f3921255$var$DEFAULT_BETWEEN_WAVES_PAUSE = 300;
const $2ba5a522f3921255$var$DEFAULT_INITIAL_DELAY = 460;
const $2ba5a522f3921255$var$DEFAULT_WITH_GHOST_FRAME = true;
const $2ba5a522f3921255$var$GHOST_FRAME_MASK_BORDER_PX = 1;
const $2ba5a522f3921255$var$AMPLITUDE_CSS_VAR = '--gw-amp';
const $2ba5a522f3921255$var$DELAY_CSS_VAR = '--gw-delay';
const $2ba5a522f3921255$var$DURATION_CSS_VAR = '--gw-duration';
const $2ba5a522f3921255$var$EASING_CSS_VAR = '--gw-easing';
const $2ba5a522f3921255$var$ITERATIONS_CSS_VAR = '--gw-iterations';
const $2ba5a522f3921255$var$ICON_OPACITY_CSS_VAR = '--gw-icon-opacity';
const $2ba5a522f3921255$var$DEFAULT_ICON_OPACITY = 0.7;
const $2ba5a522f3921255$var$INFINITE_ITERATION_COUNT = 'infinite';
const $2ba5a522f3921255$var$ROLE_IMG = 'img';
const $2ba5a522f3921255$var$SLOT_DATA_ATTR = 'data-ghost-icon-wave-slot';
const $2ba5a522f3921255$var$FRAME_DATA_ATTR = 'data-ghost-icon-wave-frame';
// Two keyframes only (rest -> peak). This keeps the animation as a single
// segment so the timing function drives the entire rise/fall/rest shape
// itself, rather than CSS applying it independently to each keyframe segment
// (which would otherwise cause the icon to "hang" at the peak and at rest
// before each segment's next phase began).
const $2ba5a522f3921255$var$bobKeyframes = null;
const $2ba5a522f3921255$var$rowStyles = null;
const $2ba5a522f3921255$var$slotStyles = null;
const $2ba5a522f3921255$var$ghostFrameStyles = null;
const $2ba5a522f3921255$var$ghostFrameSurfaceMaskStyles = null;
const $2ba5a522f3921255$var$ghostFrameWrapperStyles = null;
const $2ba5a522f3921255$var$ghostIconContentStyles = null; /**
                                      * Renders a short row of icons with a staggered left-to-right bob animation.
                                      *
                                      * The animation is fully CSS-driven: each icon receives a per-slot
                                      * `animationDelay` and `animationDuration` so the wave repeats `waveCount`
                                      * times without any JS timers, making the component SSR-safe and friendly to
                                      * the React Compiler. Consumers can replay the wave by changing the React
                                      * `key` prop on the component. Passing `waveCount={0}` renders icons in
                                      * ghost frames at rest (no motion), which is useful when callers only want to
                                      * animate first-view states and keep subsequent renders static.
                                      */ 
const $2ba5a522f3921255$export$a99469ff008e0788 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { icons: icons, maxVisible: t1, amplitude: t2, bobDuration: t3, stagger: t4, waveCount: t5, betweenWavesPause: t6, initialDelay: t7, withGhostFrame: t8, iconOpacity: iconOpacity, label: label } = t0;
    const maxVisible = t1 === undefined ? $2ba5a522f3921255$var$DEFAULT_MAX_VISIBLE : t1;
    const amplitude = t2 === undefined ? $2ba5a522f3921255$var$DEFAULT_AMPLITUDE : t2;
    const bobDuration = t3 === undefined ? $2ba5a522f3921255$var$DEFAULT_BOB_DURATION : t3;
    const stagger = t4 === undefined ? $2ba5a522f3921255$var$DEFAULT_STAGGER : t4;
    const waveCount = t5 === undefined ? $2ba5a522f3921255$var$DEFAULT_WAVE_COUNT : t5;
    const betweenWavesPause = t6 === undefined ? $2ba5a522f3921255$var$DEFAULT_BETWEEN_WAVES_PAUSE : t6;
    const initialDelay = t7 === undefined ? $2ba5a522f3921255$var$DEFAULT_INITIAL_DELAY : t7;
    const withGhostFrame = t8 === undefined ? $2ba5a522f3921255$var$DEFAULT_WITH_GHOST_FRAME : t8;
    let t10;
    let t11;
    let t12;
    let t13;
    let t9;
    if ($[0] !== amplitude || $[1] !== betweenWavesPause || $[2] !== bobDuration || $[3] !== iconOpacity || $[4] !== icons || $[5] !== initialDelay || $[6] !== label || $[7] !== maxVisible || $[8] !== stagger || $[9] !== waveCount || $[10] !== withGhostFrame) {
        const visible = icons.slice(0, maxVisible);
        const sweepSpan = Math.max(0, visible.length - 1) * stagger;
        const sweepCycleMs = sweepSpan + bobDuration + betweenWavesPause;
        const iterationCount = waveCount === Infinity ? $2ba5a522f3921255$var$INFINITE_ITERATION_COUNT : waveCount;
        const bobFraction = sweepCycleMs > 0 ? Math.min(1, bobDuration / sweepCycleMs) : 1;
        const peakPct = bobFraction / 2 * 100;
        const bobEndPct = bobFraction * 100;
        let t14;
        if ($[16] !== peakPct) {
            t14 = peakPct.toFixed(2);
            $[16] = peakPct;
            $[17] = t14;
        } else t14 = $[17];
        let t15;
        if ($[18] !== bobEndPct) {
            t15 = bobEndPct.toFixed(2);
            $[18] = bobEndPct;
            $[19] = t15;
        } else t15 = $[19];
        const scrunchedEasing = `linear(0, 1 ${t14}%, 0 ${t15}%, 0)`;
        t9 = label ? $2ba5a522f3921255$var$ROLE_IMG : undefined;
        t10 = label;
        t11 = label ? undefined : true;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = (0, $hekY6.default)([
                "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT"
            ]);
            $[20] = t12;
        } else t12 = $[20];
        let t16;
        if ($[21] !== amplitude || $[22] !== iconOpacity || $[23] !== initialDelay || $[24] !== iterationCount || $[25] !== scrunchedEasing || $[26] !== stagger || $[27] !== sweepCycleMs || $[28] !== withGhostFrame) {
            t16 = (icon, index)=>{
                const slotChildren = withGhostFrame ? /*#__PURE__*/ $cozmU.createElement("span", {
                    className: (0, $hekY6.default)([
                        "_0hPCNLDIqT _0pI6nMDIqT _1mT5xdRAKS _3iDTPbkfkE"
                    ])
                }, /*#__PURE__*/ $cozmU.createElement("span", {
                    style: iconOpacity === undefined ? undefined : {
                        [$2ba5a522f3921255$var$ICON_OPACITY_CSS_VAR]: `${iconOpacity}`
                    },
                    className: (0, $hekY6.default)([
                        "_0hPCNLDIqT _0pI6nMDIqT _3iDTPbkfkE _1llTr64jUD"
                    ])
                }, icon), /*#__PURE__*/ $cozmU.createElement("span", {
                    className: (0, $hekY6.default)([
                        "_49OCfRdnbC _0bjKvDKxmn _2V7sgOHZdu _3hxITi6wH8 _3vBAKHlfZc _1mT5xdWVPG _24h04i2Njc _1pp6NdYbGa"
                    ])
                }), /*#__PURE__*/ $cozmU.createElement("span", {
                    [$2ba5a522f3921255$var$FRAME_DATA_ATTR]: "",
                    className: (0, $hekY6.default)([
                        "_49OCfRdnbC _0bjKvDKxmn _2V7sgONvrM _3hxITisurO _3vBAKH9r67 _1mT5xdWVPG _24h04i2Njc _1pp6NdYbGa _3rk7i1WkXl"
                    ])
                })) : icon;
                const slotInlineStyle = {
                    [$2ba5a522f3921255$var$AMPLITUDE_CSS_VAR]: `${amplitude}px`,
                    [$2ba5a522f3921255$var$DELAY_CSS_VAR]: `${initialDelay + index * stagger}ms`,
                    [$2ba5a522f3921255$var$DURATION_CSS_VAR]: `${sweepCycleMs}ms`,
                    [$2ba5a522f3921255$var$EASING_CSS_VAR]: scrunchedEasing,
                    [$2ba5a522f3921255$var$ITERATIONS_CSS_VAR]: `${iterationCount}`
                };
                return /*#__PURE__*/ $cozmU.createElement("span", {
                    key: index,
                    style: slotInlineStyle,
                    "aria-hidden": true,
                    [$2ba5a522f3921255$var$SLOT_DATA_ATTR]: "",
                    className: (0, $hekY6.default)([
                        "_0hPCNLDIqT _0pI6nMDIqT _3iDTPbkfkE _1gBibyExt7 _1jakNn2Zfq _0nFVCGQpeo _43vdfT3A3Y _03m2ny7u69 _3Y6bKpYbGa _39Ohv4YbGa _1LeFqTYbGa"
                    ])
                }, slotChildren);
            };
            $[21] = amplitude;
            $[22] = iconOpacity;
            $[23] = initialDelay;
            $[24] = iterationCount;
            $[25] = scrunchedEasing;
            $[26] = stagger;
            $[27] = sweepCycleMs;
            $[28] = withGhostFrame;
            $[29] = t16;
        } else t16 = $[29];
        t13 = visible.map(t16);
        $[0] = amplitude;
        $[1] = betweenWavesPause;
        $[2] = bobDuration;
        $[3] = iconOpacity;
        $[4] = icons;
        $[5] = initialDelay;
        $[6] = label;
        $[7] = maxVisible;
        $[8] = stagger;
        $[9] = waveCount;
        $[10] = withGhostFrame;
        $[11] = t10;
        $[12] = t11;
        $[13] = t12;
        $[14] = t13;
        $[15] = t9;
    } else {
        t10 = $[11];
        t11 = $[12];
        t12 = $[13];
        t13 = $[14];
        t9 = $[15];
    }
    let t14;
    if ($[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t13 || $[34] !== t9) {
        t14 = /*#__PURE__*/ $cozmU.createElement("span", {
            role: t9,
            "aria-label": t10,
            "aria-hidden": t11,
            className: t12
        }, t13);
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
        $[33] = t13;
        $[34] = t9;
        $[35] = t14;
    } else t14 = $[35];
    return t14;
} : ({ icons: icons, maxVisible: maxVisible = $2ba5a522f3921255$var$DEFAULT_MAX_VISIBLE, amplitude: amplitude = $2ba5a522f3921255$var$DEFAULT_AMPLITUDE, bobDuration: bobDuration = $2ba5a522f3921255$var$DEFAULT_BOB_DURATION, stagger: stagger = $2ba5a522f3921255$var$DEFAULT_STAGGER, waveCount: waveCount = $2ba5a522f3921255$var$DEFAULT_WAVE_COUNT, betweenWavesPause: betweenWavesPause = $2ba5a522f3921255$var$DEFAULT_BETWEEN_WAVES_PAUSE, initialDelay: initialDelay = $2ba5a522f3921255$var$DEFAULT_INITIAL_DELAY, withGhostFrame: withGhostFrame = $2ba5a522f3921255$var$DEFAULT_WITH_GHOST_FRAME, iconOpacity: iconOpacity, label: label })=>{
    const visible = icons.slice(0, maxVisible); // One full sweep = time from the first icon starting to the last icon
    // finishing its bob, plus a quiet pause between sweeps. Every slot uses
    // the same cycle length so their phases stay aligned across iterations.
    const sweepSpan = Math.max(0, visible.length - 1) * stagger;
    const sweepCycleMs = sweepSpan + bobDuration + betweenWavesPause;
    const iterationCount = waveCount === Infinity ? $2ba5a522f3921255$var$INFINITE_ITERATION_COUNT : waveCount; // The keyframes are just `rest -> peak`, so a single segment spans the
    // whole animation. The timing function drives keyframe progress through
    // the full rise/fall/rest shape: up to `1` (peak) at the bob's midpoint,
    // back to `0` (rest) at the bob's end, then held at `0` for the remainder
    // of the cycle. The peak is just an instant — the icon never hangs at the
    // top and comes back down as soon as it peaks.
    const bobFraction = sweepCycleMs > 0 ? Math.min(1, bobDuration / sweepCycleMs) : 1;
    const peakPct = bobFraction / 2 * 100;
    const bobEndPct = bobFraction * 100;
    const scrunchedEasing = `linear(0, 1 ${peakPct.toFixed(2)}%, 0 ${bobEndPct.toFixed(2)}%, 0)`;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        role: label ? $2ba5a522f3921255$var$ROLE_IMG : undefined,
        "aria-label": label,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT"
        ])
    }, visible.map((icon, index)=>{
        const slotChildren = withGhostFrame ? /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_0hPCNLDIqT _0pI6nMDIqT _1mT5xdRAKS _3iDTPbkfkE"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span" // Only set the override when a value is provided; otherwise the CSS
        , {
            // `var(..., DEFAULT_ICON_OPACITY)` fallback governs.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- icon opacity is set inline as a CSS custom property so it can be overridden per-render
            style: iconOpacity === undefined ? undefined : {
                [$2ba5a522f3921255$var$ICON_OPACITY_CSS_VAR]: `${iconOpacity}`
            },
            className: (0, $hekY6.default)([
                "_0hPCNLDIqT _0pI6nMDIqT _3iDTPbkfkE _1llTr64jUD"
            ])
        }, icon), /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _0bjKvDKxmn _2V7sgOHZdu _3hxITi6wH8 _3vBAKHlfZc _1mT5xdWVPG _24h04i2Njc _1pp6NdYbGa"
            ])
        }), /*#__PURE__*/ $cozmU.createElement("span", {
            [$2ba5a522f3921255$var$FRAME_DATA_ATTR]: '',
            className: (0, $hekY6.default)([
                "_49OCfRdnbC _0bjKvDKxmn _2V7sgONvrM _3hxITisurO _3vBAKH9r67 _1mT5xdWVPG _24h04i2Njc _1pp6NdYbGa _3rk7i1WkXl"
            ])
        })) : icon;
        const slotInlineStyle = {
            [$2ba5a522f3921255$var$AMPLITUDE_CSS_VAR]: `${amplitude}px`,
            [$2ba5a522f3921255$var$DELAY_CSS_VAR]: `${initialDelay + index * stagger}ms`,
            [$2ba5a522f3921255$var$DURATION_CSS_VAR]: `${sweepCycleMs}ms`,
            [$2ba5a522f3921255$var$EASING_CSS_VAR]: scrunchedEasing,
            [$2ba5a522f3921255$var$ITERATIONS_CSS_VAR]: `${iterationCount}`
        };
        return /*#__PURE__*/ $cozmU.createElement("span", {
            key: index,
            style: slotInlineStyle,
            "aria-hidden": true,
            [$2ba5a522f3921255$var$SLOT_DATA_ATTR]: '',
            className: (0, $hekY6.default)([
                "_0hPCNLDIqT _0pI6nMDIqT _3iDTPbkfkE _1gBibyExt7 _1jakNn2Zfq _0nFVCGQpeo _43vdfT3A3Y _03m2ny7u69 _3Y6bKpYbGa _39Ohv4YbGa _1LeFqTYbGa"
            ])
        }, slotChildren);
    }));
};



var $ak8CL = parcelRequire("ak8CL");


var $its7R = parcelRequire("its7R");


var $6xccU = parcelRequire("6xccU");

function $5cd243480b1ee9b0$export$aad051ed2e5eb6f1(connectors) {
    const toMs = (c)=>c.connectedAt ? new Date(c.connectedAt).getTime() : 0;
    const authedConnectors = Object.values(connectors).filter((c)=>c.isUserOAuthed);
    const thirdPartyApps = authedConnectors.filter((c)=>(0, $6xccU.is3pApp)(c.friendlyName)).sort((a, b)=>toMs(b) - toMs(a));
    const firstPartyApps = authedConnectors.filter((c)=>!(0, $6xccU.is3pApp)(c.friendlyName)).sort((a, b)=>toMs(b) - toMs(a));
    return [
        ...thirdPartyApps,
        ...firstPartyApps
    ].map((c)=>({
            source: c.source,
            friendlyName: c.friendlyName,
            iconUrl: c.iconUrl
        }));
}



























var $jmUhx = parcelRequire("jmUhx");








var $a1ZzW = parcelRequire("a1ZzW");


var $kpuvJ = parcelRequire("kpuvJ");








var $hLP6B = parcelRequire("hLP6B");































var $gitiq = parcelRequire("gitiq");


var $a9u73 = parcelRequire("a9u73");





var $8hYSP = parcelRequire("8hYSP");




/**
 * Decides whether a connector row renders as toggled on in the sources dropdown.
 *
 * An empty selection with org knowledge on means "all connected apps apply" (see
 * `getAppFilters`), so every connected app must read as on — otherwise a freshly
 * connected app would show off even though it is included in the next
 * message. A non-empty selection is an explicit narrowed set, so only the listed
 * apps are on. This mirrors the initial-load `shouldSelectAll` behaviour and is
 * shared by the init and both re-init paths so they cannot drift.
 */ const $d654b99b72f44b8f$export$6cee836ceb3fcfa0 = (app, preservedSelectedApps, orgKnowledgeEnabled)=>{
    const shouldSelectAll = preservedSelectedApps.length === 0 && orgKnowledgeEnabled !== false;
    return shouldSelectAll ? !!app.isUserOAuthed : preservedSelectedApps.some((a)=>a.source === app.source);
};





const $c3f48f68df089ed0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    searchAppsPlaceholder: {
        id: "ai-mate.chat-input.mode.menu.search-apps.placeholder",
        defaultMessage: "Search apps"
    },
    loadingApps: {
        id: "ai-mate.chat-input.mode.menu.loading-apps",
        defaultMessage: "Loading apps..."
    },
    filterByApps: {
        id: "ai-mate.chat-input.mode.menu.filter-by-apps",
        defaultMessage: "Filter by apps"
    },
    clearAll: {
        id: "ai-mate.chat-input.mode.menu.clear-all",
        defaultMessage: "Clear all"
    },
    backButtonLabel: {
        id: "ai-mate.chat-input.mode.menu.back-button-label",
        defaultMessage: "Go back"
    },
    connect: {
        id: "ai-mate.chat-input.mode.menu.connect-button-label",
        defaultMessage: "Connect"
    },
    selectApp: {
        id: "ai-mate.chat-input.mode.menu.select-app",
        defaultMessage: "Select {appName}"
    },
    deselectApp: {
        id: "ai-mate.chat-input.mode.menu.deselect-app",
        defaultMessage: "Deselect {appName}"
    },
    connectApp: {
        id: "ai-mate.chat-input.mode.menu.connect-app",
        defaultMessage: "Connect {appName}"
    },
    sourcesHeader: {
        id: "ai-mate.chat-input.mode.menu.sources-header",
        defaultMessage: "Sources"
    },
    appsHeader: {
        id: "ai-mate.chat-input.mode.menu.apps-header",
        defaultMessage: "Recently connected apps"
    },
    spaceAppsHeader: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.chat-mode-menu.app-filter.spaceAppsHeader",
        defaultMessage: "Apps"
    },
    includeWebResults: {
        id: "ai-mate.chat-input.mode.menu.include-web-results",
        defaultMessage: "Include web results"
    },
    searchCompanyKnowledge: {
        id: "ai-mate.chat-input.mode.menu.search-company-knowledge",
        defaultMessage: "Search company knowledge"
    },
    strictSourceMode: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.chat-mode-menu.app-filter.strictSourceMode",
        defaultMessage: "Use specific knowledge"
    },
    strictSourceModeTooltip: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.chat-mode-menu.app-filter.strictSourceModeTooltip",
        defaultMessage: "Rovo will only answer with knowledge you add to this space"
    },
    strictSourceModeDescription: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.chat-mode-menu.app-filter.strictSourceModeDescription",
        defaultMessage: "Other sources are unavailable when \u2018Use specific knowledge\u2019 is selected"
    },
    newBadge: {
        id: "ai-mate.chat-input.mode.menu.new-badge",
        defaultMessage: "New"
    },
    viewMore: {
        id: "ai-mate.chat-input.mode.menu.view-more",
        defaultMessage: "View more"
    },
    viewMoreModalTitle: {
        id: "ai-mate.chat-input.mode.menu.view-more-modal-title",
        defaultMessage: "Sources & apps"
    },
    viewMoreConnectedApps: {
        id: "ai-mate.chat-input.mode.menu.view-more-connected-apps",
        defaultMessage: "Connected apps"
    },
    searchSettingsPlaceholder: {
        id: "ai-mate.chat-input.mode.menu.search-settings-placeholder",
        defaultMessage: "Search settings"
    },
    rovoSettingsHeader: {
        id: "ai-mate.chat-input.mode.menu.rovo-settings-header",
        defaultMessage: "Rovo Settings"
    },
    connectedAppsDescription: {
        id: "ai-mate.chat-input.mode.menu.connected-apps-description",
        defaultMessage: "Manage web results and company knowledge sources."
    },
    connectedAppsOutOfTotal: {
        id: "ai-mate.chat-input.mode.menu.connected-apps-out-of-total",
        defaultMessage: "{connectedCount} of your {totalCount} apps are connected"
    },
    connectMoreApps: {
        id: "ai-mate.chat-input.mode.menu.connect-more-apps",
        defaultMessage: "Connect more"
    },
    appsAvailableToConnectSectionHeader: {
        id: "ai-mate.chat-input.mode.menu.apps-available-to-connect-section-header",
        defaultMessage: "{count, plural, one {# app available to connect} other {# apps available to connect}}"
    },
    discoverMoreApps: {
        id: "ai-mate.chat-input.mode.menu.discover-more-apps",
        defaultMessage: "Discover more apps"
    }
});















var $ad7Ou = parcelRequire("ad7Ou");





var $5wHqn = parcelRequire("5wHqn");









var $4M6Ac = parcelRequire("4M6Ac");




const $b92d72d1e60f1273$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    authorizeConnectApp: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.authorize-connect-app",
        defaultMessage: "Your admin has added <strong>{appName}!</strong>{br}\n\t\t\tConnect your account to see missing results, including documents only you have access to.\n\t\t"
    },
    connect: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.connect",
        defaultMessage: "Connect"
    },
    notNow: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.app-filter.oauth-popup.not-now",
        defaultMessage: "Not now"
    }
});


const $74d0a6c3c6ad2b23$var$styles = {
    popupContent: "_0bjKvDKxmn _39xV02zZoh _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _2OUyjtGk8v",
    buttonContainer: "_3iDTPbQ4SZ _37wbyuz9WS _0aFT5v1qpb",
    button: "_3138422ADO _0adFHs2ADO _1DCdHi2ADO _2XsHFM2ADO"
};
const $74d0a6c3c6ad2b23$var$OAuthPopupWrapperImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { app: app, source: t1, surface: surface, onAuthorizeAction: onAuthorizeAction, onCompletedAction: onCompletedAction, onDismissAction: onDismissAction, trigger: trigger, placement: placement } = t0;
    const source = t1 === undefined ? "appFilterMenu" : t1;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t2 = app.outboundAuthUrl || "";
    let t3;
    if ($[0] !== onCompletedAction) {
        t3 = ()=>{
            setIsOpen(false);
            onCompletedAction?.();
        };
        $[0] = onCompletedAction;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setIsOpen(false);
        };
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== app.isNewlyEnabled || $[4] !== source || $[5] !== surface) {
        t5 = {
            source: source,
            isNewlyEnabled: app.isNewlyEnabled,
            surface: surface
        };
        $[3] = app.isNewlyEnabled;
        $[4] = source;
        $[5] = surface;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== app.friendlyName || $[8] !== app.source || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
        t6 = {
            friendlyName: app.friendlyName,
            appSource: app.source,
            outboundAuthUrl: t2,
            onCompletedAction: t3,
            onFailAction: t4,
            analyticsAttributes: t5
        };
        $[7] = app.friendlyName;
        $[8] = app.source;
        $[9] = t2;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)(t6);
    let t7;
    if ($[13] !== onDismissAction) {
        t7 = ()=>{
            setIsOpen(false);
            onDismissAction?.();
        };
        $[13] = onDismissAction;
        $[14] = t7;
    } else t7 = $[14];
    const onDismiss = t7;
    let t8;
    if ($[15] !== app.isUserOAuthed || $[16] !== onAuthorize || $[17] !== onAuthorizeAction) {
        t8 = ()=>{
            if (!app.isUserOAuthed) {
                if ((0, $cXtTj.default).getExperimentValue("rovo_chat_3p_connect_one_click", "isEnabled", false) === true) {
                    onAuthorizeAction?.();
                    onAuthorize();
                    return;
                }
                setIsOpen(true);
            }
        };
        $[15] = app.isUserOAuthed;
        $[16] = onAuthorize;
        $[17] = onAuthorizeAction;
        $[18] = t8;
    } else t8 = $[18];
    const handleTriggerClick = t8;
    let t9;
    if ($[19] !== onAuthorize || $[20] !== onAuthorizeAction) {
        t9 = ()=>{
            onAuthorizeAction?.();
            onAuthorize();
        };
        $[19] = onAuthorize;
        $[20] = onAuthorizeAction;
        $[21] = t9;
    } else t9 = $[21];
    const handleAuthorizeClick = t9;
    let t10;
    if ($[22] !== handleTriggerClick || $[23] !== trigger) {
        t10 = (triggerProps)=>trigger({
                ...triggerProps,
                onClick: handleTriggerClick
            });
        $[22] = handleTriggerClick;
        $[23] = trigger;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== app.friendlyName || $[26] !== formatMessage || $[27] !== handleAuthorizeClick || $[28] !== onDismiss) {
        t11 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $74d0a6c3c6ad2b23$var$styles.popupContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).authorizeConnectApp, {
                appName: app.friendlyName,
                strong: $74d0a6c3c6ad2b23$var$_temp,
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $74d0a6c3c6ad2b23$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: onDismiss
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).notNow))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: handleAuthorizeClick,
                appearance: "primary"
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).connect)))));
        $[25] = app.friendlyName;
        $[26] = formatMessage;
        $[27] = handleAuthorizeClick;
        $[28] = onDismiss;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== isOpen || $[31] !== onDismiss || $[32] !== placement || $[33] !== t10 || $[34] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onDismiss,
            placement: placement,
            zIndex: 600,
            trigger: t10,
            shouldFitContainer: false,
            content: t11
        });
        $[30] = isOpen;
        $[31] = onDismiss;
        $[32] = placement;
        $[33] = t10;
        $[34] = t11;
        $[35] = t12;
    } else t12 = $[35];
    return t12;
} : ({ app: app, source: source = 'appFilterMenu', surface: surface, onAuthorizeAction: onAuthorizeAction, onCompletedAction: onCompletedAction, onDismissAction: onDismissAction, trigger: trigger, placement: placement })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)({
        friendlyName: app.friendlyName,
        appSource: app.source,
        outboundAuthUrl: app.outboundAuthUrl || '',
        onCompletedAction: ()=>{
            setIsOpen(false);
            onCompletedAction?.();
        },
        onFailAction: ()=>{
            setIsOpen(false);
        },
        analyticsAttributes: {
            source: source,
            isNewlyEnabled: app.isNewlyEnabled,
            surface: surface
        }
    });
    const onDismiss = ()=>{
        setIsOpen(false);
        onDismissAction?.();
    };
    const handleTriggerClick = ()=>{
        if (!app.isUserOAuthed) {
            // When the one-click 3P connect experiment is enabled, skip the confirmation
            // popup and take the user straight to the OAuth auth flow.
            if ((0, $cXtTj.default).getExperimentValue('rovo_chat_3p_connect_one_click', 'isEnabled', false) === true) {
                onAuthorizeAction?.();
                onAuthorize();
                return;
            }
            setIsOpen(true);
        }
    };
    const handleAuthorizeClick = ()=>{
        onAuthorizeAction?.();
        onAuthorize();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: onDismiss,
        placement: placement,
        zIndex: 600,
        trigger: (triggerProps)=>trigger({
                ...triggerProps,
                onClick: handleTriggerClick
            }),
        shouldFitContainer: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $74d0a6c3c6ad2b23$var$styles.popupContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).authorizeConnectApp, {
                appName: app.friendlyName,
                strong: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        as: "strong"
                    }, text),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $74d0a6c3c6ad2b23$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: onDismiss
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).notNow))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $74d0a6c3c6ad2b23$var$styles.button
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: handleAuthorizeClick,
                appearance: "primary"
            }, formatMessage((0, $b92d72d1e60f1273$export$defe85febe8b728c).connect)))))
    });
};
const $74d0a6c3c6ad2b23$export$766eeb8940fb526 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($74d0a6c3c6ad2b23$var$OAuthPopupWrapperImpl, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($74d0a6c3c6ad2b23$var$OAuthPopupWrapperImpl, props);
function $74d0a6c3c6ad2b23$var$_temp(text) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, text);
}



var $j3dQ1 = parcelRequire("j3dQ1");

const $cb6cdf8aaf174b1d$var$MAX_UNCONNECTED_APPS_FOR_DISCOVERY = 10;
const $cb6cdf8aaf174b1d$var$styles = {
    appList: "_39xV02N91d _2Zuz6QdnbC _2XsHFMdnbC",
    appListItem: "_4c065U2ADO _2Y7lL42ADO _39xV02N91d _0wOv4Q7zJH _0KLXru66of _1eOmH6o126",
    appListItemHoverFromParent: "_1eOmH666of",
    appSelector: "_1mT5xdRAKS _4ouGXIBfNa _39xV02N91d _0jFU0V9zBZ _2Zuz6Q2ADO _1Znuxb2ADO _3iDTPbQ4SZ _0aFT5vbt8w",
    appSelectorModal: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _4ouGXIBfNa _39xV02N91d _0jFU0VN91d _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5vbt8w",
    scrollableContent: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2WAcuGIZbP _4bt5LAnQyn _3oUqlsUzH9 _4kiQYAdnbC",
    rovoLogoWrapper: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _30huDKOeNX _0jFU0VoWWg _39xV02oWWg _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuDIqT",
    placeholderLogo: "_0bjKvDKxmn _0jFU0VoWWg _39xV02oWWg _0KLXru28sy",
    skeletonItem: "_2Y7lL4Pgdg _4kiQYAUofl",
    appItemInline: "_3iDTPbQ4SZ",
    connectButtonText: "_1UtDYz866Z _0wOv4Q7zJH _253ZDm98eZ _2r76lK0Rl6 _4umoPx6wH8 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    appItemContentNew: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
    sectionHeader: "_4c065UgVvo _2Y7lL42ADO",
    searchInputWrapper: "_3YEZNOdnbC",
    modalSectionHeader: "_4c065UgVvo _2Y7lL42ADO",
    modalSectionHeaderWithSearch: "_2mHwu85zaO _4c065UgVvo _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0LQT5EdnbC",
    modalSectionList: "_30huDKOeNX _0bjKvDKxmn _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC",
    popupSectionList: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC",
    modalSectionListItem: "_43nrzTdnbC _0Of8r2gVvo _1ZnuxbgVvo _1wydGWgVvo _2Zuz6QgVvo",
    modalSectionListItemRowHover: "_0wOv4Q7zJH _1eOmH6o126",
    modalSectionListItemDivider: "_2R4pr3OeNX",
    sourceRow: "_4c065U2ADO _2Y7lL42ADO _39xV02N91d _0KLXrujOvk",
    sourceModeDescription: "_1v3aPqOeNX _0LQT5E2ADO _03SyCP2ADO _46hvQm2ADO",
    separator: "_2R4pr3OeNX _0xmtko2ADO _0rIjyk2ADO",
    iconWrapper: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    sourceModeIconGlyph: "_3iDTPbQ4SZ _1VJPcaPrS9",
    viewMoreFooter: "_1v3aPqOeNX _3YEZNOdnbC _43nrzT2ADO _46hvQm2ADO",
    connectMoreAppsButton: "_0bjKvDKxmn"
};
const $cb6cdf8aaf174b1d$var$AppListItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(60);
    const { app: app, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, suppressItemHover: suppressItemHover, renderAsListItem: t1 } = t0;
    const renderAsListItem = t1 === undefined ? true : t1;
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== app || $[1] !== onAppSelectionChange || $[2] !== sendAnalyticsEvent) {
        t2 = ()=>{
            const newCheckedState = !app.isSelected;
            if (app.isUserOAuthed) onAppSelectionChange(app, newCheckedState);
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "row",
                actionSubjectId: "rovoChatFilterByAppsClick",
                attributes: {
                    isConnected: app.isUserOAuthed,
                    interactionElement: "row",
                    isSelected: newCheckedState,
                    appSource: app.source,
                    appFriendlyName: app.friendlyName,
                    is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
                }
            });
        };
        $[0] = app;
        $[1] = onAppSelectionChange;
        $[2] = sendAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    const handleRowClick = t2;
    let t3;
    if ($[4] !== app || $[5] !== onAppSelectionChange || $[6] !== sendAnalyticsEvent) {
        t3 = (e)=>{
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            onAppSelectionChange(app, e.target.checked);
            sendAnalyticsEvent({
                action: "clicked",
                actionSubject: "row",
                actionSubjectId: "rovoChatFilterByAppsClick",
                attributes: {
                    isConnected: app.isUserOAuthed,
                    interactionElement: "toggle",
                    isSelected: e.target.checked,
                    appSource: app.source,
                    appFriendlyName: app.friendlyName,
                    is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
                }
            });
        };
        $[4] = app;
        $[5] = onAppSelectionChange;
        $[6] = sendAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const handleToggleChange = t3;
    const t4 = suppressItemHover ? $cb6cdf8aaf174b1d$var$styles.appListItemHoverFromParent : undefined;
    let t5;
    if ($[8] !== t4) {
        t5 = (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.appListItem, t4);
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== app.friendlyName || $[11] !== app.isSelected || $[12] !== app.isUserOAuthed || $[13] !== formatMessage) {
        t6 = !app.isUserOAuthed ? formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).connectApp, {
            appName: app.friendlyName
        }) : app.isSelected ? formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).deselectApp, {
            appName: app.friendlyName
        }) : formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).selectApp, {
            appName: app.friendlyName
        });
        $[10] = app.friendlyName;
        $[11] = app.isSelected;
        $[12] = app.isUserOAuthed;
        $[13] = formatMessage;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== app.iconUrl || $[16] !== app.source) {
        t7 = (0, $iDrrr.fg)("rovo_chat_use_be_knowledge_icons") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            id: app.source,
            width: 24,
            height: 24,
            src: (0, $iDrrr.fg)("use_new_knowledge_source_icon_url_prefix") ? app.iconUrl : `/gateway/api${app.iconUrl}`,
            alt: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cb6cdf8aaf174b1d$var$styles.rovoLogoWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
            appSource: app.source,
            rovoLogoProps: {
                size: "small",
                label: ""
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $cb6cdf8aaf174b1d$var$styles.placeholderLogo
            })
        }));
        $[15] = app.iconUrl;
        $[16] = app.source;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== app.friendlyName) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium",
            maxLines: 1
        }, app.friendlyName);
        $[18] = app.friendlyName;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== app.isNewlyEnabled || $[21] !== formatMessage) {
        t9 = app.isNewlyEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery",
            isBold: true
        }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).newBadge));
        $[20] = app.isNewlyEnabled;
        $[21] = formatMessage;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== t8 || $[24] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t8, t9);
        $[23] = t8;
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== app.isSelected || $[27] !== app.isUserOAuthed || $[28] !== app.source || $[29] !== formatMessage || $[30] !== handleToggleChange) {
        t11 = app.isUserOAuthed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
            id: app.source,
            isChecked: app.isSelected,
            onChange: handleToggleChange,
            size: "regular"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cb6cdf8aaf174b1d$var$styles.connectButtonText,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium",
            color: "color.link"
        }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).connect)));
        $[26] = app.isSelected;
        $[27] = app.isUserOAuthed;
        $[28] = app.source;
        $[29] = formatMessage;
        $[30] = handleToggleChange;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== t10 || $[33] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            grow: "fill",
            spread: "space-between",
            alignBlock: "center"
        }, t10, t11));
        $[32] = t10;
        $[33] = t11;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== app.source || $[36] !== t12 || $[37] !== t7) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            key: app.source,
            xcss: $cb6cdf8aaf174b1d$var$styles.appItemInline
        }, t7, t12);
        $[35] = app.source;
        $[36] = t12;
        $[37] = t7;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== handleRowClick || $[40] !== t13 || $[41] !== t5 || $[42] !== t6) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            onClick: handleRowClick,
            xcss: t5,
            "aria-label": t6
        }, t13);
        $[39] = handleRowClick;
        $[40] = t13;
        $[41] = t5;
        $[42] = t6;
        $[43] = t14;
    } else t14 = $[43];
    const appItemContent = t14;
    let t15;
    if ($[44] !== app.source || $[45] !== onAppConnectClick) {
        t15 = ()=>onAppConnectClick?.(app.source);
        $[44] = app.source;
        $[45] = onAppConnectClick;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== app || $[48] !== onAppSelectionChange) {
        t16 = ()=>{
            onAppSelectionChange(app, true, true);
        };
        $[47] = app;
        $[48] = onAppSelectionChange;
        $[49] = t16;
    } else t16 = $[49];
    let t17;
    if ($[50] !== appItemContent || $[51] !== renderAsListItem) {
        t17 = (triggerProps)=>renderAsListItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "li",
                ...triggerProps
            }, appItemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", triggerProps, appItemContent);
        $[50] = appItemContent;
        $[51] = renderAsListItem;
        $[52] = t17;
    } else t17 = $[52];
    let t18;
    if ($[53] !== app || $[54] !== oauthSource || $[55] !== oauthSurface || $[56] !== t15 || $[57] !== t16 || $[58] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74d0a6c3c6ad2b23$export$766eeb8940fb526), {
            app: app,
            source: oauthSource,
            surface: oauthSurface,
            onAuthorizeAction: t15,
            onCompletedAction: t16,
            placement: "left",
            trigger: t17
        });
        $[53] = app;
        $[54] = oauthSource;
        $[55] = oauthSurface;
        $[56] = t15;
        $[57] = t16;
        $[58] = t17;
        $[59] = t18;
    } else t18 = $[59];
    return t18;
} : ({ app: app, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, suppressItemHover: suppressItemHover, renderAsListItem: renderAsListItem = true })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleRowClick = ()=>{
        const newCheckedState = !app.isSelected;
        if (app.isUserOAuthed) onAppSelectionChange(app, newCheckedState);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'row',
            actionSubjectId: 'rovoChatFilterByAppsClick',
            attributes: {
                isConnected: app.isUserOAuthed,
                interactionElement: 'row',
                isSelected: newCheckedState,
                appSource: app.source,
                appFriendlyName: app.friendlyName,
                is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
            }
        });
    };
    const handleToggleChange = (e)=>{
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        onAppSelectionChange(app, e.target.checked);
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'row',
            actionSubjectId: 'rovoChatFilterByAppsClick',
            attributes: {
                isConnected: app.isUserOAuthed,
                interactionElement: 'toggle',
                isSelected: e.target.checked,
                appSource: app.source,
                appFriendlyName: app.friendlyName,
                is3pApp: (0, $6xccU.is3pApp)(app.friendlyName)
            }
        });
    };
    const appItemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: handleRowClick,
        xcss: (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.appListItem, suppressItemHover ? $cb6cdf8aaf174b1d$var$styles.appListItemHoverFromParent : undefined),
        "aria-label": !app.isUserOAuthed ? formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).connectApp, {
            appName: app.friendlyName
        }) : app.isSelected ? formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).deselectApp, {
            appName: app.friendlyName
        }) : formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).selectApp, {
            appName: app.friendlyName
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        key: app.source,
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemInline
    }, (0, $iDrrr.fg)('rovo_chat_use_be_knowledge_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        id: app.source,
        width: 24,
        height: 24,
        src: (0, $iDrrr.fg)('use_new_knowledge_source_icon_url_prefix') ? app.iconUrl : `/gateway/api${app.iconUrl}`,
        alt: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.rovoLogoWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
        appSource: app.source,
        rovoLogoProps: {
            size: 'small',
            label: ''
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $cb6cdf8aaf174b1d$var$styles.placeholderLogo
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, app.friendlyName), app.isNewlyEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery",
        isBold: true
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).newBadge))), app.isUserOAuthed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        id: app.source,
        isChecked: app.isSelected,
        onChange: handleToggleChange,
        size: "regular"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.connectButtonText,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        color: "color.link"
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).connect)))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74d0a6c3c6ad2b23$export$766eeb8940fb526), {
        app: app,
        source: oauthSource,
        surface: oauthSurface,
        onAuthorizeAction: ()=>onAppConnectClick?.(app.source),
        onCompletedAction: ()=>{
            onAppSelectionChange(app, true, true);
        },
        placement: "left",
        trigger: (triggerProps)=>renderAsListItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "li",
                ...triggerProps
            }, appItemContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", triggerProps, appItemContent)
    });
};
const $cb6cdf8aaf174b1d$var$AppsList = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { apps: apps, isLoading: isLoading, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, showItemDividers: t1 } = t0;
    const showItemDividers = t1 === undefined ? false : t1;
    if (isLoading) {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                as: "ul",
                space: "space.100",
                xcss: $cb6cdf8aaf174b1d$var$styles.appList
            }, [
                ...Array(7)
            ].map($cb6cdf8aaf174b1d$var$_temp));
            $[0] = t2;
        } else t2 = $[0];
        return t2;
    }
    let t2;
    if ($[1] !== apps || $[2] !== oauthSource || $[3] !== oauthSurface || $[4] !== onAppConnectClick || $[5] !== onAppSelectionChange || $[6] !== showItemDividers) {
        let t3;
        if ($[8] !== apps.length || $[9] !== oauthSource || $[10] !== oauthSurface || $[11] !== onAppConnectClick || $[12] !== onAppSelectionChange || $[13] !== showItemDividers) {
            t3 = (app, index_0)=>{
                const isLast = index_0 === apps.length - 1;
                const item = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppListItem, {
                    key: app.source,
                    app: app,
                    oauthSource: oauthSource,
                    oauthSurface: oauthSurface,
                    onAppConnectClick: onAppConnectClick,
                    onAppSelectionChange: onAppSelectionChange,
                    suppressItemHover: showItemDividers,
                    renderAsListItem: !showItemDividers
                });
                if (showItemDividers) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    key: app.source,
                    as: "li",
                    xcss: (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.modalSectionListItem, !isLast && $cb6cdf8aaf174b1d$var$styles.modalSectionListItemDivider, $cb6cdf8aaf174b1d$var$styles.modalSectionListItemRowHover)
                }, item);
                return item;
            };
            $[8] = apps.length;
            $[9] = oauthSource;
            $[10] = oauthSurface;
            $[11] = onAppConnectClick;
            $[12] = onAppSelectionChange;
            $[13] = showItemDividers;
            $[14] = t3;
        } else t3 = $[14];
        t2 = apps.map(t3);
        $[1] = apps;
        $[2] = oauthSource;
        $[3] = oauthSurface;
        $[4] = onAppConnectClick;
        $[5] = onAppSelectionChange;
        $[6] = showItemDividers;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[15] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            as: "ul",
            space: "space.0",
            xcss: $cb6cdf8aaf174b1d$var$styles.appList
        }, t2);
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ apps: apps, isLoading: isLoading, onAppSelectionChange: onAppSelectionChange, onAppConnectClick: onAppConnectClick, oauthSource: oauthSource, oauthSurface: oauthSurface, showItemDividers: showItemDividers = false })=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        as: "ul",
        space: "space.100",
        xcss: $cb6cdf8aaf174b1d$var$styles.appList
    }, [
        ...Array(7)
    ].map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: index,
            as: "li",
            xcss: $cb6cdf8aaf174b1d$var$styles.skeletonItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hLP6B.default), {
            hasIcon: true
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        as: "ul",
        space: "space.0",
        xcss: $cb6cdf8aaf174b1d$var$styles.appList
    }, apps.map((app, index_0)=>{
        const isLast = index_0 === apps.length - 1;
        const item = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppListItem, {
            key: app.source,
            app: app,
            oauthSource: oauthSource,
            oauthSurface: oauthSurface,
            onAppConnectClick: onAppConnectClick,
            onAppSelectionChange: onAppSelectionChange,
            suppressItemHover: showItemDividers,
            renderAsListItem: !showItemDividers
        });
        if (showItemDividers) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: app.source,
            as: "li",
            xcss: (0, $w6R6I.cx)($cb6cdf8aaf174b1d$var$styles.modalSectionListItem, !isLast && $cb6cdf8aaf174b1d$var$styles.modalSectionListItemDivider, $cb6cdf8aaf174b1d$var$styles.modalSectionListItemRowHover)
        }, item);
        return item;
    }));
};
const $cb6cdf8aaf174b1d$export$5b094453ea724a = ({ assistanceServiceParams: assistanceServiceParams, preservedSelectedApps: preservedSelectedApps, onChange: onChange, hideViewMoreButton: hideViewMoreButton = false, showGroupedSectionsWithCounts: showGroupedSectionsWithCounts = false, webSearchEnabled: webSearchEnabled, onWebSearchToggle: onWebSearchToggle, orgKnowledgeEnabled: orgKnowledgeEnabled, onOrgKnowledgeToggle: onOrgKnowledgeToggle, sourceMode: sourceMode, onSourceModeChange: onSourceModeChange, showSourceModeToggle: showSourceModeToggle = false, oauthSource: oauthSource = 'appFilterMenu', oauthSurface: oauthSurface, onAppConnectClick: onAppConnectClick, initialScrollToAvailableApps: initialScrollToAvailableApps = false, enableAppsDiscoveryUi: enableAppsDiscoveryUi })=>{
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const sourceModeToggleId = (0, $cozmU.useId)();
    const sourceModeDescriptionId = (0, $cozmU.useId)();
    const webSearchToggleId = (0, $cozmU.useId)();
    const orgKnowledgeToggleId = (0, $cozmU.useId)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [appSelectorState, setAppSelectorState] = (0, $cozmU.useState)({
        type: 'loading'
    });
    const [allSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [storeFetching] = (0, $7pCWA.useConnectorsIsFetching)();
    const newlyEnabledConnectors = (0, $7pCWA.useNewlyEnabledConnectors)();
    const [connectors] = (0, $7pCWA.useConnectors)();
    const appsAvailableToConnectSectionRef = (0, $cozmU.useRef)(null);
    const hasInitializedRef = (0, $cozmU.useRef)(false);
    const newlyEnabledConnectorSet = (0, $cozmU.useMemo)(()=>new Set(newlyEnabledConnectors.map((c)=>c.source)), [
        newlyEnabledConnectors
    ]);
    const { open: openSideNavModal, disabled: sideNavModalDisabled } = (0, $a9u73.useSideNavModal)(); // Apps discovery UI relies on the side nav modal as the "Discover more apps"
    // destination. When the modal is disabled, keep the in-menu list uncapped.
    const shouldApplyAppsDiscoveryUi = !!enableAppsDiscoveryUi && !sideNavModalDisabled;
    const productSortOrderProvider = (0, $8hYSP.useProductSortOrder)();
    const scrollToAppsAvailableToConnect = (0, $cozmU.useCallback)(()=>{
        appsAvailableToConnectSectionRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, []);
    const handleConnectMoreClick = (0, $cozmU.useCallback)(()=>{
        /** Already inside Rovo settings modal — opening again is a no-op; scroll in place */ if (oauthSource === 'rovoSettingsModal') {
            scrollToAppsAvailableToConnect();
            return;
        }
        if (shouldApplyAppsDiscoveryUi) openSideNavModal({
            title: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).viewMoreModalTitle),
            searchPlaceholder: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).searchSettingsPlaceholder),
            navAriaLabel: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).viewMoreModalTitle),
            defaultSelectedId: 'discovery',
            scrollToAvailableApps: true
        });
        else scrollToAppsAvailableToConnect();
    }, [
        oauthSource,
        openSideNavModal,
        formatMessage,
        scrollToAppsAvailableToConnect,
        shouldApplyAppsDiscoveryUi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (storeFetching) return;
        if (allSources.length === 0 && appSelectorState.type === 'loading') return;
        if (hasInitializedRef.current) {
            setAppSelectorState((currentState)=>{
                if (currentState.type !== 'available') return currentState;
                const updatedApps = allSources.map((source)=>({
                        friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source.source, source.friendlyName),
                        source: source.source,
                        iconUrl: source.iconUrl,
                        isSelected: (0, $d654b99b72f44b8f$export$6cee836ceb3fcfa0)(source, preservedSelectedApps, orgKnowledgeEnabled),
                        outboundAuthUrl: source.outboundAuthUrl,
                        isUserOAuthed: source.isUserOAuthed,
                        isNewlyEnabled: newlyEnabledConnectorSet.has(source.source)
                    }));
                return {
                    ...currentState,
                    apps: updatedApps
                };
            });
            return;
        }
        const loadApps = async ()=>{
            if (hasInitializedRef.current) return;
            const sortProduct = await productSortOrderProvider();
            const shouldSelectAll = preservedSelectedApps.length === 0 && orgKnowledgeEnabled !== false;
            const apps = allSources.map((source)=>({
                    friendlyName: (0, $j3dQ1.getKnowledgeSourceDisplayName)(source.source, source.friendlyName),
                    source: source.source,
                    iconUrl: source.iconUrl,
                    isSelected: (0, $d654b99b72f44b8f$export$6cee836ceb3fcfa0)(source, preservedSelectedApps, orgKnowledgeEnabled),
                    outboundAuthUrl: source.outboundAuthUrl,
                    isUserOAuthed: source.isUserOAuthed,
                    isNewlyEnabled: newlyEnabledConnectorSet.has(source.source)
                })).sort((a, b)=>sortProduct(a.source, b.source));
            setAppSelectorState({
                type: 'available',
                apps: apps,
                searchTerm: undefined
            });
            if (shouldSelectAll) {
                const selectedApps = apps.filter((app)=>app.isSelected);
                onChange(selectedApps);
            }
            hasInitializedRef.current = true;
        };
        loadApps(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productSortOrderProvider,
        allSources,
        storeFetching,
        preservedSelectedApps,
        appSelectorState.type,
        onChange,
        newlyEnabledConnectorSet,
        orgKnowledgeEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!hasInitializedRef.current) return;
        setAppSelectorState((currentState)=>{
            if (currentState.type === 'loading' || currentState.type === 'errored') return currentState;
            return {
                ...currentState,
                apps: currentState.apps.map((app)=>({
                        ...app,
                        isSelected: (0, $d654b99b72f44b8f$export$6cee836ceb3fcfa0)(app, preservedSelectedApps, orgKnowledgeEnabled)
                    }))
            };
        });
    }, [
        preservedSelectedApps,
        setAppSelectorState,
        orgKnowledgeEnabled
    ]);
    const onAppSelectionChange = (0, $cozmU.useCallback)((app, checked, successfulOauth)=>{
        let filteredApps = preservedSelectedApps.filter((a)=>a.source !== app.source);
        let updatedApp = {
            ...app
        };
        if (successfulOauth && appSelectorState.type === 'available') {
            updatedApp = {
                ...app,
                isUserOAuthed: true
            };
            setAppSelectorState((currentState)=>{
                if (currentState.type === 'loading' || currentState.type === 'errored') return currentState;
                return {
                    ...currentState,
                    apps: currentState.apps.map((existingApp)=>existingApp.source === app.source ? {
                            ...existingApp,
                            isUserOAuthed: true,
                            isSelected: true
                        } : existingApp)
                };
            });
        }
        if (checked) filteredApps = [
            ...filteredApps,
            updatedApp
        ];
        onChange(filteredApps);
    }, [
        preservedSelectedApps,
        onChange,
        setAppSelectorState,
        appSelectorState.type
    ]);
    const handleSearchChange = (0, $cozmU.useCallback)((searchText)=>{
        setAppSelectorState((currentState)=>{
            if (currentState.type === 'loading' || currentState.type === 'errored') return currentState;
            return {
                ...currentState,
                searchTerm: searchText
            };
        });
        sendAnalyticsEvent({
            action: 'searched',
            actionSubject: 'input',
            actionSubjectId: 'rovoChatFilterByAppsSearchInput',
            attributes: {
                searchValueLength: searchText.length
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const sortedAndFilteredApps = (0, $cozmU.useMemo)(()=>{
        if (appSelectorState.type !== 'available') return [];
        return [
            ...appSelectorState.apps
        ].sort((a, b)=>{
            const aConnected = a.isUserOAuthed ? 1 : 0;
            const bConnected = b.isUserOAuthed ? 1 : 0;
            if (aConnected !== bConnected) return bConnected - aConnected;
            const aTimestamp = connectors[a.source]?.connectedAt ? new Date(connectors[a.source].connectedAt).getTime() : 0;
            const bTimestamp = connectors[b.source]?.connectedAt ? new Date(connectors[b.source].connectedAt).getTime() : 0;
            return bTimestamp - aTimestamp;
        });
    }, [
        appSelectorState,
        connectors
    ]);
    const searchTerm = appSelectorState.type === 'available' ? appSelectorState.searchTerm : undefined;
    const { connectedApps: connectedApps, availableToConnectApps: availableToConnectApps } = (0, $cozmU.useMemo)(()=>{
        if (appSelectorState.type !== 'available') return {
            connectedApps: [],
            availableToConnectApps: []
        };
        let apps = sortedAndFilteredApps;
        if (showGroupedSectionsWithCounts && searchTerm) apps = apps.filter((app)=>app.friendlyName.toLowerCase().includes(searchTerm.toLowerCase()));
        const connected = apps.filter((app)=>app.isUserOAuthed);
        const available = apps.filter((app)=>!app.isUserOAuthed);
        return {
            connectedApps: connected,
            availableToConnectApps: available
        };
    }, [
        appSelectorState.type,
        searchTerm,
        sortedAndFilteredApps,
        showGroupedSectionsWithCounts
    ]);
    const totalAppsInSections = showGroupedSectionsWithCounts && appSelectorState.type === 'available' ? connectedApps.length + availableToConnectApps.length : 0;
    const isStrictSourceModeEnabled = showSourceModeToggle && sourceMode === 'STRICT';
    const { connectedAppsForDisplay: connectedAppsForDisplay, availableToConnectAppsForDisplay: availableToConnectAppsForDisplay } = (0, $cozmU.useMemo)(()=>{
        if (shouldApplyAppsDiscoveryUi) // Apps discovery limit: show all connected apps, cap unconnected apps only
        return {
            connectedAppsForDisplay: connectedApps,
            availableToConnectAppsForDisplay: availableToConnectApps.slice(0, $cb6cdf8aaf174b1d$var$MAX_UNCONNECTED_APPS_FOR_DISCOVERY)
        };
        return {
            connectedAppsForDisplay: connectedApps,
            availableToConnectAppsForDisplay: availableToConnectApps
        };
    }, [
        connectedApps,
        availableToConnectApps,
        shouldApplyAppsDiscoveryUi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!initialScrollToAvailableApps) return;
        if (appSelectorState.type !== 'available' || availableToConnectApps.length === 0) return;
        const frame = requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                appsAvailableToConnectSectionRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
        return ()=>cancelAnimationFrame(frame);
    }, [
        initialScrollToAvailableApps,
        appSelectorState.type,
        availableToConnectApps.length
    ]);
    const renderContent = ()=>{
        switch(appSelectorState.type){
            case 'errored':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
            case 'loading':
            case 'available':
                if (showGroupedSectionsWithCounts && !showSourceModeToggle && appSelectorState.type === 'available') {
                    const isModalGroupedLayout = oauthSource === 'rovoSettingsModal';
                    const connectedAppsSummaryRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                        space: "space.100",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        size: "small",
                        weight: isModalGroupedLayout ? 'bold' : 'semibold',
                        color: isModalGroupedLayout ? 'color.text' : 'color.text.subtlest'
                    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).connectedAppsOutOfTotal, {
                        connectedCount: connectedApps.length,
                        totalCount: totalAppsInSections
                    })), availableToConnectApps.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                        role: "button",
                        onClick: handleConnectMoreClick,
                        xcss: $cb6cdf8aaf174b1d$var$styles.connectMoreAppsButton
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        size: "small",
                        weight: "medium",
                        color: "color.link"
                    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).connectMoreApps))));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                        space: "space.200"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, isModalGroupedLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: $cb6cdf8aaf174b1d$var$styles.modalSectionHeaderWithSearch
                    }, connectedAppsSummaryRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: $cb6cdf8aaf174b1d$var$styles.searchInputWrapper
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gitiq.SearchInput), {
                        placeholderText: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).searchAppsPlaceholder),
                        onSearch: handleSearchChange,
                        isDisabled: false,
                        debounceTime: 200,
                        isCompact: true
                    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: $cb6cdf8aaf174b1d$var$styles.sectionHeader
                    }, connectedAppsSummaryRow), connectedAppsForDisplay.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: isModalGroupedLayout ? $cb6cdf8aaf174b1d$var$styles.modalSectionList : $cb6cdf8aaf174b1d$var$styles.popupSectionList
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppsList, {
                        apps: connectedAppsForDisplay,
                        onAppSelectionChange: onAppSelectionChange,
                        isLoading: false,
                        oauthSource: oauthSource,
                        oauthSurface: oauthSurface,
                        onAppConnectClick: onAppConnectClick,
                        showItemDividers: oauthSource === 'rovoSettingsModal'
                    }))), availableToConnectAppsForDisplay.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        ref: appsAvailableToConnectSectionRef
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: isModalGroupedLayout ? $cb6cdf8aaf174b1d$var$styles.modalSectionHeader : $cb6cdf8aaf174b1d$var$styles.sectionHeader
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        size: "small",
                        weight: isModalGroupedLayout ? 'bold' : 'semibold',
                        color: isModalGroupedLayout ? 'color.text' : 'color.text.subtlest'
                    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).appsAvailableToConnectSectionHeader, {
                        count: availableToConnectApps.length
                    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        xcss: isModalGroupedLayout ? $cb6cdf8aaf174b1d$var$styles.modalSectionList : $cb6cdf8aaf174b1d$var$styles.popupSectionList
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppsList, {
                        apps: availableToConnectAppsForDisplay,
                        onAppSelectionChange: onAppSelectionChange,
                        isLoading: false,
                        oauthSource: oauthSource,
                        oauthSurface: oauthSurface,
                        onAppConnectClick: onAppConnectClick,
                        showItemDividers: oauthSource === 'rovoSettingsModal'
                    }))));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb6cdf8aaf174b1d$var$AppsList, {
                    apps: sortedAndFilteredApps,
                    onAppSelectionChange: onAppSelectionChange,
                    isLoading: appSelectorState.type === 'loading',
                    oauthSource: oauthSource,
                    oauthSurface: oauthSurface,
                    onAppConnectClick: onAppConnectClick
                });
        }
    };
    const showSourcesSection = showSourceModeToggle || onWebSearchToggle !== undefined || onOrgKnowledgeToggle !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: showGroupedSectionsWithCounts && oauthSource === 'rovoSettingsModal' ? $cb6cdf8aaf174b1d$var$styles.appSelectorModal : $cb6cdf8aaf174b1d$var$styles.appSelector
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.scrollableContent
    }, showSourcesSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.separator
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.sectionHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).sourcesHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, showSourceModeToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.sourceRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.sourceModeIconGlyph
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
        label: "",
        size: "medium"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).strictSourceMode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery"
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).newBadge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).strictSourceModeTooltip),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        id: sourceModeToggleId,
        label: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).strictSourceMode),
        descriptionId: isStrictSourceModeEnabled ? sourceModeDescriptionId : undefined,
        isChecked: isStrictSourceModeEnabled,
        onChange: (e)=>{
            onSourceModeChange?.(e.target.checked ? 'STRICT' : 'GENERAL');
        },
        size: "regular"
    }))))), isStrictSourceModeEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        id: sourceModeDescriptionId,
        xcss: $cb6cdf8aaf174b1d$var$styles.sourceModeDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
        label: "",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).strictSourceModeDescription))))), onWebSearchToggle !== undefined && !isStrictSourceModeEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "label",
        htmlFor: webSearchToggleId,
        xcss: $cb6cdf8aaf174b1d$var$styles.sourceRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
        label: "",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).includeWebResults)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        id: webSearchToggleId,
        label: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).includeWebResults),
        isChecked: !!webSearchEnabled,
        onChange: (e)=>{
            onWebSearchToggle(e.target.checked);
        },
        size: "regular"
    }))))), onOrgKnowledgeToggle !== undefined && !isStrictSourceModeEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "label",
        htmlFor: orgKnowledgeToggleId,
        xcss: $cb6cdf8aaf174b1d$var$styles.sourceRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kpuvJ))), {
        label: "",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.appItemContentNew
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        grow: "fill",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).searchCompanyKnowledge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
        id: orgKnowledgeToggleId,
        label: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).searchCompanyKnowledge),
        isChecked: !!orgKnowledgeEnabled,
        onChange: (e)=>{
            onOrgKnowledgeToggle(e.target.checked);
        },
        size: "regular"
    }))))))), (!showGroupedSectionsWithCounts || showSourceModeToggle) && !isStrictSourceModeEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.sectionHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, formatMessage(showSourceModeToggle ? (0, $c3f48f68df089ed0$export$defe85febe8b728c).spaceAppsHeader : (0, $c3f48f68df089ed0$export$defe85febe8b728c).appsHeader))), !isStrictSourceModeEnabled && renderContent()), !isStrictSourceModeEnabled && !hideViewMoreButton && shouldApplyAppsDiscoveryUi && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.viewMoreFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $cb6cdf8aaf174b1d$var$styles.sourceRow,
        onClick: ()=>{
            openSideNavModal({
                title: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).viewMoreModalTitle),
                searchPlaceholder: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).searchSettingsPlaceholder),
                navAriaLabel: formatMessage((0, $c3f48f68df089ed0$export$defe85febe8b728c).viewMoreModalTitle),
                defaultSelectedId: 'discovery'
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb6cdf8aaf174b1d$var$styles.iconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage(showSourceModeToggle ? (0, $c3f48f68df089ed0$export$defe85febe8b728c).viewMore : (0, $c3f48f68df089ed0$export$defe85febe8b728c).discoverMoreApps))))));
};
function $cb6cdf8aaf174b1d$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: index,
        as: "li",
        xcss: $cb6cdf8aaf174b1d$var$styles.skeletonItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hLP6B.default), {
        hasIcon: true
    }));
}


















var $3eYzF = parcelRequire("3eYzF");


var $uyMbP = parcelRequire("uyMbP");


var $gi4qj = parcelRequire("gi4qj");


var $4AC39 = parcelRequire("4AC39");


var $l3ydK = parcelRequire("l3ydK");


var $2Vz7H = parcelRequire("2Vz7H");


var $6VFk2 = parcelRequire("6VFk2");


var $4enp7 = parcelRequire("4enp7");


var $dOlTT = parcelRequire("dOlTT");


var $9Zall = parcelRequire("9Zall");


var $8jXZv = parcelRequire("8jXZv");


var $2K2hA = parcelRequire("2K2hA");




const $18413269ea167174$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    removeAppFilters: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.remove-app-filters",
        defaultMessage: "Remove all app filters"
    },
    filteredAppsTooltip: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.tooltip",
        defaultMessage: "Filtered sources mode"
    },
    ghostIconsConnectAppsTooltip: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.ghost-icons-connect-apps-tooltip",
        defaultMessage: "Connect apps so Rovo can reference the work you do"
    },
    filteredAppsLabel: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.label",
        defaultMessage: "Sources:"
    },
    ghostIconsLabel: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.ghost-icons-label",
        defaultMessage: "Suggested apps to connect"
    },
    newBadge: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.chat-mode-menu.filtered-apps.newBadge",
        defaultMessage: "New"
    },
    agentDisabledTooltip: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.agent-disabled-tooltip",
        defaultMessage: "Filtered sources are only available when chatting with Rovo."
    },
    agentSourceControlSpotlightTitle: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.agent-source-control-spotlight-title",
        defaultMessage: "Source control isn\u2019t available"
    },
    agentSourceControlSpotlightBody: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.agent-source-control-spotlight-body",
        defaultMessage: "The agent does not support source control features, such as web access or content source switching."
    },
    agentSourceControlSpotlightUnderstood: {
        id: "rovo.conversation-assistant.chat-prompt-input.filtered-apps.agent-source-control-spotlight-understood",
        defaultMessage: "Understood"
    }
});


const $63676e71fabd2bc0$var$styles = {
    spotlightTarget: "_1mT5xdWVPG _39xV02HZdu _0jFU0VHZdu _3iC0zdVa5s _1ZB6UydnbC _1pp6NdYbGa"
};
const $63676e71fabd2bc0$var$OFFSET = [
    -75,
    0
];
const $63676e71fabd2bc0$export$ff815d78bbb5387b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { isVisible: isVisible, onDismiss: onDismiss, postOfficeMessage: postOfficeMessage } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!isVisible || !postOfficeMessage) return null;
    const { PostOfficeMessageInstance: PostOfficeMessageInstance, messageInstanceId: messageInstanceId } = postOfficeMessage;
    let t1;
    if ($[0] !== onDismiss) {
        t1 = ()=>onDismiss("cross-icon");
        $[0] = onDismiss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentSourceControlSpotlightTitle);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== onDismiss) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
            onClick: ()=>onDismiss("cross-icon")
        }));
        $[6] = onDismiss;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, t3, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== formatMessage) {
        t6 = formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentSourceControlSpotlightBody);
        $[11] = formatMessage;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, t6);
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== onDismiss) {
        t8 = ()=>onDismiss("understood-button");
        $[15] = onDismiss;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== formatMessage) {
        t9 = formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentSourceControlSpotlightUnderstood);
        $[17] = formatMessage;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== t8 || $[20] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
            onClick: t8
        }, t9)));
        $[19] = t8;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t5 || $[24] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: "agent-source-control-spotlight"
        }, t5, t7, t10);
        $[22] = t10;
        $[23] = t5;
        $[24] = t7;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== isVisible || $[27] !== t1 || $[28] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
            dismiss: t1,
            isVisible: isVisible,
            placement: "bottom-end",
            offset: $63676e71fabd2bc0$var$OFFSET
        }, t11);
        $[26] = isVisible;
        $[27] = t1;
        $[28] = t11;
        $[29] = t12;
    } else t12 = $[29];
    const popoverContent = t12;
    let t13;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $63676e71fabd2bc0$var$styles.spotlightTarget
        }));
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== popoverContent) {
        t14 = ()=>popoverContent;
        $[31] = popoverContent;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== PostOfficeMessageInstance || $[34] !== messageInstanceId || $[35] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficeMessageInstance, {
            messageInstanceId: messageInstanceId
        }, t14));
        $[33] = PostOfficeMessageInstance;
        $[34] = messageInstanceId;
        $[35] = t14;
        $[36] = t15;
    } else t15 = $[36];
    return t15;
} : ({ isVisible: isVisible, onDismiss: onDismiss, postOfficeMessage: postOfficeMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!isVisible || !postOfficeMessage) return null;
    const { PostOfficeMessageInstance: PostOfficeMessageInstance, messageInstanceId: messageInstanceId } = postOfficeMessage;
    const popoverContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: ()=>onDismiss('cross-icon'),
        isVisible: isVisible,
        placement: "bottom-end",
        offset: $63676e71fabd2bc0$var$OFFSET
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "agent-source-control-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentSourceControlSpotlightTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: ()=>onDismiss('cross-icon')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentSourceControlSpotlightBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: ()=>onDismiss('understood-button')
    }, formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentSourceControlSpotlightUnderstood))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $63676e71fabd2bc0$var$styles.spotlightTarget
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficeMessageInstance, {
        messageInstanceId: messageInstanceId
    }, ()=>popoverContent));
};


/* buildGhostIconNodes.tsx generated by @compiled/babel-plugin v2.0.0 */ 














const $5a690b33f7f3e9f9$var$styles = {
    rovoLogoWrapper: "_0bjKvDcjp5 _4bt5LAnQyn _2WAcuGnQyn _0jFU0VSPN1 _39xV02SPN1 _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuDIqT",
    placeholderLogo: "_0bjKvD8fU6 _0jFU0VSPN1 _39xV02SPN1 _0KLXru28sy"
};
const $5a690b33f7f3e9f9$export$94085a614b07ca11 = (ghostConnectors)=>ghostConnectors.map((connector)=>(0, $iDrrr.fg)('rovo_chat_use_be_knowledge_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            key: connector.source,
            src: (0, $iDrrr.fg)('use_new_knowledge_source_icon_url_prefix') ? connector.iconUrl : `/gateway/api${connector.iconUrl}`,
            alt: connector.friendlyName,
            width: 20,
            height: 20
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: connector.source,
            xcss: $5a690b33f7f3e9f9$var$styles.rovoLogoWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
            appSource: connector.source,
            rovoLogoProps: {
                size: 'xsmall'
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $5a690b33f7f3e9f9$var$styles.placeholderLogo
            })
        })));






var $mW7G5 = parcelRequire("mW7G5");


var $4nhQC = parcelRequire("4nhQC");

var $TTB05 = parcelRequire("TTB05");














var $6e8qW = parcelRequire("6e8qW");







const $0f5913ad0da206a6$var$DEFAULT_GHOST_ICON_LIMIT = 2;
const $0f5913ad0da206a6$var$TAP_TRAITS_FETCH_TIMEOUT_MS = 3000;
const $0f5913ad0da206a6$export$a9e6985205f52251 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId, enabled, options)=>{
    const $ = (0, $bDgLe.c)(16);
    const limit = options?.limit ?? $0f5913ad0da206a6$var$DEFAULT_GHOST_ICON_LIMIT;
    const onFetchComplete = options?.onFetchComplete;
    const [allKnowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [tapStats, setTapStats] = (0, $cozmU.useState)(null);
    const fetchKey = enabled && siteId ? siteId : null;
    const [completedFetchKey, setCompletedFetchKey] = (0, $cozmU.useState)(null);
    const loaded = fetchKey === null || completedFetchKey === fetchKey;
    const onFetchCompleteRef = (0, $cozmU.useRef)(onFetchComplete);
    let t0;
    let t1;
    if ($[0] !== onFetchComplete) {
        t0 = ()=>{
            onFetchCompleteRef.current = onFetchComplete;
        };
        t1 = [
            onFetchComplete
        ];
        $[0] = onFetchComplete;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[3] !== fetchKey) {
        t2 = ()=>{
            if (fetchKey === null) {
                setTapStats(null);
                setCompletedFetchKey(null);
                return;
            }
            let cancelled = false;
            let timedOut = false;
            let outcome = "failure";
            const startedAt = performance.now();
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>{
                timedOut = true;
                controller.abort();
            }, $0f5913ad0da206a6$var$TAP_TRAITS_FETCH_TIMEOUT_MS);
            (0, $6e8qW.fetchSiteTraits)(fetchKey, controller.signal).then((traits)=>{
                if (cancelled) return;
                const parsed = (0, $6e8qW.parseProductValueTrait)(traits, (0, $6e8qW.CONNECTOR_AUTH_RATE_TRAIT));
                setTapStats((0, $6e8qW.normalizeTapKeys)(parsed));
                outcome = "success";
            }).catch(()=>{
                if (cancelled) return;
                setTapStats(null);
                outcome = timedOut ? "timeout" : "failure";
            }).finally(()=>{
                clearTimeout(timeoutId);
                if (cancelled) return;
                setCompletedFetchKey(fetchKey);
                onFetchCompleteRef.current?.({
                    outcome: outcome,
                    durationMs: performance.now() - startedAt
                });
            });
            return ()=>{
                cancelled = true;
                clearTimeout(timeoutId);
                controller.abort();
            };
        };
        t3 = [
            fetchKey
        ];
        $[3] = fetchKey;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    bb0: {
        if (!enabled || !tapStats || allKnowledgeSources.length === 0) {
            let t5;
            if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
                t5 = [];
                $[6] = t5;
            } else t5 = $[6];
            t4 = t5;
            break bb0;
        }
        let t5;
        if ($[7] !== allKnowledgeSources || $[8] !== limit || $[9] !== tapStats) {
            let t6;
            if ($[11] !== tapStats) {
                t6 = (connector_0)=>({
                        source: connector_0.source,
                        friendlyName: connector_0.friendlyName,
                        iconUrl: connector_0.iconUrl,
                        orgAuthPercent: tapStats[connector_0.source] ?? 0
                    });
                $[11] = tapStats;
                $[12] = t6;
            } else t6 = $[12];
            t5 = allKnowledgeSources.filter($0f5913ad0da206a6$var$_temp).map(t6).sort($0f5913ad0da206a6$var$_temp2).slice(0, limit);
            $[7] = allKnowledgeSources;
            $[8] = limit;
            $[9] = tapStats;
            $[10] = t5;
        } else t5 = $[10];
        t4 = t5;
    }
    const connectors = t4;
    let t5;
    if ($[13] !== connectors || $[14] !== loaded) {
        t5 = {
            connectors: connectors,
            loaded: loaded
        };
        $[13] = connectors;
        $[14] = loaded;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : (siteId, enabled, options)=>{
    const limit = options?.limit ?? $0f5913ad0da206a6$var$DEFAULT_GHOST_ICON_LIMIT;
    const onFetchComplete = options?.onFetchComplete;
    const [allKnowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const [tapStats, setTapStats] = (0, $cozmU.useState)(null);
    // Identifies the (enabled, siteId) combination that decides whether to
    // fetch and what to fetch. `null` means "no fetch needed" (loaded
    // immediately); a string means "must fetch for this key". Using a derived
    // key instead of a boolean `loaded` flag avoids a one-render lag where
    // `loaded` would still be `true` from a previous "no fetch needed" state
    // after `enabled` flips on — that transient surfaces to the parent as
    // `loaded=true && connectors=[]`, which the not-rendered classifier then
    // (incorrectly) reports as `no_eligible_connectors` before the fetch even
    // starts.
    const fetchKey = enabled && siteId ? siteId : null;
    // Which key we have actually completed a fetch for. When `fetchKey`
    // changes, `loaded` automatically reports `false` until the new fetch
    // settles and pushes the new key in here.
    const [completedFetchKey, setCompletedFetchKey] = (0, $cozmU.useState)(null);
    const loaded = fetchKey === null || completedFetchKey === fetchKey;
    // Capture the latest callback in a ref so the fetch effect does not have to
    // re-run when only the callback identity changes — re-running would cancel
    // any in-flight TAP request and start a new one, which is the wrong
    // trade-off for an instrumentation hook.
    const onFetchCompleteRef = (0, $cozmU.useRef)(onFetchComplete);
    (0, $cozmU.useEffect)(()=>{
        onFetchCompleteRef.current = onFetchComplete;
    }, [
        onFetchComplete
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (fetchKey === null) {
            setTapStats(null);
            // Also clear the completed key so a later `null → siteId` flip with
            // the SAME siteId does not read `loaded=true` from the stale key
            // before the new fetch runs. Without this, the `true → false → true`
            // path re-surfaces the `{loaded:true, connectors:[]}` transient that
            // the fetch-key refactor fixed for the initial `false → true` flip
            // (tapStats is null here, so connectors would be [] while loaded
            // reported true).
            setCompletedFetchKey(null);
            return;
        }
        let cancelled = false;
        // Distinguishes "we aborted because the user's request took >3s" from
        // "we aborted because the consumer unmounted mid-fetch". Both surface as
        // AbortError in the catch path; only the timer path should be reported
        // as 'timeout' to callers.
        let timedOut = false;
        let outcome = 'failure';
        const startedAt = performance.now();
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, $0f5913ad0da206a6$var$TAP_TRAITS_FETCH_TIMEOUT_MS);
        (0, $6e8qW.fetchSiteTraits)(fetchKey, controller.signal).then((traits)=>{
            if (cancelled) return;
            const parsed = (0, $6e8qW.parseProductValueTrait)(traits, (0, $6e8qW.CONNECTOR_AUTH_RATE_TRAIT));
            setTapStats((0, $6e8qW.normalizeTapKeys)(parsed));
            outcome = 'success';
        }).catch(()=>{
            if (cancelled) return;
            // Fail-open path: return no connectors but mark loaded.
            setTapStats(null);
            outcome = timedOut ? 'timeout' : 'failure';
        }).finally(()=>{
            clearTimeout(timeoutId);
            if (cancelled) return;
            setCompletedFetchKey(fetchKey);
            // Report after the `loaded` flip so any caller that re-renders
            // on `loaded` has the latest connector data available when the
            // event fires (e.g. for an `eligibleConnectorCount` attribute
            // computed from the rendered list).
            onFetchCompleteRef.current?.({
                outcome: outcome,
                durationMs: performance.now() - startedAt
            });
        });
        return ()=>{
            cancelled = true;
            clearTimeout(timeoutId);
            controller.abort();
        };
    }, [
        fetchKey
    ]);
    const connectors = (0, $cozmU.useMemo)(()=>{
        if (!enabled || !tapStats || allKnowledgeSources.length === 0) return [];
        return allKnowledgeSources.filter((connector)=>!connector.isUserOAuthed && (0, $6xccU.is3pApp)(connector.friendlyName)).map((connector_0)=>({
                source: connector_0.source,
                friendlyName: connector_0.friendlyName,
                iconUrl: connector_0.iconUrl,
                orgAuthPercent: tapStats[connector_0.source] ?? 0
            })).sort((a, b)=>b.orgAuthPercent - a.orgAuthPercent).slice(0, limit);
    }, [
        allKnowledgeSources,
        tapStats,
        limit,
        enabled
    ]);
    return {
        connectors: connectors,
        loaded: loaded
    };
};
function $0f5913ad0da206a6$var$_temp(connector) {
    return !connector.isUserOAuthed && (0, $6xccU.is3pApp)(connector.friendlyName);
}
function $0f5913ad0da206a6$var$_temp2(a, b) {
    return b.orgAuthPercent - a.orgAuthPercent;
}


const $81c6ce0d09e2f05b$export$476fa6ce9a37bea9 = {
    SEEN: 'SEEN',
    TIMER_RUNNING: 'TIMER_RUNNING',
    DISMISSED: 'DISMISSED'
};



// Once Sources is clicked, give users a bounded intent-to-act window before hiding.
const $a2850525f71f54c3$export$9c62be2252ccf517 = 1209600000;



var $7dBf8 = parcelRequire("7dBf8");

const $07507dad6d168dea$export$750144e462377e1e = 'rovo-ghost-icons-';


const $c8e17e1dd47fd41e$export$33bfc37712032746 = (aaid)=>`${0, $07507dad6d168dea$export$750144e462377e1e}${aaid}`;






const $81768b2ab2bd1002$export$b3c41ba61d96c207 = ({ functionName: functionName, kind: kind })=>{
    (0, $hlvTd.logException)({
        exception: new Error('Unexpected ghost icons dismiss state kind'),
        name: 'ghost-icons-dismiss-state-unexpected-kind',
        tags: {
            source: 'ghost-icons-dismiss-state',
            functionName: functionName,
            kind: kind
        }
    });
};


const $bce0120080a1f540$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $bce0120080a1f540$var$isFiniteNumber = (value)=>typeof value === 'number' && Number.isFinite(value);
// Returns the value typed as number when valid, or null otherwise. Wrapping
// validation + typing in one place lets callers use positive narrowing
// (`if (x === null) return null`) for both required and optional timestamps.
const $bce0120080a1f540$var$requireFiniteNumber = (value)=>$bce0120080a1f540$var$isFiniteNumber(value) ? value : null;
// Like requireFiniteNumber but allows the field to be absent. Returns:
//   - undefined when the field is missing (a valid optional state),
//   - the number when present and finite,
//   - null when present but not a finite number (invalid persisted state).
const $bce0120080a1f540$var$optionalFiniteNumber = (value)=>{
    if (value === undefined) return undefined;
    return $bce0120080a1f540$var$isFiniteNumber(value) ? value : null;
};
const $bce0120080a1f540$var$parseDismissState = (value)=>{
    if (!$bce0120080a1f540$var$isRecord(value) || typeof value.kind !== 'string') // Unrecognized shape: treat as no persisted state (fail-open).
    return null;
    switch(value.kind){
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN:
            {
                const firstViewedAt = $bce0120080a1f540$var$requireFiniteNumber(value.firstViewedAt);
                if (firstViewedAt === null) return null;
                return {
                    kind: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN,
                    firstViewedAt: firstViewedAt
                };
            }
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING:
            {
                const firstViewedAt = $bce0120080a1f540$var$requireFiniteNumber(value.firstViewedAt);
                const sourcesClickedAt = $bce0120080a1f540$var$requireFiniteNumber(value.sourcesClickedAt);
                if (firstViewedAt === null || sourcesClickedAt === null) return null;
                return {
                    kind: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING,
                    firstViewedAt: firstViewedAt,
                    sourcesClickedAt: sourcesClickedAt
                };
            }
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED:
            {
                const firstViewedAt = $bce0120080a1f540$var$requireFiniteNumber(value.firstViewedAt);
                const dismissedAt = $bce0120080a1f540$var$requireFiniteNumber(value.dismissedAt);
                const sourcesClickedAt = $bce0120080a1f540$var$optionalFiniteNumber(value.sourcesClickedAt);
                if (firstViewedAt === null || dismissedAt === null || sourcesClickedAt === null) return null;
                return {
                    kind: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
                    firstViewedAt: firstViewedAt,
                    sourcesClickedAt: sourcesClickedAt,
                    dismissedAt: dismissedAt
                };
            }
        default:
            // Unknown kind means persisted data is invalid, so we ignore it and treat as no state.
            (0, $81768b2ab2bd1002$export$b3c41ba61d96c207)({
                functionName: 'parseDismissState',
                kind: value.kind
            });
            return null;
    }
};
const $bce0120080a1f540$export$bc198d2b0e4b9a92 = (aaid)=>{
    // SSR guard: localStorage is browser-only. This is read at render time via
    // `getGhostIconsRenderMode` inside a `useMemo` (see useGhostIconsPillState),
    // which also executes on the server, so short-circuit before touching
    // AtlBrowserStorageLocal rather than relying solely on the try/catch below.
    if (typeof window === 'undefined') return null;
    const key = (0, $c8e17e1dd47fd41e$export$33bfc37712032746)(aaid);
    try {
        const rawState = (0, $7dBf8.AtlBrowserStorageLocal).getItem(key);
        if (rawState === null) return null;
        return $bce0120080a1f540$var$parseDismissState(JSON.parse(rawState));
    } catch  {
        // AtlBrowserStorageLocal handles cookie-preference categorisation, but
        // the underlying storage call can still throw (SSR contexts where
        // localStorage is undefined, corrupt JSON, quota limits). Treat any
        // read failure as no state.
        return null;
    }
};


const $93e66f12701f3a54$export$5dbfcb34a4069cad = {
    HIDDEN: 'hidden',
    ANIMATED: 'animated',
    STATIC: 'static'
};



// Safety net so the nudge cannot remain visible indefinitely for non-interacting users.
const $321b50f8ddf95b65$export$fc57455263271036 = 2592000000;


const $3d4c4882efa014d4$export$a2425bd15a8fa63 = (aaid)=>{
    const state = (0, $bce0120080a1f540$export$bc198d2b0e4b9a92)(aaid);
    if (state === null) // No valid saved state means we treat this as first exposure, so icons should be shown
    // with first-time animation.
    return (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).ANIMATED;
    switch(state.kind){
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED:
            // User clicked Connect earlier (recordDismissed), so keep ghost icons hidden from now on.
            return (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).HIDDEN;
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING:
            // After the Sources Dropdown is opened, keep icons visible (static, not animated) for 14 days.
            // Past 14 days we just return HIDDEN here — this is a pure read, so the stored state stays
            // TIMER_RUNNING forever; it is never rewritten to DISMISSED. The icons simply stop rendering.
            return Date.now() - state.sourcesClickedAt < (0, $a2850525f71f54c3$export$9c62be2252ccf517) ? (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).STATIC : (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).HIDDEN;
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN:
            // This branch is the SEEN state: user has not opened the Sources Dropdown yet.
            // Keep icons visible (static, not animated) for up to 30 days.
            // Past 30 days we just return HIDDEN here — same as TIMER_RUNNING above, this is a pure read,
            // so the stored state stays SEEN forever; it is never rewritten to DISMISSED.
            return Date.now() - state.firstViewedAt < (0, $321b50f8ddf95b65$export$fc57455263271036) ? (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).STATIC : (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).HIDDEN;
        default:
            // Fail open if an unexpected kind reaches here.
            (0, $81768b2ab2bd1002$export$b3c41ba61d96c207)({
                functionName: 'getGhostIconsRenderMode',
                kind: state.kind
            });
            return (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).ANIMATED;
    }
};





const $8cdcfeeaa08bf727$export$432f13259446ba66 = (firstViewedAt, dismissedAt, sourcesClickedAt)=>({
        kind: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
        firstViewedAt: firstViewedAt,
        sourcesClickedAt: sourcesClickedAt,
        dismissedAt: dismissedAt
    });









const $11929dd2ea8f6a81$export$e0a7de6785683e03 = async (aaid, state)=>{
    const key = (0, $c8e17e1dd47fd41e$export$33bfc37712032746)(aaid);
    // Callers that need write visibility for a subsequent mutation or read can
    // await this Promise. Callers that do not care can still fire-and-forget via
    // `void setLocalState(...)`. Swallow async write failures so this helper
    // remains non-throwing for dismiss-state persistence.
    await (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, JSON.stringify(state)).catch(()=>{});
};


const $80d10555be9748e1$export$510ed6151311957b = async (aaid)=>{
    const state = (0, $bce0120080a1f540$export$bc198d2b0e4b9a92)(aaid);
    const now = Date.now();
    if (state === null) {
        // If Connect is clicked before first view or Sources Dropdown events are recorded,
        // write DISMISSED with firstViewedAt and dismissedAt set to now.
        await (0, $11929dd2ea8f6a81$export$e0a7de6785683e03)(aaid, (0, $8cdcfeeaa08bf727$export$432f13259446ba66)(now, now));
        return {
            from: null,
            to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
            noop: false
        };
    }
    switch(state.kind){
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED:
            // Already dismissed; keep the original dismissal time and do not rewrite it.
            return {
                from: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
                to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
                noop: true
            };
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING:
            // User opened Sources Dropdown earlier, then clicked Connect:
            // keep firstViewedAt and sourcesClickedAt, and add dismissedAt now.
            await (0, $11929dd2ea8f6a81$export$e0a7de6785683e03)(aaid, (0, $8cdcfeeaa08bf727$export$432f13259446ba66)(state.firstViewedAt, now, state.sourcesClickedAt));
            return {
                from: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING,
                to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
                noop: false
            };
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN:
            // User clicked Connect before opening the Sources Dropdown, so we treat this as final dismissal.
            // Keep the original firstViewedAt time so the state history stays accurate.
            await (0, $11929dd2ea8f6a81$export$e0a7de6785683e03)(aaid, (0, $8cdcfeeaa08bf727$export$432f13259446ba66)(state.firstViewedAt, now));
            return {
                from: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN,
                to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
                noop: false
            };
        default:
            (0, $81768b2ab2bd1002$export$b3c41ba61d96c207)({
                functionName: 'recordDismissed',
                kind: state.kind
            });
            return {
                from: null,
                to: null,
                noop: true
            };
    }
};



const $149f9f22255562ec$export$13775747ac003d73 = (firstViewedAt)=>({
        kind: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN,
        firstViewedAt: firstViewedAt
    });





const $9bbc8f61c22f14f2$export$cd302f1f511afb35 = async (aaid)=>{
    const state = (0, $bce0120080a1f540$export$bc198d2b0e4b9a92)(aaid);
    if (state !== null) // We only stamp "first seen" once, so repeated calls do not overwrite the original time.
    return {
        from: state.kind,
        to: state.kind,
        noop: true
    };
    await (0, $11929dd2ea8f6a81$export$e0a7de6785683e03)(aaid, (0, $149f9f22255562ec$export$13775747ac003d73)(Date.now()));
    return {
        from: null,
        to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN,
        noop: false
    };
};



const $5eee7df60486e301$export$aa51067aa04ea4ca = (firstViewedAt, sourcesClickedAt)=>({
        kind: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING,
        firstViewedAt: firstViewedAt,
        sourcesClickedAt: sourcesClickedAt
    });







const $e58352f976b3498d$export$7f6316e108bb9d37 = async (aaid)=>{
    const state = (0, $bce0120080a1f540$export$bc198d2b0e4b9a92)(aaid);
    const now = Date.now();
    if (state === null) {
        // Called before first view was recorded: write TIMER_RUNNING with both timestamps set to now.
        // This keeps icons visible as static and starts the 14-day Sources Dropdown window immediately.
        await (0, $11929dd2ea8f6a81$export$e0a7de6785683e03)(aaid, (0, $5eee7df60486e301$export$aa51067aa04ea4ca)(now, now));
        return {
            from: null,
            to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING,
            noop: false
        };
    }
    switch(state.kind){
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED:
            // Dismissed is final: opening the Sources Dropdown later should not make icons visible again.
            return {
                from: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
                to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED,
                noop: true
            };
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING:
            // Sources Dropdown was already opened before, so keep the original timer start time.
            return {
                from: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING,
                to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING,
                noop: true
            };
        case (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN:
            // SEEN state past the 30-day safety net is effectively expired. Do not promote
            // to TIMER_RUNNING — that would re-surface icons that the render-mode query
            // already treats as hidden, undoing the implicit "user disengaged" signal.
            if (now - state.firstViewedAt >= (0, $321b50f8ddf95b65$export$fc57455263271036)) return {
                from: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN,
                to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN,
                noop: true
            };
            await (0, $11929dd2ea8f6a81$export$e0a7de6785683e03)(aaid, (0, $5eee7df60486e301$export$aa51067aa04ea4ca)(state.firstViewedAt, now));
            return {
                from: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN,
                to: (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING,
                noop: false
            };
        default:
            (0, $81768b2ab2bd1002$export$b3c41ba61d96c207)({
                functionName: 'recordSourcesClicked',
                kind: state.kind
            });
            return {
                from: null,
                to: null,
                noop: true
            };
    }
};


// Lazy localStorage read used at analytics-fire time so the persisted dismiss
// kind can be attached as an attribute without leaking it into render-time
// memoization (the state machine can mutate during the session via
// recordFirstView / recordSourcesClicked / recordDismissed).
const $b066e252bf36de11$var$readDismissStateKind = (aaid)=>{
    if (!aaid) return null;
    return (0, $bce0120080a1f540$export$bc198d2b0e4b9a92)(aaid)?.kind ?? null;
};
const $b066e252bf36de11$export$51f4d707e6c8070b = ({ assistanceServiceParams: assistanceServiceParams, contentContext: contentContext, connectedThirdPartyAppCount: connectedThirdPartyAppCount, sendAnalyticsEvent: sendAnalyticsEvent })=>{
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [hasFunctionalConsent, setHasFunctionalConsent] = (0, $cozmU.useState)(false);
    const hasConnectedThirdPartyApps = connectedThirdPartyAppCount > 0;
    const shouldUseDismissState = hasFunctionalConsent && Boolean(aaid);
    const renderMode = (0, $cozmU.useMemo)(()=>{
        if (!aaid) return (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).HIDDEN;
        if (!hasFunctionalConsent) return (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).STATIC;
        return (0, $3d4c4882efa014d4$export$a2425bd15a8fa63)(aaid);
    }, [
        aaid,
        hasFunctionalConsent
    ]);
    // Single, consolidated experiment check. Every cheap exclusion that does
    // not require fetching connector data runs first, so we only fire an
    // exposure for users who could plausibly see ghost icons (anything else
    // would dilute the experiment results). The experiment value must always
    // be the last term in the boolean chain.
    //
    // This value also gates the TAP fetch in `useGhostIconConnectors` below,
    // so consumers outside the experiment never pay the network cost — and we
    // avoid making a second `expVal` call to gate the fetch separately.
    const isInGhostIconsExperiment = (0, $cozmU.useMemo)(()=>{
        if (!aaid) return false;
        if (shouldUseDismissState && renderMode === (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).HIDDEN) return false;
        return (0, $mW7G5.expVal)('confluence_3p_in_cwr_ghost_icons', 'isEnabled', false);
    }, [
        aaid,
        renderMode,
        shouldUseDismissState
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Only fetch consent when the user is authenticated (ConsentHub requires
        // a session — will always 404 without one) AND the experiment is active.
        // This references the single consolidated expVal check above, so we
        // avoid firing a second exposure or diluting experiment results.
        if (!aaid || !isInGhostIconsExperiment) return;
        let cancelled = false;
        (0, $4nhQC.getPreferences)().then((prefs)=>{
            if (!cancelled) setHasFunctionalConsent(Boolean(prefs?.[(0, $TTB05.PreferenceCategory).Functional]));
        }).catch(()=>{
            if (!cancelled) setHasFunctionalConsent(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        aaid,
        isInGhostIconsExperiment
    ]);
    // Captured from the connectors hook's onFetchComplete callback so the
    // `not_rendered` reason can distinguish "TAP succeeded but returned an
    // empty list" from "TAP failed and we fell back to empty". Without this
    // the two are indistinguishable to the analytics consumer.
    const [lastFetchResult, setLastFetchResult] = (0, $cozmU.useState)(null);
    // Invalidate the cached fetch result whenever the site changes so a stale
    // outcome from the previous site cannot be attached to the new site's
    // `ghost_icons_not_rendered` event. The connectors hook already reports
    // `loaded=false` during the refetch (so the reason is suppressed as
    // transient until the new fetch settles), but resetting here keeps the
    // invariant local instead of relying on cross-hook timing.
    (0, $cozmU.useEffect)(()=>{
        setLastFetchResult(null);
    }, [
        assistanceServiceParams.siteId
    ]);
    const handleConnectorsFetchComplete = (0, $cozmU.useCallback)((result)=>{
        setLastFetchResult(result);
        // Operational (not track) so this does not show up in product
        // analytics dashboards, but lets SRE alert on the failure /
        // timeout rate and tune TAP_TRAITS_FETCH_TIMEOUT_MS against
        // real p95s instead of guesses.
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'ghost_icons_connectors_fetch_completed',
            actionSubject: 'ghostIcons',
            attributes: {
                outcome: result.outcome,
                durationMs: Math.round(result.durationMs)
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const { connectors: ghostConnectors, loaded: ghostConnectorsLoaded } = (0, $0f5913ad0da206a6$export$a9e6985205f52251)(assistanceServiceParams.siteId, isInGhostIconsExperiment, {
        onFetchComplete: handleConnectorsFetchComplete
    });
    const showGhostIcons = isInGhostIconsExperiment && ghostConnectorsLoaded && ghostConnectors.length > 0 && (hasFunctionalConsent || !hasConnectedThirdPartyApps);
    // True while ghost icons could still appear but their connector data has not
    // loaded yet. Distinct from showGhostIcons (which requires loaded data) so the
    // pill can hide the overflow count during the fetch and avoid a flash.
    const isGhostIconsPending = isInGhostIconsExperiment && !ghostConnectorsLoaded;
    const shouldAnimate = showGhostIcons && hasFunctionalConsent && renderMode === (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).ANIMATED;
    // Helper that fires the dismiss-state transition event. Hoisted so all three
    // state-changing call sites (recordFirstView, recordSourcesClicked,
    // recordDismissed) use the exact same shape. Noop results (idempotent or
    // safety-net branches that did not rewrite storage — e.g. `recordFirstView`
    // being called a second time after a re-render, or `recordSourcesClicked`
    // hitting the expired-SEEN branch) are intentionally dropped: the event
    // name promises an actual transition, and re-firing on every effect
    // re-run would inflate the dismiss-state funnel with phantom moves.
    const fireDismissStateTransition = (0, $cozmU.useCallback)((trigger, transitionResult)=>{
        if (transitionResult.noop) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'ghost_icons_dismiss_state_transitioned',
            actionSubject: 'ghostIcons',
            attributes: {
                trigger: trigger,
                from: transitionResult.from,
                to: transitionResult.to,
                surface: contentContext
            }
        });
    }, [
        sendAnalyticsEvent,
        contentContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!showGhostIcons || !shouldUseDismissState || !aaid) return;
        // Chain on the recordX promise so we observe the actual transition the
        // service computed. The fire helper drops noop results, so re-running
        // this effect (e.g. on a new `sendAnalyticsEvent` identity) after the
        // first view has already been recorded is safe — `recordFirstView`
        // returns `{noop: true}` and no event is emitted.
        (0, $9bbc8f61c22f14f2$export$cd302f1f511afb35)(aaid).then((transitionResult)=>{
            fireDismissStateTransition('first_view', transitionResult);
        });
    }, [
        showGhostIcons,
        shouldUseDismissState,
        aaid,
        fireDismissStateTransition
    ]);
    // `ghost_icons_rendered` dedupe: fire exactly once per "showGhostIcons
    // transitions false → true" window. Previously this fired any time
    // `ghostConnectors` re-referenced (every connector store re-emit) or
    // `sendAnalyticsEvent` identity churned, inflating impression counts and
    // distorting the numerator of the conversion funnel.
    const renderedFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!showGhostIcons) {
            renderedFiredRef.current = false;
            return;
        }
        if (renderedFiredRef.current) return;
        renderedFiredRef.current = true;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'ghost_icons_rendered',
            actionSubject: 'ghostIcons',
            attributes: {
                sources: ghostConnectors.map((connector)=>connector.source),
                surface: contentContext,
                animated: shouldAnimate,
                renderMode: // New attributes for richer funnel slicing — let dashboards split
                // rendered impressions by which dismiss-state cohort the user
                // was in (SEEN first-time animated vs TIMER_RUNNING static
                // follow-up) without needing a separate event.
                renderMode,
                dismissStateKind: shouldUseDismissState ? $b066e252bf36de11$var$readDismissStateKind(aaid) : null,
                connectorCount: ghostConnectors.length
            }
        });
    // Intentionally only re-runs when the visibility predicate flips. The
    // other values are read from the current closure at fire time, which
    // matches the impression we are recording (the wave the user is
    // looking at right now).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showGhostIcons
    ]);
    // Inferred reason the user did not see ghost icons. Returns null in two
    // cases that we explicitly do NOT want to report:
    //   1. transient — fetch is still in flight, so any "no connectors"
    //      conclusion would be a false signal.
    //   2. user is out of the experiment AND not blocked by dismiss state —
    //      this is the experiment baseline and reporting it would flood the
    //      track event with the population we are not trying to convert.
    const notRenderedReason = (0, $cozmU.useMemo)(()=>{
        if (!aaid || showGhostIcons) return null;
        // Hidden render mode short-circuits the experiment, so the dismiss
        // state is the only signal available. SEEN / TIMER_RUNNING + HIDDEN
        // implies the safety-net window expired (otherwise renderMode would
        // be STATIC); fold that knowledge into the reason value.
        if (!hasFunctionalConsent && hasConnectedThirdPartyApps) return 'no_functional_consent_with_connected_apps';
        if (shouldUseDismissState && renderMode === (0, $93e66f12701f3a54$export$5dbfcb34a4069cad).HIDDEN) {
            const kind = $b066e252bf36de11$var$readDismissStateKind(aaid);
            if (kind === (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).DISMISSED) return 'hidden_dismissed';
            if (kind === (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).SEEN) return 'hidden_seen_expired';
            if (kind === (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING) return 'hidden_timer_expired';
            // Defensive: null state always maps to ANIMATED in the service,
            // so we should never get HIDDEN with no kind. Skip rather than
            // emit a misleading reason.
            return null;
        }
        // From here, renderMode is not HIDDEN. Anything else implies we are
        // either in the experiment funnel (so we want the diagnostics) or out
        // of it entirely (which we skip per the rationale above).
        if (!isInGhostIconsExperiment) return null;
        if (!assistanceServiceParams.siteId) return 'no_site_id';
        if (!ghostConnectorsLoaded) // Transient — wait for the fetch to settle before drawing any
        // conclusion. notRenderedReason will recompute when `loaded`
        // flips, at which point we will either show icons or pick a
        // concrete reason below.
        return null;
        if (lastFetchResult?.outcome === 'failure' || lastFetchResult?.outcome === 'timeout') return 'fetch_failed';
        if (ghostConnectors.length === 0) {
            // Only classify as "no eligible connectors" once a fetch has
            // actually settled. Without this guard, any render where the
            // connectors hook reports `loaded=true` with an empty list before
            // a real fetch completes (e.g. the pre-fetch transient when
            // `enabled` flips on) would be reported as a TAP-empty outcome,
            // which would also incorrectly co-fire with `ghost_icons_rendered`
            // once the fetch settles with results.
            if (!lastFetchResult || lastFetchResult.outcome !== 'success') return null;
            return 'no_eligible_connectors';
        }
        return null;
    }, [
        aaid,
        showGhostIcons,
        renderMode,
        hasFunctionalConsent,
        hasConnectedThirdPartyApps,
        shouldUseDismissState,
        isInGhostIconsExperiment,
        assistanceServiceParams.siteId,
        ghostConnectorsLoaded,
        ghostConnectors.length,
        lastFetchResult
    ]);
    const lastNotRenderedReasonRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!notRenderedReason) {
            // Resetting on transitions back to null lets a later regression
            // (e.g. site change → refetch → empty again) re-fire the same
            // reason instead of being silently suppressed by the dedupe latch.
            lastNotRenderedReasonRef.current = null;
            return;
        }
        if (lastNotRenderedReasonRef.current === notRenderedReason) return;
        lastNotRenderedReasonRef.current = notRenderedReason;
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'ghost_icons_not_rendered',
            actionSubject: 'ghostIcons',
            attributes: {
                surface: contentContext,
                reason: notRenderedReason,
                renderMode: renderMode,
                dismissStateKind: shouldUseDismissState ? $b066e252bf36de11$var$readDismissStateKind(aaid) : null,
                // Attach fetch context only when relevant — keeps the payload
                // small for the dismiss-state branches that never touched TAP.
                fetchOutcome: notRenderedReason === 'fetch_failed' || notRenderedReason === 'no_eligible_connectors' ? lastFetchResult?.outcome ?? null : null,
                fetchDurationMs: notRenderedReason === 'fetch_failed' || notRenderedReason === 'no_eligible_connectors' ? lastFetchResult ? Math.round(lastFetchResult.durationMs) : null : null
            }
        });
    }, [
        notRenderedReason,
        sendAnalyticsEvent,
        contentContext,
        renderMode,
        shouldUseDismissState,
        aaid,
        lastFetchResult
    ]);
    const handleSourcesPillClick = (0, $cozmU.useCallback)(()=>{
        if (!showGhostIcons || !aaid) return;
        const timerAlreadyStarted = shouldUseDismissState && (0, $bce0120080a1f540$export$bc198d2b0e4b9a92)(aaid)?.kind === (0, $81c6ce0d09e2f05b$export$476fa6ce9a37bea9).TIMER_RUNNING;
        if (shouldUseDismissState) (0, $e58352f976b3498d$export$7f6316e108bb9d37)(aaid).then((transitionResult)=>{
            fireDismissStateTransition('sources_clicked', transitionResult);
        });
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'ghost_icons_sources_pill_clicked',
            actionSubject: 'ghostIcons',
            attributes: {
                sources: ghostConnectors.map((connector)=>connector.source),
                surface: contentContext,
                timerAlreadyStarted: timerAlreadyStarted
            }
        });
    }, [
        showGhostIcons,
        aaid,
        sendAnalyticsEvent,
        ghostConnectors,
        contentContext,
        fireDismissStateTransition,
        shouldUseDismissState
    ]);
    const handleGhostConnectClick = (0, $cozmU.useCallback)((source)=>{
        if (!showGhostIcons || !aaid) return;
        if (shouldUseDismissState) (0, $80d10555be9748e1$export$510ed6151311957b)(aaid).then((transitionResult)=>{
            fireDismissStateTransition('connect_clicked', transitionResult);
        });
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'ghost_icons_connect_clicked',
            actionSubject: 'ghostIcons',
            attributes: {
                source: source,
                surface: contentContext
            }
        });
    }, [
        showGhostIcons,
        aaid,
        sendAnalyticsEvent,
        contentContext,
        fireDismissStateTransition,
        shouldUseDismissState
    ]);
    // Wraps an operational `ghost_icons_render_blocked` event so the caller
    // (FilteredAppsTagNew) can pass this straight into `useGhostRenderCoordination`'s
    // `onRenderBlocked` option without re-implementing the event shape. Kept
    // here so every ghost-icons analytics event is constructed from the same
    // hook and the event vocabulary is easy to audit.
    const reportRenderBlocked = (0, $cozmU.useCallback)((detail)=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'ghost_icons_render_blocked',
            actionSubject: 'ghostIcons',
            attributes: {
                reason: detail.reason,
                pendingSources: detail.pendingSources,
                surface: contentContext
            }
        });
    }, [
        sendAnalyticsEvent,
        contentContext
    ]);
    return {
        ghostConnectors: ghostConnectors,
        showGhostIcons: showGhostIcons,
        isGhostIconsPending: isGhostIconsPending,
        shouldAnimate: shouldAnimate,
        oauthSource: showGhostIcons ? 'ghostIconNudge' : 'appFilterMenu',
        handleSourcesPillClick: handleSourcesPillClick,
        handleGhostConnectClick: handleGhostConnectClick,
        reportRenderBlocked: reportRenderBlocked
    };
};














const $2c7ec2fcd1a866b7$var$GHOST_ICONS_RENDER_DELAY_MS = 300;
// How long to wait after ghost icons become renderable before deciding that
// we are still blocked on source-icon image loads. Set well above the 300ms
// coordination delay so a normal slow image load does not trip it, but low
// enough that a stuck `<Image>` (no `onLoad` and no `onError`) shows up in
// dashboards within a single user interaction window.
const $2c7ec2fcd1a866b7$var$GHOST_ICONS_RENDER_BLOCKED_THRESHOLD_MS = 2000;
const $2c7ec2fcd1a866b7$export$f7dc980b918dcccc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { filteredApps: filteredApps, webSearchEnabled: webSearchEnabled, webSearchConfigEnabled: webSearchConfigEnabled, shouldRenderGhostIcons: shouldRenderGhostIcons, isGhostIconsPending: isGhostIconsPending, ghostIconCount: ghostIconCount, onRenderBlocked: onRenderBlocked } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [loadedSourceIconsBySource, setLoadedSourceIconsBySource] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (source)=>{
            setLoadedSourceIconsBySource((previous)=>previous[source] ? previous : {
                    ...previous,
                    [source]: true
                });
        };
        $[1] = t2;
    } else t2 = $[1];
    const markSourceIconLoaded = t2;
    const maxAppIconsVisible = webSearchEnabled && webSearchConfigEnabled ? 2 : 3;
    let t3;
    if ($[2] !== filteredApps || $[3] !== maxAppIconsVisible) {
        t3 = filteredApps.slice(0, maxAppIconsVisible);
        $[2] = filteredApps;
        $[3] = maxAppIconsVisible;
        $[4] = t3;
    } else t3 = $[4];
    const visibleAppSources = t3;
    let t4;
    bb0: {
        if (filteredApps.length === 0) {
            t4 = true;
            break bb0;
        }
        if (!(0, $iDrrr.fg)("rovo_chat_use_be_knowledge_icons")) {
            t4 = true;
            break bb0;
        }
        let t5;
        if ($[5] !== loadedSourceIconsBySource || $[6] !== visibleAppSources) {
            let t6;
            if ($[8] !== loadedSourceIconsBySource) {
                t6 = (app)=>loadedSourceIconsBySource[app.source];
                $[8] = loadedSourceIconsBySource;
                $[9] = t6;
            } else t6 = $[9];
            t5 = visibleAppSources.every(t6);
            $[5] = loadedSourceIconsBySource;
            $[6] = visibleAppSources;
            $[7] = t5;
        } else t5 = $[7];
        t4 = t5;
    }
    const hasLoadedAppSourceIcons = t4;
    const [isCoordinatedRenderReady, setIsCoordinatedRenderReady] = (0, $cozmU.useState)(false);
    let t5;
    let t6;
    if ($[10] !== hasLoadedAppSourceIcons || $[11] !== shouldRenderGhostIcons) {
        t5 = ()=>{
            if (!shouldRenderGhostIcons || !hasLoadedAppSourceIcons) {
                setIsCoordinatedRenderReady(false);
                return;
            }
            const timeoutId = globalThis.setTimeout(()=>setIsCoordinatedRenderReady(true), $2c7ec2fcd1a866b7$var$GHOST_ICONS_RENDER_DELAY_MS);
            return ()=>globalThis.clearTimeout(timeoutId);
        };
        t6 = [
            shouldRenderGhostIcons,
            hasLoadedAppSourceIcons
        ];
        $[10] = hasLoadedAppSourceIcons;
        $[11] = shouldRenderGhostIcons;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const onRenderBlockedRef = (0, $cozmU.useRef)(onRenderBlocked);
    let t7;
    let t8;
    if ($[14] !== onRenderBlocked) {
        t7 = ()=>{
            onRenderBlockedRef.current = onRenderBlocked;
        };
        t8 = [
            onRenderBlocked
        ];
        $[14] = onRenderBlocked;
        $[15] = t7;
        $[16] = t8;
    } else {
        t7 = $[15];
        t8 = $[16];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const renderBlockedFiredRef = (0, $cozmU.useRef)(false);
    let t10;
    let t9;
    if ($[17] !== hasLoadedAppSourceIcons || $[18] !== loadedSourceIconsBySource || $[19] !== shouldRenderGhostIcons || $[20] !== visibleAppSources) {
        t9 = ()=>{
            if (!shouldRenderGhostIcons || hasLoadedAppSourceIcons) {
                renderBlockedFiredRef.current = false;
                return;
            }
            if (renderBlockedFiredRef.current) return;
            const timeoutId_0 = globalThis.setTimeout(()=>{
                renderBlockedFiredRef.current = true;
                onRenderBlockedRef.current?.({
                    reason: "awaiting_source_icons",
                    pendingSources: visibleAppSources.filter((app_0)=>!loadedSourceIconsBySource[app_0.source]).map($2c7ec2fcd1a866b7$var$_temp)
                });
            }, $2c7ec2fcd1a866b7$var$GHOST_ICONS_RENDER_BLOCKED_THRESHOLD_MS);
            return ()=>globalThis.clearTimeout(timeoutId_0);
        };
        t10 = [
            shouldRenderGhostIcons,
            hasLoadedAppSourceIcons,
            visibleAppSources,
            loadedSourceIconsBySource
        ];
        $[17] = hasLoadedAppSourceIcons;
        $[18] = loadedSourceIconsBySource;
        $[19] = shouldRenderGhostIcons;
        $[20] = visibleAppSources;
        $[21] = t10;
        $[22] = t9;
    } else {
        t10 = $[21];
        t9 = $[22];
    }
    (0, $cozmU.useEffect)(t9, t10);
    const t11 = isCoordinatedRenderReady && ghostIconCount > 0;
    const t12 = isGhostIconsPending || shouldRenderGhostIcons && ghostIconCount > 0;
    let t13;
    if ($[23] !== t11 || $[24] !== t12) {
        t13 = {
            isVisible: t11,
            shouldHideOverflowCount: t12
        };
        $[23] = t11;
        $[24] = t12;
        $[25] = t13;
    } else t13 = $[25];
    const ghostIconRow = t13;
    let t14;
    if ($[26] !== ghostIconRow) {
        t14 = {
            ghostIconRow: ghostIconRow,
            markSourceIconLoaded: markSourceIconLoaded
        };
        $[26] = ghostIconRow;
        $[27] = t14;
    } else t14 = $[27];
    return t14;
} : ({ filteredApps: filteredApps, webSearchEnabled: webSearchEnabled, webSearchConfigEnabled: webSearchConfigEnabled, shouldRenderGhostIcons: shouldRenderGhostIcons, isGhostIconsPending: isGhostIconsPending, ghostIconCount: ghostIconCount, onRenderBlocked: onRenderBlocked })=>{
    // Tracks which visible 1P source icons have finished loading so ghost icons
    // can appear in sync (avoids a jarring staggered render).
    const [loadedSourceIconsBySource, setLoadedSourceIconsBySource] = (0, $cozmU.useState)({});
    // Idempotently marks a source icon as loaded from either onLoad or onError,
    // so one missing icon does not block ghost icon rendering forever.
    const markSourceIconLoaded = (0, $cozmU.useCallback)((source)=>{
        setLoadedSourceIconsBySource((previous)=>previous[source] ? previous : {
                ...previous,
                [source]: true
            });
    }, []);
    // Cap the number of icons we gate on — and report — at the number of icons
    // the pill will actually render. Hoisted so both the load-gate and the
    // `onRenderBlocked` payload agree on the same set.
    const visibleAppSources = (0, $cozmU.useMemo)(()=>{
        const maxVisible = 3;
        const maxAppIconsVisible = webSearchEnabled && webSearchConfigEnabled ? maxVisible - 1 : maxVisible;
        return filteredApps.slice(0, maxAppIconsVisible);
    }, [
        filteredApps,
        webSearchEnabled,
        webSearchConfigEnabled
    ]);
    const hasLoadedAppSourceIcons = (0, $cozmU.useMemo)(()=>{
        if (filteredApps.length === 0) // No 1P icons to wait for — allow ghost icons to render.
        return true;
        if (!(0, $iDrrr.fg)('rovo_chat_use_be_knowledge_icons')) // Without BE icon URLs we render logo fallbacks immediately, so there is
        // no async image load gate to wait on.
        return true;
        // Only gate on the icons that are actually visible in the pill. When web
        // is shown, it consumes one slot, so one fewer app icon needs loading.
        return visibleAppSources.every((app)=>loadedSourceIconsBySource[app.source]);
    }, [
        filteredApps,
        loadedSourceIconsBySource,
        visibleAppSources
    ]);
    // Adds a short delay before showing ghost icons so they animate in only after
    // the source icon row is stable.
    const [isCoordinatedRenderReady, setIsCoordinatedRenderReady] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRenderGhostIcons || !hasLoadedAppSourceIcons) {
            // Reset immediately when ghost rendering is disabled or we are still
            // waiting for required source icons.
            setIsCoordinatedRenderReady(false);
            return;
        }
        const timeoutId = globalThis.setTimeout(()=>setIsCoordinatedRenderReady(true), $2c7ec2fcd1a866b7$var$GHOST_ICONS_RENDER_DELAY_MS);
        return ()=>globalThis.clearTimeout(timeoutId);
    }, [
        shouldRenderGhostIcons,
        hasLoadedAppSourceIcons
    ]);
    // "Render blocked" detection: when ghost icons are ready to render but the
    // source-icon load gate has been false for longer than the threshold, fire
    // a single notification per eligibility window so callers can emit an
    // operational analytics event. Reference held in a ref so identity churn
    // on the callback does not retrigger the timer.
    const onRenderBlockedRef = (0, $cozmU.useRef)(onRenderBlocked);
    (0, $cozmU.useEffect)(()=>{
        onRenderBlockedRef.current = onRenderBlocked;
    }, [
        onRenderBlocked
    ]);
    const renderBlockedFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        // Reset the dedupe latch whenever ghost rendering is not eligible OR the
        // load gate has opened — both make the "blocked" state no longer apply
        // and any future stall should re-fire.
        if (!shouldRenderGhostIcons || hasLoadedAppSourceIcons) {
            renderBlockedFiredRef.current = false;
            return;
        }
        if (renderBlockedFiredRef.current) return;
        const timeoutId_0 = globalThis.setTimeout(()=>{
            renderBlockedFiredRef.current = true;
            onRenderBlockedRef.current?.({
                reason: 'awaiting_source_icons',
                pendingSources: visibleAppSources.filter((app_0)=>!loadedSourceIconsBySource[app_0.source]).map((app_1)=>app_1.source)
            });
        }, $2c7ec2fcd1a866b7$var$GHOST_ICONS_RENDER_BLOCKED_THRESHOLD_MS);
        return ()=>globalThis.clearTimeout(timeoutId_0);
    }, [
        shouldRenderGhostIcons,
        hasLoadedAppSourceIcons,
        visibleAppSources,
        loadedSourceIconsBySource
    ]);
    const ghostIconRow = (0, $cozmU.useMemo)(()=>({
            isVisible: isCoordinatedRenderReady && ghostIconCount > 0,
            // Hide the overflow count from the moment ghost icons are pending, through
            // the coordination delay, until the wave is on screen.
            shouldHideOverflowCount: isGhostIconsPending || shouldRenderGhostIcons && ghostIconCount > 0
        }), [
        isCoordinatedRenderReady,
        ghostIconCount,
        isGhostIconsPending,
        shouldRenderGhostIcons
    ]);
    return {
        ghostIconRow: ghostIconRow,
        markSourceIconLoaded: markSourceIconLoaded
    };
};
function $2c7ec2fcd1a866b7$var$_temp(app_1) {
    return app_1.source;
}












var $cnobl = parcelRequire("cnobl");











var $jdw9n = parcelRequire("jdw9n");

const $b32119f74d338cc6$export$1f7f0157ade8de0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { PostOfficePlacement: PostOfficePlacement, isMounted: isMounted } = (0, $jdw9n.usePostOfficePlacement)();
    if (!isMounted || !PostOfficePlacement) return null;
    let t0;
    if ($[0] !== PostOfficePlacement) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficePlacement, {
            placementId: "rovo-chat-sources"
        });
        $[0] = PostOfficePlacement;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const { PostOfficePlacement: PostOfficePlacement, isMounted: isMounted } = (0, $jdw9n.usePostOfficePlacement)();
    if (!isMounted || !PostOfficePlacement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PostOfficePlacement, {
        placementId: "rovo-chat-sources"
    });
};


const $c9ca12ddb32894ba$var$renderRemotePlacement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b32119f74d338cc6$export$1f7f0157ade8de0), null);
const $c9ca12ddb32894ba$var$ufoCustomDataKeys = {
    result: 'chatSourcesHeadlessProbeResult',
    responseMessageCount: 'chatSourcesHeadlessProbeResponseMessageCount',
    nonDismissedMessageCount: 'chatSourcesHeadlessProbeNonDismissedMessageCount'
};
const $c9ca12ddb32894ba$export$a7d6c8ff3b3b89d2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnobl.LoadableHeadlessProbePostOfficePlacement), {
            placementId: "rovo-chat-sources",
            renderRemotePlacement: $c9ca12ddb32894ba$var$renderRemotePlacement,
            ufoCustomDataKeys: $c9ca12ddb32894ba$var$ufoCustomDataKeys
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnobl.LoadableHeadlessProbePostOfficePlacement), {
        placementId: "rovo-chat-sources",
        renderRemotePlacement: $c9ca12ddb32894ba$var$renderRemotePlacement,
        ufoCustomDataKeys: $c9ca12ddb32894ba$var$ufoCustomDataKeys
    });
};



const $e8a20caf1e04623f$var$ClientSideOnly = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = typeof window !== "undefined" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>typeof window !== 'undefined' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
const $e8a20caf1e04623f$var$styles = {
    rovoLogoWrapper: "_0bjKvDcjp5 _4bt5LAnQyn _2WAcuGnQyn _0jFU0Vey7F _39xV02ey7F _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuDIqT",
    placeholderLogo: "_0bjKvD8fU6 _0jFU0Vey7F _39xV02ey7F _0KLXru28sy",
    popupContainer: "_0Of8r2gVvo _1wydGW2ADO",
    pillPressable: "_4c065UPgdg _0KLXrujOvk",
    pillPressableDisabled: "_4c065UPgdg _0KLXrujOvk _0wOv4Qsyl5 _1YKVNsVx3j",
    pillContainer: "_0bjKvD8fU6 _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _4c065UgVvo _2Y7lL48HPE _3iDTPbQ4SZ _0hPCNLDIqT _1eOmH6o126",
    pillContainerSelected: "_0bjKvD8fU6 _3vBAKHrzt2 _2V7sgONvrM _3hxITi6wH8 _4c065UgVvo _2Y7lL48HPE _3iDTPbQ4SZ _0hPCNLDIqT _0KLXruY9q9 _1UtDYzjTy9",
    iconItem: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02SPN1 _0jFU0VSPN1",
    remainingCount: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02IZbP",
    spotlightWrapper: "_1mT5xdRAKS _3iDTPbccYA",
    spotlightContainer: "_4bt5LAYvD1 _2WAcuGYvD1 _39xV02dnbC _0jFU0VdnbC"
};
const $e8a20caf1e04623f$export$f7c7d985a9c5951d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isDisabled: isDisabled, chatModeKey: chatModeKey, assistanceServiceParams: assistanceServiceParams, hideLabel: hideLabel, webSearchConfigEnabled: webSearchConfigEnabled, onFilteredAppsChange: onFilteredAppsChange, onWebSearchToggle: onWebSearchToggle, onOrgKnowledgeToggle: onOrgKnowledgeToggle, contentContext: t1, enableAppsDiscoveryUi: enableAppsDiscoveryUi, showSourceModeToggle: showSourceModeToggle, shouldRenderInPortal: shouldRenderInPortal, disabledTooltip: disabledTooltip, showAgentSourceControlSpotlight: t2, onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight, sourceControlPostOfficeMessage: sourceControlPostOfficeMessage } = t0;
    const contentContext = t1 === undefined ? "global" : t1;
    const showAgentSourceControlSpotlight = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== assistanceServiceParams || $[1] !== chatModeKey || $[2] !== contentContext || $[3] !== disabledTooltip || $[4] !== enableAppsDiscoveryUi || $[5] !== hideLabel || $[6] !== isDisabled || $[7] !== onDismissAgentSourceControlSpotlight || $[8] !== onFilteredAppsChange || $[9] !== onOrgKnowledgeToggle || $[10] !== onWebSearchToggle || $[11] !== shouldRenderInPortal || $[12] !== showAgentSourceControlSpotlight || $[13] !== showSourceModeToggle || $[14] !== sourceControlPostOfficeMessage || $[15] !== webSearchConfigEnabled) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a20caf1e04623f$var$FilteredAppsTagNew, {
            isDisabled: isDisabled,
            chatModeKey: chatModeKey,
            assistanceServiceParams: assistanceServiceParams,
            hideLabel: hideLabel,
            webSearchConfigEnabled: webSearchConfigEnabled,
            onFilteredAppsChange: onFilteredAppsChange,
            onWebSearchToggle: onWebSearchToggle,
            onOrgKnowledgeToggle: onOrgKnowledgeToggle,
            contentContext: contentContext,
            enableAppsDiscoveryUi: enableAppsDiscoveryUi,
            showSourceModeToggle: showSourceModeToggle,
            shouldRenderInPortal: shouldRenderInPortal,
            disabledTooltip: disabledTooltip,
            showAgentSourceControlSpotlight: showAgentSourceControlSpotlight,
            onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight,
            sourceControlPostOfficeMessage: sourceControlPostOfficeMessage
        });
        $[0] = assistanceServiceParams;
        $[1] = chatModeKey;
        $[2] = contentContext;
        $[3] = disabledTooltip;
        $[4] = enableAppsDiscoveryUi;
        $[5] = hideLabel;
        $[6] = isDisabled;
        $[7] = onDismissAgentSourceControlSpotlight;
        $[8] = onFilteredAppsChange;
        $[9] = onOrgKnowledgeToggle;
        $[10] = onWebSearchToggle;
        $[11] = shouldRenderInPortal;
        $[12] = showAgentSourceControlSpotlight;
        $[13] = showSourceModeToggle;
        $[14] = sourceControlPostOfficeMessage;
        $[15] = webSearchConfigEnabled;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
} : ({ isDisabled: isDisabled, chatModeKey: chatModeKey, assistanceServiceParams: assistanceServiceParams, hideLabel: hideLabel, webSearchConfigEnabled: webSearchConfigEnabled, onFilteredAppsChange: onFilteredAppsChange, onWebSearchToggle: onWebSearchToggle, onOrgKnowledgeToggle: onOrgKnowledgeToggle, contentContext: contentContext = 'global', enableAppsDiscoveryUi: enableAppsDiscoveryUi, showSourceModeToggle: showSourceModeToggle, shouldRenderInPortal: shouldRenderInPortal, disabledTooltip: disabledTooltip, showAgentSourceControlSpotlight: showAgentSourceControlSpotlight = false, onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight, sourceControlPostOfficeMessage: sourceControlPostOfficeMessage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a20caf1e04623f$var$FilteredAppsTagNew, {
        isDisabled: isDisabled,
        chatModeKey: chatModeKey,
        assistanceServiceParams: assistanceServiceParams,
        hideLabel: hideLabel,
        webSearchConfigEnabled: webSearchConfigEnabled,
        onFilteredAppsChange: onFilteredAppsChange,
        onWebSearchToggle: onWebSearchToggle,
        onOrgKnowledgeToggle: onOrgKnowledgeToggle,
        contentContext: contentContext,
        enableAppsDiscoveryUi: enableAppsDiscoveryUi,
        showSourceModeToggle: showSourceModeToggle,
        shouldRenderInPortal: shouldRenderInPortal,
        disabledTooltip: disabledTooltip,
        showAgentSourceControlSpotlight: showAgentSourceControlSpotlight,
        onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight,
        sourceControlPostOfficeMessage: sourceControlPostOfficeMessage
    });
};
const $e8a20caf1e04623f$var$FilteredAppsTagNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(147);
    const { isDisabled: isDisabled, chatModeKey: chatModeKey, assistanceServiceParams: assistanceServiceParams, webSearchConfigEnabled: webSearchConfigEnabled, onFilteredAppsChange: onFilteredAppsChange, onWebSearchToggle: onWebSearchToggle, onOrgKnowledgeToggle: onOrgKnowledgeToggle, contentContext: t1, enableAppsDiscoveryUi: enableAppsDiscoveryUi, showSourceModeToggle: showSourceModeToggle, shouldRenderInPortal: shouldRenderInPortal, disabledTooltip: disabledTooltip, showAgentSourceControlSpotlight: t2, onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight, sourceControlPostOfficeMessage: sourceControlPostOfficeMessage } = t0;
    const contentContext = t1 === undefined ? "global" : t1;
    const showAgentSourceControlSpotlight = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== assistanceServiceParams) {
        t3 = {
            assistanceServiceParams: assistanceServiceParams
        };
        $[0] = assistanceServiceParams;
        $[1] = t3;
    } else t3 = $[1];
    (0, $ekfm7.useEnsureConnectorsLoaded)(t3);
    const { setOrgKnowledge: setOrgKnowledge, setSourceMode: setSourceMode, setWebSearchEnabled: setWebSearchEnabled } = (0, $aJU2k.useChatModeStoreActions)();
    const { orgKnowledge: orgKnowledge, sourceMode: sourceMode, webSearchEnabled: webSearchEnabled } = (0, $7685l.useChatModeStore)(chatModeKey)[0];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [connectors] = (0, $7pCWA.useConnectors)();
    let t4;
    if ($[2] !== connectors) {
        t4 = Object.values(connectors).filter($e8a20caf1e04623f$var$_temp);
        $[2] = connectors;
        $[3] = t4;
    } else t4 = $[3];
    const connectedThirdPartyAppCount = t4.length;
    let t5;
    if ($[4] !== assistanceServiceParams || $[5] !== connectedThirdPartyAppCount || $[6] !== contentContext || $[7] !== sendAnalyticsEvent) {
        t5 = {
            assistanceServiceParams: assistanceServiceParams,
            contentContext: contentContext,
            connectedThirdPartyAppCount: connectedThirdPartyAppCount,
            sendAnalyticsEvent: sendAnalyticsEvent
        };
        $[4] = assistanceServiceParams;
        $[5] = connectedThirdPartyAppCount;
        $[6] = contentContext;
        $[7] = sendAnalyticsEvent;
        $[8] = t5;
    } else t5 = $[8];
    const { ghostConnectors: ghostConnectors, showGhostIcons: shouldRenderGhostIcons, isGhostIconsPending: isGhostIconsPending, shouldAnimate: shouldAnimate, oauthSource: oauthSource, handleSourcesPillClick: handleSourcesPillClick, handleGhostConnectClick: handleGhostConnectClick, reportRenderBlocked: reportRenderBlocked } = (0, $b066e252bf36de11$export$51f4d707e6c8070b)(t5);
    let t6;
    let t7;
    if ($[9] !== chatModeKey || $[10] !== setWebSearchEnabled) {
        t6 = ()=>{
            const handlePreferenceChange = (event)=>{
                if (event instanceof CustomEvent && typeof event.detail?.enabled === "boolean") setWebSearchEnabled(chatModeKey, event.detail.enabled);
            };
            const unbind = (0, $cbY7C.bind)(globalThis, {
                type: "rovo-chat-web-search-preference-changed",
                listener: handlePreferenceChange
            });
            return unbind;
        };
        t7 = [
            chatModeKey,
            setWebSearchEnabled
        ];
        $[9] = chatModeKey;
        $[10] = setWebSearchEnabled;
        $[11] = t6;
        $[12] = t7;
    } else {
        t6 = $[11];
        t7 = $[12];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[13] !== connectors) {
        t8 = (0, $5cd243480b1ee9b0$export$aad051ed2e5eb6f1)(connectors);
        $[13] = connectors;
        $[14] = t8;
    } else t8 = $[14];
    const allConnectedApps = t8;
    const hasInitializedAppsRef = (0, $cozmU.useRef)(false);
    let t10;
    let t9;
    if ($[15] !== allConnectedApps || $[16] !== chatModeKey || $[17] !== orgKnowledge || $[18] !== setOrgKnowledge) {
        t9 = ()=>{
            if (!hasInitializedAppsRef.current && allConnectedApps.length > 0 && orgKnowledge !== "disabled" && orgKnowledge.filteredApps.length === 0) {
                hasInitializedAppsRef.current = true;
                setOrgKnowledge(chatModeKey, {
                    filteredApps: allConnectedApps
                });
            }
        };
        t10 = [
            allConnectedApps,
            chatModeKey,
            orgKnowledge,
            setOrgKnowledge
        ];
        $[15] = allConnectedApps;
        $[16] = chatModeKey;
        $[17] = orgKnowledge;
        $[18] = setOrgKnowledge;
        $[19] = t10;
        $[20] = t9;
    } else {
        t10 = $[19];
        t9 = $[20];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    bb0: {
        if (orgKnowledge === "disabled") {
            let t12;
            if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
                t12 = [];
                $[21] = t12;
            } else t12 = $[21];
            t11 = t12;
            break bb0;
        }
        if (orgKnowledge.filteredApps && orgKnowledge.filteredApps.length > 0) {
            let t12;
            if ($[22] !== orgKnowledge.filteredApps) {
                t12 = new Set(orgKnowledge.filteredApps.map($e8a20caf1e04623f$var$_temp2));
                $[22] = orgKnowledge.filteredApps;
                $[23] = t12;
            } else t12 = $[23];
            const selectedSources = t12;
            let t13;
            if ($[24] !== allConnectedApps || $[25] !== selectedSources) {
                let t14;
                if ($[27] !== selectedSources) {
                    t14 = (app_0)=>selectedSources.has(app_0.source);
                    $[27] = selectedSources;
                    $[28] = t14;
                } else t14 = $[28];
                t13 = allConnectedApps.filter(t14);
                $[24] = allConnectedApps;
                $[25] = selectedSources;
                $[26] = t13;
            } else t13 = $[26];
            t11 = t13;
            break bb0;
        }
        t11 = allConnectedApps;
    }
    const filteredApps = t11;
    const isStrictSourceModeEnabled = showSourceModeToggle && sourceMode === "STRICT";
    const [isPillSelected, setIsPillSelected] = (0, $cozmU.useState)(false);
    let t12;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (isOpen)=>setIsPillSelected(isOpen);
        $[29] = t12;
    } else t12 = $[29];
    const onPillOpenChange = t12;
    let t13;
    if ($[30] !== filteredApps || $[31] !== ghostConnectors.length || $[32] !== isGhostIconsPending || $[33] !== reportRenderBlocked || $[34] !== shouldRenderGhostIcons || $[35] !== webSearchConfigEnabled || $[36] !== webSearchEnabled) {
        t13 = {
            filteredApps: filteredApps,
            webSearchEnabled: webSearchEnabled,
            webSearchConfigEnabled: webSearchConfigEnabled,
            shouldRenderGhostIcons: shouldRenderGhostIcons,
            isGhostIconsPending: isGhostIconsPending,
            ghostIconCount: ghostConnectors.length,
            onRenderBlocked: reportRenderBlocked
        };
        $[30] = filteredApps;
        $[31] = ghostConnectors.length;
        $[32] = isGhostIconsPending;
        $[33] = reportRenderBlocked;
        $[34] = shouldRenderGhostIcons;
        $[35] = webSearchConfigEnabled;
        $[36] = webSearchEnabled;
        $[37] = t13;
    } else t13 = $[37];
    const { ghostIconRow: ghostIconRow, markSourceIconLoaded: markSourceIconLoaded } = (0, $2c7ec2fcd1a866b7$export$f7dc980b918dcccc)(t13);
    let t14;
    bb1: {
        const tooltipMessage = shouldRenderGhostIcons ? (0, $18413269ea167174$export$defe85febe8b728c).ghostIconsConnectAppsTooltip : (0, $18413269ea167174$export$defe85febe8b728c).filteredAppsTooltip;
        let t15;
        if ($[38] !== disabledTooltip || $[39] !== formatMessage || $[40] !== tooltipMessage) {
            t15 = disabledTooltip ?? formatMessage(tooltipMessage);
            $[38] = disabledTooltip;
            $[39] = formatMessage;
            $[40] = tooltipMessage;
            $[41] = t15;
        } else t15 = $[41];
        const tooltipContent = t15;
        if (isStrictSourceModeEnabled) {
            const t16 = isPillSelected ? $e8a20caf1e04623f$var$styles.pillContainerSelected : $e8a20caf1e04623f$var$styles.pillContainer;
            let t17;
            if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
                t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $e8a20caf1e04623f$var$styles.iconItem
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                    label: "",
                    size: "small"
                }));
                $[42] = t17;
            } else t17 = $[42];
            let t18;
            if ($[43] !== formatMessage) {
                t18 = formatMessage((0, $18413269ea167174$export$defe85febe8b728c).newBadge);
                $[43] = formatMessage;
                $[44] = t18;
            } else t18 = $[44];
            let t19;
            if ($[45] !== t18) {
                t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    space: "space.050",
                    alignBlock: "center"
                }, t17, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                    appearance: "discovery"
                }, t18));
                $[45] = t18;
                $[46] = t19;
            } else t19 = $[46];
            let t20;
            if ($[47] !== t16 || $[48] !== t19) {
                t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t16
                }, t19);
                $[47] = t16;
                $[48] = t19;
                $[49] = t20;
            } else t20 = $[49];
            let t21;
            if ($[50] !== t20 || $[51] !== tooltipContent) {
                t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: tooltipContent
                }, t20);
                $[50] = t20;
                $[51] = tooltipContent;
                $[52] = t21;
            } else t21 = $[52];
            t14 = t21;
            break bb1;
        }
        let T0;
        let T1;
        let T2;
        let ghostIconNodes;
        let remainingCount;
        let t16;
        let t17;
        let t18;
        let t19;
        let t20;
        if ($[53] !== filteredApps || $[54] !== ghostConnectors || $[55] !== ghostIconRow.isVisible || $[56] !== isPillSelected || $[57] !== markSourceIconLoaded || $[58] !== tooltipContent || $[59] !== webSearchConfigEnabled || $[60] !== webSearchEnabled) {
            let t21;
            if ($[71] !== markSourceIconLoaded) {
                t21 = (app_1)=>(0, $iDrrr.fg)("rovo_chat_use_be_knowledge_icons") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                        key: app_1.source,
                        src: (0, $iDrrr.fg)("use_new_knowledge_source_icon_url_prefix") ? app_1.iconUrl : `/gateway/api${app_1.iconUrl}`,
                        alt: app_1.friendlyName,
                        width: 20,
                        height: 20,
                        onLoad: ()=>markSourceIconLoaded(app_1.source),
                        onError: ()=>markSourceIconLoaded(app_1.source)
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                        key: app_1.source,
                        xcss: $e8a20caf1e04623f$var$styles.rovoLogoWrapper
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
                        appSource: app_1.source,
                        rovoLogoProps: {
                            size: "xsmall"
                        },
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                            xcss: $e8a20caf1e04623f$var$styles.placeholderLogo
                        })
                    }));
                $[71] = markSourceIconLoaded;
                $[72] = t21;
            } else t21 = $[72];
            const appIcons = filteredApps.map(t21);
            const webSourceIcon = (0, $ak8CL.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), "Filter Web result")({
                size: "xsmall"
            });
            const defaultIcon = (0, $ak8CL.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($9Bssi))), "Sources")({
                size: "xsmall"
            });
            let t22;
            if ($[73] !== ghostConnectors) {
                t22 = (0, $5a690b33f7f3e9f9$export$94085a614b07ca11)(ghostConnectors);
                $[73] = ghostConnectors;
                $[74] = t22;
            } else t22 = $[74];
            ghostIconNodes = t22;
            const icons = webSearchEnabled && webSearchConfigEnabled ? [
                webSourceIcon,
                ...appIcons
            ] : appIcons.length > 0 ? appIcons : ghostIconRow.isVisible ? [] : [
                defaultIcon
            ];
            const visibleIcons = icons.slice(0, 3);
            remainingCount = Math.max(0, icons.length - 3);
            T2 = (0, $lpNn5.default);
            t20 = tooltipContent;
            T1 = (0, $iMnC5.Box);
            t19 = isPillSelected ? $e8a20caf1e04623f$var$styles.pillContainerSelected : $e8a20caf1e04623f$var$styles.pillContainer;
            T0 = (0, $1l0kj.Inline);
            t16 = "space.050";
            t17 = "center";
            t18 = visibleIcons.map($e8a20caf1e04623f$var$_temp3);
            $[53] = filteredApps;
            $[54] = ghostConnectors;
            $[55] = ghostIconRow.isVisible;
            $[56] = isPillSelected;
            $[57] = markSourceIconLoaded;
            $[58] = tooltipContent;
            $[59] = webSearchConfigEnabled;
            $[60] = webSearchEnabled;
            $[61] = T0;
            $[62] = T1;
            $[63] = T2;
            $[64] = ghostIconNodes;
            $[65] = remainingCount;
            $[66] = t16;
            $[67] = t17;
            $[68] = t18;
            $[69] = t19;
            $[70] = t20;
        } else {
            T0 = $[61];
            T1 = $[62];
            T2 = $[63];
            ghostIconNodes = $[64];
            remainingCount = $[65];
            t16 = $[66];
            t17 = $[67];
            t18 = $[68];
            t19 = $[69];
            t20 = $[70];
        }
        let t21;
        if ($[75] !== ghostIconRow.shouldHideOverflowCount || $[76] !== remainingCount) {
            t21 = remainingCount > 0 && !ghostIconRow.shouldHideOverflowCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $e8a20caf1e04623f$var$styles.remainingCount
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                weight: "medium"
            }, "+", remainingCount));
            $[75] = ghostIconRow.shouldHideOverflowCount;
            $[76] = remainingCount;
            $[77] = t21;
        } else t21 = $[77];
        let t22;
        if ($[78] !== formatMessage || $[79] !== ghostIconNodes || $[80] !== ghostIconRow.isVisible || $[81] !== shouldAnimate) {
            t22 = ghostIconRow.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ba5a522f3921255$export$a99469ff008e0788), {
                icons: ghostIconNodes,
                label: formatMessage((0, $18413269ea167174$export$defe85febe8b728c).ghostIconsLabel),
                waveCount: shouldAnimate ? 3 : 0,
                iconOpacity: 0.5
            });
            $[78] = formatMessage;
            $[79] = ghostIconNodes;
            $[80] = ghostIconRow.isVisible;
            $[81] = shouldAnimate;
            $[82] = t22;
        } else t22 = $[82];
        let t23;
        if ($[83] !== T0 || $[84] !== t16 || $[85] !== t17 || $[86] !== t18 || $[87] !== t21 || $[88] !== t22) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
                space: t16,
                alignBlock: t17
            }, t18, t21, t22);
            $[83] = T0;
            $[84] = t16;
            $[85] = t17;
            $[86] = t18;
            $[87] = t21;
            $[88] = t22;
            $[89] = t23;
        } else t23 = $[89];
        let t24;
        if ($[90] !== T1 || $[91] !== t19 || $[92] !== t23) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T1, {
                xcss: t19
            }, t23);
            $[90] = T1;
            $[91] = t19;
            $[92] = t23;
            $[93] = t24;
        } else t24 = $[93];
        let t25;
        if ($[94] !== T2 || $[95] !== t20 || $[96] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T2, {
                content: t20
            }, t24);
            $[94] = T2;
            $[95] = t20;
            $[96] = t24;
            $[97] = t25;
        } else t25 = $[97];
        t14 = t25;
    }
    const filteredAppsIcons = t14;
    let t15;
    if ($[98] !== onDismissAgentSourceControlSpotlight) {
        t15 = (source)=>{
            onDismissAgentSourceControlSpotlight?.(source);
        };
        $[98] = onDismissAgentSourceControlSpotlight;
        $[99] = t15;
    } else t15 = $[99];
    const dismissAgentSourceControlSpotlight = t15;
    let t16;
    if ($[100] !== dismissAgentSourceControlSpotlight || $[101] !== filteredApps || $[102] !== filteredAppsIcons || $[103] !== handleSourcesPillClick || $[104] !== isDisabled || $[105] !== sendAnalyticsEvent || $[106] !== showAgentSourceControlSpotlight || $[107] !== sourceControlPostOfficeMessage || $[108] !== webSearchConfigEnabled || $[109] !== webSearchEnabled) {
        t16 = (t17)=>{
            const { triggerRef: triggerRef, onClick: onClick, ...props } = t17;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $e8a20caf1e04623f$var$styles.spotlightWrapper,
                "data-spotlight-wrapper": true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                onClick: (e)=>{
                    if (isDisabled) return;
                    handleSourcesPillClick();
                    sendAnalyticsEvent({
                        action: "clicked",
                        actionSubject: "pill",
                        actionSubjectId: "filterByAppsSourcesPill",
                        attributes: {
                            appSources: filteredApps.map($e8a20caf1e04623f$var$_temp4),
                            webSearchEnabled: webSearchEnabled
                        }
                    });
                    onClick?.(e);
                },
                ...props,
                ref: triggerRef,
                isDisabled: isDisabled,
                "aria-disabled": isDisabled || undefined,
                xcss: isDisabled ? $e8a20caf1e04623f$var$styles.pillPressableDisabled : $e8a20caf1e04623f$var$styles.pillPressable,
                "data-spotlight-target": "rovo-chat-web-search-spotlight-target"
            }, filteredAppsIcons), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                id: "rovo-chat-web-search-spotlight",
                xcss: $e8a20caf1e04623f$var$styles.spotlightContainer
            }, webSearchEnabled && webSearchConfigEnabled && (0, $cXtTj.default).getExperimentValue("rovo_web_search_default_on", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9ca12ddb32894ba$export$a7d6c8ff3b3b89d2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63676e71fabd2bc0$export$ff815d78bbb5387b), {
                isVisible: showAgentSourceControlSpotlight,
                onDismiss: dismissAgentSourceControlSpotlight,
                postOfficeMessage: sourceControlPostOfficeMessage
            }));
        };
        $[100] = dismissAgentSourceControlSpotlight;
        $[101] = filteredApps;
        $[102] = filteredAppsIcons;
        $[103] = handleSourcesPillClick;
        $[104] = isDisabled;
        $[105] = sendAnalyticsEvent;
        $[106] = showAgentSourceControlSpotlight;
        $[107] = sourceControlPostOfficeMessage;
        $[108] = webSearchConfigEnabled;
        $[109] = webSearchEnabled;
        $[110] = t16;
    } else t16 = $[110];
    let t17;
    if ($[111] !== chatModeKey || $[112] !== onFilteredAppsChange || $[113] !== onOrgKnowledgeToggle || $[114] !== setOrgKnowledge) {
        t17 = (updatedOrgKnowledge)=>{
            if (updatedOrgKnowledge.filteredApps.length === 0) {
                setOrgKnowledge(chatModeKey, "disabled");
                onOrgKnowledgeToggle?.(false);
                onFilteredAppsChange?.([]);
            } else {
                setOrgKnowledge(chatModeKey, updatedOrgKnowledge);
                onOrgKnowledgeToggle?.(true);
                onFilteredAppsChange?.(updatedOrgKnowledge.filteredApps);
            }
        };
        $[111] = chatModeKey;
        $[112] = onFilteredAppsChange;
        $[113] = onOrgKnowledgeToggle;
        $[114] = setOrgKnowledge;
        $[115] = t17;
    } else t17 = $[115];
    let t18;
    if ($[116] !== chatModeKey || $[117] !== onWebSearchToggle || $[118] !== setWebSearchEnabled || $[119] !== webSearchConfigEnabled) {
        t18 = webSearchConfigEnabled ? (enabled)=>{
            setWebSearchEnabled(chatModeKey, enabled);
            onWebSearchToggle?.(enabled);
        } : undefined;
        $[116] = chatModeKey;
        $[117] = onWebSearchToggle;
        $[118] = setWebSearchEnabled;
        $[119] = webSearchConfigEnabled;
        $[120] = t18;
    } else t18 = $[120];
    const t19 = orgKnowledge !== "disabled";
    let t20;
    if ($[121] !== allConnectedApps || $[122] !== chatModeKey || $[123] !== onFilteredAppsChange || $[124] !== onOrgKnowledgeToggle || $[125] !== setOrgKnowledge) {
        t20 = (enabled_0)=>{
            if (enabled_0) {
                setOrgKnowledge(chatModeKey, {
                    filteredApps: allConnectedApps
                });
                onOrgKnowledgeToggle?.(true);
                onFilteredAppsChange?.(allConnectedApps);
            } else {
                setOrgKnowledge(chatModeKey, "disabled");
                onOrgKnowledgeToggle?.(false);
                onFilteredAppsChange?.([]);
            }
        };
        $[121] = allConnectedApps;
        $[122] = chatModeKey;
        $[123] = onFilteredAppsChange;
        $[124] = onOrgKnowledgeToggle;
        $[125] = setOrgKnowledge;
        $[126] = t20;
    } else t20 = $[126];
    let t21;
    if ($[127] !== chatModeKey || $[128] !== setSourceMode) {
        t21 = (updatedSourceMode)=>{
            setSourceMode(chatModeKey, updatedSourceMode);
        };
        $[127] = chatModeKey;
        $[128] = setSourceMode;
        $[129] = t21;
    } else t21 = $[129];
    let t22;
    if ($[130] !== assistanceServiceParams || $[131] !== contentContext || $[132] !== enableAppsDiscoveryUi || $[133] !== handleGhostConnectClick || $[134] !== oauthSource || $[135] !== orgKnowledge || $[136] !== shouldRenderInPortal || $[137] !== showSourceModeToggle || $[138] !== sourceMode || $[139] !== t16 || $[140] !== t17 || $[141] !== t18 || $[142] !== t19 || $[143] !== t20 || $[144] !== t21 || $[145] !== webSearchEnabled) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a20caf1e04623f$var$ClientSideOnly, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a20caf1e04623f$var$FilterByAppsSelectorMenu, {
            onOpenChange: onPillOpenChange,
            enableAppsDiscoveryUi: enableAppsDiscoveryUi,
            shouldRenderInPortal: shouldRenderInPortal,
            trigger: t16,
            orgKnowledge: orgKnowledge,
            assistanceServiceParams: assistanceServiceParams,
            oauthSource: oauthSource,
            oauthSurface: contentContext,
            onAppConnectClick: handleGhostConnectClick,
            onOrgKnowledgeToggle: t17,
            webSearchEnabled: webSearchEnabled,
            onWebSearchToggle: t18,
            orgKnowledgeEnabled: t19,
            onOrgKnowledgeEnabled: t20,
            sourceMode: sourceMode,
            onSourceModeChange: t21,
            showSourceModeToggle: showSourceModeToggle
        }));
        $[130] = assistanceServiceParams;
        $[131] = contentContext;
        $[132] = enableAppsDiscoveryUi;
        $[133] = handleGhostConnectClick;
        $[134] = oauthSource;
        $[135] = orgKnowledge;
        $[136] = shouldRenderInPortal;
        $[137] = showSourceModeToggle;
        $[138] = sourceMode;
        $[139] = t16;
        $[140] = t17;
        $[141] = t18;
        $[142] = t19;
        $[143] = t20;
        $[144] = t21;
        $[145] = webSearchEnabled;
        $[146] = t22;
    } else t22 = $[146];
    return t22;
} : ({ isDisabled: isDisabled, chatModeKey: chatModeKey, assistanceServiceParams: assistanceServiceParams, hideLabel: _hideLabel, webSearchConfigEnabled: webSearchConfigEnabled, onFilteredAppsChange: onFilteredAppsChange, onWebSearchToggle: onWebSearchToggle, onOrgKnowledgeToggle: onOrgKnowledgeToggle, contentContext: contentContext = 'global', enableAppsDiscoveryUi: enableAppsDiscoveryUi, showSourceModeToggle: showSourceModeToggle, shouldRenderInPortal: shouldRenderInPortal, disabledTooltip: disabledTooltip, showAgentSourceControlSpotlight: showAgentSourceControlSpotlight = false, onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight, sourceControlPostOfficeMessage: sourceControlPostOfficeMessage })=>{
    (0, $ekfm7.useEnsureConnectorsLoaded)({
        assistanceServiceParams: assistanceServiceParams
    });
    const { setOrgKnowledge: setOrgKnowledge, setSourceMode: setSourceMode, setWebSearchEnabled: setWebSearchEnabled } = (0, $aJU2k.useChatModeStoreActions)();
    const { orgKnowledge: orgKnowledge, sourceMode: sourceMode, webSearchEnabled: webSearchEnabled } = (0, $7685l.useChatModeStore)(chatModeKey)[0];
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const [connectors] = (0, $7pCWA.useConnectors)();
    const connectedThirdPartyAppCount = (0, $cozmU.useMemo)(()=>Object.values(connectors).filter((connector)=>connector.isUserOAuthed && (0, $6xccU.is3pApp)(connector.friendlyName)).length, [
        connectors
    ]);
    const { ghostConnectors: ghostConnectors, showGhostIcons: shouldRenderGhostIcons, isGhostIconsPending: isGhostIconsPending, shouldAnimate: shouldAnimate, oauthSource: oauthSource, handleSourcesPillClick: handleSourcesPillClick, handleGhostConnectClick: handleGhostConnectClick, reportRenderBlocked: reportRenderBlocked } = (0, $b066e252bf36de11$export$51f4d707e6c8070b)({
        assistanceServiceParams: assistanceServiceParams,
        contentContext: contentContext,
        connectedThirdPartyAppCount: connectedThirdPartyAppCount,
        sendAnalyticsEvent: sendAnalyticsEvent
    });
    (0, $cozmU.useEffect)(()=>{
        const handlePreferenceChange = (event)=>{
            if (event instanceof CustomEvent && typeof event.detail?.enabled === 'boolean') setWebSearchEnabled(chatModeKey, event.detail.enabled);
        };
        const unbind = (0, $cbY7C.bind)(globalThis, {
            type: 'rovo-chat-web-search-preference-changed',
            listener: handlePreferenceChange
        });
        return unbind;
    }, [
        chatModeKey,
        setWebSearchEnabled
    ]);
    const allConnectedApps = (0, $cozmU.useMemo)(()=>(0, $5cd243480b1ee9b0$export$aad051ed2e5eb6f1)(connectors), [
        connectors
    ]);
    const hasInitializedAppsRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasInitializedAppsRef.current && allConnectedApps.length > 0 && orgKnowledge !== 'disabled' && orgKnowledge.filteredApps.length === 0) {
            hasInitializedAppsRef.current = true;
            setOrgKnowledge(chatModeKey, {
                filteredApps: allConnectedApps
            });
        }
    }, [
        allConnectedApps,
        chatModeKey,
        orgKnowledge,
        setOrgKnowledge
    ]);
    const filteredApps = (0, $cozmU.useMemo)(()=>{
        if (orgKnowledge === 'disabled') return [];
        if (orgKnowledge.filteredApps && orgKnowledge.filteredApps.length > 0) {
            const selectedSources = new Set(orgKnowledge.filteredApps.map((app)=>app.source));
            return allConnectedApps.filter((app_0)=>selectedSources.has(app_0.source));
        }
        return allConnectedApps;
    }, [
        orgKnowledge,
        allConnectedApps
    ]);
    const isStrictSourceModeEnabled = showSourceModeToggle && sourceMode === 'STRICT';
    const [isPillSelected, setIsPillSelected] = (0, $cozmU.useState)(false);
    const onPillOpenChange = (0, $cozmU.useCallback)((isOpen)=>setIsPillSelected(isOpen), []);
    const { ghostIconRow: ghostIconRow, markSourceIconLoaded: markSourceIconLoaded } = (0, $2c7ec2fcd1a866b7$export$f7dc980b918dcccc)({
        filteredApps: filteredApps,
        webSearchEnabled: webSearchEnabled,
        webSearchConfigEnabled: webSearchConfigEnabled,
        shouldRenderGhostIcons: shouldRenderGhostIcons,
        isGhostIconsPending: isGhostIconsPending,
        ghostIconCount: ghostConnectors.length,
        // Forward to the pill state hook so the operational
        // `ghost_icons_render_blocked` event is emitted alongside the other
        // ghost-icons analytics events (same surface, same actionSubject).
        onRenderBlocked: reportRenderBlocked
    });
    const filteredAppsIcons = (0, $cozmU.useMemo)(()=>{
        const tooltipMessage = shouldRenderGhostIcons ? (0, $18413269ea167174$export$defe85febe8b728c).ghostIconsConnectAppsTooltip : (0, $18413269ea167174$export$defe85febe8b728c).filteredAppsTooltip;
        const tooltipContent = disabledTooltip ?? formatMessage(tooltipMessage);
        if (isStrictSourceModeEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isPillSelected ? $e8a20caf1e04623f$var$styles.pillContainerSelected : $e8a20caf1e04623f$var$styles.pillContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e8a20caf1e04623f$var$styles.iconItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
            label: "",
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, formatMessage((0, $18413269ea167174$export$defe85febe8b728c).newBadge)))));
        const appIcons = filteredApps.map((app_1)=>(0, $iDrrr.fg)('rovo_chat_use_be_knowledge_icons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                key: app_1.source,
                src: (0, $iDrrr.fg)('use_new_knowledge_source_icon_url_prefix') ? app_1.iconUrl : `/gateway/api${app_1.iconUrl}`,
                alt: app_1.friendlyName,
                width: 20,
                height: 20,
                onLoad: ()=>markSourceIconLoaded(app_1.source),
                onError: ()=>markSourceIconLoaded(app_1.source)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: app_1.source,
                xcss: $e8a20caf1e04623f$var$styles.rovoLogoWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $its7R.RovoLogoForAppSource), {
                appSource: app_1.source,
                rovoLogoProps: {
                    size: 'xsmall'
                },
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $e8a20caf1e04623f$var$styles.placeholderLogo
                })
            })));
        const webSourceIcon = (0, $ak8CL.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), 'Filter Web result')({
            size: 'xsmall'
        });
        const defaultIcon = (0, $ak8CL.RovoLogoFromLogo)((0, (/*@__PURE__*/$parcel$interopDefault($9Bssi))), 'Sources')({
            size: 'xsmall'
        });
        const ghostIconNodes = (0, $5a690b33f7f3e9f9$export$94085a614b07ca11)(ghostConnectors);
        const icons = webSearchEnabled && webSearchConfigEnabled ? [
            webSourceIcon,
            ...appIcons
        ] : appIcons.length > 0 ? appIcons : ghostIconRow.isVisible ? [] : [
            defaultIcon
        ];
        const maxVisible = 3;
        const visibleIcons = icons.slice(0, maxVisible);
        const remainingCount = Math.max(0, icons.length - maxVisible);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isPillSelected ? $e8a20caf1e04623f$var$styles.pillContainerSelected : $e8a20caf1e04623f$var$styles.pillContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, visibleIcons.map((icon, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                key: index,
                xcss: $e8a20caf1e04623f$var$styles.iconItem
            }, icon)), remainingCount > 0 && !ghostIconRow.shouldHideOverflowCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e8a20caf1e04623f$var$styles.remainingCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "medium"
        }, "+", remainingCount)), ghostIconRow.isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ba5a522f3921255$export$a99469ff008e0788), {
            icons: ghostIconNodes,
            label: formatMessage((0, $18413269ea167174$export$defe85febe8b728c).ghostIconsLabel),
            waveCount: shouldAnimate ? 3 : 0,
            iconOpacity: 0.5
        }))));
    }, [
        filteredApps,
        markSourceIconLoaded,
        webSearchConfigEnabled,
        webSearchEnabled,
        disabledTooltip,
        formatMessage,
        isPillSelected,
        isStrictSourceModeEnabled,
        ghostIconRow,
        ghostConnectors,
        shouldAnimate,
        shouldRenderGhostIcons
    ]);
    const dismissAgentSourceControlSpotlight = (0, $cozmU.useCallback)((source)=>{
        onDismissAgentSourceControlSpotlight?.(source);
    }, [
        onDismissAgentSourceControlSpotlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a20caf1e04623f$var$ClientSideOnly, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e8a20caf1e04623f$var$FilterByAppsSelectorMenu, {
        onOpenChange: onPillOpenChange,
        enableAppsDiscoveryUi: enableAppsDiscoveryUi,
        shouldRenderInPortal: shouldRenderInPortal,
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...props })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $e8a20caf1e04623f$var$styles.spotlightWrapper,
                "data-spotlight-wrapper": true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                onClick: (e)=>{
                    if (isDisabled) return;
                    handleSourcesPillClick();
                    sendAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'pill',
                        actionSubjectId: 'filterByAppsSourcesPill',
                        attributes: {
                            appSources: filteredApps.map((app_2)=>app_2.friendlyName),
                            webSearchEnabled: webSearchEnabled
                        }
                    });
                    onClick?.(e);
                },
                ...props,
                ref: triggerRef,
                isDisabled: isDisabled,
                "aria-disabled": isDisabled || undefined,
                xcss: isDisabled ? $e8a20caf1e04623f$var$styles.pillPressableDisabled : $e8a20caf1e04623f$var$styles.pillPressable,
                "data-spotlight-target": "rovo-chat-web-search-spotlight-target"
            }, filteredAppsIcons), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                id: "rovo-chat-web-search-spotlight",
                xcss: $e8a20caf1e04623f$var$styles.spotlightContainer
            }, webSearchEnabled && webSearchConfigEnabled && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            (0, $cXtTj.default).getExperimentValue('rovo_web_search_default_on', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9ca12ddb32894ba$export$a7d6c8ff3b3b89d2), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63676e71fabd2bc0$export$ff815d78bbb5387b), {
                isVisible: showAgentSourceControlSpotlight,
                onDismiss: dismissAgentSourceControlSpotlight,
                postOfficeMessage: sourceControlPostOfficeMessage
            }));
        },
        orgKnowledge: orgKnowledge,
        assistanceServiceParams: assistanceServiceParams,
        oauthSource: oauthSource,
        oauthSurface: contentContext,
        onAppConnectClick: handleGhostConnectClick,
        onOrgKnowledgeToggle: (updatedOrgKnowledge)=>{
            if (updatedOrgKnowledge.filteredApps.length === 0) {
                setOrgKnowledge(chatModeKey, 'disabled');
                onOrgKnowledgeToggle?.(false);
                onFilteredAppsChange?.([]);
            } else {
                setOrgKnowledge(chatModeKey, updatedOrgKnowledge);
                onOrgKnowledgeToggle?.(true);
                onFilteredAppsChange?.(updatedOrgKnowledge.filteredApps);
            }
        },
        webSearchEnabled: webSearchEnabled,
        onWebSearchToggle: webSearchConfigEnabled ? (enabled)=>{
            setWebSearchEnabled(chatModeKey, enabled);
            onWebSearchToggle?.(enabled);
        } : undefined,
        orgKnowledgeEnabled: orgKnowledge !== 'disabled',
        onOrgKnowledgeEnabled: (enabled_0)=>{
            if (enabled_0) {
                setOrgKnowledge(chatModeKey, {
                    filteredApps: allConnectedApps
                });
                onOrgKnowledgeToggle?.(true);
                onFilteredAppsChange?.(allConnectedApps);
            } else {
                setOrgKnowledge(chatModeKey, 'disabled');
                onOrgKnowledgeToggle?.(false);
                onFilteredAppsChange?.([]);
            }
        },
        sourceMode: sourceMode,
        onSourceModeChange: (updatedSourceMode)=>{
            setSourceMode(chatModeKey, updatedSourceMode);
        },
        showSourceModeToggle: showSourceModeToggle
    }));
};
const $e8a20caf1e04623f$var$MENU_FIXED_WIDTH = 360;
const $e8a20caf1e04623f$var$FilterByAppsSelectorMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { trigger: trigger, orgKnowledge: orgKnowledge, assistanceServiceParams: assistanceServiceParams, onOrgKnowledgeToggle: onOrgKnowledgeToggle, webSearchEnabled: webSearchEnabled, onWebSearchToggle: onWebSearchToggle, orgKnowledgeEnabled: orgKnowledgeEnabled, onOrgKnowledgeEnabled: onOrgKnowledgeEnabled, sourceMode: sourceMode, onSourceModeChange: onSourceModeChange, onOpenChange: onOpenChange, oauthSource: oauthSource, oauthSurface: oauthSurface, onAppConnectClick: onAppConnectClick, placement: placement, enableAppsDiscoveryUi: enableAppsDiscoveryUi, showSourceModeToggle: showSourceModeToggle, shouldRenderInPortal: t1 } = t0;
    const shouldRenderInPortal = t1 === undefined ? false : t1;
    const t2 = !shouldRenderInPortal;
    const t3 = placement || "top-start";
    let t4;
    if ($[0] !== onOpenChange) {
        t4 = (attrs)=>{
            onOpenChange?.(attrs.isOpen);
        };
        $[0] = onOpenChange;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== orgKnowledge) {
        t5 = orgKnowledge.filteredApps ?? [];
        $[2] = orgKnowledge;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== onOrgKnowledgeToggle) {
        t6 = (apps)=>{
            onOrgKnowledgeToggle({
                filteredApps: apps
            });
        };
        $[4] = onOrgKnowledgeToggle;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== assistanceServiceParams || $[7] !== enableAppsDiscoveryUi || $[8] !== oauthSource || $[9] !== oauthSurface || $[10] !== onAppConnectClick || $[11] !== onOrgKnowledgeEnabled || $[12] !== onSourceModeChange || $[13] !== onWebSearchToggle || $[14] !== orgKnowledgeEnabled || $[15] !== showSourceModeToggle || $[16] !== sourceMode || $[17] !== t5 || $[18] !== t6 || $[19] !== webSearchEnabled) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            maxWidth: $e8a20caf1e04623f$var$MENU_FIXED_WIDTH,
            minWidth: $e8a20caf1e04623f$var$MENU_FIXED_WIDTH
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e8a20caf1e04623f$var$styles.popupContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb6cdf8aaf174b1d$export$5b094453ea724a), {
            assistanceServiceParams: assistanceServiceParams,
            oauthSource: oauthSource,
            oauthSurface: oauthSurface,
            onAppConnectClick: onAppConnectClick,
            preservedSelectedApps: t5,
            onChange: t6,
            webSearchEnabled: webSearchEnabled,
            onWebSearchToggle: onWebSearchToggle,
            orgKnowledgeEnabled: orgKnowledgeEnabled,
            onOrgKnowledgeToggle: onOrgKnowledgeEnabled,
            sourceMode: sourceMode,
            onSourceModeChange: onSourceModeChange,
            showSourceModeToggle: showSourceModeToggle,
            showGroupedSectionsWithCounts: true,
            enableAppsDiscoveryUi: enableAppsDiscoveryUi
        })));
        $[6] = assistanceServiceParams;
        $[7] = enableAppsDiscoveryUi;
        $[8] = oauthSource;
        $[9] = oauthSurface;
        $[10] = onAppConnectClick;
        $[11] = onOrgKnowledgeEnabled;
        $[12] = onSourceModeChange;
        $[13] = onWebSearchToggle;
        $[14] = orgKnowledgeEnabled;
        $[15] = showSourceModeToggle;
        $[16] = sourceMode;
        $[17] = t5;
        $[18] = t6;
        $[19] = webSearchEnabled;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t7 || $[25] !== trigger) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            shouldRenderToParent: t2,
            placement: t3,
            trigger: trigger,
            onOpenChange: t4
        }, t7);
        $[21] = t2;
        $[22] = t3;
        $[23] = t4;
        $[24] = t7;
        $[25] = trigger;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
} : ({ trigger: trigger, orgKnowledge: orgKnowledge, assistanceServiceParams: assistanceServiceParams, onOrgKnowledgeToggle: onOrgKnowledgeToggle, webSearchEnabled: webSearchEnabled, onWebSearchToggle: onWebSearchToggle, orgKnowledgeEnabled: orgKnowledgeEnabled, onOrgKnowledgeEnabled: onOrgKnowledgeEnabled, sourceMode: sourceMode, onSourceModeChange: onSourceModeChange, onOpenChange: onOpenChange, oauthSource: oauthSource, oauthSurface: oauthSurface, onAppConnectClick: onAppConnectClick, placement: placement, enableAppsDiscoveryUi: enableAppsDiscoveryUi, showSourceModeToggle: showSourceModeToggle, shouldRenderInPortal: shouldRenderInPortal = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        shouldRenderToParent: !shouldRenderInPortal,
        placement: placement || 'top-start',
        trigger: trigger,
        onOpenChange: (attrs)=>{
            onOpenChange?.(attrs.isOpen);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        maxWidth: $e8a20caf1e04623f$var$MENU_FIXED_WIDTH,
        minWidth: $e8a20caf1e04623f$var$MENU_FIXED_WIDTH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e8a20caf1e04623f$var$styles.popupContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb6cdf8aaf174b1d$export$5b094453ea724a), {
        assistanceServiceParams: assistanceServiceParams,
        oauthSource: oauthSource,
        oauthSurface: oauthSurface,
        onAppConnectClick: onAppConnectClick,
        preservedSelectedApps: orgKnowledge.filteredApps ?? [],
        onChange: (apps)=>{
            onOrgKnowledgeToggle({
                filteredApps: apps
            });
        },
        webSearchEnabled: webSearchEnabled,
        onWebSearchToggle: onWebSearchToggle,
        orgKnowledgeEnabled: orgKnowledgeEnabled,
        onOrgKnowledgeToggle: onOrgKnowledgeEnabled,
        sourceMode: sourceMode,
        onSourceModeChange: onSourceModeChange,
        showSourceModeToggle: showSourceModeToggle,
        showGroupedSectionsWithCounts: true,
        enableAppsDiscoveryUi: enableAppsDiscoveryUi
    }))));
};
function $e8a20caf1e04623f$var$_temp(connector) {
    return connector.isUserOAuthed && (0, $6xccU.is3pApp)(connector.friendlyName);
}
function $e8a20caf1e04623f$var$_temp2(app) {
    return app.source;
}
function $e8a20caf1e04623f$var$_temp3(icon, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: index,
        xcss: $e8a20caf1e04623f$var$styles.iconItem
    }, icon);
}
function $e8a20caf1e04623f$var$_temp4(app_2) {
    return app_2.friendlyName;
}













var $kmQhR = parcelRequire("kmQhR");





var $1LXnB = parcelRequire("1LXnB");




const $d75b6051d08bd783$var$COMPACT_WIDTH_BREAKPOINT = 320;
const $d75b6051d08bd783$var$TINY_WIDTH_BREAKPOINT = 190;
const $d75b6051d08bd783$var$styles = {
    container: "_1mT5xdRAKS"
};
const $d75b6051d08bd783$var$useComponentsEnabled = (0, $gtMdU.isReactCompilerActivePlatform)() ? (chatModeKey)=>{
    const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled } = (0, $7685l.useChatModeStore)(chatModeKey)[0];
    const { orgKnowledge: orgKnowledge, webSearchEnabled: webSearchEnabled } = (0, $7685l.useChatModeStore)(chatModeKey)[0];
    const hasFilteredApps = orgKnowledge !== "disabled" && orgKnowledge.filteredApps.length > 0;
    return Number(deepResearchEnabled) + Number(thinkDeeperEnabled) + Number(webSearchEnabled || hasFilteredApps);
} : (chatModeKey)=>{
    const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled } = (0, $7685l.useChatModeStore)(chatModeKey)[0];
    const { orgKnowledge: orgKnowledge, webSearchEnabled: webSearchEnabled } = (0, $7685l.useChatModeStore)(chatModeKey)[0];
    const hasFilteredApps = orgKnowledge !== 'disabled' && orgKnowledge.filteredApps.length > 0;
    return Number(deepResearchEnabled) + Number(thinkDeeperEnabled) + Number(webSearchEnabled || hasFilteredApps);
};
const $d75b6051d08bd783$export$fb6fc81aa90ac691 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, chatModeKey: chatModeKey } = t0;
    const [space, setSpace] = (0, $cozmU.useState)("compact");
    const [hideLabel, setHideLabel] = (0, $cozmU.useState)(false);
    const numberOfComponentsEnabled = $d75b6051d08bd783$var$useComponentsEnabled(chatModeKey);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (width)=>{
            if (width < $d75b6051d08bd783$var$TINY_WIDTH_BREAKPOINT) setSpace("tiny");
            else if (width < $d75b6051d08bd783$var$COMPACT_WIDTH_BREAKPOINT) setSpace("compact");
            else setSpace("large");
        };
        $[0] = t1;
    } else t1 = $[0];
    const checkWidth = t1;
    let t2;
    let t3;
    if ($[1] !== numberOfComponentsEnabled || $[2] !== space) {
        t2 = ()=>{
            if (space === "tiny") setHideLabel(true);
            else if (space === "compact") setHideLabel(numberOfComponentsEnabled > 1);
            else setHideLabel(false);
        };
        t3 = [
            numberOfComponentsEnabled,
            space
        ];
        $[1] = numberOfComponentsEnabled;
        $[2] = space;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(checkWidth, 50);
        $[5] = t4;
    } else t4 = $[5];
    const throttledSetContainerSpace = t4;
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.WidthObserver), {
            setWidth: throttledSetContainerSpace
        });
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== children || $[8] !== hideLabel) {
        t6 = children(hideLabel);
        $[7] = children;
        $[8] = hideLabel;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $d75b6051d08bd783$var$styles.container,
            grow: "fill"
        }, t5, t6);
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : ({ children: children, chatModeKey: chatModeKey })=>{
    const [space, setSpace] = (0, $cozmU.useState)('compact');
    const [hideLabel, setHideLabel] = (0, $cozmU.useState)(false);
    const numberOfComponentsEnabled = $d75b6051d08bd783$var$useComponentsEnabled(chatModeKey);
    const checkWidth = (0, $cozmU.useCallback)((width)=>{
        if (width < $d75b6051d08bd783$var$TINY_WIDTH_BREAKPOINT) setSpace('tiny');
        else if (width < $d75b6051d08bd783$var$COMPACT_WIDTH_BREAKPOINT) setSpace('compact');
        else setSpace('large');
    }, []);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (space === 'tiny') setHideLabel(true);
        else if (space === 'compact') setHideLabel(numberOfComponentsEnabled > 1);
        else setHideLabel(false);
    }, [
        numberOfComponentsEnabled,
        space
    ]);
    const throttledSetContainerSpace = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))(checkWidth, 50);
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $d75b6051d08bd783$var$styles.container,
        grow: "fill"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.WidthObserver), {
        setWidth: throttledSetContainerSpace
    }), children(hideLabel));
};


















var $kQMBL = parcelRequire("kQMBL");


var $jXXTm = parcelRequire("jXXTm");


var $bggsP = parcelRequire("bggsP");


var $1z5OI = parcelRequire("1z5OI");


var $7vAVv = parcelRequire("7vAVv");


var $iQVBK = parcelRequire("iQVBK");













/* ReasoningModeMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $huzJY = parcelRequire("huzJY");
































const $37bdb5e3249c62c0$var$styles = {
    roundedItem: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn",
    checkmark: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    iconContainerDefault: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _1UtDYzy7kJ",
    iconContainerSelected: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKHjOvk _0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrugozt _1UtDYze5R3"
};
const $37bdb5e3249c62c0$export$7c43dc7b5f7864c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { id: id, title: title, subtitle: subtitle, icon: icon, isSelected: isSelected, isDisabled: t1, lozengeLabel: lozengeLabel, testId: testId, onSelect: onSelect, wrapper: Wrapper } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const t2 = isSelected ? $37bdb5e3249c62c0$var$styles.iconContainerSelected : $37bdb5e3249c62c0$var$styles.iconContainerDefault;
    let t3;
    if ($[0] !== icon || $[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2
        }, icon);
        $[0] = icon;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const t4 = testId ?? `reasoning-mode-menu-item-${id}`;
    let t5;
    if ($[3] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "medium",
            weight: "medium"
        }, title);
        $[3] = title;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== lozengeLabel || $[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t5, lozengeLabel);
        $[5] = lozengeLabel;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== subtitle) {
        t7 = subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "regular",
            color: "color.text.subtle"
        }, subtitle);
        $[8] = subtitle;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, t6, t7);
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== isSelected) {
        t9 = isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $37bdb5e3249c62c0$var$styles.checkmark
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: ""
        }));
        $[13] = isSelected;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t8 || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between",
            space: "space.200"
        }, t8, t9);
        $[15] = t8;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== isDisabled || $[19] !== isSelected || $[20] !== onSelect || $[21] !== t10 || $[22] !== t3 || $[23] !== t4) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $37bdb5e3249c62c0$var$styles.roundedItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            role: "menuitemradio",
            "aria-checked": isSelected,
            isDisabled: isDisabled,
            onClick: onSelect,
            iconBefore: t3,
            testId: t4
        }, t10));
        $[18] = isDisabled;
        $[19] = isSelected;
        $[20] = onSelect;
        $[21] = t10;
        $[22] = t3;
        $[23] = t4;
        $[24] = t11;
    } else t11 = $[24];
    const content = t11;
    if (Wrapper) {
        let t12;
        if ($[25] !== Wrapper || $[26] !== content || $[27] !== isSelected) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
                isSelected: isSelected
            }, content);
            $[25] = Wrapper;
            $[26] = content;
            $[27] = isSelected;
            $[28] = t12;
        } else t12 = $[28];
        return t12;
    }
    return content;
} : ({ id: id, title: title, subtitle: subtitle, icon: icon, isSelected: isSelected, isDisabled: isDisabled = false, lozengeLabel: lozengeLabel, testId: testId, onSelect: onSelect, wrapper: Wrapper })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $37bdb5e3249c62c0$var$styles.roundedItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        role: "menuitemradio",
        "aria-checked": isSelected,
        isDisabled: isDisabled,
        onClick: onSelect,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: isSelected ? $37bdb5e3249c62c0$var$styles.iconContainerSelected : $37bdb5e3249c62c0$var$styles.iconContainerDefault
        }, icon),
        testId: testId ?? `reasoning-mode-menu-item-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, title), lozengeLabel), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "regular",
        color: "color.text.subtle"
    }, subtitle)), isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $37bdb5e3249c62c0$var$styles.checkmark
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: ""
    })))));
    if (Wrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        isSelected: isSelected
    }, content);
    return content;
};


const $8a0b31232e120fcb$var$styles = {
    menuContainer: "_4c065U2ADO _2Y7lL42ADO",
    heading: "_0Of8r21Y8M",
    footer: "_22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0Of8r21Y8M _3138421Y8M"
};
const $8a0b31232e120fcb$export$4bc6d65b94cbeeb4 = ({ triggerLabel: triggerLabel, triggerIcon: triggerIcon, triggerTestId: triggerTestId = 'reasoning-mode-menu-trigger', items: items, isDisabled: isDisabled = false, isOpen: isOpenProp, onOpenChange: onOpenChangeProp, placement: placement = 'top-start', shouldRenderToParent: shouldRenderToParent = true, menuWidth: menuWidth = 360, renderFooter: renderFooter, headingLabel: headingLabel, triggerWrapper: TriggerWrapper })=>{
    const isControlled = isOpenProp !== undefined;
    const [isLocalOpen, setIsLocalOpen] = (0, $cozmU.useState)(false);
    const isControlledRef = (0, $cozmU.useRef)(isControlled);
    isControlledRef.current = isControlled;
    const isOpen = isControlled ? isOpenProp : isLocalOpen;
    const onOpenChange = (0, $cozmU.useCallback)((attrs)=>{
        if (!isControlledRef.current) setIsLocalOpen(attrs.isOpen);
        onOpenChangeProp?.(attrs);
    }, [
        onOpenChangeProp
    ]);
    const wrappedItems = (0, $cozmU.useMemo)(()=>items.map((item)=>({
                ...item,
                onSelect: ()=>{
                    item.onSelect();
                    onOpenChange({
                        isOpen: false
                    });
                }
            })), [
        items,
        onOpenChange
    ]);
    const trigger = (0, $cozmU.useCallback)(({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>{
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            ...triggerProps,
            ref: triggerRef,
            appearance: "subtle",
            iconBefore: triggerIcon,
            isDisabled: isDisabled,
            onClick: onClick,
            testId: triggerTestId
        }, triggerLabel);
        if (TriggerWrapper) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TriggerWrapper, null, button);
        return button;
    }, [
        TriggerWrapper,
        isDisabled,
        triggerIcon,
        triggerLabel,
        triggerTestId
    ]);
    const footerContent = renderFooter?.();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        trigger: trigger,
        label: headingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        maxWidth: menuWidth,
        minWidth: menuWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a0b31232e120fcb$var$styles.menuContainer
    }, headingLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a0b31232e120fcb$var$styles.heading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huzJY.default), {
        "aria-hidden": true
    }, headingLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, wrappedItems.map((item_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37bdb5e3249c62c0$export$7c43dc7b5f7864c6), {
            key: item_0.id,
            ...item_0
        })))) : wrappedItems.map((item_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37bdb5e3249c62c0$export$7c43dc7b5f7864c6), {
            key: item_1.id,
            ...item_1
        })), footerContent != null && footerContent !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a0b31232e120fcb$var$styles.footer
    }, footerContent))));
};






const $2e47962ad26b84ca$export$eae963a56e8eb124 = (0, $kSwu1.defineMessages)({
    autoLabel: {
        id: "ai-mate.chat-input.reasoning-mode-menu.auto.label",
        defaultMessage: "Auto"
    },
    fastLabel: {
        id: "ai-mate.chat-input.reasoning-mode-menu.fast.label",
        defaultMessage: "Quick"
    },
    fastTitle: {
        id: "ai-mate.chat-input.reasoning-mode-menu.fast.title",
        defaultMessage: "Quick answers"
    },
    fastDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.fast.description",
        defaultMessage: "Faster replies with lighter reasoning"
    },
    thinkingLabel: {
        id: "ai-mate.chat-input.reasoning-mode-menu.thinking.label",
        defaultMessage: "Thinking"
    },
    researchingLabel: {
        id: "ai-mate.chat-input.reasoning-mode-menu.researching.label",
        defaultMessage: "Researching"
    },
    menuTriggerTooltip: {
        id: "ai-mate.chat-input.reasoning-mode-menu.trigger.tooltip",
        defaultMessage: "Change reasoning mode"
    },
    autoTitle: {
        id: "ai-mate.chat-input.reasoning-mode-menu.auto.title",
        defaultMessage: "Let Rovo decide"
    },
    autoDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.auto.description",
        defaultMessage: "Rovo picks reasoning for the job"
    },
    thinkDeeperTitle: {
        id: "ai-mate.chat-input.reasoning-mode-menu.think-deeper.title",
        defaultMessage: "Think deeper"
    },
    thinkDeeperDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.think-deeper.description",
        defaultMessage: "Longer thinking for robust responses"
    },
    thinkDeeperMarathonTitle: {
        id: "ai-mate.chat-input.reasoning-mode-menu.think-deeper-marathon.title",
        defaultMessage: "Think deeper (Marathon)"
    },
    thinkDeeperMarathonDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.think-deeper-marathon.description",
        defaultMessage: "Try Rovo's marathon agent"
    },
    thinkDeeperOrchestratorTitle: {
        id: "ai-mate.chat-input.reasoning-mode-menu.think-deeper-orchestrator.title",
        defaultMessage: "Think deeper (Orchestrator)"
    },
    thinkDeeperOrchestratorDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.think-deeper-orchestrator.description",
        defaultMessage: "Try Rovo's new long orchestrator"
    },
    deepResearchTitle: {
        id: "ai-mate.chat-input.reasoning-mode-menu.deep-research.title",
        defaultMessage: "Deep Research"
    },
    deepResearchDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.deep-research.description",
        defaultMessage: "Synthesize insights and create reports"
    },
    taskLabel: {
        id: "ai-mate.chat-input.reasoning-mode-menu.task.label",
        defaultMessage: "Max"
    },
    taskTitle: {
        id: "ai-mate.chat-input.reasoning-mode-menu.task.title",
        defaultMessage: "Max"
    },
    taskDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.task.description",
        defaultMessage: "The smartest way to get work done"
    },
    taskModeDescription: {
        id: "ai-mate.chat-input.reasoning-mode-menu.task.mode.description",
        defaultMessage: "The do-it-all mode for complex, evolving work"
    },
    taskModeDescriptionRefresh: {
        id: "ai-mate.chat-input.reasoning-mode-menu.task.mode.description.refresh",
        defaultMessage: "Tackles complex work across your tools"
    },
    deepResearchAddMenuDisabledTooltip: {
        id: "ai-mate.chat-input.reasoning-mode-menu.deep-research-add-menu-disabled-tooltip",
        defaultMessage: "Rovo auto-selects the appropriate reasoning mode for deep research"
    },
    agentDisabledTooltip: {
        id: "ai-mate.chat-input.reasoning-mode-menu.agent-disabled-tooltip",
        defaultMessage: "Reasoning mode is only available when chatting with Rovo."
    },
    lozengeAlpha: {
        id: "ai-mate.chat-input.reasoning-mode-menu.lozenge.alpha",
        defaultMessage: "Alpha"
    },
    lozengeNew: {
        id: "ai-mate.chat-input.reasoning-mode-menu.lozenge.new",
        defaultMessage: "New"
    }
});














const $e685d56b198bdec5$var$compiledStyles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDJg58 _23rrnHWbNi _1mT5xdRAKS _2YgrGrP0S5",
    transparentButton: "_0ubfYRjOvk _0rushMjOvk _3Wqv1NjOvk",
    darkText: "_4keetJe5R3 _4iinwie5R3 _3VB8wbe5R3",
    overlay: "_49OCfRdnbC _0bjKvDJg58 _1mT5xdWVPG _42Yu6BvQQr _1pp6NdYbGa"
}; /* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */ 
// Use token for glow color so it adapts to light/dark mode
const $e685d56b198bdec5$var$getGlow = ()=>`radial-gradient(140px circle at var(--spotlight-x, 50%) var(--spotlight-y, 50%), ${"var(--ds-background-neutral-bold-hovered, #3B3D42)"}, transparent 70%)`;
const $e685d56b198bdec5$export$633d1a9585f96cfe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children } = t0;
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setIsHovered(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleMouseEnter = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsHovered(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleMouseLeave = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (e)=>{
            const container = containerRef.current;
            if (!container) return;
            const rect = container.getBoundingClientRect();
            container.style.setProperty("--spotlight-x", `${e.clientX - rect.left}px`);
            container.style.setProperty("--spotlight-y", `${e.clientY - rect.top}px`);
        };
        $[2] = t3;
    } else t3 = $[2];
    const handleMouseMove = t3;
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            backgroundColor: "var(--ds-background-neutral-bold, #292A2E)"
        };
        t5 = (0, $hekY6.default)([
            $e685d56b198bdec5$var$compiledStyles.container,
            $e685d56b198bdec5$var$compiledStyles.transparentButton,
            $e685d56b198bdec5$var$compiledStyles.darkText
        ]);
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    let t6;
    if ($[5] !== isHovered) {
        t6 = isHovered && /*#__PURE__*/ $cozmU.createElement("div", {
            style: {
                background: $e685d56b198bdec5$var$getGlow()
            },
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $e685d56b198bdec5$var$compiledStyles.overlay
            ])
        });
        $[5] = isHovered;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== children || $[8] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "group",
            ref: containerRef,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: $e685d56b198bdec5$var$_temp,
            onBlur: $e685d56b198bdec5$var$_temp2,
            onMouseMove: handleMouseMove,
            style: t4,
            className: t5
        }, t6, children);
        $[7] = children;
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    return t7;
} : ({ children: children })=>{
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)(null);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const handleMouseMove = (0, $cozmU.useCallback)((e)=>{
        const container = containerRef.current;
        if (!container) return;
        const rect = container.getBoundingClientRect();
        container.style.setProperty('--spotlight-x', `${e.clientX - rect.left}px`);
        container.style.setProperty('--spotlight-y', `${e.clientY - rect.top}px`);
    }, []);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "group",
        ref: containerRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: ()=>{},
        onBlur: ()=>{},
        onMouseMove: handleMouseMove,
        style: {
            backgroundColor: "var(--ds-background-neutral-bold, #292A2E)"
        },
        className: (0, $hekY6.default)([
            $e685d56b198bdec5$var$compiledStyles.container,
            $e685d56b198bdec5$var$compiledStyles.transparentButton,
            $e685d56b198bdec5$var$compiledStyles.darkText
        ])
    }, isHovered && /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            background: $e685d56b198bdec5$var$getGlow()
        },
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $e685d56b198bdec5$var$compiledStyles.overlay
        ])
    }), children);
};
function $e685d56b198bdec5$var$_temp() {}
function $e685d56b198bdec5$var$_temp2() {}














const $ae093f0719192b7d$var$compiledStyles = {
    taskTrigger: "_0bjKvDZimw _0KLXrugozt _0ubfYRjOvk _0RxVZVe5R3 _2N3XpSe5R3 _14SrI5e5R3 _1owRsSZimw _0rushMkTlo"
}; /* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors */ 
const $ae093f0719192b7d$export$a836d22c208e0b06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $ae093f0719192b7d$var$compiledStyles.taskTrigger
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ae093f0719192b7d$var$compiledStyles.taskTrigger
        ])
    }, children);


const $de38fcda73e53a53$var$styles = {
    menuWrapper: "_0adFHs1Y8M"
};
const $de38fcda73e53a53$var$lozengeChipStyles = {
    chip: "_0bjKvDKxmn _2Y7lL41Y8M _0KLXruqjHC _3iDTPbccYA _0hPCNLDIqT"
}; /**
    * Renders a styled lozenge chip matching the original ChatModeToggleMenuItem's
    * alphaChip style (purple background, white bold text).
    */ 
const $de38fcda73e53a53$var$LozengeChip = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $de38fcda73e53a53$var$lozengeChipStyles.chip
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== label) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "bold",
            color: "color.text.inverse"
        }, label));
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $de38fcda73e53a53$var$lozengeChipStyles.chip
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "bold",
        color: "color.text.inverse"
    }, label)); // Icon components keyed by reasoning mode — used for the trigger pill icon
const $de38fcda73e53a53$var$getReasoningModeIcon = (mode)=>{
    switch(mode){
        case 'auto':
            return 0, (/*@__PURE__*/$parcel$interopDefault($bggsP));
        case 'fast':
            return 0, (/*@__PURE__*/$parcel$interopDefault($7vAVv));
        case 'think-deeper':
        case 'think-deeper-marathon':
        case 'think-deeper-orchestrator':
            return 0, (/*@__PURE__*/$parcel$interopDefault($kQMBL));
        case 'deep-research':
            return 0, (/*@__PURE__*/$parcel$interopDefault($1z5OI));
        case 'task':
            return 0, (/*@__PURE__*/$parcel$interopDefault($jXXTm));
    }
};
const $de38fcda73e53a53$export$4bc6d65b94cbeeb4 = ({ chatModeState: chatModeState, onReasoningModeChange: onReasoningModeChange, renderAutoApplyToggle: renderAutoApplyToggle, isDisabled: isDisabled, enableMaxMode: enableMaxMode = true, disabledTooltip: disabledTooltip, placement: placement, onMenuOpen: onMenuOpen, onMenuOpenChange: onMenuOpenChange, shouldRenderInPortal: shouldRenderInPortal = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { reasoningMode: reasoningMode } = chatModeState;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false); // Avoid inheriting stale task mode state when Max mode is disabled.
    const allowedReasoningMode = reasoningMode === 'task' && !enableMaxMode ? 'auto' : reasoningMode; // When the tasks flag is on, DR is selected from the add menu and runs
    // silently — the pill should show "Auto" rather than "Researching".
    const isDeepResearchAsAddMenuMode = allowedReasoningMode === 'deep-research' && (0, $iDrrr.fg)('rovo_chat_enable_tasks');
    const pillReasoningMode = isDeepResearchAsAddMenuMode ? 'auto' : allowedReasoningMode;
    const triggerLabel = formatMessage(pillReasoningMode === 'fast' ? (0, $2e47962ad26b84ca$export$eae963a56e8eb124).fastLabel : pillReasoningMode === 'think-deeper' || pillReasoningMode === 'think-deeper-marathon' || pillReasoningMode === 'think-deeper-orchestrator' ? (0, $2e47962ad26b84ca$export$eae963a56e8eb124).thinkingLabel : pillReasoningMode === 'deep-research' ? (0, $2e47962ad26b84ca$export$eae963a56e8eb124).researchingLabel : pillReasoningMode === 'task' ? (0, $2e47962ad26b84ca$export$eae963a56e8eb124).taskLabel : (0, $2e47962ad26b84ca$export$eae963a56e8eb124).autoLabel);
    const TriggerIcon = $de38fcda73e53a53$var$getReasoningModeIcon(pillReasoningMode); // Feature gate checks — these are AI Mate–specific and stay here
    const isTDSupportedWithTenant = (0, $iDrrr.fg)('rovo_chat_exclude_atlassian_hosted_models_orgs');
    const isExtendedThinkingVariantsEnabled = (0, $iDrrr.fg)('rovo_chat_marathon_orchestrator_reasoning_modes');
    const isTaskModeEnabled = (0, $iDrrr.fg)('rovo_chat_enable_tasks') && enableMaxMode;
    const isTaskModeDesignRefresh = (0, $iDrrr.fg)('rovo_chat_task_mode_design_refresh');
    const isTaskTrigger = isTaskModeDesignRefresh && allowedReasoningMode === 'task'; // Build the items array — feature gates + analytics + i18n all owned here
    const items = (0, $cozmU.useMemo)(()=>{
        const makeOnSelect = (mode, analyticsSubjectId)=>()=>{
                onReasoningModeChange(mode);
                sendAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: analyticsSubjectId
                });
            };
        const result = [
            {
                id: 'auto',
                title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).autoTitle),
                subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).autoDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bggsP))), {
                    spacing: "spacious",
                    label: ""
                }),
                isSelected: allowedReasoningMode === 'auto',
                isDisabled: false,
                onSelect: makeOnSelect('auto', 'rovoChatAutoReasoningButton')
            },
            {
                id: 'fast',
                title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).fastTitle),
                subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).fastDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))), {
                    spacing: "spacious",
                    label: ""
                }),
                isSelected: allowedReasoningMode === 'fast',
                isDisabled: false,
                onSelect: makeOnSelect('fast', 'rovoChatFastModeButton')
            },
            {
                id: 'think-deeper',
                title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).thinkDeeperTitle),
                subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).thinkDeeperDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kQMBL))), {
                    spacing: "spacious",
                    label: ""
                }),
                isSelected: allowedReasoningMode === 'think-deeper',
                isDisabled: !isTDSupportedWithTenant,
                onSelect: makeOnSelect('think-deeper', 'rovoChatThinkDeeperButton')
            }
        ];
        if (isExtendedThinkingVariantsEnabled) result.push({
            id: 'think-deeper-marathon',
            title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).thinkDeeperMarathonTitle),
            subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).thinkDeeperMarathonDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kQMBL))), {
                spacing: "spacious",
                label: ""
            }),
            isSelected: allowedReasoningMode === 'think-deeper-marathon',
            isDisabled: false,
            lozengeLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de38fcda73e53a53$var$LozengeChip, {
                label: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).lozengeAlpha)
            }),
            onSelect: makeOnSelect('think-deeper-marathon', 'rovoChatThinkDeeperMarathonButton')
        }, {
            id: 'think-deeper-orchestrator',
            title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).thinkDeeperOrchestratorTitle),
            subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).thinkDeeperOrchestratorDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kQMBL))), {
                spacing: "spacious",
                label: ""
            }),
            isSelected: allowedReasoningMode === 'think-deeper-orchestrator',
            isDisabled: false,
            lozengeLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de38fcda73e53a53$var$LozengeChip, {
                label: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).lozengeAlpha)
            }),
            onSelect: makeOnSelect('think-deeper-orchestrator', 'rovoChatThinkDeeperOrchestratorButton')
        });
        if (!isTaskModeEnabled) result.push({
            id: 'deep-research',
            title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).deepResearchTitle),
            subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).deepResearchDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1z5OI))), {
                spacing: "spacious",
                label: ""
            }),
            isSelected: allowedReasoningMode === 'deep-research',
            isDisabled: false,
            onSelect: makeOnSelect('deep-research', 'rovoChatDeepResearchButton')
        });
        if (isTaskModeEnabled) {
            if (isTaskModeDesignRefresh) result.push({
                id: 'task',
                title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).taskTitle),
                subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).taskModeDescriptionRefresh),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXXTm))), {
                    spacing: "spacious",
                    label: ""
                }),
                isSelected: allowedReasoningMode === 'task',
                isDisabled: false,
                lozengeLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de38fcda73e53a53$var$LozengeChip, {
                    label: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).lozengeNew)
                }),
                onSelect: makeOnSelect('task', 'rovoChatTaskModeButton'),
                wrapper: (0, $e685d56b198bdec5$export$633d1a9585f96cfe)
            });
            else result.push({
                id: 'task',
                title: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).taskTitle),
                subtitle: formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).taskModeDescription),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iQVBK))), {
                    spacing: "spacious",
                    label: ""
                }),
                isSelected: allowedReasoningMode === 'task',
                isDisabled: false,
                onSelect: makeOnSelect('task', 'rovoChatTaskModeButton')
            });
        }
        return result;
    }, [
        allowedReasoningMode,
        formatMessage,
        isExtendedThinkingVariantsEnabled,
        isTDSupportedWithTenant,
        isTaskModeDesignRefresh,
        isTaskModeEnabled,
        onReasoningModeChange,
        sendAnalyticsEvent
    ]);
    const onOpenChange = (0, $cozmU.useCallback)(({ isOpen: open })=>{
        setIsOpen(open);
        onMenuOpenChange?.(open);
        if (open) {
            onMenuOpen?.();
            sendAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'rovoChatReasoningModeMenuTrigger'
            });
            sendAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'menu',
                actionSubjectId: 'rovoChatReasoningModeMenu'
            });
        }
    }, [
        onMenuOpen,
        onMenuOpenChange,
        sendAnalyticsEvent
    ]); // Keep a ref so TooltipTriggerWrapper can always read the latest value without being recreated.
    const disabledTooltipRef = (0, $cozmU.useRef)(disabledTooltip);
    disabledTooltipRef.current = disabledTooltip; // Stable component type (empty deps) — reads from ref to avoid recreating on each change.
    const TooltipTriggerWrapper = (0, $cozmU.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: disabledTooltipRef.current
            }, children), // eslint-disable-next-line react-hooks/exhaustive-deps
    []); // Priority: disabled tooltip > task mode > none.
    const TriggerWrapper = (0, $cozmU.useMemo)(()=>{
        if (isDisabled && disabledTooltip) return TooltipTriggerWrapper;
        if (isTaskTrigger) return 0, $ae093f0719192b7d$export$a836d22c208e0b06;
        return undefined;
    }, [
        isDisabled,
        disabledTooltip,
        isTaskTrigger,
        TooltipTriggerWrapper
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $de38fcda73e53a53$var$styles.menuWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a0b31232e120fcb$export$4bc6d65b94cbeeb4), {
        triggerLabel: triggerLabel,
        triggerIcon: TriggerIcon,
        triggerTestId: "reasoning-mode-menu-trigger",
        items: items,
        isDisabled: isDisabled,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement || 'top-end',
        shouldRenderToParent: !shouldRenderInPortal,
        renderFooter: renderAutoApplyToggle,
        headingLabel: formatMessage((0, $e50ecf229d50e279$export$defe85febe8b728c).reasoningSectionTitle),
        triggerWrapper: TriggerWrapper
    }));
};



















var $f6cdQ = parcelRequire("f6cdQ");


var $1pTZX = parcelRequire("1pTZX");







const $904e70f09b35e298$var$_default_1 = (0, $kSwu1.defineMessages)({
    sendButtonLabel: {
        id: "ai-mate.chat-input.send-button.label",
        defaultMessage: "Submit"
    },
    stopGeneratingButtonLabel: {
        id: "ai-mate.chat-input.stop-generating-button.label",
        defaultMessage: "Stop generating"
    }
});
var $904e70f09b35e298$export$2e2bcd8739ae039 = $904e70f09b35e298$var$_default_1;


const $8a90455e56c91900$export$41daf28bb61ded76 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { isAgentTyping: isAgentTyping, isSendDisabled: isSendDisabled, promptDraftAndModeKey: promptDraftAndModeKey, submitButtonTooltip: submitButtonTooltip, tooltipOptions: tooltipOptions, onSave: onSave, onAbort: onAbort, getChatMode: getChatMode } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== isAgentTyping || $[1] !== isSendDisabled) {
        t1 = isAgentTyping && !isSendDisabled && (0, $iDrrr.fg)("rovo_chat_message_queue");
        $[0] = isAgentTyping;
        $[1] = isSendDisabled;
        $[2] = t1;
    } else t1 = $[2];
    const showSubmitInsteadOfStop = t1;
    let t2;
    if ($[3] !== formatMessage || $[4] !== getChatMode || $[5] !== isAgentTyping || $[6] !== isSendDisabled || $[7] !== onAbort || $[8] !== onSave || $[9] !== promptDraftAndModeKey || $[10] !== showSubmitInsteadOfStop || $[11] !== submitButtonTooltip || $[12] !== tooltipOptions) {
        t2 = isAgentTyping && !showSubmitInsteadOfStop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            onClick: (_, e)=>{
                onAbort(getChatMode(promptDraftAndModeKey), e);
            },
            icon: $8a90455e56c91900$var$_temp,
            label: formatMessage((0, $904e70f09b35e298$export$2e2bcd8739ae039).stopGeneratingButtonLabel)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            isTooltipDisabled: false,
            tooltip: submitButtonTooltip ? tooltipOptions : undefined,
            appearance: "primary",
            onClick: onSave,
            type: "submit",
            isDisabled: isSendDisabled,
            interactionName: "ai-mate.send-message-button",
            icon: $8a90455e56c91900$var$_temp2,
            label: submitButtonTooltip ? submitButtonTooltip : formatMessage((0, $904e70f09b35e298$export$2e2bcd8739ae039).sendButtonLabel)
        });
        $[3] = formatMessage;
        $[4] = getChatMode;
        $[5] = isAgentTyping;
        $[6] = isSendDisabled;
        $[7] = onAbort;
        $[8] = onSave;
        $[9] = promptDraftAndModeKey;
        $[10] = showSubmitInsteadOfStop;
        $[11] = submitButtonTooltip;
        $[12] = tooltipOptions;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
} : ({ isAgentTyping: isAgentTyping, isSendDisabled: isSendDisabled, promptDraftAndModeKey: promptDraftAndModeKey, submitButtonTooltip: submitButtonTooltip, tooltipOptions: tooltipOptions, onSave: onSave, onAbort: onAbort, getChatMode: getChatMode })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showSubmitInsteadOfStop = isAgentTyping && !isSendDisabled && (0, $iDrrr.fg)('rovo_chat_message_queue');
    return isAgentTyping && !showSubmitInsteadOfStop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        onClick: (_, e)=>{
            onAbort(getChatMode(promptDraftAndModeKey), e);
        },
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                ...iconProps,
                color: "var(--ds-icon-danger, #C9372C)",
                label: ''
            }),
        label: formatMessage((0, $904e70f09b35e298$export$2e2bcd8739ae039).stopGeneratingButtonLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        tooltip: submitButtonTooltip ? tooltipOptions : undefined,
        appearance: "primary",
        onClick: onSave,
        type: "submit",
        isDisabled: isSendDisabled,
        interactionName: "ai-mate.send-message-button",
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
                ...iconProps_0,
                label: ''
            }),
        label: submitButtonTooltip ? submitButtonTooltip : formatMessage((0, $904e70f09b35e298$export$2e2bcd8739ae039).sendButtonLabel)
    });
};
function $8a90455e56c91900$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        ...iconProps,
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    });
}
function $8a90455e56c91900$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
        ...iconProps_0,
        label: ""
    });
}





























const $72b15252e718d034$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    deepResearchTagLabel: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.deep-research-tag.deepResearchTagLabel",
        defaultMessage: "Deep research"
    },
    deepResearchTagDismissLabel: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.deep-research-tag.deepResearchTagDismissLabel",
        defaultMessage: "Remove deep research"
    },
    agentDisabledTooltip: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.deep-research-tag.agentDisabledTooltip",
        defaultMessage: "Deep Research is only available when chatting with Rovo."
    }
});


const $e6c2d4ad6502919e$var$tagStyles = null;
const $e6c2d4ad6502919e$var$dismissButtonStyles = null;
const $e6c2d4ad6502919e$export$a34759a6f8815868 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { onDismiss: onDismiss, isDisabled: isDisabled, disabledTooltip: disabledTooltip } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2mHwu81Y8M _0bjKvDKxmn _2sNsIg7NXe _4c065U1Y8M _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _0hPCNLDIqT _0LQT5EgVvo _03SyCP1Y8M _0KLXruDMqu _1UtDYzZpcK _1ANEUSLRg7"
        ]);
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1z5OI))), {
            label: "",
            size: "small"
        });
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $72b15252e718d034$export$defe85febe8b728c).deepResearchTagLabel);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage((0, $72b15252e718d034$export$defe85febe8b728c).deepResearchTagDismissLabel);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_2uo31fYbGa _30huDKYbGa _0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0wOv4Q7zJH _1UtDYzZpcK _02aXbK18ZR"
        ]);
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: "",
            size: "small"
        });
        $[6] = t5;
        $[7] = t6;
    } else {
        t5 = $[6];
        t6 = $[7];
    }
    let t7;
    if ($[8] !== isDisabled || $[9] !== onDismiss || $[10] !== t4) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            onClick: onDismiss,
            "aria-label": t4,
            disabled: isDisabled,
            type: "button",
            className: t5
        }, t6);
        $[8] = isDisabled;
        $[9] = onDismiss;
        $[10] = t4;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t3 || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t1
        }, t2, t3, t7);
        $[12] = t3;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    const tag = t8;
    let t9;
    if ($[15] !== disabledTooltip || $[16] !== tag) {
        t9 = disabledTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: disabledTooltip
        }, tag) : tag;
        $[15] = disabledTooltip;
        $[16] = tag;
        $[17] = t9;
    } else t9 = $[17];
    return t9;
} : ({ onDismiss: onDismiss, isDisabled: isDisabled, disabledTooltip: disabledTooltip })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _0bjKvDKxmn _2sNsIg7NXe _4c065U1Y8M _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbccYA _0hPCNLDIqT _0LQT5EgVvo _03SyCP1Y8M _0KLXruDMqu _1UtDYzZpcK _1ANEUSLRg7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1z5OI))), {
        label: "",
        size: "small"
    }), formatMessage((0, $72b15252e718d034$export$defe85febe8b728c).deepResearchTagLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
        onClick: onDismiss,
        "aria-label": formatMessage((0, $72b15252e718d034$export$defe85febe8b728c).deepResearchTagDismissLabel),
        disabled: isDisabled,
        type: "button",
        className: (0, $hekY6.default)([
            "_2uo31fYbGa _30huDKYbGa _0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0wOv4Q7zJH _1UtDYzZpcK _02aXbK18ZR"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "",
        size: "small"
    })));
    return disabledTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: disabledTooltip
    }, tag) : tag;
};
























var $f6wWZ = parcelRequire("f6wWZ");


var $6wOvs = parcelRequire("6wOvs");




const $e78443c7519dc888$var$message = (0, $kSwu1.defineMessages)({
    // keep consistent with /conversation-assistant-content-renderer/src/controllers/editor/messages.ts -> placeholderUpdated
    defaultAssistiveLabel: {
        id: "ai-mate.chat-input.chat-input-start-assistive-label",
        defaultMessage: "Write a prompt, @mentions someone, or use / for actions"
    },
    deepResearchAssistiveLabel: {
        id: "ai-mate.chat-input.chat-input-deep-research-assistive-label",
        defaultMessage: "Get a detailed report"
    },
    deletedAgentIconLabel: {
        id: "ai-mate.chat-input.deleted-agent-icon-label",
        defaultMessage: "Agent deleted"
    },
    deletedAgent: {
        id: "ai-mate.chat-input.deleted-agent-warning",
        defaultMessage: "This Agent has been deleted."
    },
    deletedAgentStartNewChatButton: {
        id: "ai-mate.chat-input.deleted-agent-start-new-chat",
        defaultMessage: "Start new chat"
    },
    dictationListeningLabel: {
        id: "ai-mate.chat-input.dictation-listening-label",
        defaultMessage: "Listening\u2026"
    },
    dictationTranscribingLabel: {
        id: "ai-mate.chat-input.dictation-transcribing-label",
        defaultMessage: "Transcribing"
    },
    agentRoutingFailed: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.agentRoutingFailed",
        defaultMessage: "Agent unavailable. Remove the mention and select the agent again."
    },
    agentRoutingResolving: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.agentRoutingResolving",
        defaultMessage: "Resolving mentioned agent\u2026"
    },
    mentionAgentsSectionSwitch: {
        id: "ai-mate.chat-input.mention-agents-section-switch",
        defaultMessage: "Switch to"
    },
    rovoMentionName: {
        id: "ai-mate.chat-input.rovo-mention-name",
        defaultMessage: "Rovo"
    },
    agentMentionsOnboardingSpotlightTitle: {
        id: "ai-mate.chat-input.agent-mentions-onboarding-spotlight-title",
        defaultMessage: "Invoke agents with @Mentions"
    },
    agentMentionsOnboardingSpotlightBody: {
        id: "ai-mate.chat-input.agent-mentions-onboarding-spotlight-body",
        defaultMessage: "Bring agents into your workflow instantly. Type @ to select an agent and include it in your chat"
    },
    agentMentionsOnboardingSpotlightOk: {
        id: "ai-mate.chat-input.agent-mentions-onboarding-spotlight-ok",
        defaultMessage: "OK"
    },
    agentMentionsOnboardingSpotlightDismissLabel: {
        id: "ai-mate.chat-input.agent-mentions-onboarding-spotlight-dismiss-label",
        defaultMessage: "Dismiss agent mentions onboarding spotlight"
    },
    skillsOnboardingSpotlightTitle: {
        id: "ai-mate.chat-input.skills-onboarding-spotlight-title",
        defaultMessage: "Type / to try a skill"
    },
    skillsOnboardingSpotlightBody: {
        id: "ai-mate.chat-input.skills-onboarding-spotlight-body",
        defaultMessage: "Skills help with specialized workflows and can be assigned to agents. Type / in chat to explore them all."
    },
    skillsOnboardingSpotlightViewSkills: {
        id: "ai-mate.chat-input.skills-onboarding-spotlight-view-skills",
        defaultMessage: "View skills"
    }
});
var $e78443c7519dc888$export$2e2bcd8739ae039 = $e78443c7519dc888$var$message;


const $4e4781d535aac0d4$var$overlayBackgroundStyles = {
    surface: "_0KLXrulfZc",
    'surface-raised': "_0KLXruqi9L",
    'surface-sunken': "_0KLXrunmFW"
};
const $4e4781d535aac0d4$var$styles = {
    overlay: "_1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _1OKFqYdnbC _42Yu6B7dHp",
    label: "_2sNsIgmnOE _1UtDYzKGUX _46hvQmgVvo _0LQT5EgVvo"
};
const $4e4781d535aac0d4$export$68be235c79785025 = (status)=>status === 'recording' || status === 'processing'; /**
                                                                                                                                         * Tracks the current dictation status so the editor can display "Listening"
                                                                                                                                         * or "Transcribing" as either an overlay or a status row.
                                                                                                                                         *
                                                                                                                                         * Lives above the lazy `VoiceEnabledFooterRow` because the status renders
                                                                                                                                         * inside the editor Box, which is a sibling of the footer row.
                                                                                                                                         */ 
const $4e4781d535aac0d4$export$596d2ba8e2799493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [dictationStatus, setDictationStatus] = (0, $cozmU.useState)("idle");
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (status)=>{
            setDictationStatus(status);
        };
        $[0] = t0;
    } else t0 = $[0];
    const handleDictationStatusChange = t0;
    let t1;
    if ($[1] !== dictationStatus) {
        t1 = {
            dictationStatus: dictationStatus,
            handleDictationStatusChange: handleDictationStatusChange
        };
        $[1] = dictationStatus;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [dictationStatus, setDictationStatus] = (0, $cozmU.useState)('idle');
    const handleDictationStatusChange = (0, $cozmU.useCallback)((status)=>{
        setDictationStatus(status);
    }, []);
    return {
        dictationStatus: dictationStatus,
        handleDictationStatusChange: handleDictationStatusChange
    };
};
const $4e4781d535aac0d4$export$56e81c7d50c77896 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { appearance: appearance, status: status, backgroundOverride: t1 } = t0;
    const backgroundOverride = t1 === undefined ? "surface" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!$4e4781d535aac0d4$export$68be235c79785025(status)) return null;
    const t2 = appearance === "overlay" && $4e4781d535aac0d4$var$styles.overlay;
    const t3 = appearance === "overlay" && $4e4781d535aac0d4$var$overlayBackgroundStyles[backgroundOverride];
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $w6R6I.cx)(t2, t3, $4e4781d535aac0d4$var$styles.label);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== formatMessage || $[4] !== status) {
        t5 = status === "recording" ? formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).dictationListeningLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), null, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).dictationTranscribingLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), null)));
        $[3] = formatMessage;
        $[4] = status;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            role: "status",
            xcss: t4,
            testId: "dictation-status-display"
        }, t5);
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ appearance: appearance, status: status, backgroundOverride: backgroundOverride = 'surface' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!$4e4781d535aac0d4$export$68be235c79785025(status)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "status",
        xcss: (0, $w6R6I.cx)(appearance === 'overlay' && $4e4781d535aac0d4$var$styles.overlay, appearance === 'overlay' && $4e4781d535aac0d4$var$overlayBackgroundStyles[backgroundOverride], $4e4781d535aac0d4$var$styles.label),
        testId: "dictation-status-display"
    }, status === 'recording' ? formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).dictationListeningLabel) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wOvs.ShimmerText), null, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).dictationTranscribingLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6wWZ.EllipsesAnimation), null))));
};














/** Slow drifting motion for the three glow blobs — large percentage-based travel */ const $6c4e4cf838e4ce45$var$glowDriftA = null;
const $6c4e4cf838e4ce45$var$glowDriftB = null;
const $6c4e4cf838e4ce45$var$glowDriftC = null; /** One-shot ripple — expanding box-shadow with morphing border-radius */ 
const $6c4e4cf838e4ce45$var$maxRipple = null; /* ────────────────────────────────────────────────────────
                         * Beam keyframes — one per dot opacity level
                         * Each must be a static declaration for @compiled/react
                         * babel plugin to extract at build time.
                         * ──────────────────────────────────────────────────────── */ 
const $6c4e4cf838e4ce45$var$beamTravel100 = null;
const $6c4e4cf838e4ce45$var$beamTravel60 = null;
const $6c4e4cf838e4ce45$var$beamTravel35 = null;
const $6c4e4cf838e4ce45$var$beamTravel20 = null;
const $6c4e4cf838e4ce45$var$beamTravel10 = null; /* ────────────────────────────────────────────────────────
                            * Compiled styles
                            * ──────────────────────────────────────────────────────── */ 
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage -- gradient glow colors and shape tokens have no token equivalent */ const $6c4e4cf838e4ce45$var$compiledStyles = {
    container: "_1mT5xdRAKS",
    glowContainer: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTone0rg _3OE6xYUNDJ _4ApkO2UNDJ _0jFU0V715P _1pp6NdYbGa _2YgrGrP0S5 _1llTr6hyTI _4vaMcN2Cz2 _3X9j4q2Cz2",
    glowBlobBase: "_49OCfRdnbC _1mT5xdWVPG _1sLQ8qC67X _3XR8yiB9zL",
    glowBlobA: "_2uo31fTaqg _1gBibyXsca _0nFVCGJu3I _43vdfTN8t6 _03m2nySHWH",
    glowBlobB: "_2uo31falcI _1gBibytr22 _0nFVCGqNpL _43vdfTN8t6 _03m2nySHWH",
    glowBlobC: "_2uo31fRjuA _1gBibyDaCn _0nFVCG0BiX _43vdfTN8t6 _03m2nySHWH",
    ripple: "_49OCfRdnbC _0bjKvDxpxF _1mT5xdWVPG _1pp6NdYbGa _1gBibyHvD6 _0nFVCGkAo8 _43vdfTHVQb _3Y6bKpgRhm",
    beamContainer: "_49OCfRdnbC _4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _42Yu6BHmys _1pp6NdYbGa",
    beamDotBase: "_0bjKvD6ujj _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0KLXruy7kJ _0nFVCGOecr _43vdfTHVQb _3Y6bKpgRhm",
    beamLead: "_39xV02Zimw _0jFU0VZimw _2OUyjt0Adc _1gBiby06is _1jakNnUaiG",
    beamTrail1: "_39xV02yrFs _0jFU0VyrFs _1llTr6vgF7 _1gBibyMq2y _1jakNnb6Oe",
    beamTrail2: "_39xV02UNDJ _0jFU0VUNDJ _1llTr6uLSA _1gBibywZXu _1jakNnnhlv",
    beamTrail3: "_39xV02UNDJ _0jFU0VUNDJ _1llTr6g2JY _1gBibyg1sh _1jakNnTJH6",
    beamTrail4: "_39xV024Y4b _0jFU0V4Y4b _1llTr6zPGV _1gBibyIdii _1jakNn4dMr"
}; /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 
/* ────────────────────────────────────────────────────────
 * Offset-path inline style (not supported by @compiled/react)
 * ──────────────────────────────────────────────────────── */ const $6c4e4cf838e4ce45$var$beamOffsetStyle = {
    offsetPath: 'inset(0 round 12px)',
    offsetRotate: '0deg',
    offsetDistance: '0%'
}; /* ────────────────────────────────────────────────────────
    * Component
    * ──────────────────────────────────────────────────────── */ 
const $6c4e4cf838e4ce45$export$79e9e288b405a1b8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children, isTaskMode: isTaskMode, shouldKeepPromptMounted: shouldKeepPromptMounted, triggerAnimation: triggerAnimation } = t0;
    const [rippleKey, setRippleKey] = (0, $cozmU.useState)(0);
    const prevTriggerRef = (0, $cozmU.useRef)(triggerAnimation);
    let t1;
    let t2;
    if ($[0] !== isTaskMode || $[1] !== triggerAnimation) {
        t1 = ()=>{
            if (triggerAnimation > prevTriggerRef.current && isTaskMode) setRippleKey($6c4e4cf838e4ce45$var$_temp);
            prevTriggerRef.current = triggerAnimation;
        };
        t2 = [
            triggerAnimation,
            isTaskMode
        ];
        $[0] = isTaskMode;
        $[1] = triggerAnimation;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[4] !== isTaskMode) {
        t3 = ()=>{
            if (!isTaskMode) setRippleKey(0);
        };
        t4 = [
            isTaskMode
        ];
        $[4] = isTaskMode;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const shouldRenderWrapper = shouldKeepPromptMounted || isTaskMode;
    if (!shouldRenderWrapper) {
        let t5;
        if ($[7] !== children) {
            t5 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, children);
            $[7] = children;
            $[8] = t5;
        } else t5 = $[8];
        return t5;
    }
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.container
        ]);
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== isTaskMode) {
        t6 = isTaskMode && /*#__PURE__*/ $cozmU.createElement("div", {
            "aria-hidden": "true",
            "data-testid": "prompt-max-glow",
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.glowContainer
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.glowBlobBase,
                $6c4e4cf838e4ce45$var$compiledStyles.glowBlobA
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.glowBlobBase,
                $6c4e4cf838e4ce45$var$compiledStyles.glowBlobB
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.glowBlobBase,
                $6c4e4cf838e4ce45$var$compiledStyles.glowBlobC
            ])
        }));
        $[10] = isTaskMode;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== rippleKey) {
        t7 = rippleKey > 0 && /*#__PURE__*/ $cozmU.createElement("div", {
            key: `ripple-${rippleKey}`,
            "aria-hidden": "true",
            "data-testid": "prompt-max-ripple",
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.ripple
            ])
        });
        $[12] = rippleKey;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== rippleKey) {
        t8 = rippleKey > 0 && /*#__PURE__*/ $cozmU.createElement("div", {
            key: `beam-${rippleKey}`,
            "aria-hidden": "true",
            "data-testid": "prompt-max-beam",
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.beamContainer
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
                $6c4e4cf838e4ce45$var$compiledStyles.beamTrail4
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
                $6c4e4cf838e4ce45$var$compiledStyles.beamTrail3
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
                $6c4e4cf838e4ce45$var$compiledStyles.beamTrail2
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
                $6c4e4cf838e4ce45$var$compiledStyles.beamTrail1
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
            className: (0, $hekY6.default)([
                $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
                $6c4e4cf838e4ce45$var$compiledStyles.beamLead
            ])
        }));
        $[14] = rippleKey;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== children || $[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, t6, t7, t8, children);
        $[16] = children;
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
} : ({ children: children, isTaskMode: isTaskMode, shouldKeepPromptMounted: shouldKeepPromptMounted, triggerAnimation: triggerAnimation })=>{
    const [rippleKey, setRippleKey] = (0, $cozmU.useState)(0);
    const prevTriggerRef = (0, $cozmU.useRef)(triggerAnimation);
    (0, $cozmU.useEffect)(()=>{
        if (triggerAnimation > prevTriggerRef.current && isTaskMode) setRippleKey((k)=>k + 1);
        prevTriggerRef.current = triggerAnimation;
    }, [
        triggerAnimation,
        isTaskMode
    ]); // Reset rippleKey when leaving task mode so that a programmatic
    // isTaskMode false→true toggle (store reset, conversation switch, etc.)
    // does not remount stale ripple/beam DOM nodes and replay their CSS animations.
    (0, $cozmU.useEffect)(()=>{
        if (!isTaskMode) setRippleKey(0);
    }, [
        isTaskMode
    ]);
    const shouldRenderWrapper = shouldKeepPromptMounted || isTaskMode;
    if (!shouldRenderWrapper) return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, children);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.container
        ])
    }, isTaskMode && /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": "true",
        "data-testid": "prompt-max-glow",
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.glowContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.glowBlobBase,
            $6c4e4cf838e4ce45$var$compiledStyles.glowBlobA
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.glowBlobBase,
            $6c4e4cf838e4ce45$var$compiledStyles.glowBlobB
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.glowBlobBase,
            $6c4e4cf838e4ce45$var$compiledStyles.glowBlobC
        ])
    })), rippleKey > 0 && /*#__PURE__*/ $cozmU.createElement("div", {
        key: `ripple-${rippleKey}`,
        "aria-hidden": "true",
        "data-testid": "prompt-max-ripple",
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.ripple
        ])
    }), rippleKey > 0 && /*#__PURE__*/ $cozmU.createElement("div", {
        key: `beam-${rippleKey}`,
        "aria-hidden": "true",
        "data-testid": "prompt-max-beam",
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.beamContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
            $6c4e4cf838e4ce45$var$compiledStyles.beamTrail4
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
            $6c4e4cf838e4ce45$var$compiledStyles.beamTrail3
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
            $6c4e4cf838e4ce45$var$compiledStyles.beamTrail2
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
            $6c4e4cf838e4ce45$var$compiledStyles.beamTrail1
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        style: $6c4e4cf838e4ce45$var$beamOffsetStyle,
        className: (0, $hekY6.default)([
            $6c4e4cf838e4ce45$var$compiledStyles.beamDotBase,
            $6c4e4cf838e4ce45$var$compiledStyles.beamLead
        ])
    })), children);
};
function $6c4e4cf838e4ce45$var$_temp(k) {
    return k + 1;
}





const $5d172eb2188ba678$var$useIsomorphicLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $5d172eb2188ba678$var$createEditorStore = (initialValue)=>{
    let currentValue = initialValue;
    const listeners = new Set();
    return {
        getSnapshot: ()=>currentValue,
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>listeners.delete(listener);
        },
        setSnapshot: (value)=>{
            if (Object.is(currentValue, value)) return;
            currentValue = value;
            listeners.forEach((listener)=>listener());
        }
    };
};
const $5d172eb2188ba678$export$3771425708360732 = (editorApi, editorProps)=>{
    const value = (0, $cozmU.useMemo)(()=>({
            editorApi: editorApi,
            editorProps: editorProps
        }), [
        editorApi,
        editorProps
    ]);
    const storeRef = (0, $cozmU.useRef)(null);
    if (!storeRef.current) storeRef.current = $5d172eb2188ba678$var$createEditorStore(value);
    $5d172eb2188ba678$var$useIsomorphicLayoutEffect(()=>{
        storeRef.current?.setSnapshot(value);
    }, [
        value
    ]);
    return storeRef.current;
};


const $d064a580ef58dc58$var$DEFAULT_INPUT_HEIGHT_ROVO_CHAT = 56;
const $d064a580ef58dc58$var$DEFAULT_INPUT_HEIGHT_STAGING_AREA = 48;
const $d064a580ef58dc58$var$SINGLE_DEFAULT_INPUT_HEIGHT_ROVO_CHAT = 24;
const $d064a580ef58dc58$var$WRAPPER_BORDER_RADIUS = "var(--ds-radius-xlarge, 12px)";
const $d064a580ef58dc58$var$fadeIn = null;

const $d064a580ef58dc58$var$VoiceEnabledFooterRow = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("6PIvc")));
const $d064a580ef58dc58$var$styles = {
    wrapper: "_30huDKOeNX _0bjKvDyzSk _4kiQYAQEt6 _1mT5xdRAKS _2OUyjtETSP _17l6pcgVvo _1bai7xgVvo _1VNMKDgVvo",
    inputHatHeader: "_4e3HrdyzSk _0mcu6jyzSk _0KLXrunmFW _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    wrapperContent: "_2Y7lL48HPE _0Of8r28HPE _1wydGW8HPE",
    deepResearchTagWrapper: "_0LQT5E1Y8M",
    wrapperBackgroundDefault: "_0KLXrujOvk",
    wrapperBackgroundOpaque: "_0KLXru7Cj1",
    wrapperWithTruncation: "_1yltTqrU95 _1jAasknQyn _14QTQ8nQyn _4BngHLzsYt _46ezwQz8Lp _0kCHqrgJ9S _1iamFHiZR3 _4zxlf9bI28 _0IxgYlpJKa",
    wrapperWithTruncationSingleLine: "_1yltTqrU95 _1jAaskoWuR _14QTQ8oWuR _4BngHLzsYt _46ezwQz8Lp _0kCHqrgJ9S _1iamFH7dHp _4zxlf9bI28 _0IxgYlk2Yr",
    wrapperWithDropdown: "_4GgNwsdnbC _3kIZMxdnbC _4kiQYAbUtj",
    actionRow: "_46hvQm1Y8M",
    editorWrapperWithSpacing: "_0rIjyk5zaO",
    editorStagingAreaMinHeight: "_0Lkh6hpJKa",
    editorRovoChatMinHeight: "_0Lkh6hmdCj",
    editorSingleLineHeight: "_2O5Vij7dHp _4kiQYAR4us _0Lkh6hoWWg",
    fileDragging: "_30huDKYbGa _0KLXruVva3",
    dictationOverlayContainer: "_1mT5xdRAKS",
    wrapperBlankObject: "_30huDKYbGa _2OUyjtV0xm"
};
const $d064a580ef58dc58$var$AutoSuggest = /*#__PURE__*/ (0, $cozmU.lazy)(async ()=>{
    const autoSuggestModule = await (0, $04373e772f510be6$export$5531859f311f2932)();
    return {
        default: autoSuggestModule.AutoSuggest
    };
});
const $d064a580ef58dc58$var$ChatInputEditor = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { contentContext: contentContext, editorApi: editorApi, editorProps: editorProps, enableSkills: enableSkills, enableSkillsInStagingArea: enableSkillsInStagingArea, enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput, isSpecialistPromptInput: isSpecialistPromptInput, promptHasSkill: promptHasSkill, siteId: siteId } = t0;
    const resolvedIsSpecialistPromptInput = isSpecialistPromptInput && !enableSkillsInSpecialistPromptInput;
    const resolvedEnableSkills = !!enableSkills && (contentContext !== "staging-area" || !!enableSkillsInStagingArea);
    const skillTagFallbackProvider = (0, $a6scT.useSkillTagExtensionProvider)(siteId);
    const t1 = resolvedEnableSkills ? skillTagFallbackProvider : undefined;
    let t2;
    if ($[0] !== editorProps || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
            extensionProviders: t1,
            ...editorProps
        });
        $[0] = editorProps;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const fallbackEditor = t2;
    let t3;
    if ($[3] !== fallbackEditor) {
        t3 = (t4)=>{
            const { error: error } = t4;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                error: error,
                name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                error: error,
                name: (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS
            }), fallbackEditor);
        };
        $[3] = fallbackEditor;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== siteId) {
        t4 = (error_0)=>{
            (0, $hlvTd.logException)({
                exception: error_0,
                name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR,
                tags: {
                    siteId: siteId
                }
            });
        };
        $[5] = siteId;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
            name: (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS
        });
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    let t7;
    if ($[9] !== editorApi || $[10] !== editorProps || $[11] !== promptHasSkill || $[12] !== resolvedEnableSkills || $[13] !== resolvedIsSpecialistPromptInput || $[14] !== siteId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4y2BX.ComposableEditorWithSkills), {
            editorApi: editorApi,
            isSpecialistPromptInput: resolvedIsSpecialistPromptInput,
            promptHasSkill: promptHasSkill,
            enableSkills: resolvedEnableSkills,
            siteId: siteId,
            ...editorProps
        });
        $[9] = editorApi;
        $[10] = editorProps;
        $[11] = promptHasSkill;
        $[12] = resolvedEnableSkills;
        $[13] = resolvedIsSpecialistPromptInput;
        $[14] = siteId;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS
        });
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== fallbackEditor || $[18] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "chat-prompt-input-skills"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: fallbackEditor
        }, t7, t8)));
        $[17] = fallbackEditor;
        $[18] = t7;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
            name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR
        });
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t3 || $[22] !== t4 || $[23] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "composable-editor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: t3,
            onError: t4
        }, t5, t6, t9, t10));
        $[21] = t3;
        $[22] = t4;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    return t11;
} : ({ contentContext: contentContext, editorApi: editorApi, editorProps: editorProps, enableSkills: enableSkills, enableSkillsInStagingArea: enableSkillsInStagingArea, enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput, isSpecialistPromptInput: isSpecialistPromptInput, promptHasSkill: promptHasSkill, siteId: siteId })=>{
    const resolvedIsSpecialistPromptInput = isSpecialistPromptInput && !enableSkillsInSpecialistPromptInput;
    const resolvedEnableSkills = !!enableSkills && (contentContext !== 'staging-area' || !!enableSkillsInStagingArea);
    const skillTagFallbackProvider = (0, $a6scT.useSkillTagExtensionProvider)(siteId);
    const fallbackEditor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        extensionProviders: resolvedEnableSkills ? skillTagFallbackProvider : undefined,
        ...editorProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "composable-editor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                error: error,
                name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceFailure), {
                error: error,
                name: (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS
            }), fallbackEditor),
        onError: (error_0)=>{
            (0, $hlvTd.logException)({
                exception: error_0,
                name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR,
                tags: {
                    siteId: siteId
                }
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "chat-prompt-input-skills"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallbackEditor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4y2BX.ComposableEditorWithSkills), {
        editorApi: editorApi,
        isSpecialistPromptInput: resolvedIsSpecialistPromptInput,
        promptHasSkill: promptHasSkill,
        enableSkills: resolvedEnableSkills,
        siteId: siteId,
        ...editorProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).LOAD_PANEL_COMPOSABLE_EDITOR
    })));
};
const $d064a580ef58dc58$var$StoreBackedChatInputEditor = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let editorContainerProps;
    let editorStore;
    if ($[0] !== t0) {
        ({ editorStore: editorStore, ...editorContainerProps } = t0);
        $[0] = t0;
        $[1] = editorContainerProps;
        $[2] = editorStore;
    } else {
        editorContainerProps = $[1];
        editorStore = $[2];
    }
    const { editorApi: editorApi, editorProps: currentEditorProps } = (0, $cozmU.useSyncExternalStore)(editorStore.subscribe, editorStore.getSnapshot, editorStore.getSnapshot);
    let t1;
    if ($[3] !== currentEditorProps || $[4] !== editorApi || $[5] !== editorContainerProps) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$ChatInputEditor, {
            ...editorContainerProps,
            editorApi: editorApi,
            editorProps: currentEditorProps
        });
        $[3] = currentEditorProps;
        $[4] = editorApi;
        $[5] = editorContainerProps;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ editorStore: editorStore, ...editorContainerProps })=>{
    const { editorApi: editorApi, editorProps: currentEditorProps } = (0, $cozmU.useSyncExternalStore)(editorStore.subscribe, editorStore.getSnapshot, editorStore.getSnapshot);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$ChatInputEditor, {
        ...editorContainerProps,
        editorApi: editorApi,
        editorProps: currentEditorProps
    });
};
const $d064a580ef58dc58$var$ChatInputInnerContent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(141);
    (0, $6cFsl.di)((0, $jlRK6.ComposableEditor), (0, $4y2BX.ComposableEditorWithSkills), (0, $d5gEx.AtlassianRelayEnvironmentProvider));
    const { files: files, handleFilesSelected: handleFilesSelected, handleUrlsSelected: handleUrlsSelected, urlValidationConfig: urlValidationConfig, chatModeReasoningMode: chatModeReasoningMode, chatModeDeepResearchEnabled: chatModeDeepResearchEnabled, chatModeTaskModeEnabled: chatModeTaskModeEnabled, taskModeAnimationTrigger: taskModeAnimationTrigger, isBackgroundTransparent: isBackgroundTransparent, dropdownSlot: dropdownSlot, isAgentTyping: isAgentTyping, showSingleLineEditor: showSingleLineEditor, hoveredPrompt: hoveredPrompt, forceTruncatedWrapperOnEmptyEditor: forceTruncatedWrapperOnEmptyEditor, inputValueLength: inputValueLength, blankObjectStyles: blankObjectStyles, dictationOverlayBackground: dictationOverlayBackground, selectedAgentForInputHat: selectedAgentForInputHat, shouldRenderInputAgentHat: shouldRenderInputAgentHat, selectedAgentInputHatImageUrl: selectedAgentInputHatImageUrl, handleSelectedAgentDismiss: handleSelectedAgentDismiss, siteId: siteId, topAccessory: topAccessory, shouldShowDeepResearchInAddMenu: shouldShowDeepResearchInAddMenu, isSpecialistPromptInput: isSpecialistPromptInput, canSwitchBackToRovo: canSwitchBackToRovo, showAgentSourceControlSpotlight: showAgentSourceControlSpotlight, onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight, sourceControlPostOfficeMessage: sourceControlPostOfficeMessage, setDeepResearchEnabled: setDeepResearchEnabled, promptDraftAndModeKey: promptDraftAndModeKey, onReasoningModeChange: onReasoningModeChange, isDisabled: isDisabled, handleEditorBlur: handleEditorBlur, hasCodeBlock: hasCodeBlock, contentContext: contentContext, editorApi: editorApi, editorProps: editorProps, editorStore: editorStore, promptHasSkill: promptHasSkill, enableSkills: enableSkills, enableSkillsInStagingArea: enableSkillsInStagingArea, enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput, charactersOverLimit: charactersOverLimit, customSlotAboveActionRow: customSlotAboveActionRow, customSlotBeforeChatModeMenu: customSlotBeforeChatModeMenu, showChatModeMenu: showChatModeMenu, showActionsButton: showActionsButton, actionsMenuItemsVisibility: actionsMenuItemsVisibility, entryPoint: entryPoint, mode: mode, menuPosition: menuPosition, openLinkTypeAheadFromMenu: openLinkTypeAheadFromMenu, openMentionTypeAhead: openMentionTypeAhead, openAddTypeAhead: openAddTypeAhead, onDiscoverSkillsClick: onDiscoverSkillsClick, handleDeepResearchClick: handleDeepResearchClick, onBrowsePromptLibraryClick: onBrowsePromptLibraryClick, onCreateSpaceClick: onCreateSpaceClick, hasActiveAgentMention: hasActiveAgentMention, assistanceServiceParams: assistanceServiceParams, fileUploadAssistanceOverrides: fileUploadAssistanceOverrides, contextProviders: contextProviders, onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable, useCurrentPageContext: t0, closeTypeAhead: closeTypeAhead, closeEditorToolbar: closeEditorToolbar, shouldRenderQuickActionsInPortal: shouldRenderQuickActionsInPortal, enableBrowserContextBanner: enableBrowserContextBanner, browserContextSanitizer: browserContextSanitizer, shouldRenderChatModeMenusInPortal: shouldRenderChatModeMenusInPortal, webSearchConfigEnabled: webSearchConfigEnabled, setWebSearchEnabled: setWebSearchEnabled, onWebSearchToggle: onWebSearchToggle, onOrgKnowledgeToggle: onOrgKnowledgeToggle, onFilteredAppsChange: onFilteredAppsChange, onInsertTranscript: onInsertTranscript, onMicPermissionDenied: onMicPermissionDenied, setReasoningMode: setReasoningMode, enableAppsDiscoveryUi: enableAppsDiscoveryUi, enableMaxMode: enableMaxMode, setTaskModeAnimationTrigger: setTaskModeAnimationTrigger, onReasoningModeMenuOpenChange: onReasoningModeMenuOpenChange, shouldKeepTaskModePromptMounted: shouldKeepTaskModePromptMounted, isReasoningModeDisabledByDeepResearch: isReasoningModeDisabledByDeepResearch, stableFileInputChange: stableFileInputChange, formatMessage: formatMessage, customSlotBeforeSubmitButton: customSlotBeforeSubmitButton, submitButtonOnSave: submitButtonOnSave, SubmitButton: SubmitButton, isSendDisabled: isSendDisabled, submitButtonTooltip: submitButtonTooltip, tooltipOptions: tooltipOptions, onAbort: onAbort, getChatMode: getChatMode, shouldRenderVoiceEnabledFooterRow: shouldRenderVoiceEnabledFooterRow, productKey: productKey, autoSuggestConfig: autoSuggestConfig, autoSuggestQuery: autoSuggestQuery, autoSuggestADF: autoSuggestADF, handleSuggestionSelect: handleSuggestionSelect, showSourceModeToggle: showSourceModeToggle, pageContextType: pageContextType, renderAutoApplyToggle: renderAutoApplyToggle } = props;
    const useCurrentPageContext = t0 === undefined ? false : t0;
    let t1;
    if ($[0] !== chatModeReasoningMode) {
        t1 = {
            reasoningMode: chatModeReasoningMode
        };
        $[0] = chatModeReasoningMode;
        $[1] = t1;
    } else t1 = $[1];
    const chatModeStateForReasoningModeMenu = t1;
    const { dictationStatus: dictationStatus, handleDictationStatusChange: handleDictationStatusChange } = (0, $4e4781d535aac0d4$export$596d2ba8e2799493)();
    let t2;
    if ($[2] !== dictationStatus || $[3] !== inputValueLength) {
        t2 = inputValueLength === 0 && (0, $4e4781d535aac0d4$export$68be235c79785025)(dictationStatus);
        $[2] = dictationStatus;
        $[3] = inputValueLength;
        $[4] = t2;
    } else t2 = $[4];
    const shouldOverlayDictationStatus = t2;
    let t3;
    if ($[5] !== closeEditorToolbar || $[6] !== closeTypeAhead) {
        t3 = ()=>{
            closeTypeAhead();
            closeEditorToolbar();
        };
        $[5] = closeEditorToolbar;
        $[6] = closeTypeAhead;
        $[7] = t3;
    } else t3 = $[7];
    const handleMenuOpen = t3;
    const showDisabledRovoControlsForAgent = canSwitchBackToRovo;
    const hideRovoControlsForAgent = isSpecialistPromptInput && !canSwitchBackToRovo;
    let t4;
    if ($[8] !== formatMessage) {
        t4 = formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).agentDisabledTooltip);
        $[8] = formatMessage;
        $[9] = t4;
    } else t4 = $[9];
    const reasoningModeAgentDisabledTooltip = t4;
    let t5;
    if ($[10] !== formatMessage) {
        t5 = formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentDisabledTooltip);
        $[10] = formatMessage;
        $[11] = t5;
    } else t5 = $[11];
    const filteredAppsAgentDisabledTooltip = t5;
    let t6;
    if ($[12] !== formatMessage) {
        t6 = formatMessage((0, $72b15252e718d034$export$defe85febe8b728c).agentDisabledTooltip);
        $[12] = formatMessage;
        $[13] = t6;
    } else t6 = $[13];
    const deepResearchAgentDisabledTooltip = t6;
    let t7;
    if ($[14] !== onReasoningModeChange || $[15] !== promptDraftAndModeKey || $[16] !== setDeepResearchEnabled) {
        t7 = (enabled)=>{
            const mode_0 = enabled ? "deep-research" : "auto";
            setDeepResearchEnabled(promptDraftAndModeKey, enabled);
            onReasoningModeChange?.(mode_0);
        };
        $[14] = onReasoningModeChange;
        $[15] = promptDraftAndModeKey;
        $[16] = setDeepResearchEnabled;
        $[17] = t7;
    } else t7 = $[17];
    const handleDeepResearchToggle = t7;
    let t8;
    if ($[18] !== onWebSearchToggle || $[19] !== promptDraftAndModeKey || $[20] !== setWebSearchEnabled) {
        t8 = (enabled_0)=>{
            setWebSearchEnabled(promptDraftAndModeKey, enabled_0);
            onWebSearchToggle?.(enabled_0);
        };
        $[18] = onWebSearchToggle;
        $[19] = promptDraftAndModeKey;
        $[20] = setWebSearchEnabled;
        $[21] = t8;
    } else t8 = $[21];
    const handleWebSearchToggle = t8;
    let t9;
    if ($[22] !== handleDeepResearchToggle) {
        t9 = ()=>{
            handleDeepResearchToggle(false);
        };
        $[22] = handleDeepResearchToggle;
        $[23] = t9;
    } else t9 = $[23];
    const handleDeepResearchDismiss = t9;
    let t10;
    if ($[24] !== chatModeTaskModeEnabled || $[25] !== onReasoningModeChange || $[26] !== promptDraftAndModeKey || $[27] !== setReasoningMode || $[28] !== setTaskModeAnimationTrigger) {
        t10 = (mode_1)=>{
            if (mode_1 === "task" && !chatModeTaskModeEnabled && (0, $iDrrr.fg)("rovo_chat_task_mode_design_refresh")) setTaskModeAnimationTrigger($d064a580ef58dc58$var$_temp);
            setReasoningMode(promptDraftAndModeKey, mode_1);
            onReasoningModeChange?.(mode_1);
        };
        $[24] = chatModeTaskModeEnabled;
        $[25] = onReasoningModeChange;
        $[26] = promptDraftAndModeKey;
        $[27] = setReasoningMode;
        $[28] = setTaskModeAnimationTrigger;
        $[29] = t10;
    } else t10 = $[29];
    const handleFastReasoningModeChange = t10;
    let t11;
    if ($[30] !== SubmitButton || $[31] !== actionsMenuItemsVisibility || $[32] !== assistanceServiceParams || $[33] !== autoSuggestADF || $[34] !== autoSuggestConfig || $[35] !== autoSuggestQuery || $[36] !== blankObjectStyles || $[37] !== browserContextSanitizer || $[38] !== charactersOverLimit || $[39] !== chatModeDeepResearchEnabled || $[40] !== chatModeStateForReasoningModeMenu || $[41] !== chatModeTaskModeEnabled || $[42] !== contentContext || $[43] !== contextProviders || $[44] !== customSlotAboveActionRow || $[45] !== customSlotBeforeChatModeMenu || $[46] !== customSlotBeforeSubmitButton || $[47] !== deepResearchAgentDisabledTooltip || $[48] !== dictationOverlayBackground || $[49] !== dictationStatus || $[50] !== dropdownSlot || $[51] !== editorApi || $[52] !== editorProps || $[53] !== editorStore || $[54] !== enableAppsDiscoveryUi || $[55] !== enableBrowserContextBanner || $[56] !== enableMaxMode || $[57] !== enableSkills || $[58] !== enableSkillsInSpecialistPromptInput || $[59] !== enableSkillsInStagingArea || $[60] !== entryPoint || $[61] !== fileUploadAssistanceOverrides || $[62] !== filteredAppsAgentDisabledTooltip || $[63] !== forceTruncatedWrapperOnEmptyEditor || $[64] !== formatMessage || $[65] !== getChatMode || $[66] !== handleDeepResearchClick || $[67] !== handleDeepResearchDismiss || $[68] !== handleDictationStatusChange || $[69] !== handleEditorBlur || $[70] !== handleFastReasoningModeChange || $[71] !== handleMenuOpen || $[72] !== handleSelectedAgentDismiss || $[73] !== handleSuggestionSelect || $[74] !== handleWebSearchToggle || $[75] !== hasActiveAgentMention || $[76] !== hasCodeBlock || $[77] !== hideRovoControlsForAgent || $[78] !== hoveredPrompt || $[79] !== inputValueLength || $[80] !== isAgentTyping || $[81] !== isBackgroundTransparent || $[82] !== isDisabled || $[83] !== isReasoningModeDisabledByDeepResearch || $[84] !== isSendDisabled || $[85] !== isSpecialistPromptInput || $[86] !== menuPosition || $[87] !== mode || $[88] !== onAbort || $[89] !== onBrowsePromptLibraryClick || $[90] !== onContextAvailable || $[91] !== onContextBrowserShow || $[92] !== onCreateSpaceClick || $[93] !== onDiscoverSkillsClick || $[94] !== onDismissAgentSourceControlSpotlight || $[95] !== onFilteredAppsChange || $[96] !== onInsertTranscript || $[97] !== onMicPermissionDenied || $[98] !== onOrgKnowledgeToggle || $[99] !== onReasoningModeMenuOpenChange || $[100] !== openAddTypeAhead || $[101] !== openLinkTypeAheadFromMenu || $[102] !== openMentionTypeAhead || $[103] !== pageContextType || $[104] !== productKey || $[105] !== promptDraftAndModeKey || $[106] !== promptHasSkill || $[107] !== reasoningModeAgentDisabledTooltip || $[108] !== renderAutoApplyToggle || $[109] !== selectedAgentForInputHat || $[110] !== selectedAgentInputHatImageUrl || $[111] !== shouldKeepTaskModePromptMounted || $[112] !== shouldOverlayDictationStatus || $[113] !== shouldRenderChatModeMenusInPortal || $[114] !== shouldRenderInputAgentHat || $[115] !== shouldRenderQuickActionsInPortal || $[116] !== shouldRenderVoiceEnabledFooterRow || $[117] !== shouldShowDeepResearchInAddMenu || $[118] !== showActionsButton || $[119] !== showAgentSourceControlSpotlight || $[120] !== showChatModeMenu || $[121] !== showDisabledRovoControlsForAgent || $[122] !== showSingleLineEditor || $[123] !== showSourceModeToggle || $[124] !== siteId || $[125] !== sourceControlPostOfficeMessage || $[126] !== stableFileInputChange || $[127] !== submitButtonOnSave || $[128] !== submitButtonTooltip || $[129] !== taskModeAnimationTrigger || $[130] !== tooltipOptions || $[131] !== topAccessory || $[132] !== useCurrentPageContext || $[133] !== webSearchConfigEnabled) {
        t11 = (t12)=>{
            const { isDraggedOver: isDraggedOver, innerProps: innerProps, dropzoneContent: dropzoneContent } = t12;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c4e4cf838e4ce45$export$79e9e288b405a1b8), {
                isTaskMode: !!(enableMaxMode && chatModeTaskModeEnabled && (0, $iDrrr.fg)("rovo_chat_task_mode_design_refresh")),
                shouldKeepPromptMounted: shouldKeepTaskModePromptMounted,
                triggerAnimation: taskModeAnimationTrigger
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                ref: innerProps.ref,
                xcss: (0, $w6R6I.cx)($d064a580ef58dc58$var$styles.wrapper, isBackgroundTransparent && !(enableMaxMode && chatModeTaskModeEnabled && (0, $iDrrr.fg)("rovo_chat_task_mode_design_refresh")) ? $d064a580ef58dc58$var$styles.wrapperBackgroundDefault : $d064a580ef58dc58$var$styles.wrapperBackgroundOpaque, !!dropdownSlot && $d064a580ef58dc58$var$styles.wrapperWithDropdown, isDraggedOver && $d064a580ef58dc58$var$styles.fileDragging, !showSingleLineEditor && (!!hoveredPrompt || !!forceTruncatedWrapperOnEmptyEditor && inputValueLength === 0) && $d064a580ef58dc58$var$styles.wrapperWithTruncation, showSingleLineEditor && (!!hoveredPrompt || inputValueLength === 0) && $d064a580ef58dc58$var$styles.wrapperWithTruncationSingleLine, blankObjectStyles && $d064a580ef58dc58$var$styles.wrapperBlankObject),
                testId: "chat-input-wrapper"
            }, selectedAgentForInputHat && shouldRenderInputAgentHat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $d064a580ef58dc58$var$styles.inputHatHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60b389bd4ceedccc$export$9c8d9142406f756c), {
                agentId: selectedAgentForInputHat.id,
                agentName: selectedAgentForInputHat.name,
                agentNamedId: selectedAgentForInputHat.namedId,
                agentIdentityAccountId: selectedAgentForInputHat.identityAccountId,
                creatorType: selectedAgentForInputHat.creatorType,
                imageUrl: selectedAgentInputHatImageUrl,
                cloudId: siteId,
                onDismiss: handleSelectedAgentDismiss
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $d064a580ef58dc58$var$styles.wrapperContent,
                testId: "chat-input-wrapper-content"
            }, topAccessory, shouldShowDeepResearchInAddMenu && chatModeDeepResearchEnabled && !hideRovoControlsForAgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $d064a580ef58dc58$var$styles.deepResearchTagWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6c2d4ad6502919e$export$a34759a6f8815868), {
                onDismiss: handleDeepResearchDismiss,
                isDisabled: isDisabled || isAgentTyping || isSpecialistPromptInput,
                disabledTooltip: showDisabledRovoControlsForAgent ? deepResearchAgentDisabledTooltip : undefined
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                onBlur: handleEditorBlur,
                onPaste: innerProps.onPaste,
                xcss: (0, $w6R6I.cx)(shouldOverlayDictationStatus ? $d064a580ef58dc58$var$styles.dictationOverlayContainer : undefined, hasCodeBlock ? $d064a580ef58dc58$var$styles.editorWrapperWithSpacing : undefined, showSingleLineEditor ? $d064a580ef58dc58$var$styles.editorSingleLineHeight : contentContext === "staging-area" || contentContext === "blank-object-experience" ? $d064a580ef58dc58$var$styles.editorStagingAreaMinHeight : $d064a580ef58dc58$var$styles.editorRovoChatMinHeight)
            }, editorStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$StoreBackedChatInputEditor, {
                contentContext: contentContext,
                editorStore: editorStore,
                enableSkills: enableSkills,
                enableSkillsInStagingArea: enableSkillsInStagingArea,
                enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput,
                isSpecialistPromptInput: isSpecialistPromptInput,
                promptHasSkill: promptHasSkill,
                siteId: siteId
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$ChatInputEditor, {
                contentContext: contentContext,
                editorApi: editorApi,
                editorProps: editorProps,
                enableSkills: enableSkills,
                enableSkillsInStagingArea: enableSkillsInStagingArea,
                enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput,
                isSpecialistPromptInput: isSpecialistPromptInput,
                promptHasSkill: promptHasSkill,
                siteId: siteId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e4781d535aac0d4$export$56e81c7d50c77896), {
                appearance: shouldOverlayDictationStatus ? "overlay" : "row",
                status: dictationStatus,
                backgroundOverride: dictationOverlayBackground
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c6cfd9419ae9608$export$4f20080e67eaaf20), {
                count: -1 * charactersOverLimit
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8kYV.InputContextListDisplay), {
                attachtmentsStoreKey: promptDraftAndModeKey
            }), customSlotAboveActionRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between",
                xcss: $d064a580ef58dc58$var$styles.actionRow,
                testId: "chat-prompt-footer-row"
            }, (()=>{
                const promptControlsSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.050",
                    grow: "fill"
                }, showActionsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cH7ad.ChatInputActionButtons), {
                    menuItemsVisibility: actionsMenuItemsVisibility,
                    entryPoint: entryPoint,
                    siteId: siteId,
                    placement: menuPosition,
                    attachmentsAndCurrentPageAsContextStoreKey: promptDraftAndModeKey,
                    isDisabled: isDisabled || isAgentTyping,
                    onLinkTypeAheadClick: openLinkTypeAheadFromMenu,
                    onMentionTypeAheadClick: openMentionTypeAhead,
                    onAddTypeAheadClick: openAddTypeAhead,
                    onDiscoverSkillsClick: onDiscoverSkillsClick,
                    onDeepResearchClick: shouldShowDeepResearchInAddMenu ? handleDeepResearchClick : undefined,
                    isDeepResearchActive: chatModeDeepResearchEnabled,
                    onBrowsePromptLibraryClick: onBrowsePromptLibraryClick,
                    onCreateSpaceClick: onCreateSpaceClick,
                    hasSkillInPrompt: promptHasSkill,
                    isAgentMentionActive: hasActiveAgentMention,
                    assistanceServiceParams: assistanceServiceParams,
                    fileUploadAssistanceOverrides: fileUploadAssistanceOverrides,
                    stableFileInputChange: stableFileInputChange,
                    contextProviders: contextProviders,
                    onContextBrowserShow: onContextBrowserShow,
                    onContextAvailable: onContextAvailable,
                    useCurrentPageContext: useCurrentPageContext,
                    onMenuOpen: handleMenuOpen,
                    shouldRenderInPortal: shouldRenderQuickActionsInPortal,
                    enableBrowserContextBanner: enableBrowserContextBanner,
                    browserContextSanitizer: browserContextSanitizer
                }), showChatModeMenu && (!hideRovoControlsForAgent || !!showAgentSourceControlSpotlight) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d75b6051d08bd783$export$fb6fc81aa90ac691), {
                    chatModeKey: promptDraftAndModeKey
                }, (hideLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (!hideRovoControlsForAgent || !!showAgentSourceControlSpotlight) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8a20caf1e04623f$export$f7c7d985a9c5951d), {
                        assistanceServiceParams: assistanceServiceParams,
                        hideLabel: hideLabel,
                        chatModeKey: promptDraftAndModeKey,
                        contentContext: contentContext,
                        isDisabled: isDisabled || isAgentTyping || hasActiveAgentMention || isSpecialistPromptInput,
                        webSearchConfigEnabled: webSearchConfigEnabled,
                        onFilteredAppsChange: onFilteredAppsChange,
                        onWebSearchToggle: handleWebSearchToggle,
                        onOrgKnowledgeToggle: onOrgKnowledgeToggle,
                        enableAppsDiscoveryUi: enableAppsDiscoveryUi,
                        showSourceModeToggle: showSourceModeToggle,
                        shouldRenderInPortal: shouldRenderChatModeMenusInPortal,
                        disabledTooltip: showDisabledRovoControlsForAgent ? filteredAppsAgentDisabledTooltip : undefined,
                        showAgentSourceControlSpotlight: showAgentSourceControlSpotlight,
                        onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight,
                        sourceControlPostOfficeMessage: sourceControlPostOfficeMessage
                    }))));
                const actionsBeforeSubmitSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customSlotBeforeChatModeMenu, showChatModeMenu && !hideRovoControlsForAgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de38fcda73e53a53$export$4bc6d65b94cbeeb4), {
                    chatModeState: chatModeStateForReasoningModeMenu,
                    enableMaxMode: enableMaxMode,
                    onReasoningModeChange: handleFastReasoningModeChange,
                    renderAutoApplyToggle: renderAutoApplyToggle,
                    isDisabled: isDisabled || isAgentTyping || hasActiveAgentMention || isReasoningModeDisabledByDeepResearch || isSpecialistPromptInput,
                    disabledTooltip: isReasoningModeDisabledByDeepResearch ? formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).deepResearchAddMenuDisabledTooltip) : showDisabledRovoControlsForAgent ? reasoningModeAgentDisabledTooltip : undefined,
                    placement: menuPosition,
                    shouldRenderInPortal: shouldRenderChatModeMenusInPortal,
                    onMenuOpen: handleMenuOpen,
                    onMenuOpenChange: onReasoningModeMenuOpenChange
                }), customSlotBeforeSubmitButton);
                const submitButtonSlot = SubmitButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SubmitButton, {
                    isAgentTyping: isAgentTyping,
                    isSendDisabled: isSendDisabled,
                    promptDraftAndModeKey: promptDraftAndModeKey,
                    submitButtonTooltip: submitButtonTooltip,
                    tooltipOptions: tooltipOptions,
                    onSave: submitButtonOnSave,
                    onAbort: onAbort,
                    getChatMode: getChatMode
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a90455e56c91900$export$41daf28bb61ded76), {
                    isAgentTyping: isAgentTyping,
                    isSendDisabled: isSendDisabled,
                    promptDraftAndModeKey: promptDraftAndModeKey,
                    submitButtonTooltip: submitButtonTooltip,
                    tooltipOptions: tooltipOptions,
                    onSave: submitButtonOnSave,
                    onAbort: onAbort,
                    getChatMode: getChatMode
                });
                const disabledFallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6718c697198a5dc$export$2e2bcd8739ae039), {
                    promptControlsSlot: promptControlsSlot,
                    actionsBeforeSubmitSlot: actionsBeforeSubmitSlot,
                    submitButtonSlot: submitButtonSlot
                });
                return shouldRenderVoiceEnabledFooterRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                    fallbackRender: ()=>disabledFallback,
                    onError: (error)=>{
                        (0, $hlvTd.logException)({
                            exception: error,
                            name: "load-panel-voice-enabled-footer-row",
                            tags: {
                                siteId: siteId
                            }
                        });
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                    fallback: disabledFallback
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$VoiceEnabledFooterRow, {
                    cloudId: siteId,
                    entryPoint: entryPoint,
                    mode: mode,
                    productKey: productKey,
                    promptControlsSlot: promptControlsSlot,
                    actionsBeforeSubmitSlot: actionsBeforeSubmitSlot,
                    submitButtonSlot: submitButtonSlot,
                    onInsertTranscript: onInsertTranscript,
                    onMicPermissionDenied: onMicPermissionDenied,
                    onDictationStatusChange: handleDictationStatusChange
                }))) : disabledFallback;
            })()), dropzoneContent, autoSuggestConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
                fallback: null,
                interactionName: "chat-prompt-input-autosuggest"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$AutoSuggest, {
                query: autoSuggestQuery,
                adf: autoSuggestADF ?? undefined,
                onSuggestionSelect: handleSuggestionSelect,
                position: autoSuggestConfig.position,
                cloudId: siteId,
                source: autoSuggestConfig.source,
                pageContextType: pageContextType,
                productKey: productKey
            })))));
        };
        $[30] = SubmitButton;
        $[31] = actionsMenuItemsVisibility;
        $[32] = assistanceServiceParams;
        $[33] = autoSuggestADF;
        $[34] = autoSuggestConfig;
        $[35] = autoSuggestQuery;
        $[36] = blankObjectStyles;
        $[37] = browserContextSanitizer;
        $[38] = charactersOverLimit;
        $[39] = chatModeDeepResearchEnabled;
        $[40] = chatModeStateForReasoningModeMenu;
        $[41] = chatModeTaskModeEnabled;
        $[42] = contentContext;
        $[43] = contextProviders;
        $[44] = customSlotAboveActionRow;
        $[45] = customSlotBeforeChatModeMenu;
        $[46] = customSlotBeforeSubmitButton;
        $[47] = deepResearchAgentDisabledTooltip;
        $[48] = dictationOverlayBackground;
        $[49] = dictationStatus;
        $[50] = dropdownSlot;
        $[51] = editorApi;
        $[52] = editorProps;
        $[53] = editorStore;
        $[54] = enableAppsDiscoveryUi;
        $[55] = enableBrowserContextBanner;
        $[56] = enableMaxMode;
        $[57] = enableSkills;
        $[58] = enableSkillsInSpecialistPromptInput;
        $[59] = enableSkillsInStagingArea;
        $[60] = entryPoint;
        $[61] = fileUploadAssistanceOverrides;
        $[62] = filteredAppsAgentDisabledTooltip;
        $[63] = forceTruncatedWrapperOnEmptyEditor;
        $[64] = formatMessage;
        $[65] = getChatMode;
        $[66] = handleDeepResearchClick;
        $[67] = handleDeepResearchDismiss;
        $[68] = handleDictationStatusChange;
        $[69] = handleEditorBlur;
        $[70] = handleFastReasoningModeChange;
        $[71] = handleMenuOpen;
        $[72] = handleSelectedAgentDismiss;
        $[73] = handleSuggestionSelect;
        $[74] = handleWebSearchToggle;
        $[75] = hasActiveAgentMention;
        $[76] = hasCodeBlock;
        $[77] = hideRovoControlsForAgent;
        $[78] = hoveredPrompt;
        $[79] = inputValueLength;
        $[80] = isAgentTyping;
        $[81] = isBackgroundTransparent;
        $[82] = isDisabled;
        $[83] = isReasoningModeDisabledByDeepResearch;
        $[84] = isSendDisabled;
        $[85] = isSpecialistPromptInput;
        $[86] = menuPosition;
        $[87] = mode;
        $[88] = onAbort;
        $[89] = onBrowsePromptLibraryClick;
        $[90] = onContextAvailable;
        $[91] = onContextBrowserShow;
        $[92] = onCreateSpaceClick;
        $[93] = onDiscoverSkillsClick;
        $[94] = onDismissAgentSourceControlSpotlight;
        $[95] = onFilteredAppsChange;
        $[96] = onInsertTranscript;
        $[97] = onMicPermissionDenied;
        $[98] = onOrgKnowledgeToggle;
        $[99] = onReasoningModeMenuOpenChange;
        $[100] = openAddTypeAhead;
        $[101] = openLinkTypeAheadFromMenu;
        $[102] = openMentionTypeAhead;
        $[103] = pageContextType;
        $[104] = productKey;
        $[105] = promptDraftAndModeKey;
        $[106] = promptHasSkill;
        $[107] = reasoningModeAgentDisabledTooltip;
        $[108] = renderAutoApplyToggle;
        $[109] = selectedAgentForInputHat;
        $[110] = selectedAgentInputHatImageUrl;
        $[111] = shouldKeepTaskModePromptMounted;
        $[112] = shouldOverlayDictationStatus;
        $[113] = shouldRenderChatModeMenusInPortal;
        $[114] = shouldRenderInputAgentHat;
        $[115] = shouldRenderQuickActionsInPortal;
        $[116] = shouldRenderVoiceEnabledFooterRow;
        $[117] = shouldShowDeepResearchInAddMenu;
        $[118] = showActionsButton;
        $[119] = showAgentSourceControlSpotlight;
        $[120] = showChatModeMenu;
        $[121] = showDisabledRovoControlsForAgent;
        $[122] = showSingleLineEditor;
        $[123] = showSourceModeToggle;
        $[124] = siteId;
        $[125] = sourceControlPostOfficeMessage;
        $[126] = stableFileInputChange;
        $[127] = submitButtonOnSave;
        $[128] = submitButtonTooltip;
        $[129] = taskModeAnimationTrigger;
        $[130] = tooltipOptions;
        $[131] = topAccessory;
        $[132] = useCurrentPageContext;
        $[133] = webSearchConfigEnabled;
        $[134] = t11;
    } else t11 = $[134];
    let t12;
    if ($[135] !== files.length || $[136] !== handleFilesSelected || $[137] !== handleUrlsSelected || $[138] !== t11 || $[139] !== urlValidationConfig) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "chat-input-inner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $215735e71f9a3265$export$e182130f07919e28), {
            maxFiles: (0, $1SiET.MAX_FILES),
            currentFileCount: files.length,
            onFilesSelected: handleFilesSelected,
            onUrlsSelected: handleUrlsSelected,
            urlValidationConfig: urlValidationConfig
        }, t11));
        $[135] = files.length;
        $[136] = handleFilesSelected;
        $[137] = handleUrlsSelected;
        $[138] = t11;
        $[139] = urlValidationConfig;
        $[140] = t12;
    } else t12 = $[140];
    return t12;
} : (props)=>{
    (0, $6cFsl.di)((0, $jlRK6.ComposableEditor), (0, $4y2BX.ComposableEditorWithSkills), (0, $d5gEx.AtlassianRelayEnvironmentProvider));
    const { files: files, handleFilesSelected: handleFilesSelected, handleUrlsSelected: handleUrlsSelected, urlValidationConfig: urlValidationConfig, chatModeReasoningMode: chatModeReasoningMode, chatModeDeepResearchEnabled: chatModeDeepResearchEnabled, chatModeTaskModeEnabled: chatModeTaskModeEnabled, taskModeAnimationTrigger: taskModeAnimationTrigger, isBackgroundTransparent: isBackgroundTransparent, dropdownSlot: dropdownSlot, isAgentTyping: isAgentTyping, showSingleLineEditor: showSingleLineEditor, hoveredPrompt: hoveredPrompt, forceTruncatedWrapperOnEmptyEditor: forceTruncatedWrapperOnEmptyEditor, inputValueLength: inputValueLength, blankObjectStyles: blankObjectStyles, dictationOverlayBackground: dictationOverlayBackground, selectedAgentForInputHat: selectedAgentForInputHat, shouldRenderInputAgentHat: shouldRenderInputAgentHat, selectedAgentInputHatImageUrl: selectedAgentInputHatImageUrl, handleSelectedAgentDismiss: handleSelectedAgentDismiss, siteId: siteId, topAccessory: topAccessory, shouldShowDeepResearchInAddMenu: shouldShowDeepResearchInAddMenu, isSpecialistPromptInput: isSpecialistPromptInput, canSwitchBackToRovo: canSwitchBackToRovo, showAgentSourceControlSpotlight: showAgentSourceControlSpotlight, onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight, sourceControlPostOfficeMessage: sourceControlPostOfficeMessage, setDeepResearchEnabled: setDeepResearchEnabled, promptDraftAndModeKey: promptDraftAndModeKey, onReasoningModeChange: onReasoningModeChange, isDisabled: isDisabled, handleEditorBlur: handleEditorBlur, hasCodeBlock: hasCodeBlock, contentContext: contentContext, editorApi: editorApi, editorProps: editorProps, editorStore: editorStore, promptHasSkill: promptHasSkill, enableSkills: enableSkills, enableSkillsInStagingArea: enableSkillsInStagingArea, enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput, charactersOverLimit: charactersOverLimit, customSlotAboveActionRow: customSlotAboveActionRow, customSlotBeforeChatModeMenu: customSlotBeforeChatModeMenu, showChatModeMenu: showChatModeMenu, showActionsButton: showActionsButton, actionsMenuItemsVisibility: actionsMenuItemsVisibility, entryPoint: entryPoint, mode: mode, menuPosition: menuPosition, openLinkTypeAheadFromMenu: openLinkTypeAheadFromMenu, openMentionTypeAhead: openMentionTypeAhead, openAddTypeAhead: openAddTypeAhead, onDiscoverSkillsClick: onDiscoverSkillsClick, handleDeepResearchClick: handleDeepResearchClick, onBrowsePromptLibraryClick: onBrowsePromptLibraryClick, onCreateSpaceClick: onCreateSpaceClick, hasActiveAgentMention: hasActiveAgentMention, assistanceServiceParams: assistanceServiceParams, fileUploadAssistanceOverrides: fileUploadAssistanceOverrides, contextProviders: contextProviders, onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable, useCurrentPageContext: useCurrentPageContext = false, closeTypeAhead: closeTypeAhead, closeEditorToolbar: closeEditorToolbar, shouldRenderQuickActionsInPortal: shouldRenderQuickActionsInPortal, enableBrowserContextBanner: enableBrowserContextBanner, browserContextSanitizer: browserContextSanitizer, shouldRenderChatModeMenusInPortal: shouldRenderChatModeMenusInPortal, webSearchConfigEnabled: webSearchConfigEnabled, setWebSearchEnabled: setWebSearchEnabled, onWebSearchToggle: onWebSearchToggle, onOrgKnowledgeToggle: onOrgKnowledgeToggle, onFilteredAppsChange: onFilteredAppsChange, onInsertTranscript: onInsertTranscript, onMicPermissionDenied: onMicPermissionDenied, setReasoningMode: setReasoningMode, enableAppsDiscoveryUi: enableAppsDiscoveryUi, enableMaxMode: enableMaxMode, setTaskModeAnimationTrigger: setTaskModeAnimationTrigger, onReasoningModeMenuOpenChange: onReasoningModeMenuOpenChange, shouldKeepTaskModePromptMounted: shouldKeepTaskModePromptMounted, isReasoningModeDisabledByDeepResearch: isReasoningModeDisabledByDeepResearch, stableFileInputChange: stableFileInputChange, formatMessage: formatMessage, customSlotBeforeSubmitButton: customSlotBeforeSubmitButton, submitButtonOnSave: submitButtonOnSave, SubmitButton: SubmitButton, isSendDisabled: isSendDisabled, submitButtonTooltip: submitButtonTooltip, tooltipOptions: tooltipOptions, onAbort: onAbort, getChatMode: getChatMode, shouldRenderVoiceEnabledFooterRow: shouldRenderVoiceEnabledFooterRow, productKey: productKey, autoSuggestConfig: autoSuggestConfig, autoSuggestQuery: autoSuggestQuery, autoSuggestADF: autoSuggestADF, handleSuggestionSelect: handleSuggestionSelect, showSourceModeToggle: showSourceModeToggle, pageContextType: pageContextType, renderAutoApplyToggle: renderAutoApplyToggle } = props; // Stable callback shared by the footer controls so the
    // outer `React.memo` boundary is not defeated by a new function identity on
    // every render.
    const chatModeStateForReasoningModeMenu = (0, $cozmU.useMemo)(()=>({
            reasoningMode: chatModeReasoningMode
        }), [
        chatModeReasoningMode
    ]);
    const { dictationStatus: dictationStatus, handleDictationStatusChange: handleDictationStatusChange } = (0, $4e4781d535aac0d4$export$596d2ba8e2799493)();
    const shouldOverlayDictationStatus = inputValueLength === 0 && (0, $4e4781d535aac0d4$export$68be235c79785025)(dictationStatus);
    const handleMenuOpen = (0, $cozmU.useCallback)(()=>{
        closeTypeAhead();
        closeEditorToolbar();
    }, [
        closeTypeAhead,
        closeEditorToolbar
    ]); // Show Rovo-owned controls disabled (informative) when switch-back is reachable;
    // otherwise hide them entirely. See the `canSwitchBackToRovo` prop doc above.
    const showDisabledRovoControlsForAgent = canSwitchBackToRovo;
    const hideRovoControlsForAgent = isSpecialistPromptInput && !canSwitchBackToRovo; // Named per-control tooltips shown when the Rovo-only controls are disabled
    // because the user is chatting with an agent. Each names its own control so
    // the reason is clear to sighted and screen-reader users alike.
    const reasoningModeAgentDisabledTooltip = formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).agentDisabledTooltip);
    const filteredAppsAgentDisabledTooltip = formatMessage((0, $18413269ea167174$export$defe85febe8b728c).agentDisabledTooltip);
    const deepResearchAgentDisabledTooltip = formatMessage((0, $72b15252e718d034$export$defe85febe8b728c).agentDisabledTooltip); // Stable composing callbacks so a new function identity per render does not
    // defeat memo boundaries on footer controls.
    const handleDeepResearchToggle = (0, $cozmU.useCallback)((enabled)=>{
        const mode_0 = enabled ? 'deep-research' : 'auto';
        setDeepResearchEnabled(promptDraftAndModeKey, enabled);
        onReasoningModeChange?.(mode_0);
    }, [
        setDeepResearchEnabled,
        promptDraftAndModeKey,
        onReasoningModeChange
    ]);
    const handleWebSearchToggle = (0, $cozmU.useCallback)((enabled_0)=>{
        setWebSearchEnabled(promptDraftAndModeKey, enabled_0);
        onWebSearchToggle?.(enabled_0);
    }, [
        setWebSearchEnabled,
        promptDraftAndModeKey,
        onWebSearchToggle
    ]);
    const handleDeepResearchDismiss = (0, $cozmU.useCallback)(()=>{
        handleDeepResearchToggle(false);
    }, [
        handleDeepResearchToggle
    ]);
    const handleFastReasoningModeChange = (0, $cozmU.useCallback)((mode_1)=>{
        if (mode_1 === 'task' && !chatModeTaskModeEnabled && (0, $iDrrr.fg)('rovo_chat_task_mode_design_refresh')) setTaskModeAnimationTrigger((n)=>n + 1);
        setReasoningMode(promptDraftAndModeKey, mode_1);
        onReasoningModeChange?.(mode_1);
    }, [
        chatModeTaskModeEnabled,
        setTaskModeAnimationTrigger,
        setReasoningMode,
        promptDraftAndModeKey,
        onReasoningModeChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "chat-input-inner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $215735e71f9a3265$export$e182130f07919e28), {
        maxFiles: (0, $1SiET.MAX_FILES),
        currentFileCount: files.length,
        onFilesSelected: handleFilesSelected,
        onUrlsSelected: handleUrlsSelected,
        urlValidationConfig: urlValidationConfig
    }, ({ isDraggedOver: isDraggedOver, innerProps: innerProps, dropzoneContent: dropzoneContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c4e4cf838e4ce45$export$79e9e288b405a1b8), {
            isTaskMode: !!(enableMaxMode && chatModeTaskModeEnabled && (0, $iDrrr.fg)('rovo_chat_task_mode_design_refresh')),
            shouldKeepPromptMounted: shouldKeepTaskModePromptMounted,
            triggerAnimation: taskModeAnimationTrigger
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            ref: innerProps.ref,
            xcss: (0, $w6R6I.cx)($d064a580ef58dc58$var$styles.wrapper, isBackgroundTransparent && !(enableMaxMode && chatModeTaskModeEnabled && (0, $iDrrr.fg)('rovo_chat_task_mode_design_refresh')) ? $d064a580ef58dc58$var$styles.wrapperBackgroundDefault : $d064a580ef58dc58$var$styles.wrapperBackgroundOpaque, !!dropdownSlot && $d064a580ef58dc58$var$styles.wrapperWithDropdown, isDraggedOver && $d064a580ef58dc58$var$styles.fileDragging, !showSingleLineEditor && (!!hoveredPrompt || !!forceTruncatedWrapperOnEmptyEditor && inputValueLength === 0) && $d064a580ef58dc58$var$styles.wrapperWithTruncation, showSingleLineEditor && (!!hoveredPrompt || inputValueLength === 0) && $d064a580ef58dc58$var$styles.wrapperWithTruncationSingleLine, blankObjectStyles && $d064a580ef58dc58$var$styles.wrapperBlankObject),
            testId: "chat-input-wrapper"
        }, selectedAgentForInputHat && shouldRenderInputAgentHat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d064a580ef58dc58$var$styles.inputHatHeader
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60b389bd4ceedccc$export$9c8d9142406f756c), {
            agentId: selectedAgentForInputHat.id,
            agentName: selectedAgentForInputHat.name,
            agentNamedId: selectedAgentForInputHat.namedId,
            agentIdentityAccountId: selectedAgentForInputHat.identityAccountId,
            creatorType: selectedAgentForInputHat.creatorType,
            imageUrl: selectedAgentInputHatImageUrl,
            cloudId: siteId,
            onDismiss: handleSelectedAgentDismiss
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $d064a580ef58dc58$var$styles.wrapperContent,
            testId: "chat-input-wrapper-content"
        }, topAccessory, shouldShowDeepResearchInAddMenu && chatModeDeepResearchEnabled && !hideRovoControlsForAgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $d064a580ef58dc58$var$styles.deepResearchTagWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6c2d4ad6502919e$export$a34759a6f8815868), {
            onDismiss: handleDeepResearchDismiss,
            isDisabled: isDisabled || isAgentTyping || isSpecialistPromptInput,
            disabledTooltip: showDisabledRovoControlsForAgent ? deepResearchAgentDisabledTooltip : undefined
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onBlur: handleEditorBlur,
            onPaste: innerProps.onPaste,
            xcss: (0, $w6R6I.cx)(shouldOverlayDictationStatus ? $d064a580ef58dc58$var$styles.dictationOverlayContainer : undefined, hasCodeBlock ? $d064a580ef58dc58$var$styles.editorWrapperWithSpacing : undefined, showSingleLineEditor ? $d064a580ef58dc58$var$styles.editorSingleLineHeight : contentContext === 'staging-area' || contentContext === 'blank-object-experience' ? $d064a580ef58dc58$var$styles.editorStagingAreaMinHeight : $d064a580ef58dc58$var$styles.editorRovoChatMinHeight)
        }, editorStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$StoreBackedChatInputEditor, {
            contentContext: contentContext,
            editorStore: editorStore,
            enableSkills: enableSkills,
            enableSkillsInStagingArea: enableSkillsInStagingArea,
            enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput,
            isSpecialistPromptInput: isSpecialistPromptInput,
            promptHasSkill: promptHasSkill,
            siteId: siteId
        }) : /*
               * Gate-off keeps the pre-stabilization direct-prop path.
               * Once `rovo_ttai_segment_render_stabilization` rolls out and
               * this bridge is removed, editorApi/editorProps can be required
               * again and these assertions should go away with the fallback.
               */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$ChatInputEditor, {
            contentContext: contentContext,
            editorApi: editorApi,
            editorProps: editorProps,
            enableSkills: enableSkills,
            enableSkillsInStagingArea: enableSkillsInStagingArea,
            enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput,
            isSpecialistPromptInput: isSpecialistPromptInput,
            promptHasSkill: promptHasSkill,
            siteId: siteId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e4781d535aac0d4$export$56e81c7d50c77896), {
            appearance: shouldOverlayDictationStatus ? 'overlay' : 'row',
            status: dictationStatus,
            backgroundOverride: dictationOverlayBackground
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c6cfd9419ae9608$export$4f20080e67eaaf20), {
            count: -1 * charactersOverLimit
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8kYV.InputContextListDisplay), {
            attachtmentsStoreKey: promptDraftAndModeKey
        }), customSlotAboveActionRow, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            xcss: $d064a580ef58dc58$var$styles.actionRow,
            testId: "chat-prompt-footer-row"
        }, (()=>{
            // Slot variables shared between the lazy voice-enabled and
            // disabled fallback branches. Defined once to keep prop
            // updates (e.g. to ChatInputActionButtons or the submit
            // button) localized to a single source of truth.
            const promptControlsSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.050",
                grow: "fill"
            }, showActionsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cH7ad.ChatInputActionButtons), {
                menuItemsVisibility: actionsMenuItemsVisibility,
                entryPoint: entryPoint,
                siteId: siteId,
                placement: menuPosition,
                attachmentsAndCurrentPageAsContextStoreKey: promptDraftAndModeKey,
                isDisabled: isDisabled || isAgentTyping,
                onLinkTypeAheadClick: openLinkTypeAheadFromMenu,
                onMentionTypeAheadClick: openMentionTypeAhead,
                onAddTypeAheadClick: openAddTypeAhead,
                onDiscoverSkillsClick: onDiscoverSkillsClick,
                onDeepResearchClick: shouldShowDeepResearchInAddMenu ? handleDeepResearchClick : undefined,
                isDeepResearchActive: chatModeDeepResearchEnabled,
                onBrowsePromptLibraryClick: onBrowsePromptLibraryClick,
                onCreateSpaceClick: onCreateSpaceClick,
                hasSkillInPrompt: promptHasSkill,
                isAgentMentionActive: hasActiveAgentMention,
                assistanceServiceParams: assistanceServiceParams,
                fileUploadAssistanceOverrides: fileUploadAssistanceOverrides,
                stableFileInputChange: stableFileInputChange,
                contextProviders: contextProviders,
                onContextBrowserShow: onContextBrowserShow,
                onContextAvailable: onContextAvailable,
                useCurrentPageContext: useCurrentPageContext,
                onMenuOpen: handleMenuOpen,
                shouldRenderInPortal: shouldRenderQuickActionsInPortal,
                enableBrowserContextBanner: enableBrowserContextBanner,
                browserContextSanitizer: browserContextSanitizer
            }), showChatModeMenu && (!hideRovoControlsForAgent || !!showAgentSourceControlSpotlight) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d75b6051d08bd783$export$fb6fc81aa90ac691), {
                chatModeKey: promptDraftAndModeKey
            }, (hideLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (!hideRovoControlsForAgent || !!showAgentSourceControlSpotlight) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8a20caf1e04623f$export$f7c7d985a9c5951d), {
                    assistanceServiceParams: assistanceServiceParams,
                    hideLabel: hideLabel,
                    chatModeKey: promptDraftAndModeKey,
                    contentContext: contentContext,
                    isDisabled: isDisabled || isAgentTyping || hasActiveAgentMention || isSpecialistPromptInput,
                    webSearchConfigEnabled: webSearchConfigEnabled,
                    onFilteredAppsChange: onFilteredAppsChange,
                    onWebSearchToggle: handleWebSearchToggle,
                    onOrgKnowledgeToggle: onOrgKnowledgeToggle,
                    enableAppsDiscoveryUi: enableAppsDiscoveryUi,
                    showSourceModeToggle: showSourceModeToggle,
                    shouldRenderInPortal: shouldRenderChatModeMenusInPortal,
                    disabledTooltip: showDisabledRovoControlsForAgent ? filteredAppsAgentDisabledTooltip : undefined,
                    showAgentSourceControlSpotlight: showAgentSourceControlSpotlight,
                    onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight,
                    sourceControlPostOfficeMessage: sourceControlPostOfficeMessage
                }))));
            const actionsBeforeSubmitSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customSlotBeforeChatModeMenu, showChatModeMenu && !hideRovoControlsForAgent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de38fcda73e53a53$export$4bc6d65b94cbeeb4), {
                chatModeState: chatModeStateForReasoningModeMenu,
                enableMaxMode: enableMaxMode,
                onReasoningModeChange: handleFastReasoningModeChange,
                renderAutoApplyToggle: renderAutoApplyToggle,
                isDisabled: isDisabled || isAgentTyping || hasActiveAgentMention || isReasoningModeDisabledByDeepResearch || isSpecialistPromptInput,
                disabledTooltip: isReasoningModeDisabledByDeepResearch ? formatMessage((0, $2e47962ad26b84ca$export$eae963a56e8eb124).deepResearchAddMenuDisabledTooltip) : showDisabledRovoControlsForAgent ? reasoningModeAgentDisabledTooltip : undefined,
                placement: menuPosition,
                shouldRenderInPortal: shouldRenderChatModeMenusInPortal,
                onMenuOpen: handleMenuOpen,
                onMenuOpenChange: onReasoningModeMenuOpenChange
            }), customSlotBeforeSubmitButton);
            const submitButtonSlot = SubmitButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SubmitButton, {
                isAgentTyping: isAgentTyping,
                isSendDisabled: isSendDisabled,
                promptDraftAndModeKey: promptDraftAndModeKey,
                submitButtonTooltip: submitButtonTooltip,
                tooltipOptions: tooltipOptions,
                onSave: submitButtonOnSave,
                onAbort: onAbort,
                getChatMode: getChatMode
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a90455e56c91900$export$41daf28bb61ded76), {
                isAgentTyping: isAgentTyping,
                isSendDisabled: isSendDisabled,
                promptDraftAndModeKey: promptDraftAndModeKey,
                submitButtonTooltip: submitButtonTooltip,
                tooltipOptions: tooltipOptions,
                onSave: submitButtonOnSave,
                onAbort: onAbort,
                getChatMode: getChatMode
            });
            const disabledFallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6718c697198a5dc$export$2e2bcd8739ae039), {
                promptControlsSlot: promptControlsSlot,
                actionsBeforeSubmitSlot: actionsBeforeSubmitSlot,
                submitButtonSlot: submitButtonSlot
            });
            return shouldRenderVoiceEnabledFooterRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                fallbackRender: ()=>disabledFallback,
                onError: (error)=>{
                    (0, $hlvTd.logException)({
                        exception: error,
                        name: 'load-panel-voice-enabled-footer-row',
                        tags: {
                            siteId: siteId
                        }
                    });
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: disabledFallback
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$VoiceEnabledFooterRow, {
                cloudId: siteId,
                entryPoint: entryPoint,
                mode: mode,
                productKey: productKey,
                promptControlsSlot: promptControlsSlot,
                actionsBeforeSubmitSlot: actionsBeforeSubmitSlot,
                submitButtonSlot: submitButtonSlot,
                onInsertTranscript: onInsertTranscript,
                onMicPermissionDenied: onMicPermissionDenied,
                onDictationStatusChange: handleDictationStatusChange
            }))) : disabledFallback;
        })()), dropzoneContent, autoSuggestConfig && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: null,
            interactionName: "chat-prompt-input-autosuggest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$AutoSuggest, {
            query: autoSuggestQuery,
            adf: autoSuggestADF ?? undefined,
            onSuggestionSelect: handleSuggestionSelect,
            position: autoSuggestConfig.position,
            cloudId: siteId,
            source: autoSuggestConfig.source,
            pageContextType: pageContextType,
            productKey: productKey
        })))))));
};
const $d064a580ef58dc58$var$MemoizedChatInputInnerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($d064a580ef58dc58$var$ChatInputInnerContent, (0, $dqxOF.shallowEqualObjects));
const $d064a580ef58dc58$var$StabilizedChatInputInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    let contentProps;
    let editorApi;
    let editorProps;
    if ($[0] !== t0) {
        ({ editorApi: editorApi, editorProps: editorProps, ...contentProps } = t0);
        $[0] = t0;
        $[1] = contentProps;
        $[2] = editorApi;
        $[3] = editorProps;
    } else {
        contentProps = $[1];
        editorApi = $[2];
        editorProps = $[3];
    }
    const editorStore = (0, $5d172eb2188ba678$export$3771425708360732)(editorApi, editorProps);
    let t1;
    if ($[4] !== contentProps || $[5] !== editorStore) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$MemoizedChatInputInnerContent, {
            ...contentProps,
            editorStore: editorStore
        });
        $[4] = contentProps;
        $[5] = editorStore;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ editorApi: editorApi, editorProps: editorProps, ...contentProps })=>{
    const editorStore = (0, $5d172eb2188ba678$export$3771425708360732)(editorApi, editorProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$MemoizedChatInputInnerContent, {
        ...contentProps,
        editorStore: editorStore
    });
};
const $d064a580ef58dc58$export$6212c6fb2ac1afb8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    let contentProps;
    let isRenderStabilizationEnabled;
    if ($[0] !== props) {
        ({ isRenderStabilizationEnabled: isRenderStabilizationEnabled, ...contentProps } = props);
        $[0] = props;
        $[1] = contentProps;
        $[2] = isRenderStabilizationEnabled;
    } else {
        contentProps = $[1];
        isRenderStabilizationEnabled = $[2];
    }
    let t0;
    if ($[3] !== contentProps || $[4] !== isRenderStabilizationEnabled) {
        t0 = isRenderStabilizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$StabilizedChatInputInner, contentProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$ChatInputInnerContent, contentProps);
        $[3] = contentProps;
        $[4] = isRenderStabilizationEnabled;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : (props)=>{
    const { isRenderStabilizationEnabled: isRenderStabilizationEnabled, ...contentProps } = props;
    return isRenderStabilizationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$StabilizedChatInputInner, contentProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d064a580ef58dc58$var$ChatInputInnerContent, contentProps);
};
function $d064a580ef58dc58$var$_temp(n) {
    return n + 1;
}















var $lTaB7 = parcelRequire("lTaB7");





























const $c5c274f6faa39bf9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    connectAppTip: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.connector-source-connection-tip.connect-app-tip",
        defaultMessage: "<link>Connect {appName}</link> to enable access."
    },
    tipLabel: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.connector-source-connection-tip.tip-label",
        defaultMessage: "Tip:"
    },
    proactiveTip: {
        id: "ai-mate.conversation-assistant-chat-prompt-input.connector-source-connection-tip.proactive-tip",
        defaultMessage: "<link>Link your {appName} account</link> to unlock more context and richer details."
    }
});


const $16b426fddc2fd36f$var$styles = {
    tipWrapper: "_2sNsIg7NXe _2Y7lL41Y8M _0xmtko8HPE _1UtDYzKGUX",
    connectLink: "_2sNsIg7NXe _0KLXrujOvk _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _1UtDYzM7Tp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMAwSC"
};
const $16b426fddc2fd36f$export$a2f8b74d821c8856 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onConnected: onConnected, tipType: t1 } = t0;
    const tipType = t1 === undefined ? "reactive" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    let t2;
    let t3;
    if ($[0] !== appSource || $[1] !== sendAnalyticsEvent || $[2] !== tipType) {
        t2 = ()=>{
            sendAnalyticsEvent({
                eventType: "track",
                action: "viewed",
                actionSubject: "rovoChatConnectorSourceTip",
                attributes: {
                    appSource: appSource,
                    tipType: tipType
                }
            });
        };
        t3 = [
            appSource,
            sendAnalyticsEvent,
            tipType
        ];
        $[0] = appSource;
        $[1] = sendAnalyticsEvent;
        $[2] = tipType;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = tipType === "proactive" ? "smartLinkContextBanner" : "connectionTip";
    let t5;
    if ($[5] !== t4) {
        t5 = {
            source: t4
        };
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== appSource || $[8] !== friendlyName || $[9] !== onConnected || $[10] !== outboundAuthUrl || $[11] !== t5) {
        t6 = {
            friendlyName: friendlyName,
            appSource: appSource,
            outboundAuthUrl: outboundAuthUrl,
            onCompletedAction: onConnected,
            analyticsAttributes: t5
        };
        $[7] = appSource;
        $[8] = friendlyName;
        $[9] = onConnected;
        $[10] = outboundAuthUrl;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)(t6);
    let t7;
    if ($[13] !== onAuthorize) {
        t7 = (chunks)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                xcss: $16b426fddc2fd36f$var$styles.connectLink,
                onClick: onAuthorize
            }, chunks);
        $[13] = onAuthorize;
        $[14] = t7;
    } else t7 = $[14];
    const linkRenderer = t7;
    if (!outboundAuthUrl) return null;
    let t8;
    if ($[15] !== formatMessage) {
        t8 = formatMessage((0, $c5c274f6faa39bf9$export$defe85febe8b728c).tipLabel);
        $[15] = formatMessage;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            weight: "medium",
            color: "color.text"
        }, t8, " ");
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== formatMessage || $[20] !== friendlyName || $[21] !== linkRenderer || $[22] !== tipType) {
        t10 = tipType === "proactive" ? formatMessage((0, $c5c274f6faa39bf9$export$defe85febe8b728c).proactiveTip, {
            appName: friendlyName,
            link: linkRenderer
        }) : formatMessage((0, $c5c274f6faa39bf9$export$defe85febe8b728c).connectAppTip, {
            appName: friendlyName,
            link: linkRenderer
        });
        $[19] = formatMessage;
        $[20] = friendlyName;
        $[21] = linkRenderer;
        $[22] = tipType;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== t10 || $[25] !== t9) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $16b426fddc2fd36f$var$styles.tipWrapper
        }, t9, t10);
        $[24] = t10;
        $[25] = t9;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ({ friendlyName: friendlyName, appSource: appSource, outboundAuthUrl: outboundAuthUrl, onConnected: onConnected, tipType: tipType = 'reactive' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'track',
            action: 'viewed',
            actionSubject: 'rovoChatConnectorSourceTip',
            attributes: {
                appSource: appSource,
                tipType: tipType
            }
        });
    }, [
        appSource,
        sendAnalyticsEvent,
        tipType
    ]);
    const { onAuthorize: onAuthorize } = (0, $4M6Ac.useAppOAuth)({
        friendlyName: friendlyName,
        appSource: appSource,
        outboundAuthUrl: outboundAuthUrl,
        onCompletedAction: onConnected,
        analyticsAttributes: {
            source: tipType === 'proactive' ? 'smartLinkContextBanner' : 'connectionTip'
        }
    });
    const linkRenderer = (chunks)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $16b426fddc2fd36f$var$styles.connectLink,
            onClick: onAuthorize
        }, chunks);
    if (!outboundAuthUrl) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $16b426fddc2fd36f$var$styles.tipWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text"
    }, formatMessage((0, $c5c274f6faa39bf9$export$defe85febe8b728c).tipLabel), ' '), tipType === 'proactive' ? formatMessage((0, $c5c274f6faa39bf9$export$defe85febe8b728c).proactiveTip, {
        appName: friendlyName,
        link: linkRenderer
    }) : formatMessage((0, $c5c274f6faa39bf9$export$defe85febe8b728c).connectAppTip, {
        appName: friendlyName,
        link: linkRenderer
    }));
};


const $a73768b06a78f342$export$881917df039155cc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { unconnectedSourceTip: unconnectedSourceTip, dismissTip: dismissTip } = t0;
    const proactiveSmartLinkConnector = (0, $lTaB7.useSmartLinkConnector)();
    let t1;
    if ($[0] !== dismissTip || $[1] !== proactiveSmartLinkConnector || $[2] !== unconnectedSourceTip) {
        t1 = unconnectedSourceTip ? {
            connector: unconnectedSourceTip,
            tipType: "reactive",
            onConnected: dismissTip
        } : proactiveSmartLinkConnector ? {
            connector: proactiveSmartLinkConnector,
            tipType: "proactive",
            onConnected: undefined
        } : null;
        $[0] = dismissTip;
        $[1] = proactiveSmartLinkConnector;
        $[2] = unconnectedSourceTip;
        $[3] = t1;
    } else t1 = $[3];
    const activeTip = t1;
    if (!activeTip) return null;
    const t2 = activeTip.connector.outboundAuthUrl ?? "";
    let t3;
    if ($[4] !== activeTip.connector.friendlyName || $[5] !== activeTip.connector.source || $[6] !== activeTip.onConnected || $[7] !== activeTip.tipType || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "connector-tip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16b426fddc2fd36f$export$a2f8b74d821c8856), {
            friendlyName: activeTip.connector.friendlyName,
            appSource: activeTip.connector.source,
            outboundAuthUrl: t2,
            tipType: activeTip.tipType,
            onConnected: activeTip.onConnected
        }));
        $[4] = activeTip.connector.friendlyName;
        $[5] = activeTip.connector.source;
        $[6] = activeTip.onConnected;
        $[7] = activeTip.tipType;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ unconnectedSourceTip: unconnectedSourceTip, dismissTip: dismissTip })=>{
    const proactiveSmartLinkConnector = (0, $lTaB7.useSmartLinkConnector)();
    const activeTip = unconnectedSourceTip ? {
        connector: unconnectedSourceTip,
        tipType: 'reactive',
        onConnected: dismissTip
    } : proactiveSmartLinkConnector ? {
        connector: proactiveSmartLinkConnector,
        tipType: 'proactive',
        onConnected: undefined
    } : null;
    if (!activeTip) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "connector-tip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16b426fddc2fd36f$export$a2f8b74d821c8856), {
        friendlyName: activeTip.connector.friendlyName,
        appSource: activeTip.connector.source,
        outboundAuthUrl: activeTip.connector.outboundAuthUrl ?? '',
        tipType: activeTip.tipType,
        onConnected: activeTip.onConnected
    }));
};



















const $0a062643e8215604$var$styles = {
    tipWrapper: "_2sNsIg7NXe _2Y7lL41Y8M _0xmtko8HPE _1UtDYzKGUX"
};
const $0a062643e8215604$var$messages = (0, $kSwu1.defineMessages)({
    micPermissionTip: {
        id: "ai-mate.chat-prompt-input.mic-permission-tip.message",
        defaultMessage: "<bold>Tip:</bold> You must allow microphone access in your browser settings to use dictation."
    }
}); /**
     * Informational tip shown when the user has denied microphone access.
     * Renders in the same location and visual style as `ConnectorSourceConnectionTip`.
     */ 
const $0a062643e8215604$export$f8b8a660bb428819 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage($0a062643e8215604$var$messages.micPermissionTip, {
            bold: $0a062643e8215604$var$_temp
        });
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $0a062643e8215604$var$styles.tipWrapper
        }, t0);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0a062643e8215604$var$styles.tipWrapper
    }, formatMessage($0a062643e8215604$var$messages.micPermissionTip, {
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                weight: "medium",
                color: "color.text"
            }, chunks)
    }));
};
function $0a062643e8215604$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "medium",
        color: "color.text"
    }, chunks);
}



























var $hS5Ee = parcelRequire("hS5Ee");


var $kUFQ0 = parcelRequire("kUFQ0");


var $i1t43 = parcelRequire("i1t43");











const $170dd4548c1e9609$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    contextBannerLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.label",
        defaultMessage: "Context"
    },
    referencingDocumentLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.referencing-document-label",
        defaultMessage: "Referencing selected text in"
    },
    removeContextButtonLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.remove-context-button-label",
        defaultMessage: "Remove context"
    },
    referencingDatabaseViewLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.referencing-database-view-label",
        defaultMessage: "Referencing selected view in"
    },
    referencingSelectedCellsLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.referencing-selected-cells-label",
        defaultMessage: "Referencing selected {count, plural, one {cell} other {cells}} in"
    },
    referencingSelectedFieldsLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.referencing-selected-fields-label",
        defaultMessage: "Referencing selected {count, plural, one {field} other {fields}} in"
    },
    referencingSelectedEntriesLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.referencing-selected-entries-in-label",
        defaultMessage: "Referencing selected {count, plural, one {entry} other {entries}} in"
    },
    referencingSelectedCardsLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.referencing-selected-cards-label",
        defaultMessage: "Referencing selected {count, plural, one {card} other {cards}} in"
    },
    referencingIssuesLabel: {
        id: "conversation-assistant-chat-prompt-input.context-banner.referencing-issues-label",
        defaultMessage: "Referencing selected work in"
    }
});


















var $gzMZq = parcelRequire("gzMZq");













const $ac621f252b75cf57$export$1bd29d3e0642301 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isContextActive)=>{
    const $ = (0, $bDgLe.c)(4);
    const publish = (0, $hdBxM.usePublish)("ai-mate");
    let t0;
    let t1;
    if ($[0] !== isContextActive || $[1] !== publish) {
        t0 = ()=>{
            publish({
                type: "smartlinks-subscription-changed",
                source: "conversation-assistant",
                isActive: isContextActive,
                openChat: false
            });
        };
        t1 = [
            isContextActive,
            publish
        ];
        $[0] = isContextActive;
        $[1] = publish;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (isContextActive)=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    (0, $cozmU.useEffect)(()=>{
        publish({
            type: 'smartlinks-subscription-changed',
            source: 'conversation-assistant',
            isActive: isContextActive,
            openChat: false
        });
    }, [
        isContextActive,
        publish
    ]);
};



var $hOUgz = parcelRequire("hOUgz");


var $9zNPM = parcelRequire("9zNPM");


var $2NrpD = parcelRequire("2NrpD");


var $jOKtZ = parcelRequire("jOKtZ");


var $76AAr = parcelRequire("76AAr");

function $c901b3abdacf8d2e$var$isValidEntityContextOverride(value) {
    return value != null && typeof value === 'object' && typeof value.url === 'string' && value.url !== '' && typeof value.name === 'string' && value.name !== '';
}
function $c901b3abdacf8d2e$export$509643aff12ee03b({ contentContext: contentContext = 'global', currentPageAsContextStoreKey: currentPageAsContextStoreKey, enableBrowserContextBanner: enableBrowserContextBanner = false, browserContextSanitizer: browserContextSanitizer, aiFeatureContextOverride: aiFeatureContextOverride, onContextRemoved: onContextRemoved }) {
    (0, $6cFsl.di)((0, $hOUgz.useCurrentPageAsContext), (0, $gzMZq.useChatContextStoreActions), (0, $gzMZq.useChatContextBrowserContext), (0, $9zNPM.useCurrentPageContextEnabled));
    const { setUseCurrentPageContextUserPreference: setUseCurrentPageContextUserPreference, currentContext: pageCurrentContext } = (0, $hOUgz.useCurrentPageAsContext)();
    const overrideEntityContext = (0, $cozmU.useMemo)(()=>{
        const raw = aiFeatureContextOverride?.entityContext;
        return $c901b3abdacf8d2e$var$isValidEntityContextOverride(raw) ? raw : undefined;
    }, [
        aiFeatureContextOverride?.entityContext
    ]);
    const currentContext = (0, $cozmU.useMemo)(()=>overrideEntityContext ? {
            type: (0, $2NrpD.ENTITY_CONTEXT_TYPE),
            url: overrideEntityContext.url,
            name: overrideEntityContext.name
        } : pageCurrentContext, [
        overrideEntityContext,
        pageCurrentContext
    ]);
    const { hasTarget: hasTarget, setAIFeatureContextDismissed: setAIFeatureContextDismissed } = (0, $gzMZq.useChatContextStoreActions)();
    const [browserContext] = (0, $gzMZq.useChatContextBrowserContext)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const jiraViewPayload = currentContext.type === 'jira_view_context' ? currentContext.payload : undefined;
    const selectedIssueCount = jiraViewPayload?.selectedIssueIdentifiers?.length;
    const isReferencingBrowserSelection = (0, $iDrrr.fg)('rovo_chat_browser_selection_context') && !!browserContext?.context?.selection?.content;
    const isReferencingText = currentContext.type === 'editor_context' && !!currentContext.payload?.selection?.content || currentContext.type === 'database_context' && !!currentContext.selectedElementIds && (0, $iDrrr.fg)('confluence_frontend_rovo_db_referencing_content') || isReferencingBrowserSelection;
    const isReferencingIssues = selectedIssueCount !== undefined && selectedIssueCount > 0;
    let labelType = 'context';
    if (isReferencingText) labelType = 'referencing_text';
    else if (isReferencingIssues) labelType = 'referencing_issues';
    const hasBrowserContext = !!browserContext?.context?.browserUrl && enableBrowserContextBanner;
    const { displayUrl: displayUrl, displayTitle: displayTitle } = (0, $76AAr.useContextBannerSmartLinkInfo)({
        currentContext: currentContext,
        hasBrowserContext: hasBrowserContext,
        browserContextUrl: browserContext?.context?.browserUrl
    });
    const isBrowserContextBlocklisted = enableBrowserContextBanner && browserContextSanitizer && hasBrowserContext && browserContext?.context?.browserUrl ? browserContextSanitizer.isBlocklisted(browserContext.context.browserUrl) : false;
    const currentHostname = (0, $cozmU.useMemo)(()=>{
        try {
            const url = new URL(displayUrl);
            return url.hostname.replace(/^www\./, '');
        } catch  {
            return '';
        }
    }, [
        displayUrl
    ]);
    const previousHostnameRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const previousHostname = previousHostnameRef.current;
        if (previousHostname && previousHostname !== currentHostname) setUseCurrentPageContextUserPreference(currentPageAsContextStoreKey, true);
        previousHostnameRef.current = currentHostname;
    }, [
        currentHostname,
        setUseCurrentPageContextUserPreference,
        currentPageAsContextStoreKey
    ]);
    const useCurrentPageContextUserPreferenceValue = (0, $9zNPM.useCurrentPageContextEnabled)(currentPageAsContextStoreKey);
    const hasActiveEditorContext = hasBrowserContext ? useCurrentPageContextUserPreferenceValue : useCurrentPageContextUserPreferenceValue && (currentContext.type !== 'none' || hasTarget(contentContext));
    const isBrowserContextLoading = hasBrowserContext && currentContext.type === 'none' && labelType === 'context' && !browserContext?.context?.browserUrl;
    const activeContext = (0, $cozmU.useMemo)(()=>{
        if (!(0, $jOKtZ.shouldRenderContextBannerSmartCard)({
            hasActiveEditorContext: hasActiveEditorContext,
            isBrowserContextBlocklisted: isBrowserContextBlocklisted,
            isBrowserContextLoading: isBrowserContextLoading
        })) return null;
        return {
            labelType: labelType,
            url: displayUrl,
            title: displayTitle,
            onDismiss: ()=>{
                sendAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'rovoChatContextBannerRemoveContextButton',
                    attributes: {
                        contextType: currentContext.type,
                        labelType: labelType,
                        hasBrowserContext: hasBrowserContext
                    }
                });
                // Generic dismissal: clear any currently stored aiFeatureContext (so it
                // is not attached to the next outgoing message) AND lock the store so
                // upstream publishers
                if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
                (0, $cXtTj.default).getExperimentValue('jira-ai-jira-view-context-in-rovo-chat-experiment', 'isEnabled', false)) setAIFeatureContextDismissed(true);
                setUseCurrentPageContextUserPreference(currentPageAsContextStoreKey, false);
                // After the context is cleared the banner unmounts, which would
                // otherwise leave focus on the removed "Remove context" button and
                // strand keyboard / screen reader users. Restore focus to a sensible
                // location (the prompt input) via the consumer-provided callback.
                onContextRemoved?.();
            },
            selectedDatabaseContent: currentContext.type === 'database_context' ? currentContext.selectedElementIds : undefined,
            selectedIssueCount: selectedIssueCount
        };
    }, [
        hasActiveEditorContext,
        hasBrowserContext,
        isBrowserContextLoading,
        currentContext,
        labelType,
        displayUrl,
        displayTitle,
        setUseCurrentPageContextUserPreference,
        currentPageAsContextStoreKey,
        isBrowserContextBlocklisted,
        selectedIssueCount,
        sendAnalyticsEvent,
        setAIFeatureContextDismissed,
        onContextRemoved
    ]);
    // Fire the SmartLink subscription signal with the correct activation condition.
    (0, $ac621f252b75cf57$export$1bd29d3e0642301)(!!hasActiveEditorContext);
    return activeContext;
}



const $7b3081a59d1a8a69$var$LazySmartCard = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("bE9h1")).then((m)=>({
            default: m.Card
        })));
const $7b3081a59d1a8a69$var$SmartCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$LazySmartCard, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$LazySmartCard, props));
const $7b3081a59d1a8a69$var$styles = {
    bannerWrapper: "_0bjKvDyzSk _2Y7lL48HPE _4c065U2ADO _0KLXrunmFW _0rIjyk8HPE _4kiQYAUF4f",
    contentContainer: "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlN91d",
    contextLabel: "_3YEZNOdnbC",
    fallbackLink: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    referencingDocumentIcon: "_1VJPcal236"
};
const $7b3081a59d1a8a69$var$unsafelyCompiledCssMap = {
    smartCard: "_1EqgXlN91d _37E5QCQ4SZ"
};
const $7b3081a59d1a8a69$var$DATABASE_CONTENT_LABELS = {
    cell: (0, $170dd4548c1e9609$export$defe85febe8b728c).referencingSelectedCellsLabel,
    field: (0, $170dd4548c1e9609$export$defe85febe8b728c).referencingSelectedFieldsLabel,
    card: (0, $170dd4548c1e9609$export$defe85febe8b728c).referencingSelectedCardsLabel,
    entry: (0, $170dd4548c1e9609$export$defe85febe8b728c).referencingSelectedEntriesLabel
};
const $7b3081a59d1a8a69$var$getReferencingDatabaseContentLabel = (selectedDatabaseContent)=>{
    if (selectedDatabaseContent.length === 0) return {
        descriptor: (0, $170dd4548c1e9609$export$defe85febe8b728c).referencingDatabaseViewLabel
    };
     // extract the prefix from the first selected database content
    const prefix = selectedDatabaseContent[0].match(/^(cell|field|card|entry)/)?.[1];
    const descriptor = prefix ? $7b3081a59d1a8a69$var$DATABASE_CONTENT_LABELS[prefix] : (0, $170dd4548c1e9609$export$defe85febe8b728c).referencingDatabaseViewLabel;
    return {
        descriptor: descriptor ?? (0, $170dd4548c1e9609$export$defe85febe8b728c).referencingDatabaseViewLabel,
        count: prefix ? selectedDatabaseContent.length : undefined
    };
};
const $7b3081a59d1a8a69$var$getReferencingLabelText = (formatMessage, selectedDatabaseContent)=>{
    if (!selectedDatabaseContent) return formatMessage((0, $170dd4548c1e9609$export$defe85febe8b728c).referencingDocumentLabel);
    const { descriptor: descriptor, count: count } = $7b3081a59d1a8a69$var$getReferencingDatabaseContentLabel(selectedDatabaseContent);
    return count !== undefined ? formatMessage(descriptor, {
        count: count
    }) : formatMessage(descriptor);
};
const $7b3081a59d1a8a69$var$getContextLabelContent = (formatMessage, labelType, selectedDatabaseContent, selectedIssueCount)=>{
    if (labelType === 'referencing_text') return $7b3081a59d1a8a69$var$getReferencingLabelText(formatMessage, selectedDatabaseContent);
    if (labelType === 'referencing_issues' && selectedIssueCount !== undefined) return formatMessage((0, $170dd4548c1e9609$export$defe85febe8b728c).referencingIssuesLabel, {
        count: selectedIssueCount
    });
    return '';
};
const $7b3081a59d1a8a69$var$ContextBannerItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { contextInfo: contextInfo } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const currentUrl = contextInfo.url;
    const currentTitle = contextInfo.title;
    const { labelType: labelType, selectedDatabaseContent: selectedDatabaseContent, selectedIssueCount: selectedIssueCount } = contextInfo;
    let t1;
    if ($[0] !== formatMessage || $[1] !== labelType || $[2] !== selectedDatabaseContent || $[3] !== selectedIssueCount) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $7b3081a59d1a8a69$var$styles.contextLabel,
            space: "space.050",
            alignBlock: "center"
        }, labelType === "referencing_text" || labelType === "referencing_issues" ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $7b3081a59d1a8a69$var$styles.referencingDocumentIcon,
            space: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
            size: "small",
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)"
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, $7b3081a59d1a8a69$var$getContextLabelContent(formatMessage, labelType, selectedDatabaseContent, selectedIssueCount))) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))), {
            size: "small",
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $170dd4548c1e9609$export$defe85febe8b728c).contextBannerLabel), ":")));
        $[0] = formatMessage;
        $[1] = labelType;
        $[2] = selectedDatabaseContent;
        $[3] = selectedIssueCount;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $7b3081a59d1a8a69$var$unsafelyCompiledCssMap.smartCard
        ]);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== currentUrl) {
        t3 = ()=>{
            window.open(currentUrl, "_blank");
        };
        $[6] = currentUrl;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== currentTitle || $[9] !== currentUrl) {
        t4 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $7b3081a59d1a8a69$var$styles.fallbackLink
            }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: currentUrl,
                rel: "noopener noreferrer",
                target: "_blank",
                appearance: "subtle"
            }, currentTitle));
        $[8] = currentTitle;
        $[9] = currentUrl;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== currentTitle || $[12] !== currentUrl || $[13] !== t3 || $[14] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$SmartCard, {
            key: currentUrl,
            url: currentUrl,
            appearance: "inline",
            truncateInline: true,
            resolvingPlaceholder: currentTitle,
            onClick: t3,
            fallbackComponent: t4
        }));
        $[11] = currentTitle;
        $[12] = currentUrl;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t1 || $[17] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $7b3081a59d1a8a69$var$styles.contentContainer,
            space: "space.050",
            alignBlock: "center"
        }, t1, t5);
        $[16] = t1;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== formatMessage) {
        t7 = formatMessage((0, $170dd4548c1e9609$export$defe85febe8b728c).removeContextButtonLabel);
        $[19] = formatMessage;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== contextInfo.onDismiss || $[22] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            spacing: "compact",
            isTooltipDisabled: false,
            appearance: "subtle",
            shape: "circle",
            label: t7,
            icon: $7b3081a59d1a8a69$var$_temp,
            color: "color.text.subtlest",
            onClick: contextInfo.onDismiss
        });
        $[21] = contextInfo.onDismiss;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t6 || $[25] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center",
            space: "space.100"
        }, t6, t8);
        $[24] = t6;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ contextInfo: contextInfo })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const currentUrl = contextInfo.url;
    const currentTitle = contextInfo.title;
    const { labelType: labelType, selectedDatabaseContent: selectedDatabaseContent, selectedIssueCount: selectedIssueCount } = contextInfo;
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $7b3081a59d1a8a69$var$styles.contentContainer,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $7b3081a59d1a8a69$var$styles.contextLabel,
        space: "space.050",
        alignBlock: "center"
    }, labelType === 'referencing_text' || labelType === 'referencing_issues' ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $7b3081a59d1a8a69$var$styles.referencingDocumentIcon,
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
        size: "small",
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, $7b3081a59d1a8a69$var$getContextLabelContent(formatMessage, labelType, selectedDatabaseContent, selectedIssueCount))) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))), {
        size: "small",
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $170dd4548c1e9609$export$defe85febe8b728c).contextBannerLabel), ":"))), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $7b3081a59d1a8a69$var$unsafelyCompiledCssMap.smartCard
        ])
    }, /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$SmartCard, {
        key: currentUrl,
        url: currentUrl,
        appearance: "inline",
        truncateInline: true,
        resolvingPlaceholder: currentTitle,
        onClick: ()=>{
            window.open(currentUrl, '_blank');
        },
        fallbackComponent: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $7b3081a59d1a8a69$var$styles.fallbackLink
            }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                href: currentUrl,
                rel: "noopener noreferrer",
                target: "_blank",
                appearance: "subtle"
            }, currentTitle))
    }))), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        spacing: "compact",
        isTooltipDisabled: false,
        appearance: "subtle",
        shape: "circle",
        label: formatMessage((0, $170dd4548c1e9609$export$defe85febe8b728c).removeContextButtonLabel),
        icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                size: "small",
                label: "",
                color: "var(--ds-text-subtlest, #6B6E76)"
            }),
        color: "color.text.subtlest",
        onClick: contextInfo.onDismiss
    }));
};
const $7b3081a59d1a8a69$var$ContextBannerComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    const activeContext = (0, $c901b3abdacf8d2e$export$509643aff12ee03b)(props);
    if (!activeContext) return null;
    let t0;
    if ($[0] !== activeContext) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $7b3081a59d1a8a69$var$styles.bannerWrapper
        }, /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$ContextBannerItem, {
            contextInfo: activeContext
        }));
        $[0] = activeContext;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    const activeContext = (0, $c901b3abdacf8d2e$export$509643aff12ee03b)(props);
    if (!activeContext) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7b3081a59d1a8a69$var$styles.bannerWrapper
    }, /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$ContextBannerItem, {
        contextInfo: activeContext
    }));
}; // Reference-identity comparison of all `ContextBannerProps`. This is equivalent
// to React's default shallow compare over these props; it is spelled out so the
// freshness-input contract is explicit. Two of these props (`browserContextSanitizer`
// and `aiFeatureContextOverride`) are objects compared by identity, so callers MUST
// pass referentially stable values for them — constructing either inline at the call
// site would defeat this memo (stale UI or render thrash). If a new prop is added to
// `ContextBannerProps`, it must be added here too, otherwise it will be silently
// ignored by the memo.
const $7b3081a59d1a8a69$var$areContextBannerPropsEqual = (previousProps, nextProps)=>Object.is(previousProps.contentContext, nextProps.contentContext) && Object.is(previousProps.currentPageAsContextStoreKey, nextProps.currentPageAsContextStoreKey) && Object.is(previousProps.enableBrowserContextBanner, nextProps.enableBrowserContextBanner) && Object.is(previousProps.browserContextSanitizer, nextProps.browserContextSanitizer) && Object.is(previousProps.aiFeatureContextOverride, nextProps.aiFeatureContextOverride) && Object.is(previousProps.onContextRemoved, nextProps.onContextRemoved);
const $7b3081a59d1a8a69$var$MemoizedContextBanner = /*#__PURE__*/ (0, $cozmU.memo)($7b3081a59d1a8a69$var$ContextBannerComponent, $7b3081a59d1a8a69$var$areContextBannerPropsEqual);
const $7b3081a59d1a8a69$export$64607723dae284ee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $cXtTj.default).getExperimentValue("rovo_ttai_segment_render_stabilization", "isEnabled", false);
        $[0] = t0;
    } else t0 = $[0];
    const gateEnabled = t0;
    let t1;
    if ($[1] !== props) {
        t1 = gateEnabled ? /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$MemoizedContextBanner, props) : /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$ContextBannerComponent, props);
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const gateEnabled = (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false);
    return gateEnabled ? /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$MemoizedContextBanner, props) : /*#__PURE__*/ $cozmU.createElement($7b3081a59d1a8a69$var$ContextBannerComponent, props);
};
function $7b3081a59d1a8a69$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        size: "small",
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    });
}




const $b5dcef10fb5a07fe$export$82b9122e2536e335 = ({ isAgentMentionActive: isAgentMentionActive, isSpecialistPromptInput: isSpecialistPromptInput, sourceMode: sourceMode })=>(0, $e8dbbe344c450ab9$export$338c380e79652155)({
        isAgentMentionActive: isAgentMentionActive,
        isSpecialistPromptInput: isSpecialistPromptInput
    }) ? undefined : sourceMode;



const $940a641243f799e0$export$626ed2520b7a25ca = ({ isAgentMentionActive: isAgentMentionActive, isSpecialistPromptInput: isSpecialistPromptInput, webSearchConfigEnabled: webSearchConfigEnabled, webSearchEnabled: webSearchEnabled })=>!(0, $e8dbbe344c450ab9$export$338c380e79652155)({
        isAgentMentionActive: isAgentMentionActive,
        isSpecialistPromptInput: isSpecialistPromptInput
    }) && webSearchConfigEnabled && webSearchEnabled;














var $kEPax = parcelRequire("kEPax");




var $6NRmI = parcelRequire("6NRmI");


var $bGVJw = parcelRequire("bGVJw");


var $6m3nS = parcelRequire("6m3nS");


var $beNrf = parcelRequire("beNrf");









































var $6OwHS = parcelRequire("6OwHS");













var $e685f83141d868b0$exports = {};
$e685f83141d868b0$exports = new URL("agent-mentions-spotlight.5e344809.png", import.meta.url).toString();



const $82dc4521ca84911e$var$OFFSET = [
    -170,
    0
];
const $82dc4521ca84911e$export$dc75332b233da9b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { isVisible: isVisible, onDismiss: onDismiss, postOfficeMessage: postOfficeMessage, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== onDismiss) {
        t1 = ()=>onDismiss("cross-icon");
        $[0] = onDismiss;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentMentionsOnboardingSpotlightTitle);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== onDismiss) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
            onClick: ()=>onDismiss("cross-icon")
        }));
        $[6] = onDismiss;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, t3, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($e685f83141d868b0$exports))),
            alt: "",
            width: "288px",
            height: "138px"
        }));
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== formatMessage) {
        t7 = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentMentionsOnboardingSpotlightBody);
        $[12] = formatMessage;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, t7);
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== onDismiss) {
        t9 = ()=>onDismiss("ok-button");
        $[16] = onDismiss;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== formatMessage) {
        t10 = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentMentionsOnboardingSpotlightOk);
        $[18] = formatMessage;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== t10 || $[21] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
            onClick: t9
        }, t10)));
        $[20] = t10;
        $[21] = t9;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t5 || $[25] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: "agent-mentions-onboarding-spotlight"
        }, t5, t6, t8, t11);
        $[23] = t11;
        $[24] = t5;
        $[25] = t8;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== isVisible || $[28] !== t1 || $[29] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
            dismiss: t1,
            isVisible: isVisible,
            placement: "top-end",
            offset: $82dc4521ca84911e$var$OFFSET
        }, t12);
        $[27] = isVisible;
        $[28] = t1;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    const popoverContent = t13;
    let t14;
    if ($[31] !== children) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children);
        $[31] = children;
        $[32] = t14;
    } else t14 = $[32];
    let t15;
    if ($[33] !== popoverContent || $[34] !== postOfficeMessage) {
        t15 = postOfficeMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(postOfficeMessage.PostOfficeMessageInstance, {
            messageInstanceId: postOfficeMessage.messageInstanceId
        }, ()=>popoverContent) : null;
        $[33] = popoverContent;
        $[34] = postOfficeMessage;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== t14 || $[37] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, t14, t15);
        $[36] = t14;
        $[37] = t15;
        $[38] = t16;
    } else t16 = $[38];
    return t16;
} : ({ isVisible: isVisible, onDismiss: onDismiss, postOfficeMessage: postOfficeMessage, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const popoverContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: ()=>onDismiss('cross-icon'),
        isVisible: isVisible,
        placement: "top-end",
        offset: $82dc4521ca84911e$var$OFFSET
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "agent-mentions-onboarding-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentMentionsOnboardingSpotlightTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: ()=>onDismiss('cross-icon')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e685f83141d868b0$exports))),
        alt: "",
        width: "288px",
        height: "138px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentMentionsOnboardingSpotlightBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: ()=>onDismiss('ok-button')
    }, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentMentionsOnboardingSpotlightOk))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), postOfficeMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(postOfficeMessage.PostOfficeMessageInstance, {
        messageInstanceId: postOfficeMessage.messageInstanceId
    }, ()=>popoverContent) : null);
};


const $975230536ec8bc57$var$MENTION_AGENTS_ONBOARDING_FEATURE_ID = 'mention-agents-onboarding';
const $975230536ec8bc57$var$SOURCE_CONTROL_UNAVAILABLE_FEATURE_ID = 'source-control-unavailable';
const $975230536ec8bc57$var$NO_ACKNOWLEDGED_SPOTLIGHTS = {
    [$975230536ec8bc57$var$MENTION_AGENTS_ONBOARDING_FEATURE_ID]: false,
    [$975230536ec8bc57$var$SOURCE_CONTROL_UNAVAILABLE_FEATURE_ID]: false
};
const $975230536ec8bc57$var$ACKNOWLEDGED_SPOTLIGHTS_PAGE_STORE_KEY = Symbol.for('rovo-chat.mention-agents.acknowledged-spotlights');
// The sidebar can recreate this module when it closes and reopens. Store the two flags and their
// listeners on the page global so every copy of the sidebar bundle shares the same page-lifetime
// acknowledgement state. A full page load resets the flags.
const $975230536ec8bc57$var$getPageStore = ()=>{
    const existingStore = Reflect.get(globalThis, $975230536ec8bc57$var$ACKNOWLEDGED_SPOTLIGHTS_PAGE_STORE_KEY);
    if (existingStore) return existingStore;
    const pageStore = {
        snapshot: $975230536ec8bc57$var$NO_ACKNOWLEDGED_SPOTLIGHTS,
        listeners: new Set()
    };
    Reflect.set(globalThis, $975230536ec8bc57$var$ACKNOWLEDGED_SPOTLIGHTS_PAGE_STORE_KEY, pageStore);
    return pageStore;
};
const $975230536ec8bc57$var$subscribeToAcknowledgements = (listener)=>{
    const pageStore = $975230536ec8bc57$var$getPageStore();
    pageStore.listeners.add(listener);
    return ()=>{
        pageStore.listeners.delete(listener);
    };
};
const $975230536ec8bc57$var$getAcknowledgedSpotlights = ()=>$975230536ec8bc57$var$getPageStore().snapshot;
const $975230536ec8bc57$var$acknowledgeSpotlight = (featureId)=>{
    const pageStore = $975230536ec8bc57$var$getPageStore();
    if (pageStore.snapshot[featureId]) return;
    pageStore.snapshot = {
        ...pageStore.snapshot,
        [featureId]: true
    };
    pageStore.listeners.forEach((listener)=>listener());
};
const $975230536ec8bc57$export$53eb6e3bfa945e68 = {
    mentionAgentsOnboardingFeatureId: $975230536ec8bc57$var$MENTION_AGENTS_ONBOARDING_FEATURE_ID,
    sourceControlUnavailableFeatureId: $975230536ec8bc57$var$SOURCE_CONTROL_UNAVAILABLE_FEATURE_ID,
    subscribe: $975230536ec8bc57$var$subscribeToAcknowledgements,
    getSnapshot: $975230536ec8bc57$var$getAcknowledgedSpotlights,
    getServerSnapshot: ()=>$975230536ec8bc57$var$NO_ACKNOWLEDGED_SPOTLIGHTS,
    acknowledge: $975230536ec8bc57$var$acknowledgeSpotlight
};


const $5f8138d29eebe7ed$var$CONFLUENCE_AGENTS_SPOTLIGHTS_TRIGGER_ID = 'confluence-agents-spotlights';
const $5f8138d29eebe7ed$var$HEADLESS_PLACEMENT_ID = 'headless';
const $5f8138d29eebe7ed$var$MENTION_AGENTS_SPOTLIGHT_TEMPLATE_ID = 'rovo-chat-mention-agents-onboarding-spotlight';
const $5f8138d29eebe7ed$var$CHOREOGRAPHER_CONFIG = {
    isDefaultEnabled: true
};
const { mentionAgentsOnboardingFeatureId: $5f8138d29eebe7ed$var$MENTION_AGENTS_ONBOARDING_FEATURE_ID, sourceControlUnavailableFeatureId: $5f8138d29eebe7ed$var$SOURCE_CONTROL_UNAVAILABLE_FEATURE_ID } = (0, $975230536ec8bc57$export$53eb6e3bfa945e68);
const $5f8138d29eebe7ed$var$toInAppMessageCreationType = (messageCreationType)=>messageCreationType === 'explicit' ? 'explicit' : 'implicit';
const $5f8138d29eebe7ed$var$NOOP_DISMISS_AGENT_SOURCE_CONTROL_SPOTLIGHT = ()=>{};
const $5f8138d29eebe7ed$export$d951d9e39205c4ba = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { isEnabled: isEnabled, mode: mode, shouldRenderInputAgentHat: shouldRenderInputAgentHat, hasAvailableAgents: hasAvailableAgents, hasActiveAgentMention: hasActiveAgentMention, children: children } = t0;
    if (!isEnabled) {
        let t1;
        if ($[0] !== children) {
            t1 = children({
                showAgentSourceControlSpotlight: false,
                onDismissAgentSourceControlSpotlight: $5f8138d29eebe7ed$var$NOOP_DISMISS_AGENT_SOURCE_CONTROL_SPOTLIGHT,
                sourceControlPostOfficeMessage: undefined
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] !== children || $[5] !== hasActiveAgentMention || $[6] !== hasAvailableAgents || $[7] !== mode || $[8] !== shouldRenderInputAgentHat) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NRmI.StableChoreographerProvider), {
            choreographer: $5f8138d29eebe7ed$var$CHOREOGRAPHER_CONFIG,
            placementId: $5f8138d29eebe7ed$var$HEADLESS_PLACEMENT_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5f8138d29eebe7ed$var$MentionAgentsSpotlightControllerInner, {
            mode: mode,
            shouldRenderInputAgentHat: shouldRenderInputAgentHat,
            hasAvailableAgents: hasAvailableAgents,
            hasActiveAgentMention: hasActiveAgentMention
        }, children));
        $[4] = children;
        $[5] = hasActiveAgentMention;
        $[6] = hasAvailableAgents;
        $[7] = mode;
        $[8] = shouldRenderInputAgentHat;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : ({ isEnabled: isEnabled, mode: mode, shouldRenderInputAgentHat: shouldRenderInputAgentHat, hasAvailableAgents: hasAvailableAgents, hasActiveAgentMention: hasActiveAgentMention, children: children })=>{
    if (!isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        showAgentSourceControlSpotlight: false,
        onDismissAgentSourceControlSpotlight: $5f8138d29eebe7ed$var$NOOP_DISMISS_AGENT_SOURCE_CONTROL_SPOTLIGHT,
        sourceControlPostOfficeMessage: undefined
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6NRmI.StableChoreographerProvider), {
        choreographer: $5f8138d29eebe7ed$var$CHOREOGRAPHER_CONFIG,
        placementId: $5f8138d29eebe7ed$var$HEADLESS_PLACEMENT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5f8138d29eebe7ed$var$MentionAgentsSpotlightControllerInner, {
        mode: mode,
        shouldRenderInputAgentHat: shouldRenderInputAgentHat,
        hasAvailableAgents: hasAvailableAgents,
        hasActiveAgentMention: hasActiveAgentMention
    }, children));
};
const $5f8138d29eebe7ed$var$MentionAgentsSpotlightControllerInner = ({ mode: mode, shouldRenderInputAgentHat: shouldRenderInputAgentHat, hasAvailableAgents: hasAvailableAgents, hasActiveAgentMention: hasActiveAgentMention, children: children })=>{
    const postOfficeContext = (0, $bGVJw.usePostOfficeContext)();
    const { isActive: isConfluenceAgentsSpotlightsActive } = (0, $6m3nS.useTrigger)($5f8138d29eebe7ed$var$CONFLUENCE_AGENTS_SPOTLIGHTS_TRIGGER_ID);
    const messageInstanceEventClientRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(new (0, $kEPax.MessageInstanceEventClient)());
    const locallyAcknowledgedSpotlights = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useSyncExternalStore((0, $975230536ec8bc57$export$53eb6e3bfa945e68).subscribe, (0, $975230536ec8bc57$export$53eb6e3bfa945e68).getSnapshot, (0, $975230536ec8bc57$export$53eb6e3bfa945e68).getServerSnapshot);
    const hasAcknowledgedSpotlight = (featureId)=>locallyAcknowledgedSpotlights[featureId];
    const { messages: mentionAgentsSpotlightMessages, dismissMessage: dismissMentionAgentsSpotlightMessage, isLoading: isMentionAgentsSpotlightLoading, PostOfficeMessageInstance: PostOfficeMessageInstance } = (0, $beNrf.useMessageInstances)({
        placementId: $5f8138d29eebe7ed$var$HEADLESS_PLACEMENT_ID,
        messageTemplateId: $5f8138d29eebe7ed$var$MENTION_AGENTS_SPOTLIGHT_TEMPLATE_ID
    });
    const shouldShowOnboardingSpotlightOnSupportedSurface = mode === 'sidebar' || mode === 'mini-modal';
    const shouldShowMentionAgentsSpotlight = shouldRenderInputAgentHat && hasAvailableAgents && !isMentionAgentsSpotlightLoading;
    const mentionAgentsOnboardingSpotlight = shouldShowMentionAgentsSpotlight && !isConfluenceAgentsSpotlightsActive && shouldShowOnboardingSpotlightOnSupportedSurface && !hasAcknowledgedSpotlight($5f8138d29eebe7ed$var$MENTION_AGENTS_ONBOARDING_FEATURE_ID) ? mentionAgentsSpotlightMessages.find((message)=>message.context?.featureId === $5f8138d29eebe7ed$var$MENTION_AGENTS_ONBOARDING_FEATURE_ID) : undefined;
    const sourceControlUnavailableSpotlight = shouldShowMentionAgentsSpotlight && shouldShowOnboardingSpotlightOnSupportedSurface && hasActiveAgentMention && !hasAcknowledgedSpotlight($5f8138d29eebe7ed$var$SOURCE_CONTROL_UNAVAILABLE_FEATURE_ID) ? mentionAgentsSpotlightMessages.find((message_0)=>message_0.context?.featureId === $5f8138d29eebe7ed$var$SOURCE_CONTROL_UNAVAILABLE_FEATURE_ID) : undefined;
    const dismissAgentMentionsOnboardingSpotlight = (source)=>{
        if (!mentionAgentsOnboardingSpotlight) return;
        const clickPayload = {
            messageInstanceId: mentionAgentsOnboardingSpotlight.messageInstanceId,
            messageTemplateId: mentionAgentsOnboardingSpotlight.messageTemplateId,
            messageTriggerId: mentionAgentsOnboardingSpotlight.triggerId ?? '',
            messageCreationType: $5f8138d29eebe7ed$var$toInAppMessageCreationType(mentionAgentsOnboardingSpotlight.messageCreationType),
            deliveryChannel: 'in-app',
            placementId: $5f8138d29eebe7ed$var$HEADLESS_PLACEMENT_ID,
            channelType: 'pull',
            context: {
                ...postOfficeContext,
                source: 'headless',
                recommendation: {
                    recommendationSessionId: '',
                    recommendationEntityId: '',
                    itemFeatureSetId: ''
                }
            },
            timestamp: Date.now(),
            messageEventType: 'clicked',
            clickedElement: source === 'ok-button' ? {
                clickIdentifier: 'ok',
                clickedElement: 'button',
                buttonType: 'primary'
            } : {
                clickIdentifier: 'dismiss',
                clickedElement: 'cross-icon'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        };
        (0, $975230536ec8bc57$export$53eb6e3bfa945e68).acknowledge($5f8138d29eebe7ed$var$MENTION_AGENTS_ONBOARDING_FEATURE_ID);
        dismissMentionAgentsSpotlightMessage(mentionAgentsOnboardingSpotlight.messageInstanceId);
        try {
            const sendResult = messageInstanceEventClientRef.current.sendMessageInstanceEvent(clickPayload);
            if (sendResult) sendResult.catch(()=>{
            // Allow optimistic dismiss to proceed even if event emission fails.
            });
        } catch  {
        // Allow optimistic dismiss to proceed even if event emission throws synchronously.
        }
    };
    const dismissAgentSourceControlSpotlight = (source_0 = 'cross-icon')=>{
        if (!sourceControlUnavailableSpotlight) return;
        const clickPayload_0 = {
            messageInstanceId: sourceControlUnavailableSpotlight.messageInstanceId,
            messageTemplateId: sourceControlUnavailableSpotlight.messageTemplateId,
            messageTriggerId: sourceControlUnavailableSpotlight.triggerId ?? '',
            messageCreationType: $5f8138d29eebe7ed$var$toInAppMessageCreationType(sourceControlUnavailableSpotlight.messageCreationType),
            deliveryChannel: 'in-app',
            placementId: $5f8138d29eebe7ed$var$HEADLESS_PLACEMENT_ID,
            channelType: 'pull',
            context: {
                ...postOfficeContext,
                source: 'headless',
                recommendation: {
                    recommendationSessionId: '',
                    recommendationEntityId: '',
                    itemFeatureSetId: ''
                }
            },
            timestamp: Date.now(),
            messageEventType: 'clicked',
            clickedElement: source_0 === 'understood-button' ? {
                clickIdentifier: 'understood',
                clickedElement: 'button',
                buttonType: 'primary'
            } : {
                clickIdentifier: 'dismiss',
                clickedElement: 'cross-icon'
            },
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        };
        (0, $975230536ec8bc57$export$53eb6e3bfa945e68).acknowledge($5f8138d29eebe7ed$var$SOURCE_CONTROL_UNAVAILABLE_FEATURE_ID);
        dismissMentionAgentsSpotlightMessage(sourceControlUnavailableSpotlight.messageInstanceId);
        try {
            const sendResult_0 = messageInstanceEventClientRef.current.sendMessageInstanceEvent(clickPayload_0);
            if (sendResult_0) sendResult_0.catch(()=>{
            // Allow optimistic dismiss to proceed even if event emission fails.
            });
        } catch  {
        // Allow optimistic dismiss to proceed even if event emission throws synchronously.
        }
    };
    const onboardingPostOfficeMessage = mentionAgentsOnboardingSpotlight ? {
        messageInstanceId: mentionAgentsOnboardingSpotlight.messageInstanceId,
        PostOfficeMessageInstance: PostOfficeMessageInstance
    } : undefined;
    const sourceControlPostOfficeMessage = sourceControlUnavailableSpotlight ? {
        messageInstanceId: sourceControlUnavailableSpotlight.messageInstanceId,
        PostOfficeMessageInstance: PostOfficeMessageInstance
    } : undefined;
    const content = children({
        showAgentSourceControlSpotlight: !!sourceControlUnavailableSpotlight,
        onDismissAgentSourceControlSpotlight: dismissAgentSourceControlSpotlight,
        sourceControlPostOfficeMessage: sourceControlPostOfficeMessage
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82dc4521ca84911e$export$dc75332b233da9b1), {
        isVisible: !!mentionAgentsOnboardingSpotlight,
        onDismiss: dismissAgentMentionsOnboardingSpotlight,
        postOfficeMessage: onboardingPostOfficeMessage
    }, content);
};
























/**
 * Page-lifetime "already shown" state for the skills changeboard.
 *
 * Show-once is split in two: Post Office stops delivering the message across page loads (the
 * template's `viewed-check-filter`), and this store covers a single page load, where the headless
 * placement is not refetched and so still holds the same message instance when Rovo Chat reopens.
 *
 * Not localStorage: `AtlBrowserStorageLocal.setItem` returns `Status.BLOCKED` and writes nothing
 * for keys that are not registered in the BSC data store, so the flag never persisted and every
 * Rovo Chat open looked like a first view.
 *
 * The sidebar can recreate this module when it closes and reopens (see
 * `MentionAgentsSpotlightAcknowledgementStore`), so the flag lives on the page global rather than
 * in module scope.
 */ const $97af8a0f79e2d5fb$var$SKILLS_CHANGEBOARD_SHOWN_PAGE_STORE_KEY = Symbol.for('rovo-chat.skills-changeboard.shown');
const $97af8a0f79e2d5fb$var$hasBeenShown = ()=>Reflect.get(globalThis, $97af8a0f79e2d5fb$var$SKILLS_CHANGEBOARD_SHOWN_PAGE_STORE_KEY) === true;
const $97af8a0f79e2d5fb$var$markShown = ()=>{
    Reflect.set(globalThis, $97af8a0f79e2d5fb$var$SKILLS_CHANGEBOARD_SHOWN_PAGE_STORE_KEY, true);
};
const $97af8a0f79e2d5fb$export$7631bfc8ba199fd9 = {
    hasBeenShown: $97af8a0f79e2d5fb$var$hasBeenShown,
    markShown: $97af8a0f79e2d5fb$var$markShown,
    reset: ()=>{
        Reflect.deleteProperty(globalThis, $97af8a0f79e2d5fb$var$SKILLS_CHANGEBOARD_SHOWN_PAGE_STORE_KEY);
    }
};















var $laf3S = parcelRequire("laf3S");











































var $b77b3f0ec2b5fbaf$exports = {};
$b77b3f0ec2b5fbaf$exports = new URL("skills-spotlight.58782f2b.svg", import.meta.url).toString();



// Placed to the left of the Rovo chat panel (the anchor is the chat input), pointing right at it
const $45939f255c3a45b8$var$OFFSET = [
    0,
    12
];
const $45939f255c3a45b8$export$c3702f51eeae19e0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { isVisible: isVisible, onViewSkills: onViewSkills, onDismiss: onDismiss, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onDismiss) {
        t2 = ()=>onDismiss("light-dismiss");
        $[2] = onDismiss;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).skillsOnboardingSpotlightTitle);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== onDismiss) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
            onClick: ()=>onDismiss("cross-icon")
        }));
        $[8] = onDismiss;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b77b3f0ec2b5fbaf$exports))),
            alt: "",
            width: "100%"
        }));
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== formatMessage) {
        t8 = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).skillsOnboardingSpotlightBody);
        $[14] = formatMessage;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, t8);
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== formatMessage) {
        t10 = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).skillsOnboardingSpotlightViewSkills);
        $[18] = formatMessage;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== onViewSkills || $[21] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
            onClick: onViewSkills
        }, t10)));
        $[20] = onViewSkills;
        $[21] = t10;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t6 || $[25] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $laf3S.ThemeProvider), {
            defaultColorMode: "light"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: "skills-onboarding-spotlight"
        }, t6, t7, t9, t11));
        $[23] = t11;
        $[24] = t6;
        $[25] = t9;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== isVisible || $[28] !== t12 || $[29] !== t2) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
            dismiss: t2,
            isVisible: isVisible,
            placement: "left-start",
            offset: $45939f255c3a45b8$var$OFFSET
        }, t12);
        $[27] = isVisible;
        $[28] = t12;
        $[29] = t2;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== t1 || $[32] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, t1, t13);
        $[31] = t1;
        $[32] = t13;
        $[33] = t14;
    } else t14 = $[33];
    return t14;
} : ({ isVisible: isVisible, onViewSkills: onViewSkills, onDismiss: onDismiss, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent // Fires for any click outside the card, including closing the Rovo panel, and for Escape.
    ), {
        // The X control has its own handler below.
        dismiss: ()=>onDismiss('light-dismiss'),
        isVisible: isVisible,
        placement: "left-start",
        offset: $45939f255c3a45b8$var$OFFSET
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $laf3S.ThemeProvider), {
        defaultColorMode: "light"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "skills-onboarding-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).skillsOnboardingSpotlightTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: ()=>onDismiss('cross-icon')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b77b3f0ec2b5fbaf$exports))),
        alt: "",
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).skillsOnboardingSpotlightBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: onViewSkills
    }, formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).skillsOnboardingSpotlightViewSkills))))))));
};


const $e108032b0dd37bba$var$SKILLS_SPOTLIGHT_TEMPLATE_ID = 'rovo-chat-skills-onboarding-spotlight';
const $e108032b0dd37bba$var$SKILLS_ONBOARDING_FEATURE_ID = 'skills-onboarding';
const $e108032b0dd37bba$var$toInAppMessageCreationType = (messageCreationType)=>messageCreationType === 'explicit' ? 'explicit' : 'implicit';
const $e108032b0dd37bba$export$8f1070797568276d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { enableSkills: enableSkills, onViewSkills: onViewSkills, children: children } = t0;
    const [hasChangeboardBeenShown] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState((0, $97af8a0f79e2d5fb$export$7631bfc8ba199fd9).hasBeenShown);
    if (!enableSkills || hasChangeboardBeenShown) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (!(0, $iDrrr.fg)("post-office_rovo-chat-skills-changeboard")) {
        let t1;
        if ($[2] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[2] = children;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    let t1;
    if ($[4] !== children || $[5] !== onViewSkills) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e108032b0dd37bba$var$SkillsSpotlightControllerInner, {
            onViewSkills: onViewSkills
        }, children);
        $[4] = children;
        $[5] = onViewSkills;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ enableSkills: enableSkills, onViewSkills: onViewSkills, children: children })=>{
    // Read once per mount, not subscribed: the changeboard marks itself shown as it renders, and a
    // reactive read would unmount it mid-view. Suppression applies to the next mount instead.
    const [hasChangeboardBeenShown] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState((0, $97af8a0f79e2d5fb$export$7631bfc8ba199fd9).hasBeenShown);
    if (!enableSkills || hasChangeboardBeenShown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    // Feature-gate the rollout as the last term, after the cheap eligibility checks above. The gate
    // name must be a static string literal (@atlaskit/platform/static-feature-flags), so it is inlined
    // here rather than stored in a constant.
    if (!(0, $iDrrr.fg)('post-office_rovo-chat-skills-changeboard')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e108032b0dd37bba$var$SkillsSpotlightControllerInner, {
        onViewSkills: onViewSkills
    }, children);
};
const $e108032b0dd37bba$var$SkillsSpotlightControllerInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { onViewSkills: onViewSkills, children: children } = t0;
    const postOfficeContext = (0, $bGVJw.usePostOfficeContext)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new (0, $kEPax.MessageInstanceEventClient)();
        $[0] = t1;
    } else t1 = $[0];
    const messageInstanceEventClientRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t1);
    const [isDismissed, setIsDismissed] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            placementId: "headless",
            messageTemplateId: $e108032b0dd37bba$var$SKILLS_SPOTLIGHT_TEMPLATE_ID
        };
        $[1] = t2;
    } else t2 = $[1];
    const { messages: skillsSpotlightMessages, dismissMessage: dismissSkillsSpotlightMessage, isLoading: isSkillsSpotlightLoading } = (0, $beNrf.useMessageInstances)(t2);
    let t3;
    if ($[2] !== isSkillsSpotlightLoading || $[3] !== skillsSpotlightMessages) {
        t3 = !isSkillsSpotlightLoading ? skillsSpotlightMessages.find($e108032b0dd37bba$var$_temp) : undefined;
        $[2] = isSkillsSpotlightLoading;
        $[3] = skillsSpotlightMessages;
        $[4] = t3;
    } else t3 = $[4];
    const skillsOnboardingSpotlight = t3;
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {};
        $[5] = t4;
    } else t4 = $[5];
    const sentViewedEventIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t4);
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {};
        $[6] = t5;
    } else t5 = $[6];
    const sentDeliverySuccessfulEventIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t5);
    let t6;
    if ($[7] !== postOfficeContext) {
        t6 = (message_0)=>{
            if (!message_0) return;
            const basePayload = {
                messageInstanceId: message_0.messageInstanceId,
                messageTemplateId: message_0.messageTemplateId,
                messageTriggerId: message_0.triggerId ?? "",
                messageCreationType: $e108032b0dd37bba$var$toInAppMessageCreationType(message_0.messageCreationType),
                deliveryChannel: "in-app",
                placementId: "headless",
                channelType: "pull",
                context: {
                    ...postOfficeContext,
                    source: "headless",
                    recommendation: {
                        recommendationSessionId: "",
                        recommendationEntityId: "",
                        itemFeatureSetId: ""
                    }
                },
                timestamp: Date.now()
            };
            if (!sentViewedEventIdsRef.current[message_0.messageInstanceId]) {
                const sendViewedResult = messageInstanceEventClientRef.current.sendMessageInstanceEvent({
                    ...basePayload,
                    messageEventType: "viewed"
                });
                sentViewedEventIdsRef.current[message_0.messageInstanceId] = true;
                if (sendViewedResult) sendViewedResult.catch($e108032b0dd37bba$var$_temp2);
            }
            if (!sentDeliverySuccessfulEventIdsRef.current[message_0.messageInstanceId]) {
                const sendDeliveryResult = messageInstanceEventClientRef.current.sendMessageInstanceEvent({
                    ...basePayload,
                    messageEventType: "deliverySuccessful"
                });
                sentDeliverySuccessfulEventIdsRef.current[message_0.messageInstanceId] = true;
                if (sendDeliveryResult) sendDeliveryResult.catch($e108032b0dd37bba$var$_temp3);
            }
        };
        $[7] = postOfficeContext;
        $[8] = t6;
    } else t6 = $[8];
    const emitVisibilityLifecycleEvents = t6;
    let t7;
    let t8;
    if ($[9] !== emitVisibilityLifecycleEvents || $[10] !== skillsOnboardingSpotlight) {
        t7 = ()=>{
            emitVisibilityLifecycleEvents(skillsOnboardingSpotlight);
        };
        t8 = [
            emitVisibilityLifecycleEvents,
            skillsOnboardingSpotlight
        ];
        $[9] = emitVisibilityLifecycleEvents;
        $[10] = skillsOnboardingSpotlight;
        $[11] = t7;
        $[12] = t8;
    } else {
        t7 = $[11];
        t8 = $[12];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t7, t8);
    const seenMessageInstanceId = skillsOnboardingSpotlight?.messageInstanceId;
    let t10;
    let t9;
    if ($[13] !== seenMessageInstanceId) {
        t9 = ()=>{
            if (!seenMessageInstanceId) return;
            (0, $97af8a0f79e2d5fb$export$7631bfc8ba199fd9).markShown();
        };
        t10 = [
            seenMessageInstanceId
        ];
        $[13] = seenMessageInstanceId;
        $[14] = t10;
        $[15] = t9;
    } else {
        t10 = $[14];
        t9 = $[15];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t9, t10);
    let t11;
    if ($[16] !== dismissSkillsSpotlightMessage || $[17] !== isDismissed || $[18] !== postOfficeContext || $[19] !== skillsOnboardingSpotlight) {
        t11 = (source)=>{
            if (!skillsOnboardingSpotlight || isDismissed) return;
            const clickPayload = {
                messageInstanceId: skillsOnboardingSpotlight.messageInstanceId,
                messageTemplateId: skillsOnboardingSpotlight.messageTemplateId,
                messageTriggerId: skillsOnboardingSpotlight.triggerId ?? "",
                messageCreationType: $e108032b0dd37bba$var$toInAppMessageCreationType(skillsOnboardingSpotlight.messageCreationType),
                deliveryChannel: "in-app",
                placementId: "headless",
                channelType: "pull",
                context: {
                    ...postOfficeContext,
                    source: "headless",
                    recommendation: {
                        recommendationSessionId: "",
                        recommendationEntityId: "",
                        itemFeatureSetId: ""
                    }
                },
                timestamp: Date.now(),
                messageEventType: "clicked",
                clickedElement: source === "view-skills-button" ? {
                    clickIdentifier: "view-skills",
                    clickedElement: "button",
                    buttonType: "primary"
                } : {
                    clickIdentifier: source === "cross-icon" ? "dismiss" : "lightDismiss",
                    clickedElement: "cross-icon"
                },
                action: {
                    actionType: "dismiss"
                },
                additionalMetadataFromFrontend: {}
            };
            const sendResult = messageInstanceEventClientRef.current.sendMessageInstanceEvent(clickPayload);
            if (sendResult) sendResult.catch($e108032b0dd37bba$var$_temp4);
            dismissSkillsSpotlightMessage(skillsOnboardingSpotlight.messageInstanceId);
            setIsDismissed(true);
        };
        $[16] = dismissSkillsSpotlightMessage;
        $[17] = isDismissed;
        $[18] = postOfficeContext;
        $[19] = skillsOnboardingSpotlight;
        $[20] = t11;
    } else t11 = $[20];
    const emitClickAndDismiss = t11;
    let t12;
    if ($[21] !== emitClickAndDismiss || $[22] !== onViewSkills) {
        t12 = ()=>{
            onViewSkills?.();
            emitClickAndDismiss("view-skills-button");
        };
        $[21] = emitClickAndDismiss;
        $[22] = onViewSkills;
        $[23] = t12;
    } else t12 = $[23];
    const handleViewSkills = t12;
    let t13;
    if ($[24] !== emitClickAndDismiss) {
        t13 = (source_0)=>{
            emitClickAndDismiss(source_0);
        };
        $[24] = emitClickAndDismiss;
        $[25] = t13;
    } else t13 = $[25];
    const handleDismiss = t13;
    const t14 = !isDismissed && !!skillsOnboardingSpotlight;
    let t15;
    if ($[26] !== children || $[27] !== handleDismiss || $[28] !== handleViewSkills || $[29] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45939f255c3a45b8$export$c3702f51eeae19e0), {
            isVisible: t14,
            onViewSkills: handleViewSkills,
            onDismiss: handleDismiss
        }, children);
        $[26] = children;
        $[27] = handleDismiss;
        $[28] = handleViewSkills;
        $[29] = t14;
        $[30] = t15;
    } else t15 = $[30];
    return t15;
} : ({ onViewSkills: onViewSkills, children: children })=>{
    const postOfficeContext = (0, $bGVJw.usePostOfficeContext)();
    const messageInstanceEventClientRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(new (0, $kEPax.MessageInstanceEventClient)());
    // Optimistically hide on dismiss/CTA so the spotlight closes immediately regardless of the Post
    // Office round-trip (dismissMessage also removes it from the placement result).
    const [isDismissed, setIsDismissed] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const { messages: skillsSpotlightMessages, dismissMessage: dismissSkillsSpotlightMessage, isLoading: isSkillsSpotlightLoading } = (0, $beNrf.useMessageInstances)({
        placementId: 'headless',
        messageTemplateId: $e108032b0dd37bba$var$SKILLS_SPOTLIGHT_TEMPLATE_ID
    });
    const skillsOnboardingSpotlight = !isSkillsSpotlightLoading ? skillsSpotlightMessages.find((message)=>message.context?.featureId === $e108032b0dd37bba$var$SKILLS_ONBOARDING_FEATURE_ID) : undefined;
    const sentViewedEventIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    const sentDeliverySuccessfulEventIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    const emitVisibilityLifecycleEvents = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((message_0)=>{
        if (!message_0) return;
        const basePayload = {
            messageInstanceId: message_0.messageInstanceId,
            messageTemplateId: message_0.messageTemplateId,
            messageTriggerId: message_0.triggerId ?? '',
            messageCreationType: $e108032b0dd37bba$var$toInAppMessageCreationType(message_0.messageCreationType),
            deliveryChannel: 'in-app',
            placementId: 'headless',
            channelType: 'pull',
            context: {
                ...postOfficeContext,
                source: 'headless',
                recommendation: {
                    recommendationSessionId: '',
                    recommendationEntityId: '',
                    itemFeatureSetId: ''
                }
            },
            timestamp: Date.now()
        };
        if (!sentViewedEventIdsRef.current[message_0.messageInstanceId]) {
            const sendViewedResult = messageInstanceEventClientRef.current.sendMessageInstanceEvent({
                ...basePayload,
                messageEventType: 'viewed'
            });
            sentViewedEventIdsRef.current[message_0.messageInstanceId] = true;
            if (sendViewedResult) sendViewedResult.catch(()=>{
            // Swallow lifecycle failures to avoid blocking product-owned spotlight rendering.
            });
        }
        if (!sentDeliverySuccessfulEventIdsRef.current[message_0.messageInstanceId]) {
            const sendDeliveryResult = messageInstanceEventClientRef.current.sendMessageInstanceEvent({
                ...basePayload,
                messageEventType: 'deliverySuccessful'
            });
            sentDeliverySuccessfulEventIdsRef.current[message_0.messageInstanceId] = true;
            if (sendDeliveryResult) sendDeliveryResult.catch(()=>{
            // Swallow lifecycle failures to avoid blocking product-owned spotlight rendering.
            });
        }
    }, [
        postOfficeContext
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        emitVisibilityLifecycleEvents(skillsOnboardingSpotlight);
    }, [
        emitVisibilityLifecycleEvents,
        skillsOnboardingSpotlight
    ]);
    // Keyed on the instance id rather than on `emitVisibilityLifecycleEvents`, which depends on
    // `postOfficeContext` and so would re-fire this on every render.
    const seenMessageInstanceId = skillsOnboardingSpotlight?.messageInstanceId;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!seenMessageInstanceId) return;
        // Suppress for the rest of this page load, whether or not the user interacts. Post Office's
        // viewed-check-filter takes over from the next page load, keyed off the `viewed` event above.
        (0, $97af8a0f79e2d5fb$export$7631bfc8ba199fd9).markShown();
    }, [
        seenMessageInstanceId
    ]);
    const emitClickAndDismiss = (source)=>{
        // ADS keeps its outside-click listener bound while the card unmounts, so a second click can
        // land after the first dismissal. Post Office must not get two `clicked` events for one card.
        if (!skillsOnboardingSpotlight || isDismissed) return;
        const clickPayload = {
            messageInstanceId: skillsOnboardingSpotlight.messageInstanceId,
            messageTemplateId: skillsOnboardingSpotlight.messageTemplateId,
            messageTriggerId: skillsOnboardingSpotlight.triggerId ?? '',
            messageCreationType: $e108032b0dd37bba$var$toInAppMessageCreationType(skillsOnboardingSpotlight.messageCreationType),
            deliveryChannel: 'in-app',
            placementId: 'headless',
            channelType: 'pull',
            context: {
                ...postOfficeContext,
                source: 'headless',
                recommendation: {
                    recommendationSessionId: '',
                    recommendationEntityId: '',
                    itemFeatureSetId: ''
                }
            },
            timestamp: Date.now(),
            messageEventType: 'clicked',
            clickedElement: source === 'view-skills-button' ? {
                clickIdentifier: 'view-skills',
                clickedElement: 'button',
                buttonType: 'primary'
            } : {
                // `clickedElement` has no value for "clicked away", so the source lives here instead.
                clickIdentifier: source === 'cross-icon' ? 'dismiss' : 'lightDismiss',
                clickedElement: 'cross-icon'
            },
            // 'dismiss' for every path, matching `MentionAgentsSpotlightController`. 'acknowledge' would
            // read better for the CTA, but Post Office's click/dismiss check filters do not recognise it
            // and would keep delivering the message. Revisit once they do.
            action: {
                actionType: 'dismiss'
            },
            additionalMetadataFromFrontend: {}
        };
        const sendResult = messageInstanceEventClientRef.current.sendMessageInstanceEvent(clickPayload);
        if (sendResult) sendResult.catch(()=>{
        // Allow optimistic dismiss to proceed even if event emission fails.
        });
        dismissSkillsSpotlightMessage(skillsOnboardingSpotlight.messageInstanceId);
        setIsDismissed(true);
    };
    const handleViewSkills = ()=>{
        // Run the existing, already-implemented behavior first: insert `/` and open the skill picker.
        onViewSkills?.();
        emitClickAndDismiss('view-skills-button');
    };
    // Clicking away counts as a dismissal, not just the X, so the changeboard is not re-delivered to
    // someone who closed it the usual way.
    const handleDismiss = (source_0)=>{
        emitClickAndDismiss(source_0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45939f255c3a45b8$export$c3702f51eeae19e0), {
        isVisible: !isDismissed && !!skillsOnboardingSpotlight,
        onViewSkills: handleViewSkills,
        onDismiss: handleDismiss
    }, children);
};
function $e108032b0dd37bba$var$_temp(message) {
    return message.context?.featureId === $e108032b0dd37bba$var$SKILLS_ONBOARDING_FEATURE_ID;
}
function $e108032b0dd37bba$var$_temp2() {}
function $e108032b0dd37bba$var$_temp3() {}
function $e108032b0dd37bba$var$_temp4() {}















var $9DHhW = parcelRequire("9DHhW");








var $hMaHH = parcelRequire("hMaHH");





















const $c97ddf30984fa1be$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    referencingSourcesLabel: {
        id: "conversation-assistant-chat-prompt-input.space-context-banner.referencing-sources-label",
        defaultMessage: "Referencing {count, plural, one {# source} other {# sources}}"
    },
    viewSourcesLabel: {
        id: "conversation-assistant-chat-prompt-input.chat-prompt-input.space-context-banner.view-sources-label",
        defaultMessage: "View {count, plural, one {# source} other {# sources}}"
    },
    zeroSourcesTitle: {
        id: "conversation-assistant-chat-prompt-input.space-context-banner.zero-sources-title",
        defaultMessage: "Add sources to your space"
    },
    zeroSourcesDescription: {
        id: "conversation-assistant-chat-prompt-input.space-context-banner.zero-sources-description",
        defaultMessage: "This space doesn't have sources yet. Get more relevant answers \u2014 add Confluence pages, Jira projects, or other sources to this Space."
    },
    zeroSourcesDismissLabel: {
        id: "conversation-assistant-chat-prompt-input.space-context-banner.zero-sources-dismiss-label",
        defaultMessage: "Dismiss"
    }
});




















var $lmyCc = parcelRequire("lmyCc");


var $gzzWs = parcelRequire("gzzWs");

const $4d26b4c5363d0980$var$MAX_VISIBLE_LOGOS = 3; /** Mirrors the rotation angles in SourceButtonIcons/AppIconWrapper. */ 
const $4d26b4c5363d0980$var$ICON_ROTATIONS = {
    1: -6,
    3: 8
};
const $4d26b4c5363d0980$var$styles = {
    outerContainer: "_3iDTPbccYA _0hPCNLDIqT",
    overflowCount: "_2xTnZx1Y8M",
    container: "_3iDTPbccYA _0hPCNLDIqT _1mT5xdRAKS",
    logoWrapper: "_1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _0GTcwR4F84",
    firstLogo: "_0GTcwRLl21"
};
/**
 * Resolves and renders a single rotated provider icon for a source URL.
 * Falls back to nothing while the SmartLink is pending or on error.
 */ const $4d26b4c5363d0980$var$RotatedSourceIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { url: url, index: index, total: total } = t0;
    const { providerIcon: providerIcon } = (0, $gzzWs.useSmartLinkMetadata)(url);
    const rotation = $4d26b4c5363d0980$var$ICON_ROTATIONS[index];
    const t1 = index === 0 && $4d26b4c5363d0980$var$styles.firstLogo;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($4d26b4c5363d0980$var$styles.logoWrapper, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = total - index;
    const t4 = rotation ? `rotate(${rotation}deg)` : undefined;
    let t5;
    if ($[2] !== t3 || $[3] !== t4) {
        t5 = {
            zIndex: t3,
            transform: t4
        };
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== providerIcon) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lmyCc.ProviderIconView), {
            icon: providerIcon
        });
        $[5] = providerIcon;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== t2 || $[8] !== t5 || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            style: t5
        }, t6);
        $[7] = t2;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    return t7;
} : ({ url: url, index: index, total: total })=>{
    const { providerIcon: providerIcon } = (0, $gzzWs.useSmartLinkMetadata)(url);
    const rotation = $4d26b4c5363d0980$var$ICON_ROTATIONS[index];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($4d26b4c5363d0980$var$styles.logoWrapper, index === 0 && $4d26b4c5363d0980$var$styles.firstLogo),
        style: {
            zIndex: total - index,
            transform: rotation ? `rotate(${rotation}deg)` : undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lmyCc.ProviderIconView), {
        icon: providerIcon
    }));
};
const $4d26b4c5363d0980$export$a191f7ef02a04125 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { sources: sources } = t0;
    if (sources.length === 0) return null;
    let t1;
    if ($[0] !== sources) {
        t1 = Array.from(new Set(sources.map($4d26b4c5363d0980$var$_temp)));
        $[0] = sources;
        $[1] = t1;
    } else t1 = $[1];
    const allUniqueUrls = t1;
    let t2;
    if ($[2] !== allUniqueUrls) {
        t2 = allUniqueUrls.slice(0, $4d26b4c5363d0980$var$MAX_VISIBLE_LOGOS);
        $[2] = allUniqueUrls;
        $[3] = t2;
    } else t2 = $[3];
    const visibleUrls = t2;
    const overflowCount = allUniqueUrls.length - visibleUrls.length;
    let t3;
    if ($[4] !== visibleUrls) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4d26b4c5363d0980$var$styles.container
        }, visibleUrls.map((url, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d26b4c5363d0980$var$RotatedSourceIcon, {
                key: url,
                url: url,
                index: index,
                total: visibleUrls.length
            })));
        $[4] = visibleUrls;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== overflowCount) {
        t4 = overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4d26b4c5363d0980$var$styles.overflowCount
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, "+", overflowCount));
        $[6] = overflowCount;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $4d26b4c5363d0980$var$styles.outerContainer
        }, t3, t4);
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ sources: sources })=>{
    if (sources.length === 0) return null;
     // Deduplicate by URL so each source gets its own SmartLink resolution.
    const allUniqueUrls = Array.from(new Set(sources.map((s)=>s.url)));
    const visibleUrls = allUniqueUrls.slice(0, $4d26b4c5363d0980$var$MAX_VISIBLE_LOGOS);
    const overflowCount = allUniqueUrls.length - visibleUrls.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4d26b4c5363d0980$var$styles.outerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4d26b4c5363d0980$var$styles.container
    }, visibleUrls.map((url, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d26b4c5363d0980$var$RotatedSourceIcon, {
            key: url,
            url: url,
            index: index,
            total: visibleUrls.length
        }))), overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4d26b4c5363d0980$var$styles.overflowCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, "+", overflowCount)));
};
function $4d26b4c5363d0980$var$_temp(s) {
    return s.url;
}


const $aaf8b90c158e72ee$var$ANALYTICS_CHANNEL = 'aiMate';
const $aaf8b90c158e72ee$var$ACTIVE_CONTEXT_SOURCE_TYPE = 'active_context';

const $aaf8b90c158e72ee$var$LazySourcesPopupContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("dqfc0")).then((module)=>({
            default: module.SourcesPopupContent
        })));
const $aaf8b90c158e72ee$var$styles = {
    bannerWrapper: "_0bjKvDyzSk _2Y7lL48HPE _4c065U2ADO _0KLXrunmFW _0rIjyk8HPE _4kiQYAUF4f",
    clickableBannerWrapper: "_39xV02N91d _0wOv4Q7zJH _1eOmH6o126",
    contentContainer: "_4bt5LAnQyn _2WAcuGnQyn _1EqgXlN91d",
    contextLabel: "_3YEZNOdnbC",
    referencingDocumentIcon: "_1VJPcal236",
    zeroSourcesBanner: "_2mHwu82ADO _0bjKvDyzSk _3iDTPbQ4SZ _46hvQm8HPE _0xmtko8HPE _0LQT5E8HPE _03SyCP8HPE _0KLXrunmFW _0rIjyk5zaO",
    zeroSourcesIcon: "_0bjKvDKTcp _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02pJKa _0jFU0VpJKa _3YEZNOdnbC _43nrzT1Y8M _1UtDYzZpcK _0KLXrulfZc",
    zeroSourcesIconGlyph: "_3iDTPbQ4SZ _1VJPcaepHn",
    zeroSourcesLayout: "_4ouGXIdnbC",
    zeroSourcesContent: "_4ouGXIdnbC _2O5Vij7dHp _46hvQm1Y8M",
    fullWidthAction: "_39xV02N91d"
};
const $aaf8b90c158e72ee$var$isThirdPartySpaceSource = (source)=>!source.ari || source.ari === source.url;
const $aaf8b90c158e72ee$var$mapSourcesForPopup = (sources, activeContext)=>{
    const spaceSources = sources.filter((source)=>source.url).map((source)=>({
            source: {
                ari: source.ari === source.url ? '' : source.ari,
                title: source.name ?? source.url,
                type: source.sourceType,
                url: source.url,
                lastModified: '',
                product: source.sourceType
            },
            metadata: {
                isThirdParty: $aaf8b90c158e72ee$var$isThirdPartySpaceSource(source)
            }
        }));
    const activeContextSource = activeContext?.url && activeContext.title ? [
        {
            source: {
                ari: '',
                title: activeContext.title,
                type: $aaf8b90c158e72ee$var$ACTIVE_CONTEXT_SOURCE_TYPE,
                url: activeContext.url,
                lastModified: '',
                product: $aaf8b90c158e72ee$var$ACTIVE_CONTEXT_SOURCE_TYPE
            },
            metadata: {
                isThirdParty: false
            }
        }
    ] : [];
    const mappedSources = [
        ...spaceSources,
        ...activeContextSource
    ];
    return {
        popupSources: mappedSources.map(({ source: source })=>source),
        sourceAnalyticsMetadata: mappedSources.map(({ metadata: metadata })=>metadata)
    };
};
const $aaf8b90c158e72ee$export$9c07d9d16c63c035 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(69);
    const { sourceCount: sourceCount, sources: t1, activeContext: activeContext, hasActiveContext: t2, zeroSourcesAction: zeroSourcesAction } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const sources = t3;
    const hasActiveContext = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isZeroSourcesBannerDismissed, setIsZeroSourcesBannerDismissed] = (0, $cozmU.useState)(false);
    const isOpenRef = (0, $cozmU.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t4;
    if ($[2] !== activeContext || $[3] !== sources) {
        t4 = $aaf8b90c158e72ee$var$mapSourcesForPopup(sources, activeContext);
        $[2] = activeContext;
        $[3] = sources;
        $[4] = t4;
    } else t4 = $[4];
    const { popupSources: popupSources, sourceAnalyticsMetadata: sourceAnalyticsMetadata } = t4;
    const hasContextSource = activeContext ? true : hasActiveContext;
    let t5;
    if ($[5] !== createAnalyticsEvent) {
        t5 = (state)=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "sources",
                attributes: {
                    source: "spaceContextBanner",
                    state: state
                }
            }).fire($aaf8b90c158e72ee$var$ANALYTICS_CHANNEL);
        };
        $[5] = createAnalyticsEvent;
        $[6] = t5;
    } else t5 = $[6];
    const fireTriggerAnalytics = t5;
    let t6;
    if ($[7] !== createAnalyticsEvent || $[8] !== sourceAnalyticsMetadata) {
        t6 = (type, ari, product, index)=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "sourceLink",
                attributes: {
                    index: index,
                    is3pLink: sourceAnalyticsMetadata[index ?? -1]?.isThirdParty ?? !ari,
                    product: product,
                    source: "spaceContextBanner",
                    sourceType: type
                }
            }).fire($aaf8b90c158e72ee$var$ANALYTICS_CHANNEL);
        };
        $[7] = createAnalyticsEvent;
        $[8] = sourceAnalyticsMetadata;
        $[9] = t6;
    } else t6 = $[9];
    const handleSourceLinkClick = t6;
    let t7;
    if ($[10] !== fireTriggerAnalytics) {
        t7 = (nextIsOpen)=>{
            if (isOpenRef.current === nextIsOpen) return;
            fireTriggerAnalytics(nextIsOpen ? "open" : "closed");
            isOpenRef.current = nextIsOpen;
            setIsOpen(nextIsOpen);
        };
        $[10] = fireTriggerAnalytics;
        $[11] = t7;
    } else t7 = $[11];
    const setPopupOpen = t7;
    let t8;
    if ($[12] !== setPopupOpen) {
        t8 = ()=>{
            setPopupOpen(false);
        };
        $[12] = setPopupOpen;
        $[13] = t8;
    } else t8 = $[13];
    const handleClose = t8;
    let t9;
    if ($[14] !== setPopupOpen) {
        t9 = ()=>{
            setPopupOpen(!isOpenRef.current);
        };
        $[14] = setPopupOpen;
        $[15] = t9;
    } else t9 = $[15];
    const handleToggle = t9;
    let t10;
    if ($[16] !== handleClose || $[17] !== handleSourceLinkClick || $[18] !== popupSources) {
        t10 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaf8b90c158e72ee$var$LazySourcesPopupContent, {
                sources: popupSources,
                onClickSourceHandler: handleSourceLinkClick,
                onClose: handleClose
            }));
        $[16] = handleClose;
        $[17] = handleSourceLinkClick;
        $[18] = popupSources;
        $[19] = t10;
    } else t10 = $[19];
    const renderPopupContent = t10;
    if (!popupSources.length && sourceCount === undefined) return null;
    const effectiveSourceCount = popupSources.length > 0 ? popupSources.length : (sourceCount ?? 0) + (hasContextSource ? 1 : 0);
    if (effectiveSourceCount === 0 && zeroSourcesAction && isZeroSourcesBannerDismissed) return null;
    if (effectiveSourceCount === 0 && zeroSourcesAction) {
        let t11;
        if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesIcon,
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesIconGlyph
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                label: ""
            })));
            $[20] = t11;
        } else t11 = $[20];
        let t12;
        if ($[21] !== formatMessage) {
            t12 = formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).zeroSourcesTitle);
            $[21] = formatMessage;
            $[22] = t12;
        } else t12 = $[22];
        let t13;
        if ($[23] !== t12) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "bold"
            }, t12);
            $[23] = t12;
            $[24] = t13;
        } else t13 = $[24];
        let t14;
        if ($[25] !== formatMessage) {
            t14 = formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).zeroSourcesDescription);
            $[25] = formatMessage;
            $[26] = t14;
        } else t14 = $[26];
        let t15;
        if ($[27] !== t14) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, t14);
            $[27] = t14;
            $[28] = t15;
        } else t15 = $[28];
        let t16;
        if ($[29] !== t13 || $[30] !== t15) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesLayout,
                space: "space.150",
                alignBlock: "start"
            }, t11, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.050"
            }, t13, t15)));
            $[29] = t13;
            $[30] = t15;
            $[31] = t16;
        } else t16 = $[31];
        let t17;
        if ($[32] !== zeroSourcesAction) {
            t17 = zeroSourcesAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $aaf8b90c158e72ee$var$styles.fullWidthAction
            }, zeroSourcesAction);
            $[32] = zeroSourcesAction;
            $[33] = t17;
        } else t17 = $[33];
        let t18;
        if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
            t18 = ()=>setIsZeroSourcesBannerDismissed(true);
            $[34] = t18;
        } else t18 = $[34];
        let t19;
        if ($[35] !== formatMessage) {
            t19 = formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).zeroSourcesDismissLabel);
            $[35] = formatMessage;
            $[36] = t19;
        } else t19 = $[36];
        let t20;
        if ($[37] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: t18,
                shouldFitContainer: true
            }, t19);
            $[37] = t19;
            $[38] = t20;
        } else t20 = $[38];
        let t21;
        if ($[39] !== t17 || $[40] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.075"
            }, t17, t20);
            $[39] = t17;
            $[40] = t20;
            $[41] = t21;
        } else t21 = $[41];
        let t22;
        if ($[42] !== t16 || $[43] !== t21) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesBanner,
                space: "space.100"
            }, t16, t21);
            $[42] = t16;
            $[43] = t21;
            $[44] = t22;
        } else t22 = $[44];
        return t22;
    }
    let t11;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $aaf8b90c158e72ee$var$styles.referencingDocumentIcon,
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
            size: "small",
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)"
        }));
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== effectiveSourceCount || $[47] !== formatMessage) {
        t12 = formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).referencingSourcesLabel, {
            count: effectiveSourceCount
        });
        $[46] = effectiveSourceCount;
        $[47] = formatMessage;
        $[48] = t12;
    } else t12 = $[48];
    let t13;
    if ($[49] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest"
        }, t12);
        $[49] = t12;
        $[50] = t13;
    } else t13 = $[50];
    let t14;
    if ($[51] !== sources) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d26b4c5363d0980$export$a191f7ef02a04125), {
            sources: sources
        });
        $[51] = sources;
        $[52] = t14;
    } else t14 = $[52];
    let t15;
    if ($[53] !== t13 || $[54] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $aaf8b90c158e72ee$var$styles.contentContainer,
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $aaf8b90c158e72ee$var$styles.contextLabel,
            space: "space.050",
            alignBlock: "center"
        }, t11, t13, t14));
        $[53] = t13;
        $[54] = t14;
        $[55] = t15;
    } else t15 = $[55];
    const bannerContent = t15;
    if (popupSources.length === 0) {
        let t16;
        if ($[56] !== bannerContent) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $aaf8b90c158e72ee$var$styles.bannerWrapper
            }, bannerContent);
            $[56] = bannerContent;
            $[57] = t16;
        } else t16 = $[57];
        return t16;
    }
    let t16;
    if ($[58] !== bannerContent || $[59] !== effectiveSourceCount || $[60] !== formatMessage || $[61] !== handleToggle || $[62] !== isOpen) {
        t16 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                xcss: (0, $w6R6I.cx)($aaf8b90c158e72ee$var$styles.bannerWrapper, $aaf8b90c158e72ee$var$styles.clickableBannerWrapper),
                "aria-expanded": isOpen,
                "aria-haspopup": "dialog",
                "aria-label": formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).viewSourcesLabel, {
                    count: effectiveSourceCount
                }),
                onClick: handleToggle
            }, bannerContent);
        $[58] = bannerContent;
        $[59] = effectiveSourceCount;
        $[60] = formatMessage;
        $[61] = handleToggle;
        $[62] = isOpen;
        $[63] = t16;
    } else t16 = $[63];
    let t17;
    if ($[64] !== handleClose || $[65] !== isOpen || $[66] !== renderPopupContent || $[67] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            placement: "top-start",
            isOpen: isOpen,
            onClose: handleClose,
            content: renderPopupContent,
            trigger: t16
        });
        $[64] = handleClose;
        $[65] = isOpen;
        $[66] = renderPopupContent;
        $[67] = t16;
        $[68] = t17;
    } else t17 = $[68];
    return t17;
} : ({ sourceCount: sourceCount, sources: sources = [], activeContext: activeContext, hasActiveContext: hasActiveContext = false, zeroSourcesAction: zeroSourcesAction })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isZeroSourcesBannerDismissed, setIsZeroSourcesBannerDismissed] = (0, $cozmU.useState)(false);
    const isOpenRef = (0, $cozmU.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { popupSources: popupSources, sourceAnalyticsMetadata: sourceAnalyticsMetadata } = (0, $cozmU.useMemo)(()=>$aaf8b90c158e72ee$var$mapSourcesForPopup(sources, activeContext), [
        sources,
        activeContext
    ]);
    const hasContextSource = activeContext ? true : hasActiveContext;
    const fireTriggerAnalytics = (0, $cozmU.useCallback)((state)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'sources',
            attributes: {
                source: 'spaceContextBanner',
                state: state
            }
        }).fire($aaf8b90c158e72ee$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent
    ]);
    const handleSourceLinkClick = (0, $cozmU.useCallback)((type, ari, product, index)=>{
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'sourceLink',
            attributes: {
                index: index,
                is3pLink: sourceAnalyticsMetadata[index ?? -1]?.isThirdParty ?? !ari,
                product: product,
                source: 'spaceContextBanner',
                sourceType: type
            }
        }).fire($aaf8b90c158e72ee$var$ANALYTICS_CHANNEL);
    }, [
        createAnalyticsEvent,
        sourceAnalyticsMetadata
    ]);
    const setPopupOpen = (0, $cozmU.useCallback)((nextIsOpen)=>{
        if (isOpenRef.current === nextIsOpen) return;
        fireTriggerAnalytics(nextIsOpen ? 'open' : 'closed');
        isOpenRef.current = nextIsOpen;
        setIsOpen(nextIsOpen);
    }, [
        fireTriggerAnalytics
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setPopupOpen(false);
    }, [
        setPopupOpen
    ]);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        setPopupOpen(!isOpenRef.current);
    }, [
        setPopupOpen
    ]);
    const renderPopupContent = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaf8b90c158e72ee$var$LazySourcesPopupContent, {
            sources: popupSources,
            onClickSourceHandler: handleSourceLinkClick,
            onClose: handleClose
        })), [
        handleClose,
        handleSourceLinkClick,
        popupSources
    ]);
    if (!popupSources.length && sourceCount === undefined) return null;
    const effectiveSourceCount = popupSources.length > 0 ? popupSources.length : (sourceCount ?? 0) + (hasContextSource ? 1 : 0);
    if (effectiveSourceCount === 0 && zeroSourcesAction && isZeroSourcesBannerDismissed) return null;
    if (effectiveSourceCount === 0 && zeroSourcesAction) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesBanner,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesLayout,
        space: "space.150",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesIcon,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesIconGlyph
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $aaf8b90c158e72ee$var$styles.zeroSourcesContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).zeroSourcesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).zeroSourcesDescription))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, zeroSourcesAction && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $aaf8b90c158e72ee$var$styles.fullWidthAction
    }, zeroSourcesAction), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: ()=>setIsZeroSourcesBannerDismissed(true),
        shouldFitContainer: true
    }, formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).zeroSourcesDismissLabel))));
    const bannerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $aaf8b90c158e72ee$var$styles.contentContainer,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $aaf8b90c158e72ee$var$styles.contextLabel,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $aaf8b90c158e72ee$var$styles.referencingDocumentIcon,
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
        size: "small",
        label: "",
        color: "var(--ds-text-subtlest, #6B6E76)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).referencingSourcesLabel, {
        count: effectiveSourceCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d26b4c5363d0980$export$a191f7ef02a04125), {
        sources: sources
    })));
    if (popupSources.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $aaf8b90c158e72ee$var$styles.bannerWrapper
    }, bannerContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        placement: "top-start",
        isOpen: isOpen,
        onClose: handleClose,
        content: renderPopupContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                xcss: (0, $w6R6I.cx)($aaf8b90c158e72ee$var$styles.bannerWrapper, $aaf8b90c158e72ee$var$styles.clickableBannerWrapper),
                "aria-expanded": isOpen,
                "aria-haspopup": "dialog",
                "aria-label": formatMessage((0, $c97ddf30984fa1be$export$defe85febe8b728c).viewSourcesLabel, {
                    count: effectiveSourceCount
                }),
                onClick: handleToggle
            }, bannerContent)
    });
};


/**
 * Pure helper functions that compute which source-control fields
 * (`webSearchEnabled`, `appFilters`, `sourceMode`) should be included in the `onSubmit`
 * payload when the user sends a message.
 */ 
const $ce0a5d6eba112a39$export$f6788b5142b41b42 = ({ isAgentMentionActive: isAgentMentionActive, isSpecialistPromptInput: isSpecialistPromptInput, appFilters: appFilters })=>(0, $e8dbbe344c450ab9$export$338c380e79652155)({
        isAgentMentionActive: isAgentMentionActive,
        isSpecialistPromptInput: isSpecialistPromptInput
    }) ? undefined : appFilters;


/**
 * @generated SignedSource<<c70f59e3bfe1f04a9dbe187c546dcd89>>
 * @relayHash c62157ebb72e01e0e79eb3419849f363
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6b3afe6bf8b2bf3b1582cafd3505be9495297368a1230ccd51dfff319f6eb66c
const $05a71a179100f944$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": v3 /*: any*/ ,
        "type": "AgentStudioAssistant"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAgentRoutingIdByIdentityAccountIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_agentByIdentityAccountId",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAgentRoutingIdByIdentityAccountIdQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "agentStudio_agentByIdentityAccountId",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v3 /*: any*/ ,
                            "type": "Node",
                            "abstractKey": "__isNode"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6b3afe6bf8b2bf3b1582cafd3505be9495297368a1230ccd51dfff319f6eb66c",
            "metadata": {},
            "name": "useAgentRoutingIdByIdentityAccountIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$05a71a179100f944$var$node.hash = "d0c6265def84c4ab6a8bef5c113df534";
var $05a71a179100f944$export$2e2bcd8739ae039 = $05a71a179100f944$var$node;












var $as9lu = parcelRequire("as9lu");


var $9JsfF = parcelRequire("9JsfF");













const $9c2748a35d57f3c7$var$ROVO_AGENTS_FE_TEAM_NAME = 'rovo-agents-fe';
const $9c2748a35d57f3c7$var$RELAY_READY_QUERY_KEY_PART = 'relay-ready';
const $9c2748a35d57f3c7$var$RELAY_MISSING_QUERY_KEY_PART = 'relay-missing';
const $9c2748a35d57f3c7$export$a78a2c9a076ec8a9 = (0, $lJ6db.createHookWithAssistanceService)(({ identityAccountId: identityAccountId, assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId }, enabled: enabled = true })=>{
    (0, $6cFsl.di)((0, $6SsN4.fetchQuery));
    const environment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment ?? null;
    const { data: data, error: error, isFetching: isFetching } = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchAgentRoutingIdByIdentityAccountId',
            siteId,
            environment ? $9c2748a35d57f3c7$var$RELAY_READY_QUERY_KEY_PART : $9c2748a35d57f3c7$var$RELAY_MISSING_QUERY_KEY_PART,
            identityAccountId
        ],
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
            if (!environment) throw new Error('A Relay environment is required to resolve agent routing');
            const cloudId = siteId.trim();
            if (!cloudId) throw new Error('A cloud id is required to resolve agent routing');
            const accountId = (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(identityAccountId);
            if (!accountId) throw new Error('A valid Identity User account id is required to resolve agent routing');
            const identityUserAri = (0, $as9lu.IdentityUserAri).create({
                userId: accountId
            }).toString();
            const response = await (0, $6SsN4.fetchQuery)(environment, (0, $05a71a179100f944$export$2e2bcd8739ae039), {
                cloudId: cloudId,
                id: identityUserAri
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
            const agentResult = response?.agentStudio_agentByIdentityAccountId;
            if (agentResult?.__typename === 'QueryError') throw new Error(agentResult.message ?? 'Agent routing lookup failed');
            if (agentResult?.__typename !== 'AgentStudioAssistant') throw new Error('Agent routing lookup did not return an AgentStudio assistant');
            try {
                const routingId = (0, $9JsfF.RovoAgentAri).parse(agentResult.id).agentId.trim();
                if (!routingId) throw new Error();
                return routingId;
            } catch  {
                throw new Error('Agent routing lookup did not return a valid Rovo agent ARI');
            }
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID
            });
        },
        onError: (queryError)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID,
                error: queryError,
                teamName: $9c2748a35d57f3c7$var$ROVO_AGENTS_FE_TEAM_NAME
            });
        },
        enabled: enabled,
        refetchOnWindowFocus: true
    });
    return {
        data: data,
        error: error,
        isFetching: isFetching
    };
});





const $d107a2a0b0122ad5$export$77e0e937d39e5a85 = (actionsMenuItemsVisibility, isRenderStabilizationEnabled)=>{
    const isActionsMenuItemsVisibilityDefined = actionsMenuItemsVisibility !== undefined;
    // Keep this scalar list in lock-step with the prop type so the hook avoids
    // JSON.stringify/sort work in the render path while still failing typecheck
    // when a new visibility key needs a dependency review.
    const { fileUpload: fileUpload, mention: mention, format: format, link: link, deepResearch: deepResearch } = {
        fileUpload: actionsMenuItemsVisibility?.fileUpload,
        mention: actionsMenuItemsVisibility?.mention,
        format: actionsMenuItemsVisibility?.format,
        link: actionsMenuItemsVisibility?.link,
        deepResearch: actionsMenuItemsVisibility?.deepResearch
    };
    const stableActionsMenuItemsVisibility = (0, $cozmU.useMemo)(()=>{
        if (!isRenderStabilizationEnabled || actionsMenuItemsVisibility === undefined) return actionsMenuItemsVisibility;
        return {
            ...actionsMenuItemsVisibility
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- scalar fields above represent the object without serializing it each render.
    }, [
        isRenderStabilizationEnabled,
        isActionsMenuItemsVisibilityDefined,
        fileUpload,
        mention,
        format,
        link,
        deepResearch
    ]);
    return isRenderStabilizationEnabled ? stableActionsMenuItemsVisibility : actionsMenuItemsVisibility;
};





const $90a94a8db12a2908$var$getHeadersSignature = (headers)=>{
    if (!headers) return undefined;
    // Assistance service headers are a flat string map; sorted entries make
    // equivalent objects stable even when insertion order changes.
    return JSON.stringify(Object.entries(headers).sort(([leftKey], [rightKey])=>leftKey.localeCompare(rightKey)));
};
const $90a94a8db12a2908$export$f0acd5b360457259 = (assistanceServiceParams, isRenderStabilizationEnabled)=>{
    const headersSignature = (0, $cozmU.useMemo)(()=>isRenderStabilizationEnabled ? $90a94a8db12a2908$var$getHeadersSignature(assistanceServiceParams.headers) : undefined, [
        assistanceServiceParams.headers,
        isRenderStabilizationEnabled
    ]);
    const { touchpointSource: touchpointSource, product: product, experienceId: experienceId, siteId: siteId, baseUrl: baseUrl, minionAlias: minionAlias, fileValidatePath: fileValidatePath, fileUploadPath: fileUploadPath, channelId: channelId } = assistanceServiceParams;
    // Use the header signature, not the raw header object, so equivalent header
    // object churn does not invalidate the memo boundary.
    const headers = headersSignature;
    const stableAssistanceServiceParams = (0, $cozmU.useMemo)(()=>{
        if (!isRenderStabilizationEnabled) return assistanceServiceParams;
        return {
            ...assistanceServiceParams
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- scalar fields below represent the object without preserving parent identity churn.
    }, [
        isRenderStabilizationEnabled,
        touchpointSource,
        product,
        experienceId,
        siteId,
        headers,
        baseUrl,
        minionAlias,
        fileValidatePath,
        fileUploadPath,
        channelId
    ]);
    return isRenderStabilizationEnabled ? stableAssistanceServiceParams : assistanceServiceParams;
};



var $cha5E = parcelRequire("cha5E");

const $cd8e0c3edea6b48d$export$846a64c857573c7e = (isVoiceDictationEnabled)=>{
    if (!isVoiceDictationEnabled) return false;
    return (0, $cha5E.expVal)('ai_speech_to_text', 'isEnabled', false) || (0, $cha5E.expVal)('ai_speech_to_text_holdout_ineligible', 'isEnabled', false);
};









var $bkEQw = parcelRequire("bkEQw");

const $e30a4aa263e70924$export$a2c7dc0cc11d5035 = (conversationId, { isConversationAgentic: isConversationAgentic, enableAgentMentions: enableAgentMentions })=>{
    (0, $6cFsl.di)((0, $bkEQw.useSelectedAgentDraftController));
    const draft = (0, $bkEQw.useSelectedAgentDraftController)(conversationId);
    const hasActiveAgentMention = enableAgentMentions && draft.activeSelectedAgentId !== undefined;
    const isRovoMentioned = enableAgentMentions && (0, $2yWJZ.isDefaultRovoChat)({
        agentId: draft.activeSelectedAgentId
    });
    const hasActiveSpecialistAgentMention = hasActiveAgentMention && !isRovoMentioned;
    const isSpecialistPromptInput = isConversationAgentic && !isRovoMentioned;
    return {
        ...draft,
        hasActiveAgentMention: hasActiveAgentMention,
        isRovoMentioned: isRovoMentioned,
        hasActiveSpecialistAgentMention: hasActiveSpecialistAgentMention,
        isSpecialistPromptInput: isSpecialistPromptInput,
        canSwitchBackToRovo: isConversationAgentic && enableAgentMentions
    };
};











const $3716e2ac846a9ca7$var$getDraftAgentMentions = (draftMessage)=>{
    const agentMentions = [];
    const visit = (node)=>{
        if (!node) return;
        const mentionNodeId = node.attrs?.id?.trim();
        const appType = node.attrs?.appType;
        if (node.type === 'mention' && node.attrs?.userType === 'APP' && (appType === undefined || appType === 'agent') && mentionNodeId) agentMentions.push({
            mentionNodeId: mentionNodeId,
            ...node.attrs?.localId ? {
                mentionLocalId: node.attrs.localId
            } : {}
        });
        node.content?.forEach(visit);
    };
    visit(draftMessage);
    return agentMentions;
};
const $3716e2ac846a9ca7$var$getMentionNodeIdCounts = (agentMentions)=>{
    const counts = new Map();
    for (const { mentionNodeId: mentionNodeId } of agentMentions)counts.set(mentionNodeId, (counts.get(mentionNodeId) ?? 0) + 1);
    return counts;
};
const $3716e2ac846a9ca7$var$getAddedMentionNodeIds = (previousAgentMentions, nextAgentMentions)=>{
    const remainingPreviousCounts = $3716e2ac846a9ca7$var$getMentionNodeIdCounts(previousAgentMentions);
    return nextAgentMentions.flatMap(({ mentionNodeId: mentionNodeId })=>{
        const remainingCount = remainingPreviousCounts.get(mentionNodeId) ?? 0;
        if (remainingCount === 0) return [
            mentionNodeId
        ];
        remainingPreviousCounts.set(mentionNodeId, remainingCount - 1);
        return [];
    });
};
const $3716e2ac846a9ca7$var$getRemovedMentionNodeIds = (previousAgentMentions, nextAgentMentions)=>{
    const remainingNextCounts = $3716e2ac846a9ca7$var$getMentionNodeIdCounts(nextAgentMentions);
    const removedMentionNodeIds = previousAgentMentions.flatMap(({ mentionNodeId: mentionNodeId })=>{
        const remainingCount = remainingNextCounts.get(mentionNodeId) ?? 0;
        if (remainingCount === 0) return [
            mentionNodeId
        ];
        remainingNextCounts.set(mentionNodeId, remainingCount - 1);
        return [];
    });
    return [
        ...new Set(removedMentionNodeIds)
    ];
};
const $3716e2ac846a9ca7$export$7341f618000e529b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { enableAgentMentions: enableAgentMentions, promptDraftAndModeKey: promptDraftAndModeKey, draftMessage: draftMessage, selectedAgentTransitionHandle: selectedAgentTransitionHandle, selectedAgentIdsRef: selectedAgentIdsRef, deactivatedAgentIdsRef: deactivatedAgentIdsRef, addSelectedAgentId: addSelectedAgentId, removeSelectedAgentId: removeSelectedAgentId } = t0;
    const hasDraftMessage = draftMessage != null;
    let t1;
    if ($[0] !== draftMessage) {
        t1 = $3716e2ac846a9ca7$var$getDraftAgentMentions(draftMessage);
        $[0] = draftMessage;
        $[1] = t1;
    } else t1 = $[1];
    const draftAgentMentions = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Map();
        $[2] = t2;
    } else t2 = $[2];
    const agentMentionsByPromptKeyRef = (0, $cozmU.useRef)(t2);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = new Map();
        $[3] = t3;
    } else t3 = $[3];
    const pendingPastedMentionsByPromptKeyRef = (0, $cozmU.useRef)(t3);
    let t4;
    if ($[4] !== addSelectedAgentId || $[5] !== promptDraftAndModeKey) {
        t4 = (agentMentions)=>{
            const pendingPastedMentions = pendingPastedMentionsByPromptKeyRef.current.get(promptDraftAndModeKey) ?? [];
            if (pendingPastedMentions.length === 0) return;
            const agentMentionIdsByLocalId = new Map(agentMentions.flatMap($3716e2ac846a9ca7$var$_temp));
            for (const change of pendingPastedMentions)if (agentMentionIdsByLocalId.get(change.localId) === change.id) addSelectedAgentId(change.id, {
                identityAccountId: change.id
            });
            pendingPastedMentionsByPromptKeyRef.current.delete(promptDraftAndModeKey);
        };
        $[4] = addSelectedAgentId;
        $[5] = promptDraftAndModeKey;
        $[6] = t4;
    } else t4 = $[6];
    const activatePastedAgentMentions = t4;
    let t5;
    if ($[7] !== activatePastedAgentMentions || $[8] !== addSelectedAgentId || $[9] !== deactivatedAgentIdsRef || $[10] !== enableAgentMentions || $[11] !== promptDraftAndModeKey || $[12] !== removeSelectedAgentId || $[13] !== selectedAgentIdsRef || $[14] !== selectedAgentTransitionHandle) {
        t5 = (nextAgentMentions)=>{
            if (!enableAgentMentions) return;
            const previousAgentMentions = agentMentionsByPromptKeyRef.current.get(promptDraftAndModeKey);
            agentMentionsByPromptKeyRef.current.set(promptDraftAndModeKey, [
                ...nextAgentMentions
            ]);
            if (selectedAgentTransitionHandle.isSubmitClearing()) {
                pendingPastedMentionsByPromptKeyRef.current.delete(promptDraftAndModeKey);
                return;
            }
            if (previousAgentMentions === undefined) {
                if (selectedAgentIdsRef.current.length === 0) {
                    const deactivatedAgentIdSet = new Set(deactivatedAgentIdsRef.current);
                    for (const { mentionNodeId: mentionNodeId_0 } of nextAgentMentions)if (!deactivatedAgentIdSet.has(mentionNodeId_0)) addSelectedAgentId(mentionNodeId_0, {
                        identityAccountId: mentionNodeId_0
                    });
                }
                activatePastedAgentMentions(nextAgentMentions);
                return;
            }
            for (const removedMentionNodeId of $3716e2ac846a9ca7$var$getRemovedMentionNodeIds(previousAgentMentions, nextAgentMentions))removeSelectedAgentId(removedMentionNodeId);
            for (const addedMentionNodeId of $3716e2ac846a9ca7$var$getAddedMentionNodeIds(previousAgentMentions, nextAgentMentions))addSelectedAgentId(addedMentionNodeId, {
                identityAccountId: addedMentionNodeId
            });
            activatePastedAgentMentions(nextAgentMentions);
        };
        $[7] = activatePastedAgentMentions;
        $[8] = addSelectedAgentId;
        $[9] = deactivatedAgentIdsRef;
        $[10] = enableAgentMentions;
        $[11] = promptDraftAndModeKey;
        $[12] = removeSelectedAgentId;
        $[13] = selectedAgentIdsRef;
        $[14] = selectedAgentTransitionHandle;
        $[15] = t5;
    } else t5 = $[15];
    const reconcileAgentMentions = t5;
    let t6;
    if ($[16] !== enableAgentMentions || $[17] !== promptDraftAndModeKey) {
        t6 = (changes)=>{
            if (!enableAgentMentions) return;
            const pastedMentions = changes.filter($3716e2ac846a9ca7$var$_temp2);
            if (pastedMentions.length === 0) return;
            pendingPastedMentionsByPromptKeyRef.current.set(promptDraftAndModeKey, pastedMentions);
        };
        $[16] = enableAgentMentions;
        $[17] = promptDraftAndModeKey;
        $[18] = t6;
    } else t6 = $[18];
    const handleEditorMentionsChanged = t6;
    let t7;
    let t8;
    if ($[19] !== draftAgentMentions || $[20] !== hasDraftMessage || $[21] !== reconcileAgentMentions) {
        t7 = ()=>{
            if (hasDraftMessage) reconcileAgentMentions(draftAgentMentions);
        };
        t8 = [
            draftAgentMentions,
            hasDraftMessage,
            reconcileAgentMentions
        ];
        $[19] = draftAgentMentions;
        $[20] = hasDraftMessage;
        $[21] = reconcileAgentMentions;
        $[22] = t7;
        $[23] = t8;
    } else {
        t7 = $[22];
        t8 = $[23];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[24] !== handleEditorMentionsChanged || $[25] !== reconcileAgentMentions) {
        t9 = {
            reconcileAgentMentions: reconcileAgentMentions,
            handleEditorMentionsChanged: handleEditorMentionsChanged
        };
        $[24] = handleEditorMentionsChanged;
        $[25] = reconcileAgentMentions;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ enableAgentMentions: enableAgentMentions, promptDraftAndModeKey: promptDraftAndModeKey, draftMessage: draftMessage, selectedAgentTransitionHandle: selectedAgentTransitionHandle, selectedAgentIdsRef: selectedAgentIdsRef, deactivatedAgentIdsRef: deactivatedAgentIdsRef, addSelectedAgentId: addSelectedAgentId, removeSelectedAgentId: removeSelectedAgentId })=>{
    const hasDraftMessage = draftMessage != null;
    const draftAgentMentions = (0, $cozmU.useMemo)(()=>$3716e2ac846a9ca7$var$getDraftAgentMentions(draftMessage), [
        draftMessage
    ]);
    const agentMentionsByPromptKeyRef = (0, $cozmU.useRef)(new Map());
    const pendingPastedMentionsByPromptKeyRef = (0, $cozmU.useRef)(new Map());
    const activatePastedAgentMentions = (0, $cozmU.useCallback)((agentMentions)=>{
        const pendingPastedMentions = pendingPastedMentionsByPromptKeyRef.current.get(promptDraftAndModeKey) ?? [];
        if (pendingPastedMentions.length === 0) return;
        const agentMentionIdsByLocalId = new Map(agentMentions.flatMap(({ mentionLocalId: mentionLocalId, mentionNodeId: mentionNodeId })=>mentionLocalId ? [
                [
                    mentionLocalId,
                    mentionNodeId
                ]
            ] : []));
        for (const change of pendingPastedMentions)if (agentMentionIdsByLocalId.get(change.localId) === change.id) addSelectedAgentId(change.id, {
            identityAccountId: change.id
        });
        pendingPastedMentionsByPromptKeyRef.current.delete(promptDraftAndModeKey);
    }, [
        promptDraftAndModeKey,
        addSelectedAgentId
    ]);
    const reconcileAgentMentions = (0, $cozmU.useCallback)((nextAgentMentions)=>{
        if (!enableAgentMentions) return;
        const previousAgentMentions = agentMentionsByPromptKeyRef.current.get(promptDraftAndModeKey);
        agentMentionsByPromptKeyRef.current.set(promptDraftAndModeKey, [
            ...nextAgentMentions
        ]);
        if (selectedAgentTransitionHandle.isSubmitClearing()) {
            pendingPastedMentionsByPromptKeyRef.current.delete(promptDraftAndModeKey);
            return;
        }
        if (previousAgentMentions === undefined) {
            if (selectedAgentIdsRef.current.length === 0) {
                const deactivatedAgentIdSet = new Set(deactivatedAgentIdsRef.current);
                for (const { mentionNodeId: mentionNodeId_0 } of nextAgentMentions)if (!deactivatedAgentIdSet.has(mentionNodeId_0)) addSelectedAgentId(mentionNodeId_0, {
                    identityAccountId: mentionNodeId_0
                });
            }
            activatePastedAgentMentions(nextAgentMentions);
            return;
        }
        for (const removedMentionNodeId of $3716e2ac846a9ca7$var$getRemovedMentionNodeIds(previousAgentMentions, nextAgentMentions))removeSelectedAgentId(removedMentionNodeId);
        for (const addedMentionNodeId of $3716e2ac846a9ca7$var$getAddedMentionNodeIds(previousAgentMentions, nextAgentMentions))addSelectedAgentId(addedMentionNodeId, {
            identityAccountId: addedMentionNodeId
        });
        activatePastedAgentMentions(nextAgentMentions);
    }, [
        activatePastedAgentMentions,
        addSelectedAgentId,
        deactivatedAgentIdsRef,
        enableAgentMentions,
        promptDraftAndModeKey,
        removeSelectedAgentId,
        selectedAgentIdsRef,
        selectedAgentTransitionHandle
    ]);
    const handleEditorMentionsChanged = (0, $cozmU.useCallback)((changes)=>{
        if (!enableAgentMentions) return;
        const pastedMentions = changes.filter((change_0)=>change_0.type === 'added' && change_0.method === 'pasted');
        if (pastedMentions.length === 0) return;
        pendingPastedMentionsByPromptKeyRef.current.set(promptDraftAndModeKey, pastedMentions);
    }, [
        enableAgentMentions,
        promptDraftAndModeKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasDraftMessage) reconcileAgentMentions(draftAgentMentions);
    }, [
        draftAgentMentions,
        hasDraftMessage,
        reconcileAgentMentions
    ]);
    return {
        reconcileAgentMentions: reconcileAgentMentions,
        handleEditorMentionsChanged: handleEditorMentionsChanged
    };
};
function $3716e2ac846a9ca7$var$_temp(t0) {
    const { mentionLocalId: mentionLocalId, mentionNodeId: mentionNodeId } = t0;
    return mentionLocalId ? [
        [
            mentionLocalId,
            mentionNodeId
        ]
    ] : [];
}
function $3716e2ac846a9ca7$var$_temp2(change_0) {
    return change_0.type === "added" && change_0.method === "pasted";
}








const $1624766526b765f1$export$af30e5f2be3446db = (left = [], right = [])=>{
    if (left.length !== right.length) return false;
    for(let index = 0; index < left.length; index += 1){
        if (left[index] !== right[index]) return false;
    }
    return true;
};


const $f55f5e352cac431a$var$shouldHydrateDraftMentionIds = ({ state: state, draftAgentIds: draftAgentIds, selectedAgentIds: selectedAgentIds })=>{
    if (state.isSubmitClearing) return false;
    if ((0, $1624766526b765f1$export$af30e5f2be3446db)(state.lastHydratedDraftAgentIdsByPromptKey[state.promptKey], draftAgentIds)) return false;
    if ((0, $1624766526b765f1$export$af30e5f2be3446db)(selectedAgentIds, draftAgentIds)) return false;
    if (draftAgentIds.length === 0 && selectedAgentIds.length > 0) return false;
    return true;
};
const $f55f5e352cac431a$var$shouldRemoveMentionDestroyedAgent = ({ state: state, agentId: agentId })=>{
    if (state.isSubmitClearing) return false;
    if (state.isReasoningModeMenuOpen && (0, $2yWJZ.isDefaultRovoChat)({
        agentId: agentId
    })) return false;
    return true;
};
const $f55f5e352cac431a$export$82d7a59d29e2fa65 = {
    shouldHydrateDraftMentionIds: $f55f5e352cac431a$var$shouldHydrateDraftMentionIds,
    shouldRemoveMentionDestroyedAgent: $f55f5e352cac431a$var$shouldRemoveMentionDestroyedAgent
};



const $68118b06f59b8e0a$var$createSelectedAgentTransitionState = (promptKey)=>({
        promptKey: promptKey,
        lastHydratedDraftAgentIdsByPromptKey: {},
        isSubmitClearing: false,
        isReasoningModeMenuOpen: false
    });
const $68118b06f59b8e0a$var$selectedAgentTransitionReducer = (state, event)=>{
    switch(event.type){
        case 'conversationDraftKeyChanged':
            return event.promptKey === state.promptKey ? state : {
                ...state,
                promptKey: event.promptKey,
                isSubmitClearing: false,
                isReasoningModeMenuOpen: false
            };
        case 'draftMentionIdsSeen':
            return (0, $1624766526b765f1$export$af30e5f2be3446db)(state.lastHydratedDraftAgentIdsByPromptKey[state.promptKey], event.agentIds) ? state : {
                ...state,
                lastHydratedDraftAgentIdsByPromptKey: {
                    ...state.lastHydratedDraftAgentIdsByPromptKey,
                    [state.promptKey]: event.agentIds
                }
            };
        case 'submitClearInProgressChanged':
            return {
                ...state,
                isSubmitClearing: event.isClearing
            };
        case 'reasoningModeMenuOpenChanged':
            return {
                ...state,
                isReasoningModeMenuOpen: event.isOpen
            };
    }
};
const $68118b06f59b8e0a$export$c7a48a3552e0b9c = {
    createState: $68118b06f59b8e0a$var$createSelectedAgentTransitionState,
    reduce: $68118b06f59b8e0a$var$selectedAgentTransitionReducer
};


const $bdf7aa86310c1814$export$8ad0883be9254826 = (promptDraftAndModeKey)=>{
    const stateRef = (0, $cozmU.useRef)((0, $68118b06f59b8e0a$export$c7a48a3552e0b9c).createState(promptDraftAndModeKey));
    // Sync the prompt key during render so the freshest key is used before any
    // consumer reads a predicate this pass. The reducer treats a same-key event
    // as a no-op, keeping this idempotent under repeated/StrictMode renders.
    stateRef.current = (0, $68118b06f59b8e0a$export$c7a48a3552e0b9c).reduce(stateRef.current, {
        type: 'conversationDraftKeyChanged',
        promptKey: promptDraftAndModeKey
    });
    return (0, $cozmU.useMemo)(()=>({
            shouldHydrateDraftMentions: (draftAgentIds, selectedAgentIds)=>(0, $f55f5e352cac431a$export$82d7a59d29e2fa65).shouldHydrateDraftMentionIds({
                    state: stateRef.current,
                    draftAgentIds: draftAgentIds,
                    selectedAgentIds: selectedAgentIds
                }),
            shouldRemoveDestroyedMention: (agentId)=>(0, $f55f5e352cac431a$export$82d7a59d29e2fa65).shouldRemoveMentionDestroyedAgent({
                    state: stateRef.current,
                    agentId: agentId
                }),
            isSubmitClearing: ()=>stateRef.current.isSubmitClearing,
            markDraftMentionsSeen: (draftAgentIds_0)=>{
                stateRef.current = (0, $68118b06f59b8e0a$export$c7a48a3552e0b9c).reduce(stateRef.current, {
                    type: 'draftMentionIdsSeen',
                    agentIds: draftAgentIds_0
                });
            },
            onReasoningMenuOpenChange: (isOpen)=>{
                stateRef.current = (0, $68118b06f59b8e0a$export$c7a48a3552e0b9c).reduce(stateRef.current, {
                    type: 'reasoningModeMenuOpenChanged',
                    isOpen: isOpen
                });
            },
            onSubmitClearChange: (isClearing)=>{
                stateRef.current = (0, $68118b06f59b8e0a$export$c7a48a3552e0b9c).reduce(stateRef.current, {
                    type: 'submitClearInProgressChanged',
                    isClearing: isClearing
                });
            }
        }), []);
};


const $398f2e88274c6c6f$var$WRAPPER_BORDER_RADIUS = "var(--ds-radius-xlarge, 12px)";
const $398f2e88274c6c6f$var$WRAPPER_INLINE_MARGIN = "var(--ds-space-200, 16px)";
const $398f2e88274c6c6f$var$DEFAULT_INPUT_HEIGHT_ROVO_CHAT = 56; // 2 lines height + 8px padding applied in ComposableEditor
const $398f2e88274c6c6f$var$DEFAULT_INPUT_HEIGHT_STAGING_AREA = 48;
const $398f2e88274c6c6f$var$BUTTON_TOOLTIP_OPTIONS = {
    position: 'top'
};
const $398f2e88274c6c6f$var$styles = {
    wrapperMarginInline: "_2YLqiK5zaO",
    wrapperMarginBlock: "_43nrzT5zaO",
    fsCentered: "_2YLqiKIZbP _39xV02YGVw",
    relativeWrapper: "_1mT5xdRAKS",
    dropdownSlotAnchor: "_1mT5xdRAKS _0jFU0VdnbC",
    dropdownSlotOverlay: "_1mT5xdWVPG _2I62gzdnbC _3iC0zddnbC _1OKFqYdnbC _42Yu6BgtVO",
    promptInputLayerAboveBottomAccessory: "_1mT5xdRAKS _42Yu6B7dHp",
    outerBottomAccessory: "_2YLqiK5zaO _2Y7lL42ADO _1mT5xdRAKS _42Yu6BdnbC _0KLXrunmFW _43nrzTUgYP _46hvQmNHnM _0xmtko2ADO _4e3HrddnbC _0mcu6jdnbC _4GgNwsyzSk _3kIZMxyzSk"
};
const $398f2e88274c6c6f$var$createInitialPromptTextDocument = (initialPromptText)=>(0, $6rwn6.encodePromptToAdf)(initialPromptText, undefined, true).adf; /**
                                                                                                                                            * Wrapper component for the AppConnectionBanner that connects to the store.
                                                                                                                                            * Displays a banner prompting users to connect to apps required by a selected prompt.
                                                                                                                                            * Only shown when the prompt library v2 experiment is on.
                                                                                                                                            */ 
const $398f2e88274c6c6f$var$AppConnectionBannerWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const [t0] = (0, $kyTdj.useAppConnectionBannerStore)();
    const { unconnectedApps: unconnectedApps, isVisible: isVisible, forceMultiline: forceMultiline, showConnectedState: showConnectedState } = t0;
    const { hideBanner: hideBanner, markAppAsConnected: markAppAsConnected } = (0, $fIbhb.useAppConnectionBannerActions)();
    if (!isVisible || unconnectedApps.length === 0) return null;
    if (showConnectedState) return null;
    if (!(0, $cXtTj.default).getExperimentValue("rovo_chat_prompt_library_v2_exp", "isEnabled", false)) return null;
    let t1;
    if ($[0] !== forceMultiline || $[1] !== hideBanner || $[2] !== markAppAsConnected || $[3] !== unconnectedApps) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj7Xh.AppConnectionBanner), {
            unconnectedApps: unconnectedApps,
            onDismiss: hideBanner,
            onConnect: markAppAsConnected,
            forceMultiline: forceMultiline
        });
        $[0] = forceMultiline;
        $[1] = hideBanner;
        $[2] = markAppAsConnected;
        $[3] = unconnectedApps;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ()=>{
    const [{ unconnectedApps: unconnectedApps, isVisible: isVisible, forceMultiline: forceMultiline, showConnectedState: showConnectedState }] = (0, $kyTdj.useAppConnectionBannerStore)();
    const { hideBanner: hideBanner, markAppAsConnected: markAppAsConnected } = (0, $fIbhb.useAppConnectionBannerActions)();
    if (!isVisible || unconnectedApps.length === 0) return null;
     // The 3P suggested-prompts variant renders inline in the chat thread
    // (InThreadAppConnectionPrompt), not in the input area — keeping it independent
    // of the rovo_chat_prompt_library_v2_exp gate that guards the shared banner.
    if (showConnectedState) return null;
    if (!(0, $cXtTj.default).getExperimentValue('rovo_chat_prompt_library_v2_exp', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj7Xh.AppConnectionBanner), {
        unconnectedApps: unconnectedApps,
        onDismiss: hideBanner,
        onConnect: markAppAsConnected,
        forceMultiline: forceMultiline
    });
};
const $398f2e88274c6c6f$var$applyInitialEditorDocument = ({ actions: actions, initialPromptText: initialPromptText, shouldSeedInitialPromptText: shouldSeedInitialPromptText, draftMessage: draftMessage })=>{
    if (initialPromptText && ((0, $cXtTj.default).getExperimentValue('cc_ai_growth_welcome_from_rovo', 'isEnabled', false) || shouldSeedInitialPromptText)) // Pre-fill the editor by encoding the prompt as ADF. Any URLs embedded in
    // the prompt are converted into inline smart links.
    actions.replaceDocument($398f2e88274c6c6f$var$createInitialPromptTextDocument(initialPromptText));
    else if (initialPromptText && (0, $iDrrr.fg)('jsm_kb_from_scratch')) {
        const contentNode = {
            type: 'text',
            text: initialPromptText
        };
        const initialDoc = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        contentNode
                    ]
                }
            ]
        };
        actions.replaceDocument(initialDoc);
    } else if (draftMessage) actions.replaceDocument(draftMessage);
}; /**
    * Props crossing the `chat-input-inner` memo boundary.
    *
    * Slot-like ReactNode props (`topAccessory`, `dropdownSlot`,
    * `customSlotAboveActionRow`, and `customSlotBeforeSubmitButton`) are compared
    * by reference by `shallowEqualObjects`. Callers that create those slots from
    * inline JSX should memoize them before passing them through this boundary;
    * otherwise a fresh ReactElement reference will intentionally re-render the
    * inner content.
    */ 
const $398f2e88274c6c6f$var$ChatInputInternal = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ entryPoint: entryPoint, mode: mode, productKey: productKey, siteId: siteId, orgId: orgId, assistanceServiceParams: assistanceServiceParams, fileUploadAssistanceOverrides: fileUploadAssistanceOverrides, // eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldBeCentered: _shouldBeCentered, placeholderOverride: placeholderOverride, promptDraftAndModeKey: promptDraftAndModeKey, clearModeOnSubmit: clearModeOnSubmit, isAgentTyping: isAgentTyping, arrowKeyPluginConfigMessages: arrowKeyPluginConfigMessages, autocompleteContext: autocompleteContext, isDisabled: isDisabled = false, autoSuggestConfig: autoSuggestConfig, useCurrentPageContext: useCurrentPageContext = false, editorPopupsMountPoint: editorPopupsMountPoint, editorPopupsBoundariesElement: editorPopupsBoundariesElement, editorPopupsScrollableElement: editorPopupsScrollableElement, shouldRenderQuickActionsInPortal: shouldRenderQuickActionsInPortal, shouldRenderChatModeMenusInPortal: shouldRenderChatModeMenusInPortal = false, placeholderPrompts: placeholderPrompts, hoveredPrompt: hoveredPrompt, forceTruncatedWrapperOnEmptyEditor: forceTruncatedWrapperOnEmptyEditor, showSingleLineEditor: showSingleLineEditor = false, hideLinkDisplayText: hideLinkDisplayText, isConversationAgentic: isConversationAgentic, conversationAgentId: conversationAgentId, chatSessionId: chatSessionId, chatTurnNumber: chatTurnNumber, selectedAgentForInputHat: selectedAgentForInputHat, onSelectedAgentIdChange: onSelectedAgentIdChange, onSelectedAgentChange: onSelectedAgentChange, onSubmit: onSubmit, onAbort: onAbort, onPromptChange: onPromptChange, disabledAgentTooltip: disabledAgentTooltip, enableAgentMentions: enableAgentMentions = false, onFilesChange: onFilesChange, onKeystroke: onKeystroke, actions: actions, contextProviders: contextProviders, onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable, minHeight: minHeight, maxHeight: maxHeight, menuPosition: menuPosition, contentContext: contentContext = 'global', enableSkills: enableSkills = true, enableSkillsInStagingArea: enableSkillsInStagingArea = false, enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput = false, enableVoiceDictation: enableVoiceDictation = false, dictationOverlayBackground: dictationOverlayBackground, enableBrowserContextBanner: enableBrowserContextBanner = false, isSpaceScopedConversation: isSpaceScopedConversation, spaceSourceCount: spaceSourceCount, spaceSources: spaceSources, zeroSourcesAction: zeroSourcesAction, browserContextSanitizer: browserContextSanitizer, aiFeatureContextOverride: aiFeatureContextOverride, showContextBannerForEntityContextOverride: showContextBannerForEntityContextOverride = false, disableWrapperMarginStyles: disableWrapperMarginStyles = false, dropdownSlot: dropdownSlot, topAccessory: topAccessory, customSlotBeforeChatModeMenu: customSlotBeforeChatModeMenu, customSlotBeforeSubmitButton: customSlotBeforeSubmitButton, customSlotAboveActionRow: customSlotAboveActionRow, recentSearchListSize: recentSearchListSize, shouldRenderNoResultsImage: shouldRenderNoResultsImage, adaptiveHeight: adaptiveHeight, enableMaxMode: enableMaxMode = true, showChatModeMenu: showChatModeMenu = true, enableAppsDiscoveryUi: enableAppsDiscoveryUi, urlValidationConfig: urlValidationConfig, showActionsButton: showActionsButton = true, onDiscoverSkillsClick: onDiscoverSkillsClick, onBrowsePromptLibraryClick: onBrowsePromptLibraryClick, onCreateSpaceClick: onCreateSpaceClick, onAutoSuggestQueryChange: onAutoSuggestQueryChange, onTypeaheadStateChange: onTypeaheadStateChange, actionsMenuItemsVisibility: actionsMenuItemsVisibility, hasQueuedMessages: hasQueuedMessages = false, initialPromptText: initialPromptText, shouldSeedInitialPromptText: shouldSeedInitialPromptText, isBackgroundTransparent: isBackgroundTransparent = true, shouldFocusOnMount: shouldFocusOnMount = true, submitButton: SubmitButton, showConnectorTip: showConnectorTip = true, onFilteredAppsChange: onFilteredAppsChange, onWebSearchToggle: onWebSearchToggle, onOrgKnowledgeToggle: onOrgKnowledgeToggle, onReasoningModeChange: onReasoningModeChange, blankObjectStyles: blankObjectStyles = false, shouldUseEditorPlaceholder: shouldUseEditorPlaceholder = true }, ref)=>{
    (0, $6cFsl.di)((0, $jlRK6.ComposableEditor), (0, $iDlFY.useEditorPlaceholder), (0, $ljEF1.useEditorPreset), (0, $7685l.useChatModeStore), (0, $aJU2k.useChatModeStoreActions), (0, $isp1U.useProfileController), (0, $vQngM.useRovoUserSettings), (0, $b74a7acd29563287$export$5a87ff428a5fd37b), (0, $YooNh.useConversationFiles), (0, $d5gEx.AtlassianRelayEnvironmentProvider), (0, $e30a4aa263e70924$export$a2c7dc0cc11d5035));
    const assistanceServiceParamsForFileUpload = (0, $cozmU.useMemo)(()=>({
            ...assistanceServiceParams,
            ...fileUploadAssistanceOverrides
        }), [
        assistanceServiceParams,
        fileUploadAssistanceOverrides
    ]);
    const { webSearchEnabled: webSearchConfigEnabled } = (0, $b74a7acd29563287$export$5a87ff428a5fd37b)({
        assistanceServiceParams: assistanceServiceParams
    });
    const isWebSearchPreferenceEnabled = (0, $iDrrr.fg)('rovo_chat_web_search_preference');
    const { settings: rovoUserSettings } = (0, $vQngM.useRovoUserSettings)({
        assistanceServiceParams: assistanceServiceParams,
        enabled: isWebSearchPreferenceEnabled
    });
    const webSearchDefaultEnabled = typeof rovoUserSettings?.webSearchDefaultEnabled === 'boolean' ? rovoUserSettings.webSearchDefaultEnabled : undefined;
    const saveRef = (0, $cozmU.useRef)();
    const shouldUseSeededDefaultValueRef = (0, $cozmU.useRef)(true);
    const hasSentWelcomePromptEditedAnalyticsRef = (0, $cozmU.useRef)(false);
    const disableSeededDefaultValue = (0, $cozmU.useCallback)(()=>{
        shouldUseSeededDefaultValueRef.current = false;
    }, []);
    const [inputValueLength, setInputValueLength] = (0, $cozmU.useState)(0); // Mirrors the latest length into a ref so the imperative `getIsEmpty`
    // (memoised on `editorApi`) reads a current value, not a stale closure.
    const inputValueLengthRef = (0, $cozmU.useRef)(inputValueLength);
    inputValueLengthRef.current = inputValueLength;
    const [autoSuggestQuery, setAutoSuggestQuery] = (0, $cozmU.useState)(''); // TODO: remove during link processing feture gate cleanup
    const [autoSuggestADF, setAutoSuggestADF] = (0, $cozmU.useState)(null);
    const [livePromptText, setLivePromptText] = (0, $cozmU.useState)(initialPromptText ?? '');
    const customSlotBeforeChatModeMenuRenderer = typeof customSlotBeforeChatModeMenu === 'function' ? customSlotBeforeChatModeMenu : undefined;
    const isSelectingSuggestionRef = (0, $cozmU.useRef)(false);
    const [hasCodeBlock, setHasCodeBlock] = (0, $cozmU.useState)(false);
    const [promptHasSkill, setPromptHasSkill] = (0, $cozmU.useState)(false);
    const [taskModeAnimationTrigger, setTaskModeAnimationTrigger] = (0, $cozmU.useState)(0);
    const { unconnectedSourceTip: unconnectedSourceTip, dismissTip: dismissTip, detectUnconnectedSource: detectUnconnectedSource } = (0, $d05067ada95c5706$export$65511cb417df6a49)();
    const [autoSuggestTracking, { resetAutoSuggestTracking: resetAutoSuggestTracking }] = (0, $lxLAg.useAutoSuggestTracking)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const shouldApplySeededInitialPromptText = (0, $cozmU.useMemo)(()=>!!initialPromptText && !!shouldSeedInitialPromptText && (0, $cXtTj.default).getExperimentValue('cc_ai_growth_welcome_from_rovo', 'isEnabled', false), [
        initialPromptText,
        shouldSeedInitialPromptText
    ]);
    const sendWelcomeFromRovoChatPromptAnalytics = (0, $cozmU.useCallback)((action, attributes)=>{
        if (!shouldApplySeededInitialPromptText) return;
        sendAnalyticsEvent({
            eventType: 'track',
            action: action,
            actionSubject: 'prompt',
            actionSubjectId: 'welcomeFromRovoChat',
            source: 'welcomeFromRovoChat',
            ...attributes ? {
                attributes: attributes
            } : {}
        });
    }, [
        sendAnalyticsEvent,
        shouldApplySeededInitialPromptText
    ]);
    (0, $cozmU.useEffect)(()=>{
        hasSentWelcomePromptEditedAnalyticsRef.current = false;
    }, [
        initialPromptText,
        promptDraftAndModeKey
    ]);
    const { draftMessage: draftMessage, setDraftMessage: setDraftMessage } = (0, $j4TFB.useDraftsController)(promptDraftAndModeKey);
    const { value: mentionResourceOverride } = (0, $fJ1pJ.useRovoMentionProvider)();
    const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
    const experimentEligible = enableAgentMentions;
    const agentMentionsEnabled = experimentEligible && isMentionAgentsExperimentEnabled; // Agent typeahead wiring (only consumed when agent mentions are enabled,
    // but hooks must always run). The agent source is a stable, memoised
    // reference while siteId / productKey are unchanged, so it can be passed
    // straight into `useChatMentionResource` without churning the underlying
    // `RovoChatMentionResource`.
    // All prompt-input routing derivation (Rovo-mention recognition, the
    // specialist/Rovo prompt-input split, and the switch-back capability) lives
    // in `usePromptRouting`, which reads the per-conversation selected-agent
    // draft state and combines it with the host-owned inputs
    // (`isConversationAgentic` per conversation; `agentMentionsEnabled` is the
    // integration opt-in combined with the experiment). Stored selected-agent
    // state remains available to the controller when the experiment is off, but
    // this capability keeps it inert for rendering and routing.
    const { selectedAgentIds: selectedAgentIds, activeSelectedAgentId: activeSelectedAgentId, activeSelectedAgentMetadata: activeSelectedAgentMetadata, setSelectedAgentIds: setSelectedAgentIds, addSelectedAgentId: addSelectedAgentId, removeSelectedAgentId: removeSelectedAgentId, hasActiveSpecialistAgentMention: hasActiveSpecialistAgentMentionFromDraft, isSpecialistPromptInput: isSpecialistPromptInputFromDraft, canSwitchBackToRovo: canSwitchBackToRovo } = (0, $e30a4aa263e70924$export$a2c7dc0cc11d5035)(promptDraftAndModeKey, {
        isConversationAgentic: isConversationAgentic,
        enableAgentMentions: agentMentionsEnabled
    });
    const deactivatedAgentIds = (0, $a500ad076315612c$export$ce4317e58f8f464)(promptDraftAndModeKey); // `assistanceServiceParams.product` is the canonical product
    // identifier AGG expects on `agentStudio_getAgents` — the rest of
    // the agent-fetching code passes this exact value. The component
    // prop `productKey` is a coarser host-side string that does NOT
    // match the AGG product enumeration and would cause the query to
    // return zero agents.
    const { agentSource: agentSource, hasAvailableAgents: hasAvailableAgents } = (0, $l1WtJ.useMentionAgentSource)({
        enabled: agentMentionsEnabled,
        cloudId: siteId,
        product: assistanceServiceParams.product
    });
    const isActiveSelectedAgentDefaultRovo = agentMentionsEnabled && activeSelectedAgentId !== undefined && (0, $2yWJZ.isDefaultRovoChat)({
        agentId: activeSelectedAgentId
    });
    const isActiveSelectedAgentIdentityAccount = activeSelectedAgentId?.includes(':') ?? false;
    const activeSelectedIdentityAccountId = agentMentionsEnabled ? isActiveSelectedAgentDefaultRovo ? undefined : activeSelectedAgentMetadata?.identityAccountId ?? (!isActiveSelectedAgentIdentityAccount ? undefined : activeSelectedAgentId) : activeSelectedAgentMetadata?.identityAccountId;
    const metadataRoutingAgentId = activeSelectedAgentMetadata?.id?.trim();
    const hasKnownMetadataRoutingAgentId = metadataRoutingAgentId !== undefined && metadataRoutingAgentId !== activeSelectedAgentMetadata?.identityAccountId;
    const directSelectedRoutingAgentId = (hasKnownMetadataRoutingAgentId ? metadataRoutingAgentId : undefined) || (isActiveSelectedAgentDefaultRovo || activeSelectedAgentMetadata?.identityAccountId === undefined && !isActiveSelectedAgentIdentityAccount ? activeSelectedAgentId : undefined);
    const shouldLookupActiveSelectedAgent = agentMentionsEnabled && activeSelectedIdentityAccountId !== undefined && directSelectedRoutingAgentId === undefined;
    const { data: hydratedSelectedRoutingAgentIdData, error: selectedAgentRoutingError, isFetching: isSelectedAgentRoutingFetching } = (0, $9c2748a35d57f3c7$export$a78a2c9a076ec8a9)({
        identityAccountId: activeSelectedIdentityAccountId ?? '',
        assistanceServiceParams: assistanceServiceParams,
        enabled: shouldLookupActiveSelectedAgent
    });
    const hydratedSelectedRoutingAgentId = hydratedSelectedRoutingAgentIdData?.trim() || undefined;
    const activeSelectedRoutingAgentId = agentMentionsEnabled ? directSelectedRoutingAgentId ?? hydratedSelectedRoutingAgentId ?? undefined : activeSelectedAgentId;
    const isActiveSelectedAgentRoutingUnresolved = shouldLookupActiveSelectedAgent && activeSelectedRoutingAgentId === undefined;
    const isActiveSelectedAgentRoutingPending = isActiveSelectedAgentRoutingUnresolved && (isSelectedAgentRoutingFetching || selectedAgentRoutingError === null);
    const isResolvedRovoMentioned = agentMentionsEnabled && (0, $2yWJZ.isDefaultRovoChat)({
        agentId: activeSelectedRoutingAgentId
    });
    const hasActiveSpecialistAgentMention = agentMentionsEnabled ? activeSelectedRoutingAgentId !== undefined && !isResolvedRovoMentioned : hasActiveSpecialistAgentMentionFromDraft;
    const isSpecialistPromptInput = agentMentionsEnabled ? isConversationAgentic && !isResolvedRovoMentioned : isSpecialistPromptInputFromDraft; // `selectedAgentIds` is funnelled through a ref so the mention
    // provider's disabled-state predicate reads the freshest value on
    // every call without us having to rebuild the provider when the
    // active agent changes.
    const selectedAgentIdsRef = (0, $cozmU.useRef)(selectedAgentIds);
    selectedAgentIdsRef.current = selectedAgentIds;
    const deactivatedAgentIdsRef = (0, $cozmU.useRef)(deactivatedAgentIds);
    deactivatedAgentIdsRef.current = deactivatedAgentIds;
    const activeSelectedRoutingAgentIdRef = (0, $cozmU.useRef)(activeSelectedRoutingAgentId);
    activeSelectedRoutingAgentIdRef.current = activeSelectedRoutingAgentId;
    const activeSelectedAgentMetadataRef = (0, $cozmU.useRef)(activeSelectedAgentMetadata);
    activeSelectedAgentMetadataRef.current = activeSelectedAgentMetadata;
    const onSelectedAgentIdChangeRef = (0, $cozmU.useRef)(onSelectedAgentIdChange);
    onSelectedAgentIdChangeRef.current = onSelectedAgentIdChange;
    const onSelectedAgentChangeRef = (0, $cozmU.useRef)(onSelectedAgentChange);
    onSelectedAgentChangeRef.current = onSelectedAgentChange; // Single transition state machine shared with editor-mention reconciliation,
    // so submit/menu transitions and draft hydration decisions stay consistent.
    const selectedAgentTransitionHandle = (0, $bdf7aa86310c1814$export$8ad0883be9254826)(promptDraftAndModeKey);
    const handleReasoningModeMenuOpenChange = selectedAgentTransitionHandle.onReasoningMenuOpenChange;
    const { placeholder: placeholder, clearPlaceholder: clearPlaceholder } = (0, $iDlFY.useEditorPlaceholder)();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { files: files, clearAttachments: clearAttachments, anyFilesUploading: anyFilesUploading, handleFilesSelected: handleFilesSelected } = (0, $YooNh.useConversationFiles)({
        assistanceServiceParams: assistanceServiceParamsForFileUpload,
        key: promptDraftAndModeKey
    });
    const { externalContextsServiceRepresentations: externalContextsServiceRepresentations } = (0, $2n773.useConversationExternalAttachments)(promptDraftAndModeKey);
    const isRenderStabilizationEnabled = (0, $d5c467d18ae6b9d0$export$9499fc18c2c213f4)();
    const boundaryActionsMenuItemsVisibility = (0, $d107a2a0b0122ad5$export$77e0e937d39e5a85)(actionsMenuItemsVisibility, isRenderStabilizationEnabled);
    const boundaryAssistanceServiceParams = (0, $90a94a8db12a2908$export$f0acd5b360457259)(assistanceServiceParams, isRenderStabilizationEnabled); // Updates consumers with file changes if they pass in a handler function
    (0, $cozmU.useEffect)(()=>{
        if (onFilesChange) onFilesChange(files.filter((file)=>!file.error));
    }, [
        files,
        onFilesChange
    ]);
    const { getChatMode: getChatMode, setReasoningMode: setReasoningMode, setDeepResearchEnabled: setDeepResearchEnabled, setWebSearchEnabled: setWebSearchEnabled, seedWebSearchDefault: seedWebSearchDefault, setChatMode: setChatMode, clearMode: clearMode, setRovoControlsSuppressed: setRovoControlsSuppressed } = (0, $aJU2k.useChatModeStoreActions)();
    const { hideBanner: hideAppConnectionBanner } = (0, $fIbhb.useAppConnectionBannerActions)();
    const { propertiesRef: analyticsPropertiesRef, setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const chatModeState = (0, $7685l.useChatModeStore)(promptDraftAndModeKey)[0];
    const shouldShowDeepResearchInAddMenu = showChatModeMenu && (0, $iDrrr.fg)('rovo_chat_enable_tasks') && enableMaxMode;
    const isReasoningModeDisabledByDeepResearch = shouldShowDeepResearchInAddMenu && chatModeState.deepResearchEnabled && (0, $iDrrr.fg)('rovo_chat_enable_tasks');
    const handleDeepResearchClick = (0, $cozmU.useCallback)(()=>{
        setDeepResearchEnabled(promptDraftAndModeKey, !chatModeState.deepResearchEnabled);
    }, [
        chatModeState.deepResearchEnabled,
        promptDraftAndModeKey,
        setDeepResearchEnabled
    ]);
    (0, $ea65d716a8ff208f$export$18cf5c7f34a381c8)(promptDraftAndModeKey, assistanceServiceParams);
    const appFiltersSetByPromptRef = (0, $cozmU.useRef)(chatModeState.appFiltersSetByPrompt);
    appFiltersSetByPromptRef.current = chatModeState.appFiltersSetByPrompt;
    const { aaid: currentUserId } = (0, $isp1U.useProfileController)();
    const isInSpaceContext = Boolean(isSpaceScopedConversation);
    const activePageContext = (0, $c901b3abdacf8d2e$export$509643aff12ee03b)({
        contentContext: contentContext,
        currentPageAsContextStoreKey: promptDraftAndModeKey,
        enableBrowserContextBanner: enableBrowserContextBanner,
        browserContextSanitizer: browserContextSanitizer,
        aiFeatureContextOverride: aiFeatureContextOverride
    });
    const pageContextType = (0, $d9k9Z.usePageContextType)((0, $lN13T.UseCase).AUTOCOMPLETE);
    const isDragAndDropEnabled = (0, $iDrrr.fg)('phx_drag_and_drop_trello_cards_to_rovo_chat');
    const { autoApplyAvailability: autoApplyAvailability } = (0, $eSr5w.useAutoApplyAvailability)(contentContext, useCurrentPageContext, isSpecialistPromptInput, productKey);
    const isAutoApplyVisible = (0, $iDrrr.fg)('enable_auto_apply_toggling') && autoApplyAvailability.type === 'available';
    const renderAutoApplyToggle = (0, $cozmU.useCallback)(()=>{
        if (!isAutoApplyVisible) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5d73b339c9022b5$export$8d23ed261940919e), {
            sessionData: currentUserId && siteId ? {
                userId: currentUserId,
                cloudId: siteId
            } : undefined,
            contentContext: contentContext,
            useCurrentPageContext: useCurrentPageContext,
            isConversationAgentic: isSpecialistPromptInput,
            productKey: productKey,
            renderIcon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31f9dba6bd17fa76$export$8f314e512d92575f), {
                    selected: iconProps.selected,
                    ref: iconProps.ref
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    spacing: "spacious",
                    label: ""
                })),
            renderToggleItem: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b22d6a7777fc40da$export$d1e3ff30e3cec4a), {
                    toggleId: props.toggleId,
                    icon: props.icon,
                    title: typeof props.title === 'string' ? props.title : String(props.title),
                    subtitle: props.subtitle ? String(props.subtitle) : undefined,
                    onToggle: props.onToggle,
                    isActive: props.isActive,
                    isDisabled: props.isDisabled
                }),
            onError: ()=>{
                showFlag({
                    isAutoDismiss: true,
                    id: 'auto-apply-toggle-error',
                    title: formatMessage((0, $16d3157d3312c2b3$export$defe85febe8b728c).errorFlagTitle),
                    description: formatMessage((0, $16d3157d3312c2b3$export$defe85febe8b728c).errorFlagDescription),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        spacing: "spacious",
                        label: "",
                        color: "var(--ds-icon-danger, #C9372C)"
                    })
                });
            },
            title: formatMessage((0, $e50ecf229d50e279$export$defe85febe8b728c).autoApplyToggleTitle)
        });
    }, [
        currentUserId,
        siteId,
        contentContext,
        productKey,
        useCurrentPageContext,
        isSpecialistPromptInput,
        isAutoApplyVisible,
        showFlag,
        formatMessage
    ]);
    const handleMentionAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        (0, $37219049bd2e8e2a$export$ba17c24faf9c6458)({
            event: event,
            previousAgentId: activeSelectedRoutingAgentIdRef.current,
            previousAgentName: activeSelectedAgentMetadataRef.current?.name,
            previousAgentCreatorType: activeSelectedAgentMetadataRef.current?.creatorType,
            conversationAgentId: conversationAgentId,
            chatSessionId: chatSessionId,
            chatTurnNumber: chatTurnNumber,
            sendAnalyticsEvent: sendAnalyticsEvent
        });
    }, [
        sendAnalyticsEvent,
        conversationAgentId,
        chatSessionId,
        chatTurnNumber
    ]); // Instrumentation is independent from agent visibility. The analytics gate
    // collects the all-user people/menu baseline, while agent-only events are
    // emitted only for the agent-exposed experience.
    const shouldCollectMentionAnalytics = (0, $iDrrr.fg)('rovo_chat_mention_agents_analytics');
    const shouldCollectAgentAnalytics = shouldCollectMentionAnalytics && agentMentionsEnabled;
    const shouldCollectAgentAnalyticsRef = (0, $cozmU.useRef)(shouldCollectAgentAnalytics);
    shouldCollectAgentAnalyticsRef.current = shouldCollectAgentAnalytics;
    const { reconcileAgentMentions: reconcileAgentMentions, handleEditorMentionsChanged: handleEditorMentionsChanged } = (0, $3716e2ac846a9ca7$export$7341f618000e529b)({
        enableAgentMentions: agentMentionsEnabled,
        promptDraftAndModeKey: promptDraftAndModeKey,
        draftMessage: draftMessage,
        selectedAgentTransitionHandle: selectedAgentTransitionHandle,
        selectedAgentIdsRef: selectedAgentIdsRef,
        deactivatedAgentIdsRef: deactivatedAgentIdsRef,
        addSelectedAgentId: addSelectedAgentId,
        removeSelectedAgentId: removeSelectedAgentId
    });
    const getEnhancedAgentMentionNodeId = (0, $cozmU.useCallback)((agent)=>(0, $2yWJZ.normalizeAccountIdFromIdentityAri)(agent.identityAccountId) ?? null, []);
    const mentionResource = (0, $8ICFm.useChatMentionResource)({
        productKey: productKey,
        siteId: siteId,
        orgId: orgId,
        currentUserId: currentUserId,
        mentionResourceOverride: mentionResourceOverride,
        enableAgents: agentMentionsEnabled,
        agentSource: agentSource,
        onMentionAnalyticsEvent: shouldCollectMentionAnalytics ? handleMentionAnalyticsEvent : undefined,
        onAgentSelected: (agent)=>{
            onSelectedAgentChangeRef.current?.({
                id: agent.id,
                identityAccountId: agent.identityAccountId
            });
            const selectedAgentId = agentMentionsEnabled ? (0, $2yWJZ.normalizeAccountIdFromIdentityAri)(agent.identityAccountId) ?? agent.id : agent.id;
            addSelectedAgentId(selectedAgentId, {
                id: agent.id,
                name: agent.name,
                identityAccountId: agent.identityAccountId,
                creatorType: agent.creatorType
            });
        },
        // Only feed the disabled-state predicate when agent mentions are
        // enabled; otherwise we leave the predicate undefined so chips
        // are never disabled.
        getSelectedAgentIds: agentMentionsEnabled ? ()=>selectedAgentIdsRef.current : undefined,
        getAgentMentionNodeId: agentMentionsEnabled ? getEnhancedAgentMentionNodeId : undefined,
        // Dedicated (non-default) agent chats show the "Rovo" mention row even before an
        // agent is mentioned in the input.
        isDedicatedAgentChat: agentMentionsEnabled && isConversationAgentic,
        rovoMentionLabel: agentMentionsEnabled ? formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).rovoMentionName) : undefined,
        disabledAgentTooltip: disabledAgentTooltip
    }); // When the active agent selection changes, ping the mention provider
    // so already-rendered chips re-evaluate their disabled state. This is
    // necessary because the ProseMirror `MentionNodeView` only re-runs
    // `updateState` when the editor's shared mention state changes — it
    // otherwise has no way to know that the consumer's predicate inputs
    // (which it reads via `MentionProvider.getMentionDisabledState`) have
    // changed.
    (0, $cozmU.useEffect)(()=>{
        if (!agentMentionsEnabled) return;
        let cancelled = false;
        mentionResource.then((provider)=>{
            if (cancelled) return;
             // Guard against providers that don't implement the optional
            // notification method (e.g. tests using a bare mock provider).
            const maybeNotifier = provider;
            maybeNotifier.notifyDisabledStateChanged?.();
        });
        return ()=>{
            cancelled = true;
        }; // `mentionResource` is intentionally a stable Promise across renders
    // while the deps of `useChatMentionResource` are unchanged. The
    // effect re-runs whenever the active selection changes.
    }, [
        selectedAgentIds,
        mentionResource,
        agentMentionsEnabled
    ]);
    const selectedAgentRestoreVisibilityKey = agentMentionsEnabled ? selectedAgentForInputHat?.id : undefined;
    (0, $cozmU.useEffect)(()=>{
        const selectedAgentChange = agentMentionsEnabled && activeSelectedRoutingAgentId ? {
            id: activeSelectedRoutingAgentId,
            identityAccountId: activeSelectedIdentityAccountId
        } : undefined;
        onSelectedAgentChangeRef.current?.(selectedAgentChange);
        onSelectedAgentIdChangeRef.current?.(selectedAgentChange?.id);
    }, [
        activeSelectedRoutingAgentId,
        activeSelectedIdentityAccountId,
        agentMentionsEnabled,
        promptDraftAndModeKey,
        selectedAgentRestoreVisibilityKey
    ]);
    const selectedAgentInputHatImageUrl = selectedAgentForInputHat?.iconUrl;
    const handleSelectedAgentDismiss = (0, $cozmU.useCallback)(()=>{
        if (activeSelectedAgentId) {
            const activeSelectedRoutingAgentId = activeSelectedRoutingAgentIdRef.current;
            if (shouldCollectAgentAnalyticsRef.current && activeSelectedRoutingAgentId) (0, $e4a3cb164641be9e$export$fc8af3d94a34aff7)({
                agentId: activeSelectedRoutingAgentId,
                selectedAgentCountBeforeDismiss: selectedAgentIdsRef.current.length,
                conversationAgentId: conversationAgentId,
                sendAnalyticsEvent: sendAnalyticsEvent
            });
            removeSelectedAgentId(activeSelectedAgentId);
        }
    }, [
        activeSelectedAgentId,
        removeSelectedAgentId,
        sendAnalyticsEvent,
        conversationAgentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            onSelectedAgentChangeRef.current?.(undefined);
            onSelectedAgentIdChangeRef.current?.(undefined);
        };
    }, []); // Keep the visible Rovo-owned controls in sync with who owns the next turn:
    // the store's `setRovoControlsSuppressed` action owns the snapshot/reset/restore
    // (see its return contract); this effect just maps inputs to that action and
    // forwards the applied values to the `on*Change` props. Gated on
    // `agentMentionsEnabled` so it is inert unless agent mentions are on.
    const onReasoningModeChangeRef = (0, $cozmU.useRef)(onReasoningModeChange);
    onReasoningModeChangeRef.current = onReasoningModeChange;
    const onWebSearchToggleRef = (0, $cozmU.useRef)(onWebSearchToggle);
    onWebSearchToggleRef.current = onWebSearchToggle;
    const onFilteredAppsChangeRef = (0, $cozmU.useRef)(onFilteredAppsChange);
    onFilteredAppsChangeRef.current = onFilteredAppsChange;
    (0, $cozmU.useEffect)(()=>{
        if (!isWebSearchPreferenceEnabled || webSearchDefaultEnabled === undefined) return;
        if (seedWebSearchDefault(promptDraftAndModeKey, webSearchDefaultEnabled)) onWebSearchToggleRef.current?.(webSearchDefaultEnabled);
    }, [
        isWebSearchPreferenceEnabled,
        promptDraftAndModeKey,
        seedWebSearchDefault,
        webSearchDefaultEnabled
    ]);
    const rovoControlsSuppressed = (0, $e8dbbe344c450ab9$export$338c380e79652155)({
        isAgentMentionActive: hasActiveSpecialistAgentMention,
        isSpecialistPromptInput: isSpecialistPromptInput
    });
    (0, $cozmU.useEffect)(()=>{
        if (!agentMentionsEnabled) return;
        const applied = setRovoControlsSuppressed(promptDraftAndModeKey, {
            suppressed: rovoControlsSuppressed
        });
        if (applied) {
            onReasoningModeChangeRef.current?.(applied.reasoningMode);
            onWebSearchToggleRef.current?.(applied.webSearchEnabled);
            onFilteredAppsChangeRef.current?.(applied.appFilters ?? []);
        }
    }, [
        agentMentionsEnabled,
        promptDraftAndModeKey,
        setRovoControlsSuppressed,
        rovoControlsSuppressed
    ]);
    const inputExceedsMaxLimit = inputValueLength > (0, $ljEF1.MAX_CHARACTERS_INPUT);
    const hasSubmittableText = inputValueLength > 0;
    const hasSubmittableAttachment = files.some((file)=>!file.error && !file.isLoading);
    const isSendDisabled = isDisabled || !hasSubmittableText && !hasSubmittableAttachment || inputExceedsMaxLimit || isAgentTyping && !(0, $iDrrr.fg)('rovo_chat_message_queue') || anyFilesUploading || isActiveSelectedAgentRoutingUnresolved;
    const charactersOverLimit = inputExceedsMaxLimit ? inputValueLength - (0, $ljEF1.MAX_CHARACTERS_INPUT) : 0;
    let submitButtonTooltip;
    if (isSendDisabled && inputExceedsMaxLimit) submitButtonTooltip = `${charactersOverLimit} character${charactersOverLimit === 1 ? '' : 's'} over. Try shortening your message.`;
    else if (isActiveSelectedAgentRoutingPending) submitButtonTooltip = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentRoutingResolving);
    else if (isActiveSelectedAgentRoutingUnresolved) submitButtonTooltip = formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).agentRoutingFailed);
    const handleSubmit = (0, $cozmU.useCallback)(async ()=>{
        if (isSendDisabled) return;
        const value = (0, $e4kXe.normalizeConnectorSourceDoc)(await actions.getValue());
        sendWelcomeFromRovoChatPromptAnalytics('submitted', {
            wasInitialPromptModified: !shouldUseSeededDefaultValueRef.current
        });
        const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: derivedAlphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, sourceMode: sourceMode, webSearchEnabled: webSearchEnabled, appFilters: appFilters, useCurrentPageContext: useCurrentPageContext } = getChatMode(promptDraftAndModeKey); // `skillSelectionSource` is recorded by the surface that inserts a skill placeholder
        // (editor typeahead, inline browse, auto-suggest, prompt library) into the
        // AnalyticsPropertiesContext, then read here once at submit and cleared so the next
        // non-skill submission does not inherit a stale value.
        const skillSelectionSource = analyticsPropertiesRef.current.skillSelectionSource;
        const alphaExtendedThinkingMode = !isSpecialistPromptInput ? derivedAlphaExtendedThinkingMode : undefined;
        const validFiles = files.filter((file)=>!file.error); // Fire autosuggest usage analytics if there was any interaction
        if (autoSuggestConfig && (autoSuggestTracking.suggestionsCyclesShownCount > 0 || autoSuggestTracking.suggestionSelectionCount > 0)) {
            // Calculate edit distances for all selected suggestions
            const { processedText: processedText } = (0, $kvaCg.extractContent)(value);
            const editDistancePerSelection = (0, $24affa2b8a50a9e7$export$5305c36dce8387e9)(autoSuggestTracking.selectedTexts, processedText); // Calculate averages from the metrics
            const avgEditDistance = editDistancePerSelection.length > 0 ? editDistancePerSelection.reduce((sum, m)=>sum + m.editDistance, 0) / editDistancePerSelection.length : 0;
            const avgMaxNormalizedEditRate = editDistancePerSelection.length > 0 ? editDistancePerSelection.reduce((sum, m)=>sum + m.maxNormalizedEditRate, 0) / editDistancePerSelection.length : 0;
            sendAnalyticsEvent({
                eventType: 'track',
                action: 'submitted',
                actionSubject: 'prompt',
                actionSubjectId: 'autoSuggestUsage',
                attributes: {
                    promptLength: inputValueLength,
                    suggestionCyclesShownCount: autoSuggestTracking.suggestionsCyclesShownCount,
                    suggestionSelectionCount: autoSuggestTracking.suggestionSelectionCount,
                    totalSuggestionsShownCount: autoSuggestTracking.totalSuggestionsShownCount,
                    suggestionCycles: autoSuggestTracking.suggestionCycles,
                    avgEditDistance: avgEditDistance,
                    avgMaxNormalizedEditRate: avgMaxNormalizedEditRate,
                    editDistancePerSelection: editDistancePerSelection,
                    source: autoSuggestConfig.source
                }
            });
        }
        if (shouldCollectAgentAnalyticsRef.current && activeSelectedRoutingAgentId) {
            const selectedAgentCount = selectedAgentIdsRef.current.length;
            (0, $c7b1d7580c9f820b$export$beda2291995e7723)({
                agentId: activeSelectedRoutingAgentId,
                selectedAgentCount: selectedAgentCount,
                conversationAgentId: conversationAgentId,
                chatSessionId: chatSessionId,
                chatTurnNumber: chatTurnNumber,
                sendAnalyticsEvent: sendAnalyticsEvent
            });
        } // Keep these Rovo-owned control gates in lock-step with the reset/restore
        // effect via `areRovoControlsSuppressed` (single source of truth): reasoning
        // modes gate on `!isSpecialistPromptInput`; web search / app filters gate on
        // the full union through the shared helper.
        onSubmit(value, {
            deepResearchEnabled: !isSpecialistPromptInput && deepResearchEnabled,
            thinkDeeperEnabled: !isSpecialistPromptInput && thinkDeeperEnabled,
            ...alphaExtendedThinkingMode ? {
                alphaExtendedThinkingMode: alphaExtendedThinkingMode
            } : {},
            fastModeEnabled: !isSpecialistPromptInput && fastModeEnabled,
            taskModeEnabled: !isSpecialistPromptInput && enableMaxMode && taskModeEnabled,
            webSearchEnabled: (0, $940a641243f799e0$export$626ed2520b7a25ca)({
                isAgentMentionActive: hasActiveSpecialistAgentMention,
                isSpecialistPromptInput: isSpecialistPromptInput,
                webSearchConfigEnabled: webSearchConfigEnabled,
                webSearchEnabled: webSearchEnabled
            }),
            appFilters: (0, $ce0a5d6eba112a39$export$f6788b5142b41b42)({
                isAgentMentionActive: hasActiveSpecialistAgentMention,
                isSpecialistPromptInput: isSpecialistPromptInput,
                appFilters: appFilters
            }),
            sourceMode: (0, $b5dcef10fb5a07fe$export$82b9122e2536e335)({
                isAgentMentionActive: hasActiveSpecialistAgentMention,
                isSpecialistPromptInput: isSpecialistPromptInput,
                sourceMode: isInSpaceContext && (0, $iDrrr.fg)('rovo_chat_space_source_mode') ? sourceMode : undefined
            }),
            addCurrentPageAsContext: useCurrentPageContext,
            // The context banner is visible when the space context banner is shown OR when
            // useCurrentPageContext is on and there is an active page context.
            shouldExtractConversationScopes: isInSpaceContext || useCurrentPageContext && !!activePageContext,
            skillSelectionSource: // Only meaningful for explicit skill invocations; processStream gates this
            // further when stamping it onto skillsInvoked entries.
            skillSelectionSource,
            ...agentMentionsEnabled && activeSelectedRoutingAgentId ? {
                inputSelectedAgentId: activeSelectedRoutingAgentId,
                messageAgentIdentity: {
                    agentId: activeSelectedRoutingAgentId,
                    identityAccountId: activeSelectedIdentityAccountId
                }
            } : {}
        }, validFiles, externalContextsServiceRepresentations); // Always clear the analytics-context selection source after a submit so the next
        // non-skill prompt does not inherit a stale value. Safe to call unconditionally:
        // when the field is already undefined this is a no-op write.
        if (skillSelectionSource !== undefined) setAnalyticsPropertiesWithoutRerender({
            skillSelectionSource: undefined
        });
        if (clearModeOnSubmit) clearMode(promptDraftAndModeKey, isWebSearchPreferenceEnabled ? {
            webSearchDefaultEnabled: webSearchDefaultEnabled,
            preserveWebSearchEnabled: true
        } : undefined);
        if (agentMentionsEnabled) setSelectedAgentIds(activeSelectedAgentId ? [
            activeSelectedAgentId
        ] : []);
         // Reset autosuggest tracking for next input session
        resetAutoSuggestTracking(); // Clean up. `actions.clear()` destroys mention node views; ignore those
        // destroy notifications because this is a submit reset, not a user deleting
        // the selected-agent chip from the draft.
        if (agentMentionsEnabled) selectedAgentTransitionHandle.onSubmitClearChange(true);
        actions.clear();
        if (agentMentionsEnabled) queueMicrotask(()=>{
            selectedAgentTransitionHandle.onSubmitClearChange(false);
        });
        setDraftMessage(null);
        clearAttachments(promptDraftAndModeKey); // Synchronously reset autosuggest state here rather than relying on the
        // editor's deferred onChange callback. When sending the first message in
        // an empty conversation the chat tree re-mounts before the deferred
        // onChange flushes, so the consumer's autosuggest searchQuery never gets
        // reset to '' and the typeahead overlay stays open. Clearing here
        // mirrors the cleanup performed on editor blur and guarantees the menu
        // closes regardless of which mount the next render lands in.
        setAutoSuggestADF(null);
        setAutoSuggestQuery('');
        if (customSlotBeforeChatModeMenuRenderer) setLivePromptText('');
        onAutoSuggestQueryChange?.(''); // Hide the app connection banner if it's showing
        hideAppConnectionBanner();
    }, [
        isSpecialistPromptInput,
        webSearchConfigEnabled,
        actions,
        clearAttachments,
        files,
        getChatMode,
        hideAppConnectionBanner,
        isSendDisabled,
        agentMentionsEnabled,
        onSubmit,
        clearMode,
        promptDraftAndModeKey,
        clearModeOnSubmit,
        isWebSearchPreferenceEnabled,
        webSearchDefaultEnabled,
        setDraftMessage,
        externalContextsServiceRepresentations,
        sendAnalyticsEvent,
        inputValueLength,
        autoSuggestTracking,
        resetAutoSuggestTracking,
        autoSuggestConfig,
        analyticsPropertiesRef,
        setAnalyticsPropertiesWithoutRerender,
        activeSelectedAgentId,
        activeSelectedIdentityAccountId,
        activeSelectedRoutingAgentId,
        setSelectedAgentIds,
        activePageContext,
        isInSpaceContext,
        hasActiveSpecialistAgentMention,
        enableMaxMode,
        sendWelcomeFromRovoChatPromptAnalytics,
        onAutoSuggestQueryChange,
        customSlotBeforeChatModeMenuRenderer,
        setAutoSuggestADF,
        setAutoSuggestQuery,
        conversationAgentId,
        chatSessionId,
        chatTurnNumber,
        selectedAgentTransitionHandle
    ]);
    saveRef.current = handleSubmit;
    const [allKnowledgeSources] = (0, $7pCWA.useEnabledKnowledgeSources)();
    const connectorSources = (0, $cozmU.useMemo)(()=>allKnowledgeSources.filter((s)=>s.friendlyName).map((s)=>({
                key: s.friendlyName.toLowerCase(),
                display: s.friendlyName,
                source: s.source,
                iconUrl: s.iconUrl
            })).sort((a, b)=>b.key.length - a.key.length), [
        allKnowledgeSources
    ]);
    const { editorApi: editorApi, preset: preset } = (0, $ljEF1.useEditorPreset)({
        onSave: ()=>saveRef.current?.(),
        arrowKeyPluginConfig: {
            userMessages: arrowKeyPluginConfigMessages
        },
        productKey: productKey,
        siteId: siteId,
        placeholderPrompts: placeholderPrompts,
        linkPickerOptions: {
            hideDisplayText: hideLinkDisplayText,
            recentSearchListSize: recentSearchListSize,
            adaptiveHeight: adaptiveHeight,
            shouldRenderNoResultsImage: shouldRenderNoResultsImage
        },
        connectorSources: connectorSources,
        autocomplete: autocompleteContext,
        handleMentionsChanged: agentMentionsEnabled ? handleEditorMentionsChanged : undefined
    });
    const { insertUrls: insertUrls } = (0, $5be41c6880979bfe$export$a3e933699338c61d)(editorApi);
    const assistiveLabel = (0, $cozmU.useMemo)(()=>{
        if (placeholderOverride !== undefined) return placeholderOverride;
        if (chatModeState.deepResearchEnabled && !(0, $iDrrr.fg)('rovo_chat_enable_tasks')) return formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).deepResearchAssistiveLabel);
        return formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).defaultAssistiveLabel);
    }, [
        placeholderOverride,
        formatMessage,
        chatModeState.deepResearchEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (editorApi?.placeholder && hoveredPrompt) editorApi?.core.actions.execute(editorApi?.placeholder?.commands.setPlaceholder(hoveredPrompt));
        else if (editorApi?.placeholder && placeholderPrompts) {
            editorApi?.core.actions.execute(editorApi?.placeholder?.commands.setPlaceholder(''));
            editorApi?.core.actions.execute(editorApi?.placeholder?.commands.setAnimatingPlaceholderPrompts(placeholderPrompts));
        } else if (editorApi?.placeholder && !placeholderPrompts) editorApi?.core.actions.execute(editorApi?.placeholder?.commands.setPlaceholder(assistiveLabel));
    }, [
        hoveredPrompt,
        editorApi?.core.actions,
        editorApi?.placeholder,
        placeholderPrompts,
        assistiveLabel
    ]); // Expose the focus via ref
    (0, $cozmU.useImperativeHandle)(ref, ()=>({
            focus: ()=>{
                editorApi?.core.actions.focus();
            },
            replaceDocument: (doc)=>{
                editorApi?.core.actions.replaceDocument(doc);
                editorApi?.core.actions.focus();
            },
            getIsEmpty: ()=>inputValueLengthRef.current === 0
        }), [
        editorApi
    ]);
    const closeTypeAhead = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(()=>{
        editorApi?.typeAhead?.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        editorApi?.typeAhead?.actions
    ], isRenderStabilizationEnabled); // When an agent is already mentioned, override the mention type-ahead's "Agents" heading to "Switch to"; otherwise keep the plugin default.
    // Re-assert on mention type-ahead state changes because `updateSectionTitle` is session-scoped and sections rebuild as results load.
    (0, $cozmU.useEffect)(()=>{
        if (!agentMentionsEnabled || !editorApi?.typeAhead?.sharedState) return;
        const unsubscribe = editorApi.typeAhead.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            // Only act when the mention (`@`) type-ahead is open and an
            // agent is already mentioned; otherwise keep the plugin default.
            if (!nextSharedState?.isOpen || nextSharedState.triggerHandler?.trigger !== '@' || selectedAgentIdsRef.current.length === 0) return;
            editorApi?.mention?.actions?.updateSectionTitle?.({
                id: 'agents',
                title: formatMessage((0, $e78443c7519dc888$export$2e2bcd8739ae039).mentionAgentsSectionSwitch)
            });
        });
        return unsubscribe;
    }, [
        agentMentionsEnabled,
        editorApi?.typeAhead?.sharedState,
        editorApi?.mention?.actions,
        formatMessage
    ]); // Notify consumer when the Quick Insert typeahead opens or closes
    (0, $cozmU.useEffect)(()=>{
        if (!onTypeaheadStateChange || !editorApi?.typeAhead?.sharedState) return;
        const unsubscribe = editorApi.typeAhead.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            onTypeaheadStateChange(nextSharedState?.isOpen ?? false);
        });
        return unsubscribe;
    }, [
        onTypeaheadStateChange,
        editorApi?.typeAhead?.sharedState
    ]); // Inserts the audio transcription text into the editor
    const handleInsertTranscript = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)((transcript)=>{
        closeTypeAhead();
        actions.appendText(`${transcript.trimEnd()} `);
        actions.focus();
    }, [
        actions,
        closeTypeAhead
    ], isRenderStabilizationEnabled); // Closes the editor toolbar by moving the cursor to the end of the current selection
    // If the selection is in a codeblock, moves to the end of the codeblock instead
    const closeEditorToolbar = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(()=>{
        editorApi?.core?.actions?.execute(({ tr: tr })=>{
            const { selection: selection } = tr;
            const $anchor = selection.$anchor;
            let targetPos = selection.$to.pos;
            let codeBlockNode = $anchor.node($anchor.depth);
            if (codeBlockNode.type.name === 'codeBlock') {
                const codeBlockStart = $anchor.start($anchor.depth);
                targetPos = codeBlockStart + 1 + codeBlockNode.content.size;
            }
            const resolvedPos = tr.doc.resolve(targetPos);
            const newSelection = (0, $kCECX.TextSelection).near(resolvedPos);
            return tr.setSelection(newSelection);
        });
    }, [
        editorApi?.core?.actions
    ], isRenderStabilizationEnabled);
    const openMentionTypeAhead = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(()=>{
        closeTypeAhead(); // Small delay to ensure the editor regains focus after closing the dropdown menu
        // This prevents the typeahead from immediately closing in Safari
        // Original root cause research: https://product-fabric.atlassian.net/browse/AFC-550
        requestAnimationFrame(()=>{
            editorApi?.core.actions.focus();
            editorApi?.mention?.actions.openTypeAhead((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        });
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.mention?.actions
    ], isRenderStabilizationEnabled);
    const { openLinkTypeAheadFromMenu: openLinkTypeAheadFromMenu, openLinkTypeAheadFromPlaceholder: openLinkTypeAheadFromPlaceholder } = (0, $604bd22cb82e5411$export$b4e4aedf2922193b)({
        editorApi: editorApi,
        closeTypeAhead: closeTypeAhead,
        isRenderStabilizationEnabled: isRenderStabilizationEnabled
    });
    const openAddTypeAhead = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)(()=>{
        closeTypeAhead(); // Small delay to ensure the editor regains focus after closing the dropdown menu
        // This prevents the typeahead from immediately closing in Safari
        // Original root cause research: https://product-fabric.atlassian.net/browse/AFC-550
        requestAnimationFrame(()=>{
            editorApi?.core.actions.focus();
            editorApi?.quickInsert?.actions.openTypeAhead((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        });
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.quickInsert?.actions
    ], isRenderStabilizationEnabled);
    const tooltipOptions = $398f2e88274c6c6f$var$BUTTON_TOOLTIP_OPTIONS;
    (0, $cozmU.useEffect)(()=>{
        if (shouldUseEditorPlaceholder && !!placeholder && !!editorApi) {
            if ((0, $iDrrr.fg)('rovo_chat_fix_cold_start_prompt_insertion')) sendAnalyticsEvent({
                eventType: 'track',
                action: 'inserted',
                actionSubject: 'editorPlaceholder',
                actionSubjectId: 'rovoChatPromptInput',
                attributes: {
                    placeholderType: placeholder.type,
                    hasAdf: !!placeholder.adfDocument,
                    insertAtCursor: !!placeholder.insertAtCursor
                }
            });
             // Insert at current cursor position
            if (placeholder.insertAtCursor && placeholder.adfDocument) {
                const paragraphBlock = placeholder.adfDocument.content?.[0];
                const inlineContent = paragraphBlock?.type === 'paragraph' && paragraphBlock.content ? paragraphBlock.content : [];
                if (inlineContent.length > 0) actions.replaceSelection(inlineContent);
                actions.focus();
                clearPlaceholder();
                return;
            }
            actions.clear();
            if (placeholder.shouldFocus === false) {
                clearPlaceholder();
                return;
            }
            actions.focus();
            closeTypeAhead(); // Use ADF document to preserve formatting
            if (placeholder.adfDocument) actions.replaceDocument(placeholder.adfDocument);
            else actions.appendText(placeholder.prompt);
            editorApi?.core.actions.execute(({ tr: tr })=>{
                const maxPos = tr.doc.content.size;
                const startPos = Math.min(placeholder.selectionStartIndex, maxPos);
                const endPos = Math.min(placeholder.selectionEndIndex, maxPos);
                const transaction = tr.setSelection((0, $kCECX.TextSelection).between(tr.doc.resolve(startPos), tr.doc.resolve(endPos)));
                return transaction;
            }); // Wait for next browser frame to ensure editor focus and selection are stable
            // This prevents the typeahead from flashing when triggered from surfaces where rovo chat is not already open
            requestAnimationFrame(()=>{
                switch(placeholder.type){
                    case 'person':
                        openMentionTypeAhead();
                        break;
                    case 'link':
                        openLinkTypeAheadFromPlaceholder();
                        break;
                    default:
                        actions.focus();
                        break;
                }
            });
            clearPlaceholder();
        }
    }, [
        editorApi,
        actions,
        clearPlaceholder,
        closeTypeAhead,
        editorApi?.core.actions,
        openLinkTypeAheadFromPlaceholder,
        openMentionTypeAhead,
        placeholder,
        sendAnalyticsEvent,
        shouldUseEditorPlaceholder
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!!highlightActionsEditorPlaceholder && !!editorApi) {
            actions.clear();
            actions.focus();
            closeTypeAhead();
            editorApi.core.actions.replaceDocument(highlightActionsEditorPlaceholder);
            editorApi?.core.actions.execute(({ tr: tr })=>{
                const lastNode = tr.doc.lastChild;
                if (lastNode) {
                    const lastNodePos = tr.doc.resolve(tr.doc.content.size - lastNode.nodeSize);
                    const endPos = tr.doc.resolve(tr.doc.content.size);
                    const transaction = tr.setSelection((0, $kCECX.TextSelection).between(lastNodePos, endPos));
                    return transaction;
                }
                return null;
            }); // This is a workaround to avoid the focus being lost in Jira (and Jira sub-products)
            if (productKey === 'jira' || productKey === 'jsm' || productKey === 'jpd') requestAnimationFrame(()=>{
                setTimeout(()=>{
                    actions.focus();
                }, 1500);
            });
            clearHighlightActionsEditorPlaceholder();
        }
    }, [
        editorApi,
        actions,
        clearHighlightActionsEditorPlaceholder,
        closeTypeAhead,
        highlightActionsEditorPlaceholder,
        productKey
    ]);
    const clearSeededInitialPromptText = (0, $cozmU.useCallback)(()=>{
        sendWelcomeFromRovoChatPromptAnalytics('cleared');
        disableSeededDefaultValue();
        actions.clear();
        setInputValueLength(0);
        setAutoSuggestADF(null);
        setAutoSuggestQuery('');
        if (customSlotBeforeChatModeMenuRenderer) setLivePromptText('');
        onAutoSuggestQueryChange?.('');
        onPromptChange?.(null);
        setDraftMessage(null);
    }, [
        actions,
        disableSeededDefaultValue,
        onAutoSuggestQueryChange,
        onPromptChange,
        customSlotBeforeChatModeMenuRenderer,
        sendWelcomeFromRovoChatPromptAnalytics,
        setDraftMessage
    ]);
    const isEditorCursorAtEnd = (0, $cozmU.useCallback)(()=>{
        let isCursorAtEnd = false;
        editorApi?.core.actions.execute(({ tr: tr })=>{
            const { selection: selection } = tr;
            isCursorAtEnd = selection.empty && selection.from >= tr.doc.content.size - 1;
            return null;
        });
        return isCursorAtEnd;
    }, [
        editorApi?.core.actions
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        onKeystroke?.(e.nativeEvent);
        if (e.key === 'Backspace' && shouldApplySeededInitialPromptText && shouldUseSeededDefaultValueRef.current && (0, $cXtTj.default).getExperimentValue('cc_ai_growth_welcome_from_rovo', 'isEnabled', false)) {
            if (isEditorCursorAtEnd()) {
                e.preventDefault();
                e.stopPropagation();
                clearSeededInitialPromptText();
                return;
            }
            disableSeededDefaultValue();
        } // Handle Cmd+Enter (Mac) or Ctrl+Enter (Windows/Linux) for submission
        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            e.stopPropagation();
            handleSubmit();
            return;
        }
        if (e.key === 'Escape' && isAgentTyping) {
            const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, taskModeEnabled: taskModeEnabled, webSearchEnabled: webSearchEnabled } = getChatMode(promptDraftAndModeKey);
            onAbort({
                deepResearchEnabled: deepResearchEnabled,
                thinkDeeperEnabled: thinkDeeperEnabled,
                fastModeEnabled: fastModeEnabled,
                taskModeEnabled: enableMaxMode && taskModeEnabled,
                webSearchEnabled: webSearchEnabled
            }, undefined); // Somehow the focus is lost after pressing escape, so subsequent key presses are not captured
            e.stopPropagation();
        }
    }, [
        onKeystroke,
        isEditorCursorAtEnd,
        clearSeededInitialPromptText,
        onAbort,
        isAgentTyping,
        getChatMode,
        promptDraftAndModeKey,
        handleSubmit,
        enableMaxMode,
        shouldApplySeededInitialPromptText,
        disableSeededDefaultValue
    ]);
    const handleSuggestionSelect = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)((suggestion)=>{
        actions.clear();
        isSelectingSuggestionRef.current = true;
        if (suggestion.adf) try {
            // Insert the ADF content directly into the editor
            editorApi?.core.actions.replaceDocument(suggestion.adf);
        } catch  {
            // Fallback to text content if ADF insertion fails
            actions.appendText(suggestion.text);
        }
        else actions.appendText(suggestion.text);
        actions.focus();
        setAutoSuggestADF(null);
        setAutoSuggestQuery('');
        onAutoSuggestQueryChange?.('');
    }, [
        actions,
        editorApi?.core.actions,
        onAutoSuggestQueryChange
    ], isRenderStabilizationEnabled);
    const handleEditorBlur = (0, $cozmU.useCallback)(()=>{
        setAutoSuggestADF(null);
        setAutoSuggestQuery('');
        onAutoSuggestQueryChange?.('');
    }, [
        onAutoSuggestQueryChange
    ]);
    const handleUrlsSelected = (0, $e83b8df11f75afe4$export$1f3f2bce478b5a53)((urls)=>{
        if (!isDragAndDropEnabled) return;
        insertUrls(urls, 'rovo-chat-editor-dropzone');
    }, [
        insertUrls,
        isDragAndDropEnabled
    ], isRenderStabilizationEnabled);
    (0, $hdBxM.useSubscribe)({
        topic: 'ai-mate-chat-inserts',
        triggerLatest: true
    }, (0, $cozmU.useCallback)((payload)=>{
        if (payload.type === 'insert-skill-into-prompt-input') {
            const paragraphBlock = (0, $8lhhf.createSkillAdf)(payload.data.skill).content?.[0];
            const inlineContent = paragraphBlock?.type === 'paragraph' && paragraphBlock.content ? paragraphBlock.content : [];
            if (inlineContent.length > 0) {
                actions.replaceSelection(inlineContent);
                actions.focus();
                if (payload.data.skillSelectionSource) setAnalyticsPropertiesWithoutRerender({
                    skillSelectionSource: payload.data.skillSelectionSource
                });
            }
            return;
        }
        if (!isDragAndDropEnabled || payload.type !== 'insert-urls-into-prompt-input') return;
        const filteredUrls = (0, $eaf631758c84dc43$export$20d841f6cb4f3b8)(payload.data.urls, urlValidationConfig);
        if (filteredUrls.length > 0) insertUrls(filteredUrls, 'pubsub-insert-url-event');
    }, [
        actions,
        insertUrls,
        isDragAndDropEnabled,
        setAnalyticsPropertiesWithoutRerender,
        urlValidationConfig
    ]));
    const shouldRenderVoiceEnabledFooterRow = (0, $cd8e0c3edea6b48d$export$846a64c857573c7e)(enableVoiceDictation);
    const [isMicPermissionDenied, setIsMicPermissionDenied] = (0, $cozmU.useState)(false);
    const handleMicPermissionDenied = (0, $cozmU.useCallback)(()=>setIsMicPermissionDenied(true), []);
    const stableEditorPropsLatest = {
        appFiltersSetByPromptRef: appFiltersSetByPromptRef,
        detectUnconnectedSource: detectUnconnectedSource,
        draftMessage: draftMessage,
        editorApi: editorApi,
        hideAppConnectionBanner: hideAppConnectionBanner,
        initialPromptText: initialPromptText,
        shouldApplySeededInitialPromptText: shouldApplySeededInitialPromptText,
        isSelectingSuggestionRef: isSelectingSuggestionRef,
        onAutoSuggestQueryChange: onAutoSuggestQueryChange,
        onPromptChange: onPromptChange,
        promptHasSkill: promptHasSkill,
        promptDraftAndModeKey: promptDraftAndModeKey,
        customSlotBeforeChatModeMenuRenderer: customSlotBeforeChatModeMenuRenderer,
        setAutoSuggestADF: setAutoSuggestADF,
        setAutoSuggestQuery: setAutoSuggestQuery,
        setChatMode: setChatMode,
        setDraftMessage: setDraftMessage,
        setLivePromptText: setLivePromptText
    };
    const stableEditorPropsLatestRef = (0, $cozmU.useRef)(stableEditorPropsLatest);
    stableEditorPropsLatestRef.current = stableEditorPropsLatest;
    const deferredOnChangeFrameRef = (0, $cozmU.useRef)(null);
    const deferredOnChangeVersionRef = (0, $cozmU.useRef)(0);
    const deferredOnChangePayloadRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // On unmount we intentionally drop any pending deferred onChange side effects
            // (autosuggest, draft persistence, onPromptChange) instead of flushing them: the
            // editor subtree unmounts first, so a flush's requestDocument would no-op anyway.
            // Message submission is unaffected because handleSubmit reads the live document via
            // actions.getValue() at send time rather than from these deferred side effects.
            deferredOnChangeVersionRef.current += 1;
            deferredOnChangePayloadRef.current = null;
            if (deferredOnChangeFrameRef.current !== null) {
                cancelAnimationFrame(deferredOnChangeFrameRef.current);
                deferredOnChangeFrameRef.current = null;
            }
        };
    }, []);
    const flushEditorChangeSideEffects = (0, $cozmU.useCallback)((payload, version)=>{
        stableEditorPropsLatestRef.current.editorApi?.core.actions.requestDocument((doc)=>{
            if (version !== undefined && deferredOnChangeVersionRef.current !== version) return;
            const latest = stableEditorPropsLatestRef.current;
            const docNode = doc?.content.length ? (0, $e4kXe.normalizeConnectorSourceDoc)(doc) : null;
            if (!latest.isSelectingSuggestionRef.current) {
                if (!payload.promptHasSkill && latest.onAutoSuggestQueryChange) latest.onAutoSuggestQueryChange(payload.textContent);
                else if ((0, $iDrrr.fg)('aifc_autosuggest_link_processing')) latest.setAutoSuggestADF(docNode);
                else latest.setAutoSuggestQuery(payload.textContent);
            } // When user deletes a prompt from the input,
            // only reset app filters and banner if they were set by a prompt card click
            if (docNode === null && latest.appFiltersSetByPromptRef.current) {
                latest.setChatMode(latest.promptDraftAndModeKey, {
                    appFilters: undefined
                });
                latest.hideAppConnectionBanner();
            }
            if (latest.customSlotBeforeChatModeMenuRenderer) latest.setLivePromptText(payload.textContent);
            latest.onPromptChange?.(docNode);
            latest.setDraftMessage(docNode);
            latest.isSelectingSuggestionRef.current = false;
        });
    }, []);
    const scheduleDeferredEditorChange = (0, $cozmU.useCallback)((payload)=>{
        deferredOnChangeVersionRef.current += 1;
        const version = deferredOnChangeVersionRef.current;
        deferredOnChangePayloadRef.current = payload;
        if (deferredOnChangeFrameRef.current !== null) cancelAnimationFrame(deferredOnChangeFrameRef.current);
        deferredOnChangeFrameRef.current = requestAnimationFrame(()=>{
            deferredOnChangeFrameRef.current = null;
            const currentPayload = deferredOnChangePayloadRef.current;
            if (!currentPayload || deferredOnChangeVersionRef.current !== version) return;
            flushEditorChangeSideEffects(currentPayload, version);
        });
    }, [
        flushEditorChangeSideEffects
    ]);
    const stableOnSave = (0, $cozmU.useCallback)(()=>saveRef.current?.(), []);
    const handleEditorChange = (0, $cozmU.useCallback)((ev)=>{
        const textContent = ev.state.doc.textContent;
        if (shouldApplySeededInitialPromptText && shouldUseSeededDefaultValueRef.current && textContent !== initialPromptText) {
            if (!hasSentWelcomePromptEditedAnalyticsRef.current) {
                sendWelcomeFromRovoChatPromptAnalytics('edited');
                hasSentWelcomePromptEditedAnalyticsRef.current = true;
            }
            disableSeededDefaultValue();
        }
        stableEditorPropsLatestRef.current.detectUnconnectedSource(textContent);
        setInputValueLength((0, $a5ebe6e16ec109bd$export$5008f08b2ad8f7df)(ev.state.doc));
        let foundCodeBlock = false;
        let foundSkillExtension = false;
        const liveAgentMentions = [];
        ev.state.doc.descendants((node)=>{
            if (node.type.name === 'codeBlock') foundCodeBlock = true;
            if (node.type.name === 'inlineExtension' && node.attrs.extensionKey === (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY)) foundSkillExtension = true;
            const rawAgentMentionId = node.attrs?.id;
            const agentMentionId = typeof rawAgentMentionId === 'string' ? rawAgentMentionId.trim() : undefined;
            const isAgentMention = node.type.name === 'mention' && node.attrs?.userType === 'APP' && (node.attrs?.appType === undefined || node.attrs?.appType === 'agent');
            if (isAgentMention && agentMentionId) {
                const rawMentionLocalId = node.attrs?.localId;
                liveAgentMentions.push({
                    mentionNodeId: agentMentionId,
                    ...typeof rawMentionLocalId === 'string' && rawMentionLocalId ? {
                        mentionLocalId: rawMentionLocalId
                    } : {}
                });
            }
            return true;
        });
        setHasCodeBlock(foundCodeBlock);
        setPromptHasSkill(foundSkillExtension);
        reconcileAgentMentions(liveAgentMentions);
        const payload = {
            textContent: textContent,
            promptHasSkill: foundSkillExtension
        };
        scheduleDeferredEditorChange(payload);
    }, [
        disableSeededDefaultValue,
        initialPromptText,
        reconcileAgentMentions,
        scheduleDeferredEditorChange,
        sendWelcomeFromRovoChatPromptAnalytics,
        shouldApplySeededInitialPromptText
    ]);
    const stableOnChange = (0, $cozmU.useCallback)((ev)=>{
        handleEditorChange(ev);
    }, [
        handleEditorChange
    ]);
    const seededInitialPromptTextDocument = (0, $cozmU.useMemo)(()=>shouldApplySeededInitialPromptText && initialPromptText ? $398f2e88274c6c6f$var$createInitialPromptTextDocument(initialPromptText) : undefined, [
        initialPromptText,
        shouldApplySeededInitialPromptText
    ]);
    const initialEditorDefaultValue = (0, $cozmU.useMemo)(()=>shouldApplySeededInitialPromptText && draftMessage ? draftMessage : shouldApplySeededInitialPromptText ? seededInitialPromptTextDocument : undefined, [
        draftMessage,
        seededInitialPromptTextDocument,
        shouldApplySeededInitialPromptText
    ]);
    const handleSeededInitialPromptTextEditorReady = (0, $cozmU.useCallback)(({ initialPromptText: initialPromptText, shouldApplySeededInitialPromptText: shouldApplySeededInitialPromptText, draftMessage: draftMessage })=>{
        if (!initialPromptText || !shouldApplySeededInitialPromptText || !(0, $cXtTj.default).getExperimentValue('cc_ai_growth_welcome_from_rovo', 'isEnabled', false)) return false;
        if (draftMessage) {
            disableSeededDefaultValue();
            setInputValueLength((0, $kvaCg.extractContent)(draftMessage).processedText.length);
            return true;
        }
        if (shouldUseSeededDefaultValueRef.current) setInputValueLength(initialPromptText.trim().length);
        return true;
    }, [
        disableSeededDefaultValue
    ]);
    const stableOnEditorReady = (0, $cozmU.useCallback)((actions)=>{
        const { initialPromptText: initialPromptText, shouldApplySeededInitialPromptText: shouldApplySeededInitialPromptText, draftMessage: draftMessage } = stableEditorPropsLatestRef.current;
        if (handleSeededInitialPromptTextEditorReady({
            initialPromptText: initialPromptText,
            shouldApplySeededInitialPromptText: shouldApplySeededInitialPromptText,
            draftMessage: draftMessage
        })) return;
        $398f2e88274c6c6f$var$applyInitialEditorDocument({
            actions: actions,
            initialPromptText: initialPromptText,
            shouldSeedInitialPromptText: shouldSeedInitialPromptText,
            draftMessage: draftMessage
        }); // eslint-disable-next-line react-hooks/exhaustive-deps -- Keep stable so editor ready does not re-run when seeded prompt state changes.
    }, []);
    const sharedEditorProps = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return {
            popupsMountPoint: editorPopupsMountPoint ?? undefined,
            popupsBoundariesElement: editorPopupsBoundariesElement,
            popupsScrollableElement: editorPopupsScrollableElement,
            assistiveLabel: assistiveLabel,
            minHeight: minHeight ?? (contentContext === 'staging-area' ? $398f2e88274c6c6f$var$DEFAULT_INPUT_HEIGHT_STAGING_AREA : $398f2e88274c6c6f$var$DEFAULT_INPUT_HEIGHT_ROVO_CHAT),
            shouldFocus: shouldFocusOnMount,
            preset: preset,
            mentionProvider: mentionResource,
            maxHeight: maxHeight ?? 400,
            appearance: 'chromeless',
            defaultValue: initialEditorDefaultValue
        };
    }, [
        editorPopupsMountPoint,
        editorPopupsBoundariesElement,
        editorPopupsScrollableElement,
        assistiveLabel,
        minHeight,
        contentContext,
        shouldFocusOnMount,
        preset,
        mentionResource,
        maxHeight,
        initialEditorDefaultValue
    ]);
    const stableEditorProps = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return {
            ...sharedEditorProps,
            onSave: stableOnSave,
            onChange: stableOnChange,
            onEditorReady: stableOnEditorReady
        };
    }, [
        sharedEditorProps,
        stableOnSave,
        stableOnChange,
        stableOnEditorReady
    ]);
    const shouldRenderInputAgentHat = agentMentionsEnabled; // When the user removes the active context via the banner's "Remove
    // context" button, the banner unmounts and focus would otherwise be lost
    // (stranding keyboard / screen reader users on a detached element). Move
    // focus back to the prompt input so they can keep typing. This must be a
    // stable reference so it does not defeat `ContextBanner`'s prop memo.
    const handleContextRemoved = (0, $cozmU.useCallback)(()=>{
        if ((0, $iDrrr.fg)('rovo_chat_context_banner_focus_return')) editorApi?.core.actions.focus();
    }, [
        editorApi
    ]);
    const isMentionAgentsSpotlightEnabled = (0, $iDrrr.fg)('post-office_rovo-chat-mention-agents-spotlight');
    const shouldRenderContextBanner = !isInSpaceContext && (useCurrentPageContext || showContextBannerForEntityContextOverride && Boolean(aiFeatureContextOverride?.entityContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onKeyDown: handleKeyDown,
        xcss: (0, $w6R6I.cx)(!disableWrapperMarginStyles && !(hasQueuedMessages && (0, $iDrrr.fg)('rovo_chat_message_queue')) && $398f2e88274c6c6f$var$styles.wrapperMarginBlock, !disableWrapperMarginStyles && !blankObjectStyles && $398f2e88274c6c6f$var$styles.wrapperMarginInline)
    }, isInSpaceContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aaf8b90c158e72ee$export$9c07d9d16c63c035), {
        sourceCount: spaceSourceCount,
        sources: spaceSources,
        activeContext: activePageContext,
        zeroSourcesAction: zeroSourcesAction
    }), shouldRenderContextBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "context-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b3081a59d1a8a69$export$64607723dae284ee), {
        contentContext: contentContext,
        currentPageAsContextStoreKey: promptDraftAndModeKey,
        enableBrowserContextBanner: enableBrowserContextBanner,
        browserContextSanitizer: browserContextSanitizer,
        aiFeatureContextOverride: aiFeatureContextOverride,
        onContextRemoved: handleContextRemoved
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($398f2e88274c6c6f$var$AppConnectionBannerWrapper, null), showConnectorTip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a73768b06a78f342$export$881917df039155cc), {
        unconnectedSourceTip: unconnectedSourceTip,
        dismissTip: dismissTip
    }), isMicPermissionDenied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a062643e8215604$export$f8b8a660bb428819), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e108032b0dd37bba$export$8f1070797568276d), {
        enableSkills: enableSkills,
        onViewSkills: onDiscoverSkillsClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5f8138d29eebe7ed$export$d951d9e39205c4ba), {
        isEnabled: isMentionAgentsSpotlightEnabled,
        mode: mode,
        shouldRenderInputAgentHat: shouldRenderInputAgentHat,
        hasAvailableAgents: hasAvailableAgents,
        hasActiveAgentMention: hasActiveSpecialistAgentMention
    }, ({ showAgentSourceControlSpotlight: showAgentSourceControlSpotlight, onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight, sourceControlPostOfficeMessage: sourceControlPostOfficeMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d064a580ef58dc58$export$6212c6fb2ac1afb8), {
            isRenderStabilizationEnabled: isRenderStabilizationEnabled,
            files: files,
            handleFilesSelected: handleFilesSelected,
            handleUrlsSelected: handleUrlsSelected,
            urlValidationConfig: urlValidationConfig,
            chatModeReasoningMode: chatModeState.reasoningMode,
            chatModeDeepResearchEnabled: chatModeState.deepResearchEnabled,
            chatModeTaskModeEnabled: chatModeState.taskModeEnabled,
            taskModeAnimationTrigger: taskModeAnimationTrigger,
            shouldKeepTaskModePromptMounted: agentMentionsEnabled,
            isBackgroundTransparent: isBackgroundTransparent,
            dropdownSlot: dropdownSlot,
            isAgentTyping: isAgentTyping,
            showSingleLineEditor: showSingleLineEditor,
            hoveredPrompt: hoveredPrompt,
            forceTruncatedWrapperOnEmptyEditor: forceTruncatedWrapperOnEmptyEditor,
            inputValueLength: inputValueLength,
            blankObjectStyles: blankObjectStyles,
            selectedAgentForInputHat: selectedAgentForInputHat,
            shouldRenderInputAgentHat: shouldRenderInputAgentHat,
            selectedAgentInputHatImageUrl: selectedAgentInputHatImageUrl,
            handleSelectedAgentDismiss: handleSelectedAgentDismiss,
            siteId: siteId,
            topAccessory: topAccessory,
            shouldShowDeepResearchInAddMenu: shouldShowDeepResearchInAddMenu,
            isSpecialistPromptInput: isSpecialistPromptInput,
            canSwitchBackToRovo: canSwitchBackToRovo,
            setDeepResearchEnabled: setDeepResearchEnabled,
            promptDraftAndModeKey: promptDraftAndModeKey,
            onReasoningModeChange: onReasoningModeChange,
            isDisabled: isDisabled,
            handleEditorBlur: handleEditorBlur,
            hasCodeBlock: hasCodeBlock,
            contentContext: contentContext,
            editorProps: stableEditorProps,
            editorApi: editorApi,
            promptHasSkill: promptHasSkill,
            enableSkills: enableSkills,
            enableSkillsInStagingArea: enableSkillsInStagingArea,
            enableSkillsInSpecialistPromptInput: enableSkillsInSpecialistPromptInput,
            charactersOverLimit: charactersOverLimit,
            customSlotAboveActionRow: customSlotAboveActionRow,
            showChatModeMenu: showChatModeMenu,
            showActionsButton: showActionsButton,
            actionsMenuItemsVisibility: boundaryActionsMenuItemsVisibility,
            entryPoint: entryPoint,
            mode: mode,
            menuPosition: menuPosition,
            openLinkTypeAheadFromMenu: openLinkTypeAheadFromMenu,
            openMentionTypeAhead: openMentionTypeAhead,
            openAddTypeAhead: openAddTypeAhead,
            onDiscoverSkillsClick: onDiscoverSkillsClick,
            handleDeepResearchClick: handleDeepResearchClick,
            onBrowsePromptLibraryClick: onBrowsePromptLibraryClick,
            onCreateSpaceClick: onCreateSpaceClick,
            hasActiveAgentMention: hasActiveSpecialistAgentMention,
            assistanceServiceParams: boundaryAssistanceServiceParams,
            fileUploadAssistanceOverrides: fileUploadAssistanceOverrides,
            contextProviders: contextProviders,
            onContextBrowserShow: onContextBrowserShow,
            onContextAvailable: onContextAvailable,
            useCurrentPageContext: useCurrentPageContext,
            closeTypeAhead: closeTypeAhead,
            closeEditorToolbar: closeEditorToolbar,
            shouldRenderQuickActionsInPortal: shouldRenderQuickActionsInPortal,
            enableBrowserContextBanner: enableBrowserContextBanner,
            browserContextSanitizer: browserContextSanitizer,
            shouldRenderChatModeMenusInPortal: shouldRenderChatModeMenusInPortal,
            webSearchConfigEnabled: webSearchConfigEnabled,
            setWebSearchEnabled: setWebSearchEnabled,
            onWebSearchToggle: onWebSearchToggle,
            onOrgKnowledgeToggle: onOrgKnowledgeToggle,
            onFilteredAppsChange: onFilteredAppsChange,
            onInsertTranscript: handleInsertTranscript,
            onMicPermissionDenied: handleMicPermissionDenied,
            setReasoningMode: setReasoningMode,
            renderAutoApplyToggle: renderAutoApplyToggle,
            enableAppsDiscoveryUi: enableAppsDiscoveryUi,
            enableMaxMode: enableMaxMode,
            setTaskModeAnimationTrigger: setTaskModeAnimationTrigger,
            onReasoningModeMenuOpenChange: handleReasoningModeMenuOpenChange,
            isReasoningModeDisabledByDeepResearch: isReasoningModeDisabledByDeepResearch,
            stableFileInputChange: true,
            formatMessage: formatMessage,
            customSlotBeforeSubmitButton: customSlotBeforeSubmitButton,
            submitButtonOnSave: stableOnSave,
            SubmitButton: SubmitButton,
            isSendDisabled: isSendDisabled,
            submitButtonTooltip: submitButtonTooltip,
            tooltipOptions: tooltipOptions,
            onAbort: onAbort,
            getChatMode: getChatMode,
            shouldRenderVoiceEnabledFooterRow: shouldRenderVoiceEnabledFooterRow,
            productKey: productKey,
            autoSuggestConfig: autoSuggestConfig,
            autoSuggestQuery: autoSuggestQuery,
            autoSuggestADF: autoSuggestADF,
            handleSuggestionSelect: handleSuggestionSelect,
            pageContextType: pageContextType,
            customSlotBeforeChatModeMenu: typeof customSlotBeforeChatModeMenu === 'function' ? customSlotBeforeChatModeMenu({
                prompt: livePromptText
            }) : customSlotBeforeChatModeMenu,
            showAgentSourceControlSpotlight: showAgentSourceControlSpotlight,
            onDismissAgentSourceControlSpotlight: onDismissAgentSourceControlSpotlight,
            dictationOverlayBackground: dictationOverlayBackground,
            sourceControlPostOfficeMessage: sourceControlPostOfficeMessage,
            showSourceModeToggle: (0, $iDrrr.fg)('rovo_chat_space_source_mode') && isInSpaceContext
        }))), dropdownSlot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $398f2e88274c6c6f$var$styles.dropdownSlotAnchor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $398f2e88274c6c6f$var$styles.dropdownSlotOverlay
    }, dropdownSlot)));
});
const $398f2e88274c6c6f$export$3c09f58dae16463a = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let T0;
    let isBackgroundTransparent;
    let outerBottomAccessory;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ outerBottomAccessory: outerBottomAccessory, ...props } = t0);
        isBackgroundTransparent = outerBottomAccessory ? false : props.isBackgroundTransparent;
        T0 = (0, $iMnC5.Box);
        t1 = (0, $w6R6I.cx)(props.shouldBeCentered && $398f2e88274c6c6f$var$styles.fsCentered, $398f2e88274c6c6f$var$styles.relativeWrapper);
        $[0] = t0;
        $[1] = T0;
        $[2] = isBackgroundTransparent;
        $[3] = outerBottomAccessory;
        $[4] = props;
        $[5] = t1;
    } else {
        T0 = $[1];
        isBackgroundTransparent = $[2];
        outerBottomAccessory = $[3];
        props = $[4];
        t1 = $[5];
    }
    const t2 = outerBottomAccessory ? $398f2e88274c6c6f$var$styles.promptInputLayerAboveBottomAccessory : undefined;
    let t3;
    if ($[6] !== isBackgroundTransparent || $[7] !== props || $[8] !== ref) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $faAj4.default), {
            render: (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($398f2e88274c6c6f$var$ChatInputInternal, {
                    ...props,
                    isBackgroundTransparent: isBackgroundTransparent,
                    actions: actions,
                    ref: ref
                })
        }));
        $[6] = isBackgroundTransparent;
        $[7] = props;
        $[8] = ref;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2
        }, t3);
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== outerBottomAccessory) {
        t5 = outerBottomAccessory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $398f2e88274c6c6f$var$styles.outerBottomAccessory,
            testId: "chat-input-bottom-accessory"
        }, outerBottomAccessory);
        $[13] = outerBottomAccessory;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== T0 || $[16] !== t1 || $[17] !== t4 || $[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t1
        }, t4, t5);
        $[15] = T0;
        $[16] = t1;
        $[17] = t4;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
} : ({ outerBottomAccessory: outerBottomAccessory, ...props }, ref)=>{
    // Force an opaque white prompt background when outerBottomAccessory is present so it
    // covers the overlap area, leaving only the border-radius corner gaps visible.
    const isBackgroundTransparent = outerBottomAccessory ? false : props.isBackgroundTransparent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(props.shouldBeCentered && $398f2e88274c6c6f$var$styles.fsCentered, $398f2e88274c6c6f$var$styles.relativeWrapper)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: outerBottomAccessory ? $398f2e88274c6c6f$var$styles.promptInputLayerAboveBottomAccessory : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $faAj4.default), {
        render: (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($398f2e88274c6c6f$var$ChatInputInternal, {
                ...props,
                isBackgroundTransparent: isBackgroundTransparent,
                actions: actions,
                ref: ref
            })
    }))), outerBottomAccessory && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $398f2e88274c6c6f$var$styles.outerBottomAccessory,
        testId: "chat-input-bottom-accessory"
    }, outerBottomAccessory));
});
module.exports["RovoChatPromptInput"] = $398f2e88274c6c6f$export$3c09f58dae16463a;

});

parcelRegister("lxLAg", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6dabc25a52b4ca39$var$initialState = {
    suggestionsCyclesShownCount: 0,
    suggestionSelectionCount: 0,
    suggestionSetsBeforeSelectionCount: 0,
    totalSuggestionsShownCount: 0,
    suggestionCycles: [],
    selectedTexts: []
};
const $6dabc25a52b4ca39$var$actions = {
    incrementSuggestionSetsShown: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                suggestionsCyclesShownCount: currentState.suggestionsCyclesShownCount + 1
            });
        },
    incrementSuggestionSelected: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                suggestionSelectionCount: currentState.suggestionSelectionCount + 1
            });
        },
    incrementSuggestionSetsBeforeSelection: (totalSuggestionsShownCount = 0)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            // Check if there's an active cycle (last cycle has selected: false)
            const lastCycle = currentState.suggestionCycles[currentState.suggestionCycles.length - 1];
            const hasActiveCycle = lastCycle && !lastCycle.selected;
            let newCycles;
            if (hasActiveCycle) // Update existing active cycle
            newCycles = [
                ...currentState.suggestionCycles.slice(0, -1),
                {
                    ...lastCycle,
                    setsShown: lastCycle.setsShown + 1,
                    totalSuggestionsShown: lastCycle.totalSuggestionsShown + totalSuggestionsShownCount
                }
            ];
            else // Create new cycle
            newCycles = [
                ...currentState.suggestionCycles,
                {
                    setsShown: 1,
                    selected: false,
                    totalSuggestionsShown: totalSuggestionsShownCount
                }
            ];
            setState({
                suggestionSetsBeforeSelectionCount: currentState.suggestionSetsBeforeSelectionCount + 1,
                totalSuggestionsShownCount: currentState.totalSuggestionsShownCount + totalSuggestionsShownCount,
                suggestionCycles: newCycles
            });
        },
    resetSuggestionSetsBeforeSelection: ()=>({ setState: setState })=>{
            // Cycles are already stored, just reset the counter
            setState({
                suggestionSetsBeforeSelectionCount: 0
            });
        },
    completeCurrentCycleWithSelection: (selectedText)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            // Find the last active cycle and mark it as selected
            const lastCycle = currentState.suggestionCycles[currentState.suggestionCycles.length - 1];
            if (lastCycle && !lastCycle.selected) {
                const updatedCycles = [
                    ...currentState.suggestionCycles.slice(0, -1),
                    {
                        ...lastCycle,
                        selected: true
                    }
                ];
                setState({
                    suggestionCycles: updatedCycles,
                    suggestionSetsBeforeSelectionCount: 0,
                    // Store selected text separately for edit distance calculation
                    selectedTexts: [
                        ...currentState.selectedTexts,
                        selectedText
                    ]
                });
            }
        },
    resetAutoSuggestTracking: ()=>({ setState: setState })=>{
            setState($6dabc25a52b4ca39$var$initialState);
        }
};
const $6dabc25a52b4ca39$var$autoSuggestTrackingStore = (0, $8s9DV.createStore)({
    initialState: $6dabc25a52b4ca39$var$initialState,
    actions: $6dabc25a52b4ca39$var$actions,
    name: 'autoSuggestTracking'
});
const $6dabc25a52b4ca39$export$b3e0f8e2847e4f6f = (0, $kBr4q.createHook)($6dabc25a52b4ca39$var$autoSuggestTrackingStore);
module.exports["useAutoSuggestTracking"] = $6dabc25a52b4ca39$export$b3e0f8e2847e4f6f;

});

parcelRegister("kvaCg", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

/**
 * Extracts mention text from an ADF node
 */ const $d4a4a591a90d8948$var$getMentionText = (node)=>node.attrs?.text || '@unknown';
/**
 * Extracts URL from an inline/embed card node
 */ const $d4a4a591a90d8948$var$getCardUrl = (node)=>node.attrs?.url || '';
/**
 * Finds the link mark on a node, if present
 */ const $d4a4a591a90d8948$var$getLinkMark = (node)=>node.marks?.find((mark)=>mark.type === 'link');
const $d4a4a591a90d8948$export$b432e5fe4568ab51 = (adf)=>{
    let linkCounter = 0;
    const processADFNode = (currentValue, node)=>{
        switch(node.type){
            case 'text':
                // Check if this text has link marks
                const linkMark = $d4a4a591a90d8948$var$getLinkMark(node);
                if (linkMark && linkMark.attrs?.href && node.text) {
                    linkCounter++;
                    const placeholder = `<link_${linkCounter}>`;
                    currentValue.linkMapping[placeholder] = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        type: 'link'
                    };
                    return {
                        ...currentValue,
                        textParts: [
                            ...currentValue.textParts,
                            placeholder
                        ],
                        linkCount: linkCounter
                    };
                }
                // Regular text
                if (node.text) return {
                    ...currentValue,
                    textParts: [
                        ...currentValue.textParts,
                        node.text
                    ]
                };
                break;
            case 'inlineCard':
            case 'embedCard':
                // Handle smart cards
                linkCounter++;
                const placeholder = `<link_${linkCounter}>`;
                const cardUrl = $d4a4a591a90d8948$var$getCardUrl(node);
                currentValue.linkMapping[placeholder] = {
                    url: cardUrl,
                    text: cardUrl,
                    type: 'smartCard'
                };
                return {
                    ...currentValue,
                    textParts: [
                        ...currentValue.textParts,
                        placeholder
                    ],
                    linkCount: linkCounter
                };
            case 'mention':
                // Keep mentions as plain text in the request
                return {
                    ...currentValue,
                    textParts: [
                        ...currentValue.textParts,
                        $d4a4a591a90d8948$var$getMentionText(node)
                    ]
                };
        }
        return currentValue;
    };
    const initialState = {
        textParts: [],
        linkMapping: {},
        linkCount: 0
    };
    const result = (0, $4EPzQ.reduce)(adf, processADFNode, initialState);
    return {
        processedText: result.textParts.join(' ').replace(/\s+/g, ' ').trim(),
        linkMapping: result.linkMapping,
        linkCount: result.linkCount
    };
};
const $d4a4a591a90d8948$export$d09f5bd43cf6af52 = (suggestion, linkMapping, originalADF, onValidationFailure)=>{
    if (!$d4a4a591a90d8948$var$validateLinks(suggestion, linkMapping, onValidationFailure)) return null;
    // Extract mentions and check if any are in the suggestion
    const mentions = originalADF ? $d4a4a591a90d8948$var$extractMentionsFromADF(originalADF) : [];
    const foundMentions = mentions.filter((mention)=>suggestion.includes(mention.text));
    // Check for links and create ADF content
    const hasLinks = /<link_\d+>/.test(suggestion);
    const hasMentionsOrLinks = hasLinks || foundMentions.length > 0;
    const finalContentNodes = hasMentionsOrLinks ? $d4a4a591a90d8948$var$createADFContent(suggestion, linkMapping, foundMentions) : [];
    return {
        text: suggestion,
        adf: hasMentionsOrLinks ? $d4a4a591a90d8948$var$createADFDocument(finalContentNodes) : null
    };
};
/**
 * Validates link placeholders in suggestion text
 */ const $d4a4a591a90d8948$var$validateLinks = (suggestion, linkMapping, onValidationFailure)=>{
    const placeholdersInSuggestion = suggestion.match(/<link_\d+>/g) || [];
    if (placeholdersInSuggestion.length === 0) return true; // No links to validate
    // Validate placeholders
    const invalidPlaceholders = placeholdersInSuggestion.filter((placeholder)=>linkMapping[placeholder] === undefined);
    if (invalidPlaceholders.length > 0) {
        onValidationFailure?.({
            totalPlaceholders: placeholdersInSuggestion.length,
            invalidCount: invalidPlaceholders.length,
            invalidPlaceholders: invalidPlaceholders
        });
        return false; // Validation failed
    }
    return true; // All links are valid
};
/**
 * Creates ADF content with both links and mentions
 */ const $d4a4a591a90d8948$var$createADFContent = (suggestion, linkMapping, mentions)=>{
    const nodes = [];
    // Create regex for placeholders and mentions
    const placeholderKeys = Object.keys(linkMapping);
    const mentionTexts = mentions.map((m)=>m.text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const patterns = [];
    if (placeholderKeys.length > 0) {
        const escapedPlaceholders = placeholderKeys.map((p)=>p.replace(/[<>[\]{}()*+?.,\\^$|#\s]/g, '\\$&'));
        patterns.push(`(${escapedPlaceholders.join('|')})`);
    }
    if (mentionTexts.length > 0) patterns.push(`(${mentionTexts.join('|')})`);
    if (patterns.length === 0) return [
        {
            type: 'text',
            text: suggestion
        }
    ];
    const combinedRegex = new RegExp(patterns.join('|'), 'g');
    let lastIndex = 0;
    let match;
    while((match = combinedRegex.exec(suggestion)) !== null){
        const matchedText = match[0];
        const matchIndex = match.index;
        // Add text before the match
        if (matchIndex > lastIndex) {
            const textBefore = suggestion.substring(lastIndex, matchIndex);
            nodes.push({
                type: 'text',
                text: textBefore
            });
        }
        // Determine if it's a link placeholder or mention
        if (matchedText.startsWith('<link_')) {
            // Handle link placeholder
            const linkData = linkMapping[matchedText];
            if (linkData) {
                if (linkData.type === 'smartCard') nodes.push({
                    type: 'inlineCard',
                    attrs: {
                        url: linkData.url
                    }
                });
                else nodes.push({
                    type: 'text',
                    text: linkData.text,
                    marks: [
                        {
                            type: 'link',
                            attrs: {
                                href: linkData.url
                            }
                        }
                    ]
                });
            }
        } else {
            // Handle mention
            const mentionData = mentions.find((m)=>m.text === matchedText);
            if (mentionData) nodes.push({
                type: 'mention',
                attrs: {
                    id: mentionData.id,
                    text: matchedText,
                    displayName: mentionData.displayName,
                    ...mentionData.localId && {
                        localId: mentionData.localId
                    },
                    ...mentionData.accessLevel && {
                        accessLevel: mentionData.accessLevel
                    }
                }
            });
        }
        lastIndex = matchIndex + matchedText.length;
    }
    // Add remaining text after the last match
    if (lastIndex < suggestion.length) {
        const textAfter = suggestion.substring(lastIndex);
        nodes.push({
            type: 'text',
            text: textAfter
        });
    }
    return nodes.length > 0 ? nodes : [
        {
            type: 'text',
            text: suggestion
        }
    ];
};
/**
 * Creates an ADF document with given content nodes
 */ const $d4a4a591a90d8948$var$createADFDocument = (contentNodes)=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: contentNodes
            }
        ]
    });
/**
 * Extracts all mention data from an ADF document
 *
 * @param adf - The ADF document to extract mentions from
 * @returns Array of mention data found in the document
 */ const $d4a4a591a90d8948$var$extractMentionsFromADF = (adf)=>{
    const mentions = [];
    const extractMentions = (node)=>{
        if (!node) return;
        if (node.type === 'mention') mentions.push({
            text: node.attrs?.text || '',
            id: node.attrs?.id || '',
            displayName: node.attrs?.displayName || node.attrs?.text || '',
            localId: node.attrs?.localId,
            accessLevel: node.attrs?.accessLevel
        });
        if (node.content && Array.isArray(node.content)) node.content.forEach(extractMentions);
    };
    extractMentions(adf);
    return mentions;
};
const $d4a4a591a90d8948$export$c177e9a1ea3e78da = (adf)=>{
    const extractTextFromNode = (parts, node)=>{
        switch(node.type){
            case 'text':
                if (node.text) return [
                    ...parts,
                    node.text
                ];
                break;
            case 'inlineCard':
            case 'embedCard':
                // For cards, use the URL as representative text
                return [
                    ...parts,
                    $d4a4a591a90d8948$var$getCardUrl(node)
                ];
            case 'mention':
                return [
                    ...parts,
                    $d4a4a591a90d8948$var$getMentionText(node)
                ];
        }
        return parts;
    };
    const textParts = (0, $4EPzQ.reduce)(adf, extractTextFromNode, []);
    return textParts.join('');
};
const $d4a4a591a90d8948$export$7559e421c0b65842 = (suggestionAdf, queryAdf, queryText)=>{
    // Get the query text
    let normalizedQuery = '';
    if (queryAdf) normalizedQuery = $d4a4a591a90d8948$export$c177e9a1ea3e78da(queryAdf).toLowerCase().trim();
    else if (queryText) normalizedQuery = queryText.toLowerCase().trim();
    if (!normalizedQuery) return null;
    // Get suggestion text and find where query ends
    const suggestionText = $d4a4a591a90d8948$export$c177e9a1ea3e78da(suggestionAdf);
    const normalizedSuggestion = suggestionText.toLowerCase();
    const matchIndex = normalizedSuggestion.indexOf(normalizedQuery);
    if (matchIndex === -1) // Query not found, bold everything
    return $d4a4a591a90d8948$var$addBoldMarksFromPosition(suggestionAdf, 0);
    // Calculate where the completion starts
    const completionStartPos = matchIndex + normalizedQuery.length;
    if (completionStartPos >= suggestionText.length) // No completion portion to bold
    return null;
    return $d4a4a591a90d8948$var$addBoldMarksFromPosition(suggestionAdf, completionStartPos);
};
/**
 * Adds bold (strong) marks to text nodes starting from a character position.
 */ const $d4a4a591a90d8948$var$addBoldMarksFromPosition = (adf, startPosition)=>{
    let currentPosition = 0;
    const processNode = (node)=>{
        if (node.type === 'text' && node.text) {
            const nodeStartPos = currentPosition;
            const nodeEndPos = currentPosition + node.text.length;
            currentPosition = nodeEndPos;
            // Check if this node is entirely before the bold start position
            if (nodeEndPos <= startPosition) return node;
            // Check if bold starts within this node
            if (nodeStartPos < startPosition && nodeEndPos > startPosition) {
                // Need to split this node - but since we're returning a single node,
                // we'll just bold the whole node if any part should be bold
                // For simplicity, we bold the entire node
                const existingMarks = node.marks || [];
                const hasStrong = existingMarks.some((mark)=>mark.type === 'strong');
                if (!hasStrong) return {
                    ...node,
                    marks: [
                        ...existingMarks,
                        {
                            type: 'strong'
                        }
                    ]
                };
                return node;
            }
            // Node is entirely in the bold region
            if (nodeStartPos >= startPosition) {
                const existingMarks = node.marks || [];
                const hasStrong = existingMarks.some((mark)=>mark.type === 'strong');
                if (!hasStrong) return {
                    ...node,
                    marks: [
                        ...existingMarks,
                        {
                            type: 'strong'
                        }
                    ]
                };
            }
            return node;
        }
        // Track position for non-text inline content
        if (node.type === 'inlineCard' || node.type === 'embedCard') {
            currentPosition += $d4a4a591a90d8948$var$getCardUrl(node).length;
            return node;
        }
        if (node.type === 'mention') {
            currentPosition += $d4a4a591a90d8948$var$getMentionText(node).length;
            return node;
        }
        // For container nodes, process children
        if (node.content && Array.isArray(node.content)) return {
            ...node,
            content: node.content.filter((child)=>child !== undefined).map(processNode)
        };
        return node;
    };
    return processNode(adf);
};
const $d4a4a591a90d8948$export$d8de9d678e8ce07d = (adf)=>{
    // Placeholder length is always 8 characters: "<link_1>", "<link_2>", etc.
    const PLACEHOLDER_LENGTH = 8;
    const calculateNodeLength = (currentLength, node)=>{
        switch(node.type){
            case 'text':
                // Link
                const linkMark = $d4a4a591a90d8948$var$getLinkMark(node);
                if (linkMark && linkMark.attrs?.href && node.text) // Count placeholder length instead of actual link text
                return currentLength + PLACEHOLDER_LENGTH;
                // Regular text
                return currentLength + (node.text?.length || 0);
            case 'inlineCard':
            case 'embedCard':
                // Count placeholder length instead of URL length
                return currentLength + PLACEHOLDER_LENGTH;
            case 'mention':
                return currentLength + $d4a4a591a90d8948$var$getMentionText(node).length;
            default:
                // For other node types, don't add to length
                return currentLength;
        }
    };
    return (0, $4EPzQ.reduce)(adf, calculateNodeLength, 0);
};
const $d4a4a591a90d8948$export$6ee7827b2c781f7c = (suggestionText, query, queryAdf)=>{
    // Get the query text - prefer ADF extraction if available
    let queryText = '';
    if (queryAdf) {
        const { processedText: processedText } = $d4a4a591a90d8948$export$b432e5fe4568ab51(queryAdf);
        queryText = processedText;
    } else if (query) queryText = query;
    if (!queryText) return null;
    // Normalize both strings for comparison (lowercase, trim whitespace)
    const normalizedQuery = queryText.toLowerCase().trim();
    const normalizedSuggestion = suggestionText.toLowerCase();
    // Find where the query appears in the suggestion (case-insensitive)
    const matchIndex = normalizedSuggestion.indexOf(normalizedQuery);
    if (matchIndex === -1) // Query not found in suggestion - return entire suggestion as completion
    return {
        prefix: '',
        completion: suggestionText
    };
    // Extract the parts using original case from suggestion
    const prefixEnd = matchIndex + queryText.length;
    const prefix = suggestionText.substring(0, prefixEnd);
    const completion = suggestionText.substring(prefixEnd);
    return {
        prefix: prefix,
        completion: completion
    };
};
module.exports["extractContent"] = $d4a4a591a90d8948$export$b432e5fe4568ab51;
module.exports["processSuggestion"] = $d4a4a591a90d8948$export$d09f5bd43cf6af52;
module.exports["getADFTextLength"] = $d4a4a591a90d8948$export$d8de9d678e8ce07d;

});

parcelRegister("j4TFB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

const $3da4e8c031b6977a$var$store = (0, $8s9DV.createStore)({
    initialState: {
        drafts: {}
    },
    actions: {
        setDraftMessage: (conversationId, draftMessage)=>({ setState: setState, getState: getState })=>{
                const { drafts: drafts } = getState();
                setState({
                    drafts: {
                        ...drafts,
                        [conversationId]: draftMessage
                    }
                });
            }
    }
});
const $3da4e8c031b6977a$var$useStore = (0, $kBr4q.createHook)($3da4e8c031b6977a$var$store);
const $3da4e8c031b6977a$export$ae6e25e430bcd18b = (conversationId, draftMessage)=>{
    (0, $c6StJ.defaultRegistry).getStore($3da4e8c031b6977a$var$store).actions.setDraftMessage(conversationId, draftMessage);
};
const $3da4e8c031b6977a$export$ba483e15c3687d4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (conversationId)=>{
    const $ = (0, $bDgLe.c)(6);
    const [t0, t1] = $3da4e8c031b6977a$var$useStore();
    const { drafts: drafts } = t0;
    const { setDraftMessage: storeSetDraftMessage } = t1;
    let t2;
    if ($[0] !== conversationId || $[1] !== storeSetDraftMessage) {
        t2 = (draftMessage)=>{
            storeSetDraftMessage(conversationId, draftMessage);
        };
        $[0] = conversationId;
        $[1] = storeSetDraftMessage;
        $[2] = t2;
    } else t2 = $[2];
    const setDraftMessage = t2;
    const t3 = drafts[conversationId];
    let t4;
    if ($[3] !== setDraftMessage || $[4] !== t3) {
        t4 = {
            draftMessage: t3,
            setDraftMessage: setDraftMessage
        };
        $[3] = setDraftMessage;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : (conversationId)=>{
    const [{ drafts: drafts }, { setDraftMessage: storeSetDraftMessage }] = $3da4e8c031b6977a$var$useStore();
    const setDraftMessage = (0, $cozmU.useCallback)((draftMessage)=>{
        storeSetDraftMessage(conversationId, draftMessage);
    }, [
        conversationId,
        storeSetDraftMessage
    ]);
    return {
        draftMessage: drafts[conversationId],
        setDraftMessage: setDraftMessage
    };
};
module.exports["setDraftMessage"] = $3da4e8c031b6977a$export$ae6e25e430bcd18b;
module.exports["useDraftsController"] = $3da4e8c031b6977a$export$ba483e15c3687d4f;

});

parcelRegister("91BX8", function(module, exports) {

let $6921a5b5dacf22c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6921a5b5dacf22c9$var$load("lRgOm").then(()=>parcelRequire('79mXg'));

});

parcelRegister("cyU0n", function(module, exports) {

let $92541a7859a5b54e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $92541a7859a5b54e$var$load("gSvMu").then(()=>parcelRequire('bGdmc'));

});

parcelRegister("cnobl", function(module, exports) {

var $4wH3g = parcelRequire("4wH3g");


const $91812b9a9a4c63bf$export$6b50ea1690be27a3 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "4rG7i",
    name: "LoadableHeadlessProbePostOfficePlacement",
    loader: async ()=>(await (parcelRequire("7PgT8"))).HeadlessProbePostOfficePlacement,
    loading: ()=>null
});
$91812b9a9a4c63bf$export$6b50ea1690be27a3.displayName = 'lazy(HeadlessProbePostOfficePlacement)';
module.exports["LoadableHeadlessProbePostOfficePlacement"] = $91812b9a9a4c63bf$export$6b50ea1690be27a3;

});

parcelRegister("7PgT8", function(module, exports) {

let $5b2a657bb97a54a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b2a657bb97a54a5$var$load("j0TPm").then(()=>parcelRequire('hf5f8'));

});

parcelRegister("6PIvc", function(module, exports) {

let $4f9a06b0507a5725$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4f9a06b0507a5725$var$load("8TRae"),
    $4f9a06b0507a5725$var$load("52ZTT"),
    $4f9a06b0507a5725$var$load("6wr18"),
    $4f9a06b0507a5725$var$load("ffEVr"),
    $4f9a06b0507a5725$var$load("dlTE8")
]).then(()=>parcelRequire('GtjgS'));

});

parcelRegister("bE9h1", function(module, exports) {

let $87aa9fa7f0d924ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87aa9fa7f0d924ad$var$load("cTPK8").then(()=>parcelRequire('ewOJJ'));

});

parcelRegister("dqfc0", function(module, exports) {

let $9c597d06ab0c02cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c597d06ab0c02cb$var$load("a3UEF").then(()=>parcelRequire('bSXpv'));

});

parcelRegister("g9Q3L", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $5za37 = parcelRequire("5za37");


var $hyaRb = parcelRequire("hyaRb");

const $b6d29db3474a1555$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: $hyaRb.initialState,
    actions: $5za37.actions,
    name: 'app-connection-banner-store'
});
module.exports["store"] = $b6d29db3474a1555$export$6f57813fe9f31bf9;

});

parcelRegister("9OWHk", function(module, exports) {
const $b88b6fc87d246560$export$ca75983497356254 = [];
module.exports["EMPTY_SELECTED_AGENT_IDS"] = $b88b6fc87d246560$export$ca75983497356254;

});

parcelRegister("5aQkY", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $4o0zT = parcelRequire("4o0zT");

const $2ad76e04aef6c693$var$normalizeAgentId = (agentId)=>{
    const trimmedAgentId = agentId.trim();
    return trimmedAgentId.length > 0 ? trimmedAgentId : undefined;
};
/** Preserve the legacy gate-off behavior for duplicate selections. */ const $2ad76e04aef6c693$var$removeMostRecentSelectedAgentId = (agentIds, agentId)=>{
    const normalizedAgentId = $2ad76e04aef6c693$var$normalizeAgentId(agentId);
    if (!normalizedAgentId) return agentIds;
    for(let index = agentIds.length - 1; index >= 0; index--){
        if (agentIds[index] === normalizedAgentId) return [
            ...agentIds.slice(0, index),
            ...agentIds.slice(index + 1)
        ];
    }
    return agentIds;
};
const $2ad76e04aef6c693$var$deduplicateAgentIdsByLastActivation = (agentIds)=>{
    const seenAgentIds = new Set();
    const uniqueAgentIds = [];
    for(let index = agentIds.length - 1; index >= 0; index--){
        const agentId = agentIds[index];
        if (!seenAgentIds.has(agentId)) {
            seenAgentIds.add(agentId);
            uniqueAgentIds.push(agentId);
        }
    }
    return uniqueAgentIds.reverse();
};
const $2ad76e04aef6c693$var$keepMetadataForSelectedAgentIds = (metadata, agentIds)=>{
    if (!metadata) return undefined;
    const selectedAgentIdSet = new Set(agentIds);
    const nextMetadata = Object.fromEntries(Object.entries(metadata).filter(([agentId])=>selectedAgentIdSet.has(agentId)));
    return Object.keys(nextMetadata).length > 0 ? nextMetadata : undefined;
};
const $2ad76e04aef6c693$var$initialState = {
    selectedAgentIds: {},
    deactivatedAgentIds: {},
    selectedAgentMetadata: {}
};
const $2ad76e04aef6c693$export$41fda08e17f0cc72 = (0, $8s9DV.createStore)({
    initialState: $2ad76e04aef6c693$var$initialState,
    actions: {
        setSelectedAgentIds: (conversationId, agentIds)=>({ setState: setState, getState: getState })=>{
                const { selectedAgentIds: selectedAgentIds, deactivatedAgentIds: deactivatedAgentIds, selectedAgentMetadata: selectedAgentMetadata } = getState();
                const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
                const normalizedAgentIdsWithDuplicates = agentIds.flatMap((agentId)=>{
                    const normalizedAgentId = $2ad76e04aef6c693$var$normalizeAgentId(agentId);
                    return normalizedAgentId ? [
                        normalizedAgentId
                    ] : [];
                });
                const normalizedAgentIds = isMentionAgentsExperimentEnabled ? $2ad76e04aef6c693$var$deduplicateAgentIdsByLastActivation(normalizedAgentIdsWithDuplicates) : normalizedAgentIdsWithDuplicates;
                const { [conversationId]: _removedDeactivatedAgentIds, ...nextDeactivatedAgentIds } = deactivatedAgentIds;
                if (normalizedAgentIds.length === 0) {
                    const { [conversationId]: _removedSelectedAgentIds, ...nextSelectedAgentIds } = selectedAgentIds;
                    const { [conversationId]: _removedSelectedAgentMetadata, ...nextSelectedAgentMetadata } = selectedAgentMetadata;
                    setState({
                        selectedAgentIds: nextSelectedAgentIds,
                        deactivatedAgentIds: nextDeactivatedAgentIds,
                        selectedAgentMetadata: nextSelectedAgentMetadata
                    });
                    return;
                }
                const nextSelectedAgentMetadata = $2ad76e04aef6c693$var$keepMetadataForSelectedAgentIds(selectedAgentMetadata[conversationId], normalizedAgentIds);
                const { [conversationId]: _removedSelectedAgentMetadata, ...baseSelectedAgentMetadata } = selectedAgentMetadata;
                setState({
                    selectedAgentIds: {
                        ...selectedAgentIds,
                        [conversationId]: normalizedAgentIds
                    },
                    deactivatedAgentIds: nextDeactivatedAgentIds,
                    selectedAgentMetadata: nextSelectedAgentMetadata ? {
                        ...baseSelectedAgentMetadata,
                        [conversationId]: nextSelectedAgentMetadata
                    } : baseSelectedAgentMetadata
                });
            },
        addSelectedAgentId: (conversationId, agentId, metadata)=>({ setState: setState, getState: getState })=>{
                const normalizedAgentId = $2ad76e04aef6c693$var$normalizeAgentId(agentId);
                if (!normalizedAgentId) return;
                const { selectedAgentIds: selectedAgentIds, deactivatedAgentIds: deactivatedAgentIds, selectedAgentMetadata: selectedAgentMetadata } = getState();
                const currentSelectedAgentIds = selectedAgentIds[conversationId] ?? [];
                const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
                const nextSelectedAgentIds = isMentionAgentsExperimentEnabled ? [
                    ...currentSelectedAgentIds.filter((selectedAgentId)=>selectedAgentId !== normalizedAgentId),
                    normalizedAgentId
                ] : [
                    ...currentSelectedAgentIds,
                    normalizedAgentId
                ];
                const nextDeactivatedAgentIdsForConversation = deactivatedAgentIds[conversationId]?.filter((deactivatedAgentId)=>deactivatedAgentId !== normalizedAgentId) ?? [];
                const { [conversationId]: _removedDeactivatedAgentIds, ...baseDeactivatedAgentIds } = deactivatedAgentIds;
                setState({
                    selectedAgentIds: {
                        ...selectedAgentIds,
                        [conversationId]: nextSelectedAgentIds
                    },
                    ...isMentionAgentsExperimentEnabled ? {
                        deactivatedAgentIds: nextDeactivatedAgentIdsForConversation.length > 0 ? {
                            ...baseDeactivatedAgentIds,
                            [conversationId]: nextDeactivatedAgentIdsForConversation
                        } : baseDeactivatedAgentIds
                    } : {},
                    ...metadata ? {
                        selectedAgentMetadata: {
                            ...selectedAgentMetadata,
                            [conversationId]: {
                                ...selectedAgentMetadata[conversationId],
                                [normalizedAgentId]: metadata
                            }
                        }
                    } : {}
                });
            },
        removeSelectedAgentId: (conversationId, agentId)=>({ setState: setState, getState: getState })=>{
                const normalizedAgentId = $2ad76e04aef6c693$var$normalizeAgentId(agentId);
                if (!normalizedAgentId) return;
                const { selectedAgentIds: selectedAgentIds, deactivatedAgentIds: deactivatedAgentIds, selectedAgentMetadata: selectedAgentMetadata } = getState();
                const currentSelectedAgentIds = selectedAgentIds[conversationId];
                const isMentionAgentsExperimentEnabled = (0, $4o0zT.isExperimentEnabled)('rovo_chat_mention_agents');
                if (isMentionAgentsExperimentEnabled) {
                    const nextSelectedAgentIds = currentSelectedAgentIds?.filter((selectedAgentId)=>selectedAgentId !== normalizedAgentId) ?? [];
                    const currentDeactivatedAgentIds = deactivatedAgentIds[conversationId] ?? [];
                    const nextDeactivatedAgentIds = currentDeactivatedAgentIds.includes(normalizedAgentId) ? currentDeactivatedAgentIds : [
                        ...currentDeactivatedAgentIds,
                        normalizedAgentId
                    ];
                    const { [conversationId]: _removedSelectedAgentIds, ...nextSelectedAgentIdsByConversation } = selectedAgentIds;
                    const { [conversationId]: _removedSelectedAgentMetadata, ...nextSelectedAgentMetadata } = selectedAgentMetadata;
                    const retainedSelectedAgentMetadata = $2ad76e04aef6c693$var$keepMetadataForSelectedAgentIds(selectedAgentMetadata[conversationId], nextSelectedAgentIds);
                    setState({
                        selectedAgentIds: nextSelectedAgentIds.length > 0 ? {
                            ...nextSelectedAgentIdsByConversation,
                            [conversationId]: nextSelectedAgentIds
                        } : nextSelectedAgentIdsByConversation,
                        deactivatedAgentIds: {
                            ...deactivatedAgentIds,
                            [conversationId]: nextDeactivatedAgentIds
                        },
                        selectedAgentMetadata: retainedSelectedAgentMetadata ? {
                            ...nextSelectedAgentMetadata,
                            [conversationId]: retainedSelectedAgentMetadata
                        } : nextSelectedAgentMetadata
                    });
                    return;
                }
                if (!currentSelectedAgentIds) return;
                const nextSelectedAgentIds = $2ad76e04aef6c693$var$removeMostRecentSelectedAgentId(currentSelectedAgentIds, normalizedAgentId);
                if (nextSelectedAgentIds === currentSelectedAgentIds) return;
                if (nextSelectedAgentIds.length === 0) {
                    const { [conversationId]: _removedSelectedAgentIds, ...nextSelectedAgentIdsByConversation } = selectedAgentIds;
                    const { [conversationId]: _removedSelectedAgentMetadata, ...nextSelectedAgentMetadata } = selectedAgentMetadata;
                    setState({
                        selectedAgentIds: nextSelectedAgentIdsByConversation,
                        selectedAgentMetadata: nextSelectedAgentMetadata
                    });
                    return;
                }
                const nextSelectedAgentMetadata = $2ad76e04aef6c693$var$keepMetadataForSelectedAgentIds(selectedAgentMetadata[conversationId], nextSelectedAgentIds);
                const { [conversationId]: _removedSelectedAgentMetadata, ...baseSelectedAgentMetadata } = selectedAgentMetadata;
                setState({
                    selectedAgentIds: {
                        ...selectedAgentIds,
                        [conversationId]: nextSelectedAgentIds
                    },
                    selectedAgentMetadata: nextSelectedAgentMetadata ? {
                        ...baseSelectedAgentMetadata,
                        [conversationId]: nextSelectedAgentMetadata
                    } : baseSelectedAgentMetadata
                });
            }
    }
});
module.exports["selectedAgentDraftControllerStore"] = $2ad76e04aef6c693$export$41fda08e17f0cc72;

});

parcelRegister("bggsP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1854e5ffc3a1de1aae0317f9d1ee5de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $832df5b7da94c19b$var$_react = $832df5b7da94c19b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $832df5b7da94c19b$var$_baseNew = $832df5b7da94c19b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $832df5b7da94c19b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Randomize".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/randomize
 * Usage guidance:
 * Reserved for randomizing or shuffling functionality.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $832df5b7da94c19b$var$RandomizeIcon = (props)=>/*#__PURE__*/ $832df5b7da94c19b$var$_react.default.createElement($832df5b7da94c19b$var$_baseNew.default, Object.assign({
        name: "RandomizeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 .052 1.004l-.052.056-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="m15.78 3.72.05.06a.75.75 0 0 1-.05 1l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM2.91 3a2 2 0 0 1 1.55.74l1.53 1.88-.97 1.19-1.73-2.13a.5.5 0 0 0-.39-.18H0V3z"/>`
    }, props));
$832df5b7da94c19b$var$RandomizeIcon.displayName = 'RandomizeIcon';
var $832df5b7da94c19b$var$_default = module.exports.default = $832df5b7da94c19b$var$RandomizeIcon;

});

parcelRegister("5za37", function(module, exports) {
const $7777461046a00524$export$e324594224ef24da = {
    /**
   * Show the app connection banner with the given unconnected apps
   */ showBanner: (unconnectedApps, options)=>({ setState: setState })=>{
            if (unconnectedApps.length > 0) setState({
                unconnectedApps: unconnectedApps,
                isVisible: true,
                forceMultiline: options?.forceMultiline ?? false,
                showConnectedState: options?.showConnectedState ?? false
            });
        },
    /**
   * Hide the banner and clear the unconnected apps
   */ hideBanner: ()=>({ setState: setState })=>{
            setState({
                unconnectedApps: [],
                isVisible: false,
                forceMultiline: false,
                showConnectedState: false
            });
        },
    /**
   * Handle a successful connection.
   *
   * Default behavior removes the app's row (and hides the banner once the last
   * one connects). When `showConnectedState` is on, the row is kept instead —
   * the connected state is derived from the connectors store (`isUserOAuthed`,
   * flipped by the shared OAuth flow), so there is nothing to update here.
   */ markAppAsConnected: (appSource)=>({ setState: setState, getState: getState })=>{
            const { unconnectedApps: unconnectedApps, showConnectedState: showConnectedState } = getState();
            if (showConnectedState) return;
            const updatedApps = unconnectedApps.filter((app)=>app.source !== appSource);
            if (updatedApps.length === 0) // All apps connected, hide the banner
            setState({
                unconnectedApps: [],
                isVisible: false,
                forceMultiline: false
            });
            else setState({
                unconnectedApps: updatedApps
            });
        }
};
module.exports["actions"] = $7777461046a00524$export$e324594224ef24da;

});

parcelRegister("hyaRb", function(module, exports) {
const $b4f32f04a49a7e30$export$d4c72bab9d6cc13a = {
    unconnectedApps: [],
    isVisible: false,
    forceMultiline: false,
    showConnectedState: false
};
module.exports["initialState"] = $b4f32f04a49a7e30$export$d4c72bab9d6cc13a;

});


//# sourceMappingURL=prompt-view-with-relay.4bc66276.js.map
